/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface AdminDashboardsGetPigletRegistrationOverviewParams {
  /** @format int32 */
  Page?: number;
  /** Restricts the queue to one rule, by its identifier. */
  Rule?: string;
  /** Matches a farm's UBN or its name, case-insensitively. */
  Search?: string;
  /** Restricts the queue to one severity, by its identifier. */
  Severity?: string;
  /** @format int32 */
  Size?: number;
  /**
   * Orders the queue: a field name optionally followed by `-desc`, for instance
   * `registered-desc` for the busiest farms first or `registered` for the quietest, and
   * `weighed-desc` / `weighed` for the share of registrations really weighed.
   * Defaults to worst first.
   */
  Sort?: string;
  /**
   * Restricts the queue to one status, by its identifier - `Critical`, `Warning`,
   * `OnTrack` or `NotMonitored`.
   */
  Status?: string;
  /**
   * Restricts the queue to one weighing state, by its identifier - `OnTrack`, `Behind` or
   * `NoScale`. Combines with Status rather than replacing it.
   */
  Weighing?: string;
}

export interface AdminGetUserBusinessUnitAccessByIdParams {
  /** @format uuid */
  id: string;
}

export interface AdminGetUsersParams {
  /** @format int32 */
  Page?: number;
  SearchText?: string;
  /** @format int32 */
  Size?: number;
  Sort?: string;
}

export interface AdminJobsGetJobRunHistoryParams {
  /** @format int32 */
  Page?: number;
  /** @format int32 */
  Size?: number;
  jobName: string;
}

export interface AdminJobsGetJobRunParams {
  jobName: string;
  /** @format uuid */
  runId: string;
}

export interface AnimalsCreateExternalIdentifierParams {
  /** @format uuid */
  id: string;
}

export interface AnimalsCreateObservationParams {
  /** @format uuid */
  id: string;
}

export interface AnimalsDeleteAnimalNoteParams {
  /** @format uuid */
  NoteId?: string;
}

export interface AnimalsDeleteExternalIdentifierParams {
  /** @format uuid */
  externalIdentifierId: string;
  /** @format uuid */
  id: string;
}

export interface AnimalsDeleteObservationParams {
  /** @format uuid */
  id: string;
  /** @format uuid */
  observationId: string;
}

export interface AnimalsGetAnimalAntibioticFreeResultObsoleteParams {
  /** @format uuid */
  Id?: string;
  Number?: string;
}

export interface AnimalsGetAnimalAntibioticFreeResultParams {
  /** @format uuid */
  Id?: string;
  Number?: string;
}

export interface AnimalsGetAnimalByIdParams {
  /** @format uuid */
  Id?: string;
}

export interface AnimalsGetAnimalFeedHistoryParams {
  /** @format uuid */
  id: string;
}

export interface AnimalsGetAnimalLocationHistoryTimelineParams {
  /** @format uuid */
  id: string;
}

export interface AnimalsGetAnimalPigletsBirthCyclesParams {
  /** @format uuid */
  AnimalId?: string;
  AnimalType?: HealthSystemDALEnumsAnimalType;
}

export interface AnimalsGetAnimalPigletsParams {
  /** @format uuid */
  AnimalId?: string;
  AnimalType?: HealthSystemDALEnumsAnimalType;
  /** @format int32 */
  Page?: number;
  /** @format int32 */
  Size?: number;
  Sort?: string;
}

export interface AnimalsGetAnimalTrendDataParams {
  /** @format uuid */
  AnimalId?: string;
  AnimalTrendDataType?: HealthSystemDALEnumsAnimalTrendDataType;
  AnimalType?: HealthSystemDALEnumsAnimalType;
  /** @format date-time */
  DateOfBirth?: string;
}

export interface AnimalsGetExternalIdentifiersParams {
  /** @format uuid */
  id: string;
  /**
   * @format int32
   * @default 1
   */
  pageIndex?: number;
  /**
   * @format int32
   * @default 100
   */
  pageSize?: number;
  searchTerm?: string;
}

export interface AnimalsGetHealthLogsParams {
  /** @format uuid */
  id: string;
  /**
   * @format int32
   * @default 1
   */
  pageIndex?: number;
  /**
   * @format int32
   * @default 100
   */
  pageSize?: number;
}

export interface AnimalsGetLifecyclePredictionParams {
  /** @format uuid */
  id: string;
}

export interface AnimalsGetObservationRegistrationsParams {
  categories?: string[];
  geneticFailures?: string[];
  /**
   * @format int32
   * @default 1
   */
  pageIndex?: number;
  /**
   * @format int32
   * @default 100
   */
  pageSize?: number;
  /** @format date-time */
  registeredFrom?: string;
  /** @format date-time */
  registeredTo?: string;
}

export interface AnimalsGetObservationsParams {
  /** @format uuid */
  id: string;
  /**
   * @format int32
   * @default 1
   */
  pageIndex?: number;
  /**
   * @format int32
   * @default 100
   */
  pageSize?: number;
}

export interface AnimalsGetProjectedSlaughterDateParams {
  /** @format uuid */
  id: string;
}

export interface AnimalsUpdateAnimalSetInseminatedParams {
  /** @format uuid */
  AnimalId?: string;
  /** @format date-time */
  DateTime?: string;
}

export interface AuthGetInvitationDetailsParams {
  token: string;
}

export interface CarbonFootprintGetCarbonFootprintByYearParams {
  /** @format date */
  From?: string;
  /** @format date */
  To?: string;
  /** @format int32 */
  Year?: number;
}

export interface ChipNumbersGetChipNumberInfoParams {
  ChipNumber: string;
}

export interface ChipNumbersGetChipNumberParams {
  "Filter.FarmIds"?: string[];
  "Filter.Genders"?: HealthSystemDALEnumsAnimalGender[];
  /** @format int64 */
  "Filter.RangeFrom"?: number;
  /** @format int64 */
  "Filter.RangeTo"?: number;
  /** @format int32 */
  Page?: number;
  /** @format int32 */
  Size?: number;
  Sort?: string;
}

export interface DashboardsGetDashboardParams {
  /** @format uuid */
  farmId?: string;
}

export interface DashboardsGetPigletRegistrationDashboardParams {
  /** @format uuid */
  farmId?: string;
  /** @format int32 */
  weeks?: number;
}

export interface DashboardsGetWeightMilestoneDashboardParams {
  /** @format uuid */
  farmId?: string;
  /** @format int32 */
  weeks?: number;
}

export interface DataImportGetSlaughterImportHistoryParams {
  /**
   * Filter imports from this date (inclusive).
   * @format date-time
   */
  FromDate?: string;
  /**
   * Page number (1-based). Defaults to 1.
   * @format int32
   */
  PageIndex?: number;
  /**
   * Page size.
   * @format int32
   */
  PageSize?: number;
  /**
   * Filter imports to this date (inclusive).
   * @format date-time
   */
  ToDate?: string;
}

export interface DeviceDailyReportsCreateParams {
  /** @format uuid */
  farmId: string;
}

export type DeviceDailyReportsCreatePayload = any;

export interface DeviceDailyReportsGetByFarmParams {
  /** @format uuid */
  farmId: string;
}

export interface DeviceDownloadDeviceFirmwareParams {
  /** @format uuid */
  Id?: string;
}

export interface DeviceGetDeviceFirmwareVersionsParams {
  /** @format int32 */
  Page?: number;
  ReleaseType?: string;
  RfidType?: string;
  /** @format int32 */
  Size?: number;
  Sort?: string;
  Type?: HealthSystemDALEnumsDeviceFirmwareType;
}

export interface DeviceGetDeviceSyncStatusParams {
  /** @format uuid */
  farmId?: string;
  /**
   * @format int32
   * @default 30
   */
  historyDays?: number;
  /** @default false */
  pendingOnly?: boolean;
}

export interface DeviceGetHealthInjectorActivitiesParams {
  /**
   * Available values: DeviceRegistered, FarmAttached, FarmDetached, FarmChanged, MobileConnection, FirmwareUpdated, ManualUpdate, DeviceDisabled, DeviceEnabled, ConfigurationChanged
   * @example "DeviceRegistered"
   */
  activityType?: string;
  /** @format date-time */
  fromDate?: string;
  /** @format uuid */
  id: string;
  /**
   * @format int32
   * @default 1
   */
  page?: number;
  /**
   * @format int32
   * @default 20
   */
  size?: number;
  /** @format date-time */
  toDate?: string;
}

export interface DeviceGetHealthInjectorDetailsParams {
  /** @format uuid */
  id: string;
}

export interface DeviceGetHealthInjectorEventsParams {
  /** @format date-time */
  fromDate?: string;
  /** @format uuid */
  id: string;
  isError?: boolean;
  /**
   * @format int32
   * @default 1
   */
  page?: number;
  /**
   * @format int32
   * @default 20
   */
  size?: number;
  /** @format date-time */
  toDate?: string;
}

export interface DeviceGetHealthInjectorsParams {
  /** @format uuid */
  FarmId?: string;
  MacAddress?: string;
  /** @format int32 */
  Page?: number;
  /** @format int32 */
  Size?: number;
  Sort?: string;
}

export interface DeviceGetLatestDeviceFirmwareVersionParams {
  query?: HealthSystemDomainDeviceCommandsLatestFirmwareQuery;
}

export interface DeviceGetReadersParams {
  MacAddress?: string;
  /** @format int32 */
  Page?: number;
  /** @format int32 */
  Size?: number;
  /** @format uuid */
  SlaughterhouseId?: string;
  Sort?: string;
}

export interface DeviceRemoveDeviceFirmwareParams {
  /** @format uuid */
  Id: string;
}

export interface DeviceUpdateDeviceFirmwareDescriptionParams {
  /** @format uuid */
  id: string;
}

export interface DeviceUploadDeviceFirmwarePayload {
  /** @format binary */
  Firmware?: File;
  Info?: string;
  ReleaseNotes?: string;
  Type?: HealthSystemDALEnumsDeviceFirmwareType;
}

export interface DiseasesDiseasesSearchParams {
  /** @format int32 */
  Page?: number;
  /** @format int32 */
  Size?: number;
  Sort?: string;
}

export interface DiseasesGetAllDiseasesParams {
  query?: HealthSystemDomainDiseasesCommandsGetAllDiseasesQuery;
}

export interface DocumentsDownloadExportDocumentParams {
  /** @format uuid */
  Id?: string;
}

export interface DocumentsSearchDocumentsParams {
  /**
   * A document to bring into view, for a caller that holds an id but not a page - an export notification, for
   * instance. The page the document sits on is returned instead of Page, and comes back on the
   * result. An id that no longer exists falls back to the first page.
   * @format uuid
   */
  FocusDocumentId?: string;
  /**
   * One-based page to return. Ignored when FocusDocumentId is set.
   * @format int32
   */
  Page?: number;
  /**
   * Number of documents per page.
   * @format int32
   */
  Size?: number;
}

export interface EmissionSourceSettingsGetAllParams {
  /** @format int32 */
  Page?: number;
  /** @format int32 */
  Size?: number;
  Sort?: string;
}

export interface EmissionSourceSettingsGetParams {
  /** @format int32 */
  Page?: number;
  /** @format int32 */
  Size?: number;
  Sort?: string;
  /** @format int32 */
  Year?: number;
}

export interface FarmConfigurationProvidersDisableParams {
  /** @format uuid */
  farmId: string;
  type: string;
}

export interface FarmConfigurationProvidersEnableParams {
  /** @format uuid */
  farmId: string;
  type: string;
}

export interface FarmConfigurationProvidersGetAllParams {
  /** @format uuid */
  farmId: string;
}

export interface FarmConfigurationProvidersUpsertParams {
  /** @format uuid */
  farmId: string;
  type: string;
}

export interface FarmsGetFarmsParams {
  Ids?: string[];
  /** @format int32 */
  Page?: number;
  SearchText?: string;
  /** @format int32 */
  Size?: number;
  Sort?: string;
}

export interface FeedConversionGetFeedConversionParams {
  /** @format uuid */
  FarmId?: string;
  /** @format date-time */
  From?: string;
  /** @format date-time */
  To?: string;
}

export interface FeedRegistrationsCreateParams {
  /** @format uuid */
  farmId: string;
}

export interface FeedRegistrationsDeleteParams {
  /** @format uuid */
  farmId: string;
  /** @format uuid */
  registrationId: string;
}

export interface FeedRegistrationsGetParams {
  /** @format date */
  EndDate?: string;
  LocationIds?: string[];
  /** @format int32 */
  Page?: number;
  /** @format int32 */
  Size?: number;
  /** @format date */
  StartDate?: string;
  /** @format uuid */
  farmId: string;
}

export interface FeedRegistrationsUpdateParams {
  /** @format uuid */
  farmId: string;
  /** @format uuid */
  registrationId: string;
}

export interface FeedSilosCreateBatchParams {
  /** @format uuid */
  farmId: string;
  /** @format uuid */
  siloId: string;
}

export interface FeedSilosCreateParams {
  /** @format uuid */
  farmId: string;
}

export interface FeedSilosDeleteBatchParams {
  /** @format uuid */
  batchId: string;
  /** @format uuid */
  farmId: string;
  /** @format uuid */
  siloId: string;
}

export interface FeedSilosDeleteParams {
  /** @format uuid */
  farmId: string;
  /** @format uuid */
  siloId: string;
}

export interface FeedSilosGetBatchesParams {
  /** @format date */
  EndDate?: string;
  /** @format int32 */
  Page?: number;
  /** @format int32 */
  Size?: number;
  /** @format date */
  StartDate?: string;
  /** @format uuid */
  farmId: string;
  /** @format uuid */
  siloId: string;
}

export interface FeedSilosGetByFarmParams {
  /** @format uuid */
  farmId: string;
}

export interface FeedSilosUpdateBatchParams {
  /** @format uuid */
  batchId: string;
  /** @format uuid */
  farmId: string;
  /** @format uuid */
  siloId: string;
}

export interface FeedSilosUpdateParams {
  /** @format uuid */
  farmId: string;
  /** @format uuid */
  siloId: string;
}

export interface FeedSupplierGetFeedSuppliersParams {
  Address?: string;
  Country?: string;
  Name?: string;
  /** @format int32 */
  Page?: number;
  RegistrationNumber?: string;
  /** @format int32 */
  Size?: number;
  Sort?: string;
}

export interface FeedSuppliersDeleteParams {
  /** @format uuid */
  id: string;
}

export interface FeedSuppliersGetAllParams {
  /** @format int32 */
  Page?: number;
  SearchTerm?: string;
  /** @format int32 */
  Size?: number;
}

export interface FeedSuppliersUpdateParams {
  /** @format uuid */
  id: string;
}

export interface HSAPIHostingApiResponseApiError {
  code?: string | null;
  details?: Record<string, any> | null;
  message?: string | null;
}

export interface HSAPIHostingApiResponseApiErrorResult {
  errors: HSAPIHostingApiResponseApiError[];
}

export interface HealthSystemAPIControllersAnimalsRequestsAnimalParentNumbersRequest {
  /**
   * Which column's menu is being opened: Mother for the sow, Father for the boar.
   * @example "Mother"
   */
  parentSide: string;
  /** What was typed in the menu's search box. Optional; matched anywhere in the number, ignoring case. */
  search?: string | null;
  searchQuery: HealthSystemDomainAnimalsResultAnimalsSearchRequest;
  /**
   * How many values to return, 200 when not given and at most 1000.
   * @format int32
   */
  take?: number | null;
}

export interface HealthSystemAPIControllersAnimalsRequestsBatchUpdateAnimalFosterMotherRequest {
  animalChipNumbers: string[];
  fosterMotherChipNumber: string;
}

export interface HealthSystemAPIControllersAnimalsRequestsBatchUpdateAnimalItemModel {
  /**
   * Available values: Birthed, Weaned, TenWeeks
   * @example "Birthed"
   */
  milestone?: string | null;
  number: string;
  weight: HealthSystemDomainAnimalsModelsWeightWithDateModel;
}

export interface HealthSystemAPIControllersAnimalsRequestsBatchUpdateRequest {
  animals: HealthSystemAPIControllersAnimalsRequestsBatchUpdateAnimalItemModel[];
  /** @format uuid */
  locationId?: string | null;
}

export interface HealthSystemAPIControllersAnimalsRequestsCreateAnimalExternalIdentifierRequest {
  /** Name/Type of the external identifier */
  name: string;
  /**
   * What kind of identifier this is (PlasticNumber, Tattoo, Rfid, ...).
   * Defaults to Other when omitted.
   * @example "PlasticNumber"
   */
  type?: string | null;
  /**
   * Optional value for the external identifier
   * If not provided, will be auto-generated
   */
  value?: string | null;
}

export interface HealthSystemAPIControllersAnimalsRequestsCreateAnimalObservationRequest {
  /**
   * What is being registered: GeneticFailure, Biter or BiteVictim.
   * @example "GeneticFailure"
   */
  category: string;
  /** Optional free-text remark. */
  comment?: string | null;
  /**
   * The specific defect. Only accepted when the category is GeneticFailure, and optional even
   * then - a farmer may register a genetic failure without naming which one.
   * @example "BornDefect"
   */
  geneticFailure?: string | null;
  /**
   * The defect as typed by the farmer. Required when the genetic failure is "Other", and
   * rejected otherwise.
   */
  geneticFailureOther?: string | null;
}

export interface HealthSystemAPIControllersAnimalsRequestsMoveSowWithPigletsRequest {
  /**
   * Location the sow is assigned to, resolved by the app from the scanned pen ear tag.
   * @format uuid
   */
  locationId: string;
  /** Chip number of the sow scanned in the field. */
  sowChipNumber: string;
}

export interface HealthSystemAPIControllersAnimalsResponsesAnimalFeedHistoryItemResponse {
  /**
   * This animal's share, in grams. Fractional - a pen amount rarely divides evenly by the
   * number of animals it was split across.
   * @format double
   */
  allocatedGrams: number;
  /** @format date */
  date: string;
  feedName: string;
  /** @format uuid */
  locationId: string;
  locationNumber: string;
  /**
   * What reached the whole pen, and how many animals it was split across - together these
   * explain HealthSystem.API.Controllers.Animals.Responses.AnimalFeedHistoryItemResponse.AllocatedGrams. Sows and gilts are fed apart from the pen ration, so
   * they are not among them.
   * @format int32
   */
  penAmountGrams: number;
  /** @format int32 */
  pigletCount: number;
  source: string;
  /**
   * The record the share came from, and the supply channel it came through.
   * @format uuid
   */
  sourceId: string;
}

/**
 * One animal's whole feed history, with its share of each pen feeding, whatever supply mechanism
 * delivered it.
 */
export interface HealthSystemAPIControllersAnimalsResponsesAnimalFeedHistoryResponse {
  /** @format uuid */
  animalId: string;
  items: HealthSystemAPIControllersAnimalsResponsesAnimalFeedHistoryItemResponse[];
  /** @format double */
  totalAllocatedGrams: number;
}

export interface HealthSystemAPIControllersAnimalsResponsesAnimalLocationHistoryTimelineResponse {
  isSlaughteredAfterLastExit: boolean;
  locationHistory: HealthSystemDomainAnimalsCommandsLocationHistoryItemViewModel[];
}

export interface HealthSystemAPIControllersAnimalsResponsesAnimalParentNumbersResponse {
  /**
   * Whether any animal in the search has no parent on this side, which decides whether the menu
   * offers its blanks entry.
   */
  hasAnimalsWithoutParent: boolean;
  /**
   * The distinct parent numbers of the whole filtered search, ascending and capped at what the
   * request asked for.
   */
  numbers: string[];
  /**
   * How many distinct numbers the search holds in total, so the menu can report "first N of M"
   * when the cap trimmed the list.
   * @format int32
   */
  totalCount: number;
}

export interface HealthSystemAPIControllersAnimalsResponsesCreateAnimalObservationResponse {
  /** @format uuid */
  animalId: string;
  /**
   * Available values: GeneticFailure, Biter, BiteVictim
   * @example "GeneticFailure"
   */
  category: string;
  /**
   * Available values: BornDefect, InternalBoar, ClosedAnus, TooFewTeats, Other
   * @example "BornDefect"
   */
  geneticFailure: string | null;
  geneticFailureOther: string | null;
  /** @format uuid */
  id: string;
  /** @format date-time */
  registeredAt: string;
}

export interface HealthSystemAPIControllersAnimalsResponsesGetAnimalExternalIdentifiersResponse {
  items: HealthSystemDomainAnimalsModelsAnimalExternalIdentifierViewModel[];
  /** @format int32 */
  totalCount: number;
}

export interface HealthSystemAPIControllersAnimalsResponsesGetAnimalHealthLogsResponse {
  items: HealthSystemDomainAnimalsModelsAnimalHealthLogViewModel[];
  /** @format int32 */
  totalCount: number;
}

export interface HealthSystemAPIControllersAnimalsResponsesGetAnimalObservationOptionsResponse {
  /** The categories, each carrying the defects to nest under it in the dropdown. */
  categories: HealthSystemDomainAnimalsQueriesAnimalObservationCategoryOption[];
}

export interface HealthSystemAPIControllersAnimalsResponsesGetAnimalObservationsResponse {
  items: HealthSystemDomainAnimalsModelsAnimalObservationViewModel[];
  /** @format int32 */
  totalCount: number;
}

export interface HealthSystemAPIControllersAnimalsResponsesMoveSowWithPigletsResponse {
  /** @format uuid */
  locationId: string;
  locationNumber: string;
  /** Piglets that were assigned to the location together with the sow. */
  movedPiglets: HealthSystemAPIControllersAnimalsResponsesMovedPigletResponse[];
  /** Piglets of the same cycle that were left where they are, with the reason why. */
  skippedPiglets: HealthSystemAPIControllersAnimalsResponsesSkippedPigletResponse[];
  /** @format uuid */
  sowId: string;
  sowNumber: string;
}

export interface HealthSystemAPIControllersAnimalsResponsesMovedPigletResponse {
  /** @format uuid */
  id: string;
  number: string;
}

export interface HealthSystemAPIControllersAnimalsResponsesSkippedPigletResponse {
  /** @format uuid */
  id: string;
  number: string;
  reason: string;
}

export interface HealthSystemAPIControllersAuthRequestsAcceptInvitationRequest {
  newPassword: string;
  token: string;
}

export interface HealthSystemAPIControllersAuthRequestsForgotPasswordRequest {
  email: string;
  farmNumber: string;
}

export interface HealthSystemAPIControllersAuthRequestsResetPasswordRequest {
  newPassword: string;
  token: string;
}

export interface HealthSystemAPIControllersAuthResponsesInvitationDetailsResponse {
  email: string;
  /** @format date-time */
  expiresAt: string;
  farmName: string;
  farmNumber: string;
  name: string;
}

export interface HealthSystemAPIControllersDashboardsResponsesAdminPigletRegistrationFarmResponse {
  /**
   * Registrations over the evaluated period carrying a birth weight that came off a scale
   * within the first four days of life.
   * @format int32
   */
  birthWeightMeasuredCount: number;
  /**
   * Registrations over the evaluated period with no such measurement. Together with
   * HealthSystem.API.Controllers.Dashboards.Responses.AdminPigletRegistrationFarmResponse.BirthWeightMeasuredCount this is everything the farm registered.
   * @format int32
   */
  birthWeightMissingCount: number;
  /**
   * HealthSystem.API.Controllers.Dashboards.Responses.AdminPigletRegistrationFarmResponse.BirthWeightMissingCount as a percentage of what the farm registered, rounded
   *             to one decimal - the number the flag is decided on, and the one to put in the tooltip.
   * @format double
   */
  birthWeightMissingPercent: number;
  /**
   * How many of the most recent weeks in a row the farm registered nothing in.
   * @format int32
   */
  consecutiveWeeksWithoutRegistrations: number;
  /**
   * Piglets expected over the evaluated period.
   * @format int32
   */
  expected: number;
  /**
   * Piglets this farm is expected to register in a single week. Zero for a farm whose status is
   * `NotMonitored`, which is exactly why it cannot be judged.
   * @format int32
   */
  expectedPerWeek: number;
  /** @format uuid */
  farmId: string;
  farmName?: string | null;
  /** The farm's UBN. */
  farmNumber: string;
  /**
   * Whether the farm really weighs the piglets it registers: false when more than the
   * configured share of its registrations carry no birth weight that came off a scale.
   */
  measuresBirthWeights: boolean;
  /**
   * How far the period fell short. Zero for a farm that registered more than expected.
   * @format int32
   */
  missingCount: number;
  /**
   * HealthSystem.API.Controllers.Dashboards.Responses.AdminPigletRegistrationFarmResponse.Registered as a percentage of HealthSystem.API.Controllers.Dashboards.Responses.AdminPigletRegistrationFarmResponse.Expected. Can exceed 100.
   * @format double
   */
  percentOfExpected: number;
  /**
   * Piglets registered over the evaluated period.
   * @format int32
   */
  registered: number;
  /**
   * The rule the farm broke, or null when it broke none.
   * @example "NoRegistrations"
   */
  rule?: string | null;
  /**
   * How urgent the broken rule is, or null when the farm broke none.
   * @example "Critical"
   */
  severity?: string | null;
  /**
   * Where this farm stands: `Critical`, `Warning`, `OnTrack` or
   * `NotMonitored`. Always present - a farm that broke no rule is reported as on track
   * rather than left out of the list.
   * @example "Critical"
   */
  status: string;
  /**
   * The trend line, oldest week first. Unlike the single-farm widget this keeps the weeks the
   * farm registered nothing in: a gap is the shape the reader is looking for.
   */
  weeks: HealthSystemAPIControllersDashboardsResponsesAdminPigletRegistrationWeekResponse[];
  /**
   * The same answer as HealthSystem.API.Controllers.Dashboards.Responses.AdminPigletRegistrationFarmResponse.MeasuresBirthWeights as a state to show and filter on:
   * `OnTrack`, `Behind`, or `NoScale` for a farm that weighed nothing at all.
   * Null for a farm that registered nothing over the period, which had nothing to weigh.
   * @example "OnTrack"
   */
  weighing?: string | null;
}

/**
 * Admin piglet registration overview: counts across every monitored farm, plus the page of farms
 * that broke one of the registration rules.
 */
export interface HealthSystemAPIControllersDashboardsResponsesAdminPigletRegistrationResponse {
  /** Farms that broke a rule and match the filters, worst first. */
  data: HealthSystemAPIControllersDashboardsResponsesAdminPigletRegistrationFarmResponse[];
  /**
   * First day of the earliest week covered by the per-farm weeks.
   * @format date-time
   */
  fromDate: string;
  /**
   * Number of most recent weeks the rules were evaluated over.
   * @format int32
   */
  lookbackWeeks: number;
  /** @format int32 */
  page: number;
  /** @format int32 */
  size: number;
  /**
   * Number of weeks returned per farm in HealthSystem.API.Controllers.Dashboards.Responses.AdminPigletRegistrationFarmResponse.Weeks.
   * @format int32
   */
  sparklineWeeks: number;
  summary: HealthSystemAPIControllersDashboardsResponsesAdminPigletRegistrationSummaryResponse;
  /**
   * Number of farms matching the filters, before paging.
   * @format int64
   */
  total: number;
  /**
   * The share of its registrations a farm may leave without a real birth weight measurement
   * before HealthSystem.API.Controllers.Dashboards.Responses.AdminPigletRegistrationFarmResponse.MeasuresBirthWeights turns false.
   * Sent with the counts because it is tunable: a client that hard-codes it contradicts the flag
   * beside it the first time it is retuned.
   * @format int32
   */
  unmeasuredBirthWeightPercent: number;
}

export interface HealthSystemAPIControllersDashboardsResponsesAdminPigletRegistrationSummaryResponse {
  /**
   * Mean birth weight in grams, weighted by piglet rather than by farm. Not purely a
   * measurement: registering a piglet without a weight stores one derived from its weight
   * category, so precision depends on how consistently the farms weigh piglets. See
   * HealthSystem.API.Controllers.Dashboards.Responses.AdminPigletRegistrationSummaryResponse.WeighedCount for the denominator.
   * @format int32
   */
  averageBirthWeightGrams: number;
  /**
   * Registered piglets with a known weight category - the denominator of the three shares below.
   * @format int32
   */
  classifiedCount: number;
  /** @format int32 */
  criticalCount: number;
  /**
   * Deaths recorded across the monitored farms over the evaluated period, counting per-pen
   * entries by their recorded number of animals.
   * @format int32
   */
  deadCount: number;
  /**
   * Active farms that have an expected weekly volume.
   * @format int32
   */
  farmsMonitored: number;
  /**
   * Monitored farms that broke a rule.
   * @format int32
   */
  farmsNeedingAttention: number;
  /**
   * Active farms with no expected weekly volume configured. They are left out of every other
   * count rather than being reported as farms that registered nothing.
   * @format int32
   */
  farmsNotConfigured: number;
  /**
   * Monitored farms that registered nothing at all in the most recent weeks. A subset of
   * HealthSystem.API.Controllers.Dashboards.Responses.AdminPigletRegistrationSummaryResponse.CriticalCount.
   * @format int32
   */
  farmsNotRegistering: number;
  /**
   * Monitored farms that broke no rule.
   * @format int32
   */
  farmsOnTrack: number;
  /** @format double */
  heavyPercent: number;
  /**
   * Injections given to piglets over the evaluated period, including treatments entered for a
   * whole pen.
   * @format int32
   */
  injectionCount: number;
  /**
   * HealthSystem.API.Controllers.Dashboards.Responses.AdminPigletRegistrationSummaryResponse.InjectionCount as a percentage of HealthSystem.API.Controllers.Dashboards.Responses.AdminPigletRegistrationSummaryResponse.TotalRegistered. Can exceed
   *             100: a piglet can be injected more than once, and an injection can be given to a piglet
   *             registered before the period started.
   * @format double
   */
  injectionsPerRegisteredPercent: number;
  /** @format double */
  lightPercent: number;
  /** @format double */
  mediumPercent: number;
  /**
   * HealthSystem.API.Controllers.Dashboards.Responses.AdminPigletRegistrationSummaryResponse.DeadCount as a percentage of HealthSystem.API.Controllers.Dashboards.Responses.AdminPigletRegistrationSummaryResponse.TotalRegistered. Deaths are counted
   *             in the period they were recorded in, so this is a rate for the period rather than a cohort
   *             mortality.
   * @format double
   */
  mortalityPercent: number;
  /**
   * Piglets the monitored farms were expected to register and did not, summed across the farms
   * that fell short. Farms that registered more than expected do not subtract from it.
   * @format int32
   */
  pigletsUnaccountedFor: number;
  /**
   * Piglets registered across the monitored farms over the evaluated period - the denominator
   * behind HealthSystem.API.Controllers.Dashboards.Responses.AdminPigletRegistrationSummaryResponse.MortalityPercent and HealthSystem.API.Controllers.Dashboards.Responses.AdminPigletRegistrationSummaryResponse.InjectionsPerRegisteredPercent.
   * @format int32
   */
  totalRegistered: number;
  /** @format int32 */
  warningCount: number;
  /**
   * Registered piglets that have a birth weight stored.
   * @format int32
   */
  weighedCount: number;
}

export interface HealthSystemAPIControllersDashboardsResponsesAdminPigletRegistrationWeekResponse {
  /** @format int32 */
  expected: number;
  /** @format int32 */
  registered: number;
  /** @format int32 */
  weekNumber: number;
  /**
   * First day of the week. Carried alongside the week number because the number alone repeats
   * once a period crosses a year boundary.
   * @format date-time
   */
  weekStartDate: string;
  /** @format int32 */
  year: number;
}

/** Piglet registration widget: summary cards plus one entry per week for the chart and its hover. */
export interface HealthSystemAPIControllersDashboardsResponsesPigletRegistrationDashboardResponse {
  /**
   * Mean birth weight in grams. Not purely a measurement: registering a piglet without a weight
   * stores one derived from its weight category, so precision depends on how consistently the
   * farm weighs piglets. See HealthSystem.API.Controllers.Dashboards.Responses.PigletRegistrationDashboardResponse.WeighedCount for the denominator.
   * @format int32
   */
  averageBirthWeightGrams: number;
  /**
   * Registered piglets with a known weight category - the denominator of the three percentages.
   * @format int32
   */
  classifiedCount: number;
  /**
   * Piglets the farm is expected to register in a single week.
   * @format int32
   */
  expectedPerWeek: number;
  /**
   * First day of the earliest week in the period.
   * @format date-time
   */
  fromDate: string;
  /** @format double */
  heavyPercent: number;
  /**
   * False when the farm turned the widget off. The remaining fields are then zero and
   * HealthSystem.API.Controllers.Dashboards.Responses.PigletRegistrationDashboardResponse.Weeks is empty.
   */
  isEnabled: boolean;
  /** @format double */
  lightPercent: number;
  /** @format double */
  mediumPercent: number;
  /**
   * How far the period fell short of HealthSystem.API.Controllers.Dashboards.Responses.PigletRegistrationDashboardResponse.TotalExpected. Zero when the farm met or beat
   * the expectation.
   * @format int32
   */
  missingVsExpected: number;
  /**
   * HealthSystem.API.Controllers.Dashboards.Responses.PigletRegistrationDashboardResponse.TotalRegistered as a percentage of HealthSystem.API.Controllers.Dashboards.Responses.PigletRegistrationDashboardResponse.TotalExpected. Can exceed 100.
   * @format double
   */
  registeredPercentOfExpected: number;
  /**
   * Piglets expected across the whole period.
   * @format int32
   */
  totalExpected: number;
  /**
   * Piglets registered across the whole period.
   * @format int32
   */
  totalRegistered: number;
  /**
   * Weeks that had at least one registration, oldest first. Weeks without registrations are
   * omitted rather than reported as zero.
   */
  weeks: HealthSystemAPIControllersDashboardsResponsesPigletRegistrationWeekResponse[];
  /**
   * Number of weeks the period covers.
   * @format int32
   */
  weeksCount: number;
  /**
   * Registered piglets that have a birth weight stored.
   * @format int32
   */
  weighedCount: number;
}

export interface HealthSystemAPIControllersDashboardsResponsesPigletRegistrationWeekResponse {
  /**
   * Mean birth weight in grams for this week.
   * @format int32
   */
  averageBirthWeightGrams: number;
  /**
   * Piglets of this week with a known weight category.
   * @format int32
   */
  classifiedCount: number;
  /**
   * Piglet deaths recorded in this week, counting per-pen entries by their recorded number of
   * animals.
   * @format int32
   */
  deadCount: number;
  /** @format int32 */
  expected: number;
  /** @format double */
  heavyPercent: number;
  /** @format double */
  lightPercent: number;
  /** @format double */
  mediumPercent: number;
  /**
   * HealthSystem.API.Controllers.Dashboards.Responses.PigletRegistrationWeekResponse.DeadCount as a percentage of HealthSystem.API.Controllers.Dashboards.Responses.PigletRegistrationWeekResponse.Registered.
   * @format double
   */
  mortalityPercent: number;
  /**
   * Piglets born in this week.
   * @format int32
   */
  registered: number;
  /** @format int32 */
  weekNumber: number;
  /**
   * First day of the week. Carried alongside the week number because the number alone repeats
   * once a period crosses a year boundary.
   * @format date-time
   */
  weekStartDate: string;
  /**
   * Piglets of this week that have a birth weight stored.
   * @format int32
   */
  weighedCount: number;
  /** @format int32 */
  year: number;
}

/**
 * The two thresholds that split a milestone's weights into three bands, in grams. Below
 * HealthSystem.API.Controllers.Dashboards.Responses.WeightBandsResponse.MediumFromGrams is low, above HealthSystem.API.Controllers.Dashboards.Responses.WeightBandsResponse.MediumToGrams is high, and both
 * thresholds themselves are medium.
 */
export interface HealthSystemAPIControllersDashboardsResponsesWeightBandsResponse {
  /** @format int32 */
  mediumFromGrams: number;
  /** @format int32 */
  mediumToGrams: number;
}

/** Weight milestone chart: one series per milestone, each with one entry per week of the period. */
export interface HealthSystemAPIControllersDashboardsResponsesWeightMilestoneDashboardResponse {
  /**
   * First day of the earliest week in the period.
   * @format date-time
   */
  fromDate: string;
  series: HealthSystemAPIControllersDashboardsResponsesWeightMilestoneSeriesResponse[];
  /**
   * Number of weeks the period covers.
   * @format int32
   */
  weeksCount: number;
}

/**
 * One milestone's weights across the period, twice over: as the farm registered them, and with
 * every reading projected back to the milestone's own day.
 */
export interface HealthSystemAPIControllersDashboardsResponsesWeightMilestoneSeriesResponse {
  /**
   * Mean weight in grams as registered across the period. Null rather than zero when nothing was
   * measured, so that no measurements cannot be read as an average of zero.
   * @format int32
   */
  averageGrams?: number | null;
  /**
   * The two thresholds that split a milestone's weights into three bands, in grams. Below
   * HealthSystem.API.Controllers.Dashboards.Responses.WeightBandsResponse.MediumFromGrams is low, above HealthSystem.API.Controllers.Dashboards.Responses.WeightBandsResponse.MediumToGrams is high, and both
   * thresholds themselves are medium.
   */
  bands: HealthSystemAPIControllersDashboardsResponsesWeightBandsResponse;
  /**
   * Mean weight in grams across the period after projecting every reading back to the day of
   * birth. Null rather than zero when nothing was measured.
   * @format int32
   */
  calculatedAverageGrams?: number | null;
  /**
   * Back-calculated weights above HealthSystem.API.Controllers.Dashboards.Responses.WeightBandsResponse.MediumToGrams.
   * @format int32
   */
  calculatedHighCount: number;
  /**
   * Back-calculated weights below HealthSystem.API.Controllers.Dashboards.Responses.WeightBandsResponse.MediumFromGrams.
   * @format int32
   */
  calculatedLowCount: number;
  /**
   * Back-calculated weights between the two thresholds, both ends included.
   * @format int32
   */
  calculatedMediumCount: number;
  /**
   * Measurements above HealthSystem.API.Controllers.Dashboards.Responses.WeightBandsResponse.MediumToGrams.
   * @format int32
   */
  highCount: number;
  /**
   * Measurements below HealthSystem.API.Controllers.Dashboards.Responses.WeightBandsResponse.MediumFromGrams.
   * @format int32
   */
  lowCount: number;
  /**
   * Piglets born in the period that were really weighed at birth - the sum of the three band
   * counts.
   * @format int32
   */
  measuredCount: number;
  /**
   * Measurements between the two thresholds, both ends included.
   * @format int32
   */
  mediumCount: number;
  /**
   * Available values: Birthed, Weaned, TenWeeks
   * @example "Birthed"
   */
  milestone: string;
  /** One entry per week of the period, oldest first, including the weeks nothing was weighed in. */
  weeks: HealthSystemAPIControllersDashboardsResponsesWeightMilestoneWeekResponse[];
}

export interface HealthSystemAPIControllersDashboardsResponsesWeightMilestoneWeekResponse {
  /**
   * Mean weight in grams as registered this week, or null when none of its piglets was weighed.
   * @format int32
   */
  averageGrams?: number | null;
  /**
   * Mean weight in grams for this week after projecting each of its readings back to the day of
   * birth, or null when none of its piglets was weighed. Belongs on the same week's bar as
   * HealthSystem.API.Controllers.Dashboards.Responses.WeightMilestoneWeekResponse.AverageGrams, and is the lower of the two by the growth the piglet had already
   * put on before somebody reached for the scale.
   * @format int32
   */
  calculatedAverageGrams?: number | null;
  /**
   * Back-calculated weights of this week above HealthSystem.API.Controllers.Dashboards.Responses.WeightBandsResponse.MediumToGrams.
   * @format int32
   */
  calculatedHighCount: number;
  /**
   * Back-calculated weights of this week below HealthSystem.API.Controllers.Dashboards.Responses.WeightBandsResponse.MediumFromGrams.
   * @format int32
   */
  calculatedLowCount: number;
  /**
   * Back-calculated weights of this week between the two thresholds, both ends included.
   * @format int32
   */
  calculatedMediumCount: number;
  /**
   * Measurements of this week above HealthSystem.API.Controllers.Dashboards.Responses.WeightBandsResponse.MediumToGrams.
   * @format int32
   */
  highCount: number;
  /**
   * Measurements of this week below HealthSystem.API.Controllers.Dashboards.Responses.WeightBandsResponse.MediumFromGrams.
   * @format int32
   */
  lowCount: number;
  /**
   * Piglets born in this week that were really weighed at birth - the sum of the three band
   * counts. The week is the birth week, not the day the scale reading was taken, so this series
   * can be read beside the piglet registration widget.
   * @format int32
   */
  measuredCount: number;
  /**
   * Measurements of this week between the two thresholds, both ends included.
   * @format int32
   */
  mediumCount: number;
  /** @format int32 */
  weekNumber: number;
  /**
   * First day of the week. Carried alongside the week number because the number alone repeats
   * once a period crosses a year boundary.
   * @format date-time
   */
  weekStartDate: string;
  /** @format int32 */
  year: number;
}

export interface HealthSystemAPIControllersDataImportResponsesSlaughterImportHistoryResponse {
  /** List of import history items. */
  items: HealthSystemDomainDataImportResultSlaughterImportHistoryItemDto[];
  /**
   * Total number of items across all pages.
   * @format int32
   */
  totalCount: number;
}

export interface HealthSystemAPIControllersDeviceDailyReportsResponsesCreateDeviceDailyReportResponse {
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  farmId: string;
  /** @format uuid */
  id: string;
}

export interface HealthSystemAPIControllersDeviceDailyReportsResponsesDeviceDailyReportResponse {
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  farmId: string;
  /** @format uuid */
  id: string;
  /** The report exactly as the device uploaded it. */
  payload: any;
  /** @format date-time */
  updatedAt: string;
}

/** Request model for connecting a HealthInjector device to a farm */
export interface HealthSystemAPIControllersDeviceRequestsConnectHealthInjectorRequest {
  /** MAC address of the HealthInjector device */
  macAddress: string;
  metadata: HealthSystemDomainHealthInjectorsCommandsConnectHealthInjectorMetadataDto;
  /** Optional notes about the connection */
  notes?: string | null;
  version: HealthSystemDALModelHealthInjectorsHealthInjectorVersion;
}

export interface HealthSystemAPIControllersDeviceRequestsExportReaderActionsRequest {
  /**
   * Columns to include in the export. If empty, all columns are exported.
   * Valid values: Number, HookId, DateTime, FarmId, Farm, Weight, TradingClass,
   * BaconCutlet, Fat, LeanMeat, Belly, Ham, Spine, Shoulder, Money, EventMessage, Slaughterhouse
   */
  columns: string[];
  /** @format date-time */
  dateFrom: string;
  /** @format date-time */
  dateTo: string;
  detailsMessage?: string | null;
  excludeZeroHooks: boolean;
  excludeZeroNumbers: boolean;
  /** @format uuid */
  farmId?: string | null;
  hook?: string | null;
  id?: string | null;
  number?: string | null;
  slaughterhouseIds: string[];
}

export interface HealthSystemAPIControllersDeviceRequestsPostDeviceSyncStatusRequest {
  /**
   * Error identifier to the number of animals that hit it, for example
   * `{ "NETWORK_TIMEOUT": 12 }`. Keys are defined by the mobile app.
   */
  errors?: Record<string, number> | null;
  /** MAC address of the health injector this phone is paired with. */
  macAddress: string;
  /**
   * Animals still queued on the device, not yet sent.
   * @format int32
   */
  pendingCount: number;
  /**
   * When the device took this snapshot of its queue.
   * @format date-time
   */
  reportedAt: string;
  /**
   * Animals the device has successfully sent.
   * @format int32
   */
  sentCount: number;
}

export interface HealthSystemAPIControllersDeviceRequestsPostReaderHeartbeatRequest {
  firmwareVersion?: string | null;
  macAddress: string;
  metrics?: Record<string, any> | null;
  /** @format date-time */
  timestamp: string;
}

export interface HealthSystemAPIControllersDeviceRequestsUpdateDeviceFirmwareDescriptionRequest {
  /** Short description shown collapsed on the firmware page. */
  info: string;
  /** Full release log in markdown. Null or empty clears it. */
  releaseNotes?: string | null;
}

export interface HealthSystemAPIControllersDeviceResponsesDeviceFirmwareDescriptionResponse {
  /** @format uuid */
  id: string;
  info?: string | null;
  releaseNotes?: string | null;
}

export interface HealthSystemAPIControllersDeviceResponsesDeviceSyncStatusItemResponse {
  /**
   * Error identifier to the number of animals that hit it, as the device reported it. Keys belong to the
   * mobile app's vocabulary; render them as opaque labels.
   */
  errors?: Record<string, number> | null;
  /**
   * Null when the reported MAC address matches no registered health injector.
   * @format uuid
   */
  healthInjectorId?: string | null;
  /**
   * Id of the latest report, not of the device - devices are identified by MAC address.
   * @format uuid
   */
  id: string;
  /** False when the reporting phone named a MAC that never completed a connect. */
  injectorMatched: boolean;
  macAddress: string;
  /**
   * Animals still queued on the device.
   * @format int32
   */
  pendingCount: number;
  /**
   * Start of the unbroken run of reports in which this device has had something queued. Null when the
   * latest report is drained, and bounded by the `historyDays` window - a value at that edge means
   * "at least this long".
   * @format date-time
   */
  pendingSince?: string | null;
  /**
   * When the backend received it. Diverges from HealthSystem.API.Controllers.Device.Responses.DeviceSyncStatusItemResponse.ReportedAt under device clock drift.
   * @format date-time
   */
  receivedAt: string;
  /**
   * When the device took the snapshot, on the device's own clock.
   * @format date-time
   */
  reportedAt: string;
  /**
   * Animals the device has successfully sent, as counted by the device itself.
   * @format int32
   */
  sentCount: number;
}

/** What a farm's mobile devices have not sent yet, taken from the latest report each one filed. */
export interface HealthSystemAPIControllersDeviceResponsesDeviceSyncStatusOverviewResponse {
  /**
   * Devices that have ever reported for this farm.
   * @format int32
   */
  deviceCount: number;
  /** The counts above always cover every device; this list honours `pendingOnly`. */
  devices: HealthSystemAPIControllersDeviceResponsesDeviceSyncStatusItemResponse[];
  /**
   * Devices whose latest report carried at least one error entry.
   * @format int32
   */
  failingDeviceCount: number;
  /** @format uuid */
  farmId: string;
  /**
   * Devices whose latest report still carried a pending queue.
   * @format int32
   */
  pendingDeviceCount: number;
  /**
   * Animals still queued across every device that has reported for this farm.
   * @format int32
   */
  totalPendingCount: number;
}

export interface HealthSystemAPIControllersDeviceResponsesDeviceSyncStatusResponse {
  /** @format uuid */
  farmId: string;
  /**
   * Null when the reported MAC address matched no registered health injector.
   * @format uuid
   */
  healthInjectorId?: string | null;
  /** @format uuid */
  id: string;
  /**
   * Whether the reported MAC address resolved to a registered health injector. The report is
   * stored either way.
   */
  injectorMatched: boolean;
  /** @format date-time */
  reportedAt: string;
}

/** Response model containing paginated HealthInjector activities */
export interface HealthSystemAPIControllersDeviceResponsesHealthInjectorActivitiesResponse {
  /** List of activities for the current page */
  activities: HealthSystemAPIControllersDeviceResponsesHealthInjectorActivityResponse[];
  /**
   * Total number of activities matching the filter
   * @format int32
   */
  totalCount: number;
}

/** Response model representing a single HealthInjector activity event */
export interface HealthSystemAPIControllersDeviceResponsesHealthInjectorActivityResponse {
  /**
   * Timestamp when the activity occurred
   * @format date-time
   */
  activityTimestamp: string;
  /**
   * Type of activity (e.g., "MobileConnection", "FarmChanged")
   * @example "DeviceRegistered"
   */
  activityType: string;
  /**
   * ID of the farm after this activity (if applicable)
   * @format uuid
   */
  farmId?: string | null;
  /** Name of the farm after this activity */
  farmName?: string | null;
  /**
   * Unique identifier of the activity
   * @format uuid
   */
  id: string;
  metadata: HealthSystemDomainHealthInjectorsDtosHealthInjectorActivityMetadataDto;
  /** Additional notes or comments about the activity */
  notes?: string | null;
  /**
   * ID of the user who performed the activity
   * @format uuid
   */
  performedByUserId?: string | null;
  /** Name of the user who performed the activity */
  performedByUserName?: string | null;
  /**
   * ID of the previous farm before this activity (for farm changes)
   * @format uuid
   */
  previousFarmId?: string | null;
  /** Name of the previous farm before this activity */
  previousFarmName?: string | null;
}

/** Response model for a HealthInjector connection result */
export interface HealthSystemAPIControllersDeviceResponsesHealthInjectorConnectionResponse {
  /**
   * Timestamp when the connection was recorded
   * @format date-time
   */
  connectedAt: string;
  /** Indicates if the farm was changed during this connection */
  farmChanged: boolean;
  /** MAC address of the device */
  macAddress: string;
}

/** Response model containing detailed HealthInjector information */
export interface HealthSystemAPIControllersDeviceResponsesHealthInjectorDetailsResponse {
  /** Optional comment or description */
  comment?: string | null;
  /**
   * Timestamp when the device was registered
   * @format date-time
   */
  createdAt: string;
  /**
   * ID of the farm the device is currently associated with
   * @format uuid
   */
  currentFarmId?: string | null;
  /** Name of the farm the device is currently associated with */
  currentFarmName?: string | null;
  /** Number of the farm the device is currently associated with */
  currentFarmNumber?: string | null;
  /** Indicates if the device is disabled */
  disabled: boolean;
  /** Indicates if the device has reported errors */
  hasErrors: boolean;
  /**
   * Unique identifier of the HealthInjector
   * @format uuid
   */
  id: string;
  /**
   * Timestamp of the last connection from this device
   * @format date-time
   */
  lastConnectionAt?: string | null;
  /** MAC address of the device */
  macAddress?: string | null;
  manufacturer: HealthSystemDomainHealthInjectorsDtosHealthInjectorManufacturerDto;
  /**
   * Timestamp when the device was last updated
   * @format date-time
   */
  updatedAt?: string | null;
  version: HealthSystemDALModelHealthInjectorsHealthInjectorVersion;
}

/** Response containing paginated AppEventLog entries linked to a HealthInjector */
export interface HealthSystemAPIControllersDeviceResponsesHealthInjectorEventsResponse {
  /** List of events */
  events: HealthSystemDomainHealthInjectorsDtosAppEventLogDto[];
  /**
   * Total number of events matching the query
   * @format int32
   */
  totalCount: number;
}

export interface HealthSystemAPIControllersDocumentsRequestsExportAnimalsByChipNumbersRequest {
  chipNumbers: string[];
  /**
   * Combined weight of all animals matched by HealthSystem.API.Controllers.Documents.Requests.ExportAnimalsByChipNumbersRequest.ChipNumbers. When provided, it gets evenly
   * divided across the matched animals and saved as each animal's new weight. Omit to export without
   * touching animal weights.
   * @format double
   */
  totalWeight?: number | null;
  unit: HealthSystemDALEnumsWeightType;
}

export interface HealthSystemAPIControllersDocumentsRequestsExportLivestockBalanceCardRequest {
  /**
   * End of the period (inclusive). Animals are selected by date of birth.
   * @format date-time
   */
  endDate: string;
  /**
   * Start of the period (inclusive). Animals are selected by date of birth.
   * @format date-time
   */
  startDate: string;
}

export interface HealthSystemAPIControllersFarmConfigurationProvidersRequestsUpsertFarmConfigurationProviderRequest {
  settings: any;
}

export interface HealthSystemAPIControllersFarmConfigurationProvidersResponsesFarmConfigurationProviderResponse {
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  id: string;
  isEnabled: boolean;
  providerType: string;
  settings: any;
  /** @format date-time */
  updatedAt: string;
}

export interface HealthSystemAPIControllersFeedResponsesGetFeedConversionResponse {
  gestationFeed: HealthSystemDomainFeedFeedConversionsModelsGestationFeedModel;
  lactationFeed: HealthSystemDomainFeedFeedConversionsModelsLactationFeedModel;
  nurseryFeed: HealthSystemDomainFeedFeedConversionsModelsNurseryFeedModel;
  summary: HealthSystemDomainFeedFeedConversionsModelsSummaryFeedConversionModel;
}

export interface HealthSystemAPIControllersFeedSupplyRequestsCreateFeedBatchRequest {
  /** @format double */
  co2ePerKg?: number | null;
  /** @format date */
  deliveryDate: string;
  /** @format uuid */
  feedSupplierId?: string | null;
  /**
   * Available values: Gestation, Lactation, Nursery, Fattening, Other
   * @example "Gestation"
   */
  feedType: string;
  /** @format double */
  quantityKg: number;
  transportDocRef?: string | null;
}

export interface HealthSystemAPIControllersFeedSupplyRequestsCreateFeedRegistrationRequest {
  /**
   * The amount fed, in grams. It applies to each location in HealthSystem.API.Controllers.FeedSupply.Requests.CreateFeedRegistrationRequest.LocationIds.
   * @format int32
   */
  amountGrams: number;
  /**
   * The day the feed was handed out. Today or a past day.
   * @format date
   */
  date: string;
  /** Free text typed by the farmer — hand-fed feed has no silo and no registry entry behind it. */
  feedName: string;
  /** The locations the registration applies to: a whole room, a row, or individual pens. */
  locationIds: string[];
}

export interface HealthSystemAPIControllersFeedSupplyRequestsCreateFeedSiloRequest {
  locationIds: string[];
  name?: string | null;
  /** @format int32 */
  siloNumber: number;
}

export interface HealthSystemAPIControllersFeedSupplyRequestsCreateFeedSupplierRequest {
  companyName: string;
  contact: HealthSystemDomainValueObjectsContactDto;
  invoicingAddress: HealthSystemDomainValueObjectsAddressDto;
  legalBusinessRegistration?: string | null;
  physicalAddress: HealthSystemDomainValueObjectsAddressDto;
  registrationNumber?: string | null;
  website?: string | null;
}

export interface HealthSystemAPIControllersFeedSupplyRequestsUpdateFeedBatchRequest {
  /** @format double */
  co2ePerKg?: number | null;
  /** @format date */
  deliveryDate?: string | null;
  /** @format uuid */
  feedSupplierId?: string | null;
  /**
   * Available values: Gestation, Lactation, Nursery, Fattening, Other
   * @example "Gestation"
   */
  feedType?: string | null;
  /** @format double */
  quantityKg?: number | null;
  transportDocRef?: string | null;
}

export interface HealthSystemAPIControllersFeedSupplyRequestsUpdateFeedRegistrationRequest {
  /** @format int32 */
  amountGrams?: number | null;
  /** @format date */
  date?: string | null;
  feedName?: string | null;
}

export interface HealthSystemAPIControllersFeedSupplyRequestsUpdateFeedSiloRequest {
  isActive?: boolean | null;
  locationIds?: string[] | null;
  name?: string | null;
  /** @format int32 */
  siloNumber?: number | null;
}

export interface HealthSystemAPIControllersFeedSupplyRequestsUpdateFeedSupplierRequest {
  companyName?: string | null;
  contact: HealthSystemDomainValueObjectsContactDto;
  invoicingAddress: HealthSystemDomainValueObjectsAddressDto;
  legalBusinessRegistration?: string | null;
  physicalAddress: HealthSystemDomainValueObjectsAddressDto;
  registrationNumber?: string | null;
  website?: string | null;
}

export interface HealthSystemAPIControllersFeedSupplyResponsesFeedRegistrationResponse {
  /** @format int32 */
  amountGrams: number;
  /** @format date-time */
  createdAt: string;
  /** @format date */
  date: string;
  /** @format uuid */
  farmId: string;
  feedName: string;
  /** @format uuid */
  id: string;
  /** @format uuid */
  locationId: string;
  locationNumber: string;
  /** @format date-time */
  updatedAt: string;
}

export interface HealthSystemAPIControllersFeedSupplyResponsesFeedRegistrationsPageResponse {
  items: HealthSystemAPIControllersFeedSupplyResponsesFeedRegistrationResponse[];
  /** @format int32 */
  pageIndex: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
}

export interface HealthSystemAPIControllersFeedSupplyResponsesFeedSiloResponse {
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  farmId: string;
  /** @format uuid */
  id: string;
  isActive: boolean;
  locations: HealthSystemAPIControllersFeedSupplyResponsesSiloLocationResponse[];
  name?: string | null;
  /** @format int32 */
  siloNumber: number;
  /** @format date-time */
  updatedAt: string;
}

export interface HealthSystemAPIControllersFeedSupplyResponsesSiloLocationResponse {
  /** @format uuid */
  locationId: string;
  locationNumber?: string | null;
  stableType: HealthSystemDALEnumsLocationStableType;
}

export interface HealthSystemAPIControllersInjectionsRequestsCreateLocationOralFeedInjectionRequest {
  /**
   * Dose of the medication
   * @format double
   */
  dose: number;
  /**
   * Farm Medication supply ID
   * @format uuid
   */
  farmMedicationSupplyId: string;
  /**
   * Number of days for which the medication should be repeated
   * @format int32
   */
  repeatDays: number;
}

export interface HealthSystemAPIControllersInjectionsRequestsCreateLocationVaccinationInjectionRequest {
  /**
   * Dose of the vaccination
   * @format double
   */
  dose: number;
  /**
   * Farm Medication supply ID
   * @format uuid
   */
  farmMedicationSupplyId: string;
  /**
   * Number of days for which the vaccination should be repeated
   * @format int32
   */
  repeatDays: number;
}

export interface HealthSystemAPIControllersInjectionsResponsesCreateLocationOralFeedInjectionResponse {
  /** Created injections IDs */
  injectionsCreated: string[];
}

export interface HealthSystemAPIControllersInjectionsResponsesCreateLocationVaccinationInjectionResponse {
  /** Created injections IDs */
  injectionsCreated: string[];
}

export interface HealthSystemAPIControllersInjectionsResponsesInjectionHistoryAgeTrendDataResponse {
  trendData: HealthSystemDomainInjectionsResultAnimalAgeTrendDataInfo[];
}

export interface HealthSystemAPIControllersInjectionsResponsesInjectionHistoryLocationStrategyResponse {
  /** @format uuid */
  locationId: string;
  supplyInfo: HealthSystemDomainInjectionsResultSupplyInfo[];
  trendData: HealthSystemDomainInjectionsResultTrendDataInfo[];
  /** @format int32 */
  year: number;
}

/** A page of one job's run history. */
export interface HealthSystemAPIControllersJobsResponsesGetJobRunHistoryResponse {
  items: HealthSystemDomainJobsResultJobRunSummaryViewModel[];
  /** @format int32 */
  totalCount: number;
}

/** One run, with what it reported. */
export interface HealthSystemAPIControllersJobsResponsesGetJobRunResponse {
  errorDetail?: string | null;
  result: HealthSystemDomainJobsResultJobReportViewModel;
  run: HealthSystemDomainJobsResultJobRunSummaryViewModel;
  traceId?: string | null;
}

/** Every job that has ever run, with its most recent run. */
export interface HealthSystemAPIControllersJobsResponsesGetJobsOverviewResponse {
  jobs: HealthSystemDomainJobsResultJobRunSummaryViewModel[];
}

export interface HealthSystemAPIControllersLocationsResponsesLocationHistoryResponse {
  dateGroups: HealthSystemDomainLocationsCommandsLocationHistoryDateGroupViewModel[];
  location: HealthSystemDomainLocationsResultLocationViewModel;
}

export interface HealthSystemAPIControllersMedicalSuppliesRequestsUpdateMedicalSupplyBottleRequest {
  animalType: HealthSystemDALEnumsAnimalType;
  /** @format double */
  ccPerDose?: number | null;
  /** @format int32 */
  daysToUse: number;
  /** @format double */
  dosePerAnimal?: number | null;
  /** @format double */
  incrementStep: number;
  /** @format double */
  kgPerOneCC?: number | null;
  lotNumber: string;
  /** @format double */
  maxVolumeCC: number;
  /** @format double */
  minVolumeCC: number;
  /** @format int32 */
  size: number;
  /** @format double */
  startVolume: number;
  treatmentNumber?: string | null;
}

export interface HealthSystemAPIControllersMedicalSuppliesRequestsUpdateMedicalSupplyRequest {
  method: HealthSystemDALEnumsMedicalSupplyMethod;
  producer: string;
  registrationNumber?: string | null;
  supplyType: HealthSystemDALEnumsMedicalSupplyType;
  /** @format int32 */
  waitingTime: number;
}

export interface HealthSystemAPIControllersMedicalSuppliesResponsesMedicationMatrixResponse {
  supplies: HealthSystemDomainMedicalSuppliesResultMedicationMatrixSupplyViewModel[];
}

export interface HealthSystemAPIControllersMedicationsRequestsImportMedicationPackRequest {
  atcCodes?: string | null;
  /** `UDA`, `UDD`, `URA`, `VRIJ` or `NR`. */
  channelling?: string | null;
  dosageForm?: string | null;
  eanCode?: string | null;
  /**
   * The register's own key for the pack.
   * @format int64
   */
  internalCode: number;
  /** The register's full name, untruncated. */
  officialName: string;
  packaging?: string | null;
  /** @format double */
  packagingCount?: number | null;
  producer?: string | null;
  productName: string;
  registrationNumber: string;
  /** `Intramuscular`, `Oral`, `Subcutaneous` and so on. */
  route?: string | null;
  /** The NFC product name: ASCII, at most 19 characters. */
  shortName: string;
  /** @format int32 */
  sourceVersion: number;
  /** Active substances. A repeated name carrying no strength is the register's own noise. */
  substances: HealthSystemAPIControllersMedicationsRequestsImportSubstanceRequest[];
  /** Pig meat withdrawal rows only — the caller filters species and tissue. */
  withdrawals: HealthSystemAPIControllersMedicationsRequestsImportWithdrawalRequest[];
}

/** A batch of catalogue packs to load. Packs sharing a short name are one medication. */
export interface HealthSystemAPIControllersMedicationsRequestsImportMedicationsRequest {
  packs: HealthSystemAPIControllersMedicationsRequestsImportMedicationPackRequest[];
  /** Where the batch came from: `Fidin` or `Manual`. */
  source: string;
}

export interface HealthSystemAPIControllersMedicationsRequestsImportSubstanceRequest {
  /**
   * The strength. Zero means the register stated none.
   * @format double
   */
  amount?: number | null;
  /** What the strength is per, e.g. `cc/ml`. */
  dosageForm?: string | null;
  name: string;
  unit?: string | null;
}

export interface HealthSystemAPIControllersMedicationsRequestsImportWithdrawalRequest {
  /**
   * The register's `Doeldier/@id`, read within pigs.
   * @format int32
   */
  animalGroupId: number;
  animalGroupLabel: string;
  /** The register's `complex` marker, where it set one. */
  complexText?: string | null;
  /** The register's `dagen` verbatim; need not be a number. */
  daysRaw?: string | null;
}

export interface HealthSystemAPIControllersSavedComparisonsRequestsCreateSavedComparisonRequest {
  name: string;
  query: any;
}

export interface HealthSystemAPIControllersScheduledReportsRequestsCreateScheduledReportRequest {
  animalTrendDataType: HealthSystemDALEnumsAnimalTrendDataType;
  dayOfWeek: SystemDayOfWeek;
  /**
   * Available values: Weekly, Monthly
   * @example "Weekly"
   */
  frequency: string;
  name?: string | null;
  recipients: string[];
  /**
   * Available values: Last7Days, Last14Days, Last30Days, LastWeek, LastMonth, LastQuarter, MonthToDate, QuarterToDate, YearToDate, CurrentYear, Last2Years, Last5Years
   * @example "Last7Days"
   */
  relativeDateWindow: string;
  sources: HealthSystemDomainReportsResultScheduledReportSourceSnapshot[];
}

export interface HealthSystemAPIControllersScheduledReportsRequestsSetScheduledReportActiveRequest {
  isActive: boolean;
}

export interface HealthSystemAPIControllersScheduledReportsRequestsUpdateScheduledReportRequest {
  animalTrendDataType: HealthSystemDALEnumsAnimalTrendDataType;
  dayOfWeek: SystemDayOfWeek;
  /**
   * Available values: Weekly, Monthly
   * @example "Weekly"
   */
  frequency: string;
  name?: string | null;
  recipients: string[];
  /**
   * Available values: Last7Days, Last14Days, Last30Days, LastWeek, LastMonth, LastQuarter, MonthToDate, QuarterToDate, YearToDate, CurrentYear, Last2Years, Last5Years
   * @example "Last7Days"
   */
  relativeDateWindow: string;
  sources: HealthSystemDomainReportsResultScheduledReportSourceSnapshot[];
}

export interface HealthSystemAPIControllersScheduledReportsResponsesScheduledReportResponse {
  animalTrendDataType: HealthSystemDALEnumsAnimalTrendDataType;
  /** @format date-time */
  createdAt: string;
  dayOfWeek: SystemDayOfWeek;
  /** @format uuid */
  farmId: string;
  /**
   * Available values: Weekly, Monthly
   * @example "Weekly"
   */
  frequency: string;
  /** @format uuid */
  id: string;
  isActive: boolean;
  /** @format date-time */
  lastSentAt?: string | null;
  name: string;
  /** @format date-time */
  nextSendAt?: string | null;
  recipients: string[];
  /**
   * Available values: Last7Days, Last14Days, Last30Days, LastWeek, LastMonth, LastQuarter, MonthToDate, QuarterToDate, YearToDate, CurrentYear, Last2Years, Last5Years
   * @example "Last7Days"
   */
  relativeDateWindow: string;
  sources: HealthSystemDomainReportsResultScheduledReportSourceSnapshot[];
}

export interface HealthSystemAPIControllersScheduledReportsResponsesSendScheduledReportNowResponse {
  /** @format date-time */
  sentAt: string;
}

/** Binds a sensor device to a pen. */
export interface HealthSystemAPIControllersSensorDevicesRequestsAssignSensorDeviceLocationRequest {
  /**
   * The pen the device hangs in.
   * @format uuid
   */
  locationId: string;
  /**
   * `Correction` when the previous binding was wrong - the device's readings move to the new pen
   *             with it. `Relocation` when the device was physically carried elsewhere - its existing readings
   *             stay on the pen they were measured in. Defaults to `Correction`, which is what the arbitrary
   *             binding made on discovery almost always needs.
   */
  reason?: string | null;
}

export interface HealthSystemAPIControllersSensorDevicesResponsesDiscoverSensorDevicesResponse {
  /** @format int32 */
  devicesFound: number;
  /**
   * How many of them were not already known.
   * @format int32
   */
  devicesRegistered: number;
  /**
   * How many devices the farm had that the provider no longer lists. Each was released from its pen
   * and kept, together with its readings - the usual cause is the farm moving to another organization.
   * @format int32
   */
  devicesRetired: number;
  /**
   * How many placeholder pens had to be created because the farm had no free location.
   * @format int32
   */
  locationsCreated: number;
}

export interface HealthSystemAPIControllersSensorDevicesResponsesSensorDeviceResponse {
  /**
   * `IndoorClimate`, `WeatherStation` or `Unknown`. Only an indoor climate device can hold a location.
   * @example "IndoorClimate"
   */
  deviceType: string;
  /** The provider's source tag: `kpn-lora` and `ttn` are climate boxes, `visual-crossing` is an online weather service. */
  externalDomain: string;
  externalId: string;
  /**
   * The device name as it reads at the provider. Free text the farmer typed there, and usually the
   * only clue to which barn the device is in - which is why this endpoint exists.
   */
  externalName: string;
  /** @format uuid */
  id: string;
  /** Whether the provider has stopped reporting this device. See HealthSystem.API.Controllers.SensorDevices.Responses.SensorDeviceResponse.RetiredAt. */
  isRetired: boolean;
  /** @format date-time */
  lastSeenAt?: string | null;
  /** @format uuid */
  locationId?: string | null;
  locationNumber?: string | null;
  locationPen?: string | null;
  locationRoom?: string | null;
  measuredTags: string[];
  /**
   * The service the device was discovered through.
   * @example "Whysor"
   */
  provider: string;
  /**
   * When the provider stopped listing this device, and null while it is still reported.
   * @format date-time
   */
  retiredAt?: string | null;
}

export interface HealthSystemAPIControllersSlaughterhousesRequestsCreateSlaughterhouseRequest {
  address?: string | null;
  code?: string | null;
  contactEmail?: string | null;
  contactPhone?: string | null;
  name: string;
}

export interface HealthSystemAPIControllersSlaughterhousesRequestsGenerateApiKeyRequest {
  /** Optional description for additional context */
  description?: string | null;
  /**
   * Optional expiration date for time-limited keys
   * @format date-time
   */
  expiresAt?: string | null;
  /** Human-readable name for the API key */
  name: string;
}

export interface HealthSystemAPIControllersSlaughterhousesRequestsUpdateApiKeyRequest {
  /** New active status for the API key */
  isActive?: boolean | null;
}

export interface HealthSystemAPIControllersSlaughterhousesRequestsUpdateSlaughterhouseRequest {
  address?: string | null;
  code?: string | null;
  contactEmail?: string | null;
  contactPhone?: string | null;
  isActive?: boolean | null;
  name?: string | null;
}

export interface HealthSystemAPIControllersSlaughterhousesResponsesGenerateSlaughterhouseApiKeyResponse {
  /**
   * The plaintext API key - this is the ONLY time it will be available.
   * Must be securely stored by the client.
   */
  apiKey: string;
  /**
   * The ID of the created API key entity
   * @format uuid
   */
  apiKeyId: string;
  /** Optional description */
  description?: string | null;
  /**
   * When the key expires (if set)
   * @format date-time
   */
  expiresAt?: string | null;
  /** Name of the API key */
  name: string;
}

export interface HealthSystemAPIControllersTaskV1RequestsCreateProductionScheduleRequest {
  dismissCurrentSchedule: boolean;
  /** @format date */
  startDate: string;
  /** @format int32 */
  totalWeeks: number;
}

export interface HealthSystemAPIControllersTaskV1RequestsUpdateTaskOccurrenceRequest {
  /**
   * Full items array with current state (statuses and subtask completion).
   * Client sends back the occurrence data as received from the daily endpoint, with updates applied.
   */
  items: HealthSystemDALModelTaskLibraryTaskPlanTaskOccurrenceItemDto[];
  /**
   * The planned date of the occurrence.
   * @format date
   */
  plannedDate: string;
  /**
   * The schedule this occurrence belongs to.
   * @format uuid
   */
  taskScheduleId: string;
}

export interface HealthSystemAPIControllersTaskV1ResponsesGetAttachmentDownloadUrlResponse {
  url: string;
}

export interface HealthSystemAPIControllersTaskV1ResponsesGetAttachmentUploadUrlResponse {
  blobName: string;
  uploadUrl: string;
}

export interface HealthSystemAPIControllersTaskV1ResponsesProductionScheduleResponse {
  /** @format date-time */
  createdAt: string;
  /** @format date */
  endDate?: string | null;
  /** @format uuid */
  id: string;
  isActive: boolean;
  /** @format date */
  startDate: string;
  /** @format int32 */
  totalWeeks: number;
}

export interface HealthSystemAPIControllersTaskV1ResponsesUpdateTaskOccurrenceResponse {
  /** @format uuid */
  taskOccurrenceId: string;
}

export interface HealthSystemAPIControllersUserAccountsRequestsChangePasswordRequest {
  currentPassword: string;
  newPassword: string;
}

export interface HealthSystemAPIControllersUserAccountsRequestsSendInvitationRequest {
  availability: SystemDayOfWeek[];
  email: string;
  /** @format uuid */
  farmId?: string | null;
  languageIso: string;
  name: string;
  role: string;
  stables: HealthSystemDALEnumsLocationStableType[];
}

/** An invitation link that can be copied and passed to the invited person by hand. */
export interface HealthSystemAPIControllersUserAccountsResponsesInvitationLinkResponse {
  /**
   * Moment this link stops working.
   * @format date-time
   */
  expiresAt: string;
  /** Absolute front-end URL that opens the accept-invitation page. */
  link: string;
}

/** The growth curves and the age limit that governs dosing on them. */
export interface HealthSystemAPIControllersWeightCurvesResponsesWeightCurvesResponse {
  /** One curve per birth weight, lightest first. */
  curves: HealthSystemDomainWeightCurvesResultWeightCurveResult[];
  /**
   * The oldest age, in days, for which a weight may be estimated and a dose handed out. The curves
   * run past it, up to slaughter, so compare an animal's age against this and not against the last
   * point of its curve. Null means no limit is configured and no dose may be estimated at all.
   * @format int32
   */
  maxMedicationAgeInDays?: number | null;
}

export interface HealthSystemAPIControllersWeightDiagnosticRequestsCreateWeightDiagnosticRecordRequest {
  /** @format uuid */
  locationId?: string | null;
  /** @format date-time */
  recordedAt?: string | null;
  weightData: HealthSystemDomainWeightDiagnosticWeightDataModel;
}

export interface HealthSystemCommonExceptionsValidationError {
  code: string;
  details?: string | null;
  message: string;
}

export interface HealthSystemCommonExceptionsValidationResult {
  errors: HealthSystemCommonExceptionsValidationError[];
  isBadRequest: boolean;
}

/** @format int32 */
export type HealthSystemDALEnumsAnimalGender = 0 | 10 | 20;

/** @format int32 */
export type HealthSystemDALEnumsAnimalHealthIndicator = 10 | 20 | 30;

/** @format int32 */
export type HealthSystemDALEnumsAnimalHealthLogType = 0 | 10 | 20 | 300;

/** @format int32 */
export type HealthSystemDALEnumsAnimalTrendDataType =
  | 1
  | 2
  | 3
  | 4
  | 60
  | 61
  | 62
  | 63
  | 64
  | 65
  | 66
  | 67
  | 68
  | 69
  | 70
  | 71
  | 72;

/** @format int32 */
export type HealthSystemDALEnumsAnimalType =
  | 0
  | 10
  | 20
  | 30
  | 40
  | 50
  | 55
  | 60
  | 70;

/** @format int32 */
export type HealthSystemDALEnumsAnimalWeightCategory = 0 | 100 | 200 | 300;

/** @format int32 */
export type HealthSystemDALEnumsBusinessUnitType = 1 | 2;

/** @format int32 */
export type HealthSystemDALEnumsDeviceFirmwareType = 100 | 200 | 300 | 400;

/** @format int32 */
export type HealthSystemDALEnumsEmissionSourceRole = 1 | 2;

/** @format int32 */
export type HealthSystemDALEnumsExportDocumentType = 0 | 10 | 30;

/** @format int32 */
export type HealthSystemDALEnumsFarmSettingsContactType = 100 | 200 | 300;

/** @format int32 */
export type HealthSystemDALEnumsFarmType = 0 | 10 | 20 | 30 | 40 | 50 | 60 | 70;

/** @format int32 */
export type HealthSystemDALEnumsLabelPrintTaskStatus = 0 | 10 | 20 | 50;

/** @format int32 */
export type HealthSystemDALEnumsLocationPosition = 10 | 20;

/** @format int32 */
export type HealthSystemDALEnumsLocationStableType =
  | 0
  | 10
  | 20
  | 30
  | 40
  | 50
  | 60
  | 70
  | 80
  | 90;

/** @format int32 */
export type HealthSystemDALEnumsMedicalSupplyMethod = 0 | 10 | 20;

/** @format int32 */
export type HealthSystemDALEnumsMedicalSupplyOrderStatus = 100 | 200 | 400;

/** @format int32 */
export type HealthSystemDALEnumsMedicalSupplyType =
  | 10
  | 20
  | 30
  | 40
  | 50
  | 100;

/** @format int32 */
export type HealthSystemDALEnumsRuleType = 0 | 1 | 2 | 3;

/** @format int32 */
export type HealthSystemDALEnumsTaskListItemStatus = 10 | 20 | 30;

/** @format int32 */
export type HealthSystemDALEnumsTaskListItemType = 10 | 20 | 30;

/** @format int32 */
export type HealthSystemDALEnumsTaskListStatus = 10 | 20 | 30;

/** @format int32 */
export type HealthSystemDALEnumsTaskPlanItemType = 10 | 20;

/** @format int32 */
export type HealthSystemDALEnumsTemperatureUnit = 0 | 1;

/** @format int32 */
export type HealthSystemDALEnumsUserActionLogType =
  | 0
  | 100
  | 200
  | 201
  | 202
  | 203
  | 300
  | 301
  | 302
  | 303
  | 500;

/** @format int32 */
export type HealthSystemDALEnumsWeightType = 1 | 2;

export interface HealthSystemDALModelAnimalActivity {
  animalNumber?: string | null;
  area: HealthSystemDALModelFloorPlanAreaType;
  detectionMethod: HealthSystemDALModelAreaDetectionMethod;
  /** @format date-span */
  duration?: string | null;
  /** @format date-time */
  from?: string | null;
  /** @format uuid */
  id: string;
}

export interface HealthSystemDALModelAnimalsDataAnimalNipples {
  /** @format int32 */
  additionalLeft: number;
  /** @format int32 */
  additionalRight: number;
  /** @format int32 */
  left: number;
  /** @format int32 */
  right: number;
}

export interface HealthSystemDALModelAnimalsDataAnimalSlaughterhouseData {
  /** @format double */
  baconCutlet?: number | null;
  /** @format double */
  belly?: number | null;
  /** @format double */
  fat?: number | null;
  /** @format double */
  ham?: number | null;
  hookId?: string | null;
  /** @format double */
  leanMeat?: number | null;
  /** @format double */
  money?: number | null;
  problems: string[];
  /** @format double */
  shoulder?: number | null;
  /** @format double */
  spine?: number | null;
  /** @format date-time */
  timestamp?: string | null;
  tradingClass?: string | null;
  /** @format double */
  weight?: number | null;
}

export interface HealthSystemDALModelAnimalsDataAnimalWeight {
  birthed: HealthSystemDALModelDoubleWeightWithDate;
  slaughtered: HealthSystemDALModelDoubleWeightWithDate;
  tenWeeks: HealthSystemDALModelDoubleWeightWithDate;
  weaned: HealthSystemDALModelDoubleWeightWithDate;
  /** @format double */
  weightPerDay?: number | null;
  weights: HealthSystemDALModelDoubleWeightWithDate[];
}

/** @format int32 */
export type HealthSystemDALModelAreaDetectionMethod = 0 | 1 | 2;

export interface HealthSystemDALModelDeviceChipNumberDetails {
  attachedToFarm: boolean;
  /** @format int64 */
  endRange: number;
  /** @format int64 */
  startRange: number;
}

export interface HealthSystemDALModelDeviceReaderActionDetails {
  baconCutlet?: string | null;
  belly?: string | null;
  chipNumber: HealthSystemDALModelDeviceChipNumberDetails;
  farm?: string | null;
  /** @format uuid */
  farmId: string;
  fat?: string | null;
  ham?: string | null;
  /** @format uuid */
  id: string;
  leanMeat?: string | null;
  message?: string | null;
  money?: string | null;
  problems: string[];
  shoulder?: string | null;
  spine?: string | null;
  tradingClass?: string | null;
  weight?: string | null;
}

export interface HealthSystemDALModelDiseasesDiseaseMedicalSupply {
  /** @format int32 */
  daysToTreat: number;
  /** @format double */
  dose: number;
  /** @format uuid */
  medicalSupplyId: string;
  number?: string | null;
}

export interface HealthSystemDALModelDiseasesStableColour {
  colour?: string | null;
  stable: HealthSystemDALEnumsLocationStableType;
}

export interface HealthSystemDALModelDoubleWeightWithDate {
  /** @format date-time */
  date: string;
  unit: HealthSystemDALEnumsWeightType;
  /** @format double */
  value: number;
}

export interface HealthSystemDALModelFarmsBarChartData {
  animalType: HealthSystemDALEnumsAnimalType;
  barChartSupplies: HealthSystemDALModelFarmsBarChartMedicalSupply[];
  isDisabled: boolean;
}

export interface HealthSystemDALModelFarmsBarChartMedicalSupply {
  medicalSupply?: string | null;
  /** @format uuid */
  medicalSupplyId: string;
}

export interface HealthSystemDALModelFarmsFarmSettingsContact {
  email?: string | null;
  info?: string | null;
  isPrimary: boolean;
  name?: string | null;
  phone?: string | null;
  type: HealthSystemDALEnumsFarmSettingsContactType;
}

export interface HealthSystemDALModelFarmsFarmSettingsOptions {
  animalsWorkerEnabled: boolean;
  createTaskListDay: SystemDayOfWeek;
  /** @format double */
  dailyCarryingCostEur?: number | null;
  /** @format int32 */
  daysUntilHoldingMove: number;
  earlyWarningWorkerEnabled: boolean;
  /** @format uuid */
  holdingRoomLocationId?: string | null;
  pigletRegistrationWidgetDisabled: boolean;
  /** @format double */
  pricePerKgEur?: number | null;
  /** @format double */
  targetSlaughterWeightKg?: number | null;
  taskListWorkerEnabled: boolean;
  unweanedPigletHoldingMoveEnabled: boolean;
  /** @format int32 */
  weeksCycle: number;
}

/** @format int32 */
export type HealthSystemDALModelFloorPlanAreaType = 0 | 1 | 2 | 3 | 4 | 5 | 6;

export interface HealthSystemDALModelHealthInjectorsHealthInjectorVersion {
  bluetooth: HealthSystemDALModelHealthInjectorsVersionsBluetoothVersion;
  hardware: HealthSystemDALModelHealthInjectorsVersionsHardwareVersion;
  main: HealthSystemDALModelHealthInjectorsVersionsMainVersion;
  rfid: HealthSystemDALModelHealthInjectorsVersionsRfidVersion;
}

export interface HealthSystemDALModelHealthInjectorsVersionsBluetoothVersion {
  application?: string | null;
  bootloader?: string | null;
  softDevice?: string | null;
}

export interface HealthSystemDALModelHealthInjectorsVersionsHardwareVersion {
  pcb?: string | null;
}

export interface HealthSystemDALModelHealthInjectorsVersionsMainVersion {
  application?: string | null;
  bootloader?: string | null;
  mbr?: string | null;
  releaseType?: string | null;
  suffix?: string | null;
}

export interface HealthSystemDALModelHealthInjectorsVersionsRfidVersion {
  application?: string | null;
}

export interface HealthSystemDALModelLocationsLocationArea {
  /** @format double */
  areaInM: number;
}

export interface HealthSystemDALModelLocationsLocationData {
  pen?: string | null;
  positioning: HealthSystemDALEnumsLocationPosition;
  room?: string | null;
  stable: HealthSystemDALEnumsLocationStableType;
}

export interface HealthSystemDALModelLogAppEventLog {
  application: HealthSystemDALModelLogAppEventLogApplication;
  /** @format date-time */
  dateTime: string;
  /** @format uuid */
  healthInjectorId?: string | null;
  /** @format uuid */
  id: string;
  isAnalyzed: boolean;
  payload: HealthSystemDALModelLogAppEventLogPayload;
  processMessage?: string | null;
  userInfo: HealthSystemDALModelLogAppEventLogUserInfo;
}

export interface HealthSystemDALModelLogAppEventLogApplication {
  languageIso?: string | null;
  type: HealthSystemDALModelLogAppEventLogApplicationType;
  version?: string | null;
}

/** @format int32 */
export type HealthSystemDALModelLogAppEventLogApplicationType =
  | 10
  | 20
  | 30
  | 40
  | 50
  | 60;

export interface HealthSystemDALModelLogAppEventLogPayload {
  action?: string | null;
  additionalInfo?: string | null;
  currentUrl?: string | null;
  isError: boolean;
  message?: string | null;
  stackTrace?: string | null;
}

export interface HealthSystemDALModelLogAppEventLogUser {
  /** @format uuid */
  farmId: string;
  name?: string | null;
  role?: string | null;
  /** @format uuid */
  userId: string;
  /** @format uuid */
  veterinaryId?: string | null;
}

export interface HealthSystemDALModelLogAppEventLogUserInfo {
  injector: HealthSystemDALModelLogInjectorInfo;
  mobile: HealthSystemDALModelLogMobileInfo;
  requestIpAddress?: string | null;
  user: HealthSystemDALModelLogAppEventLogUser;
}

export interface HealthSystemDALModelLogInjectorInfo {
  application?: string | null;
  bluetooth?: string | null;
  bootloader?: string | null;
  macAddress?: string | null;
  name?: string | null;
}

export interface HealthSystemDALModelLogMobileInfo {
  hardwareModel?: string | null;
  operatingSystemVersion?: string | null;
  type: HealthSystemDALModelLogMobileInfoType;
}

/** @format int32 */
export type HealthSystemDALModelLogMobileInfoType = 100 | 200;

export interface HealthSystemDALModelMedicalSuppliesLabelPrintFarm {
  address?: string | null;
  name?: string | null;
  number?: string | null;
}

export interface HealthSystemDALModelMedicalSuppliesLabelPrintOrder {
  orderNumber?: string | null;
}

export interface HealthSystemDALModelMedicalSuppliesLabelPrintSupply {
  animalType: HealthSystemDALEnumsAnimalType;
  /** @format int32 */
  daysToUse: number;
  dose?: string | null;
  incrementStep?: string | null;
  lotNumber?: string | null;
  maxVolumeCC?: string | null;
  /** @format uuid */
  medicalSupplyId: string;
  method: HealthSystemDALEnumsMedicalSupplyMethod;
  minVolumeCC?: string | null;
  number?: string | null;
  overriddenLotNumber?: string | null;
  overriddenTreatmentNumber?: string | null;
  size?: string | null;
  startVolume?: string | null;
  treatmentNumber?: string | null;
  withdrawal?: string | null;
}

export interface HealthSystemDALModelMedicalSuppliesLabelPrintTask {
  /** @format date-time */
  completed?: string | null;
  /** @format date-time */
  created: string;
  farm: HealthSystemDALModelMedicalSuppliesLabelPrintFarm;
  /** @format uuid */
  farmId: string;
  /** @format uuid */
  id: string;
  /** @format uuid */
  medicalSupplyOrderId: string;
  message?: string | null;
  order: HealthSystemDALModelMedicalSuppliesLabelPrintOrder;
  /** @format int32 */
  printedCount: number;
  /** @format int32 */
  requestedCount: number;
  status: HealthSystemDALEnumsLabelPrintTaskStatus;
  supply: HealthSystemDALModelMedicalSuppliesLabelPrintSupply;
  /** @format date-time */
  updated?: string | null;
}

export interface HealthSystemDALModelMedicalSuppliesMedicalSupplyOrderConfirmation {
  /** @format date-time */
  dateTime?: string | null;
  /** @format uuid */
  vetUserId?: string | null;
  vetUserName?: string | null;
  vetUserUda?: string | null;
}

export interface HealthSystemDALModelMedicalSuppliesMedicalSupplyOrderDetails {
  animalsVaccinability: boolean;
  comments?: string | null;
  successTreatment: boolean;
  successVaccination: boolean;
}

export interface HealthSystemDALModelMedicalSuppliesMedicalSupplyOrderItemDetails {
  /** @format int32 */
  animalAmount: number;
  /** @format int32 */
  averageWeight: number;
  diagnosis?: string | null;
  /** @format date-time */
  expire?: string | null;
  recurrentTreatment: boolean;
  symptoms?: string | null;
}

export interface HealthSystemDALModelMedicalSuppliesMedicalSupplyOrderItemLocation {
  /** @format uuid */
  farmId: string;
  /** @format uuid */
  id: string;
  number?: string | null;
  pen?: string | null;
  positioning: HealthSystemDALEnumsLocationPosition;
  room?: string | null;
  stable: HealthSystemDALEnumsLocationStableType;
}

export interface HealthSystemDALModelNotificationRulesEmailSettings {
  userIds: string[];
}

export interface HealthSystemDALModelNotificationRulesValidationPeriodData {
  weeksData: HealthSystemDALModelNotificationRulesWeeksData;
}

/** @format int32 */
export type HealthSystemDALModelNotificationRulesValidationPeriodType =
  | 0
  | 1
  | 2;

export interface HealthSystemDALModelNotificationRulesWeeksData {
  dayOfWeek: SystemDayOfWeek;
  /** @format int32 */
  weekCount: number;
}

export interface HealthSystemDALModelSlaughterPreDeliveriesPigletSupplier {
  address?: string | null;
  country?: string | null;
  name?: string | null;
  ubn?: string | null;
}

export interface HealthSystemDALModelSlaughterPreDeliveriesPreDeliveryFeedSupplier {
  address?: string | null;
  country?: string | null;
  name?: string | null;
  ubn?: string | null;
}

export interface HealthSystemDALModelTaskLibraryTaskPlanTaskListSubtaskDto {
  completed: boolean;
  /** @format double */
  completedDose: number;
  number: string;
}

export interface HealthSystemDALModelTaskLibraryTaskPlanTaskOccurrenceItem {
  /** @format date-time */
  completedAt?: string | null;
  fromTaskLibrary: HealthSystemDALModelTaskLibraryTaskPlanTaskOccurrenceItemTemplate;
  fromVaccinationRule: HealthSystemDALModelTaskLibraryTaskPlanTaskOccurrenceItemVaccination;
  /** @format uuid */
  id: string;
  status: HealthSystemDALEnumsTaskListStatus;
  /** @format uuid */
  taskScheduleItemId: string;
  type: HealthSystemDALEnumsTaskPlanItemType;
}

export interface HealthSystemDALModelTaskLibraryTaskPlanTaskOccurrenceItemDto {
  fromVaccinationRule: HealthSystemDALModelTaskLibraryTaskPlanTaskOccurrenceItemVaccinationDto;
  status: HealthSystemDALEnumsTaskListStatus;
  /** @format uuid */
  taskScheduleItemId: string;
}

export interface HealthSystemDALModelTaskLibraryTaskPlanTaskOccurrenceItemTemplate {
  duration?: string | null;
  durationUnit?: string | null;
  instructions?: string | null;
  name?: string | null;
  scheduled?: string | null;
}

export interface HealthSystemDALModelTaskLibraryTaskPlanTaskOccurrenceItemVaccination {
  animalType: HealthSystemDALEnumsAnimalType;
  /** @format int32 */
  completedCount: number;
  subtasks: HealthSystemDALModelTaskListsTaskListSubtask[];
  /** @format int32 */
  totalCount: number;
  type: HealthSystemDALEnumsTaskListItemType;
}

export interface HealthSystemDALModelTaskLibraryTaskPlanTaskOccurrenceItemVaccinationDto {
  subtasks: HealthSystemDALModelTaskLibraryTaskPlanTaskListSubtaskDto[];
  type: HealthSystemDALEnumsTaskListItemType;
}

/** @format int32 */
export type HealthSystemDALModelTaskLibraryTaskSchedulesTaskLibraryListType =
  | 10
  | 20;

export interface HealthSystemDALModelTaskListsTaskListItem {
  animalType: HealthSystemDALEnumsAnimalType;
  /** @format date-time */
  completedAt?: string | null;
  /** @format int32 */
  completedCount: number;
  /** @format uuid */
  id: string;
  stableType: HealthSystemDALEnumsLocationStableType;
  status: HealthSystemDALEnumsTaskListItemStatus;
  subtasks: HealthSystemDALModelTaskListsTaskListSubtask[];
  /** @format int32 */
  totalCount: number;
  type: HealthSystemDALEnumsTaskListItemType;
}

export interface HealthSystemDALModelTaskListsTaskListSubtask {
  ageDays?: string | null;
  colour?: string | null;
  completed: boolean;
  /** @format double */
  completedDose: number;
  disease?: string | null;
  /** @format double */
  dose?: number | null;
  /** @format uuid */
  healthLogId?: string | null;
  /** @format uuid */
  id: string;
  location?: string | null;
  medicalSupply?: string | null;
  number?: string | null;
}

export interface HealthSystemDALModelVetDriverConfig {
  name: string;
}

export interface HealthSystemDALModelVetPrinterConfig {
  /** @format int32 */
  communicationType: number;
  driver: HealthSystemDALModelVetDriverConfig;
  tcpIp: HealthSystemDALModelVetTcpIpConfig;
  usb: HealthSystemDALModelVetUsbConfig;
}

export interface HealthSystemDALModelVetTcpIpConfig {
  ip: string;
  /** @format int32 */
  port: number;
}

export interface HealthSystemDALModelVetUsbConfig {
  port: string;
}

export interface HealthSystemDALModelVetVeterinarySettings {
  address?: string | null;
  country?: string | null;
  email?: string | null;
  phone?: string | null;
  printerConfig: HealthSystemDALModelVetPrinterConfig;
}

export interface HealthSystemDomainAnimalsCommandsAddAnimalWeightCommand {
  /** @format uuid */
  animalId?: string | null;
  number?: string | null;
  weight: HealthSystemDALModelDoubleWeightWithDate;
}

export interface HealthSystemDomainAnimalsCommandsAnimalsSearchQuery {
  /** @format int32 */
  page: number;
  searchQuery: HealthSystemDomainAnimalsResultAnimalsSearchRequest;
  /** @format int32 */
  size: number;
  sort?: string | null;
}

export interface HealthSystemDomainAnimalsCommandsCreateAnimalCommand {
  animalType: HealthSystemDALEnumsAnimalType;
  /** @format date-time */
  dateOfBirth: string;
  deviceMacAddress?: string | null;
  fatherNumber?: string | null;
  fosterMotherNumber?: string | null;
  gender: HealthSystemDALEnumsAnimalGender;
  genetics?: string | null;
  /** @format uuid */
  id: string;
  locationNumber?: string | null;
  motherNumber?: string | null;
  nipples: HealthSystemDALModelAnimalsDataAnimalNipples;
  /** @minLength 1 */
  number: string;
  weight: HealthSystemDALModelDoubleWeightWithDate;
  weightCategory: HealthSystemDALEnumsAnimalWeightCategory;
}

export interface HealthSystemDomainAnimalsCommandsCreateAnimalNoteCommand {
  /** @format uuid */
  animalId: string;
  text: string;
}

export interface HealthSystemDomainAnimalsCommandsCreateAnimalViaInjectionCommand {
  animal: HealthSystemDomainAnimalsCommandsCreateAnimalCommand;
  injection: HealthSystemDomainInjectionsCommandsCreateInjectionCommand;
  weight: HealthSystemDALModelDoubleWeightWithDate;
}

export interface HealthSystemDomainAnimalsCommandsCreateAnimalsBatchCommand {
  animals: HealthSystemDomainAnimalsResultCreateAnimalModel[];
}

export interface HealthSystemDomainAnimalsCommandsDiedAnimalCommand {
  comment?: string | null;
  /** @format uuid */
  diseaseId?: string | null;
  locationData: HealthSystemDALModelLocationsLocationData;
  /** @format uuid */
  mortalityReasonId?: string | null;
  /** @minLength 1 */
  number: string;
}

export interface HealthSystemDomainAnimalsCommandsExportAnimalSearchCommand {
  exportFormat: HealthSystemDomainAnimalsCommandsExportFormatType;
  searchQuery: HealthSystemDomainAnimalsResultAnimalsFarmSearchRequest;
}

/** @format int32 */
export type HealthSystemDomainAnimalsCommandsExportFormatType = 0 | 1 | 2 | 3;

export interface HealthSystemDomainAnimalsCommandsLocationHistoryItemViewModel {
  animalType: HealthSystemDALEnumsAnimalType;
  /** @format double */
  averageDailyGainGrams?: number | null;
  changeReason?: string | null;
  /** @format int32 */
  daysInLocation: number;
  /** @format date-time */
  enteredAt: string;
  exitReason?: string | null;
  /** @format date-time */
  exitedAt?: string | null;
  /** @format uuid */
  id: string;
  isCurrentLocation: boolean;
  location: HealthSystemDomainLocationsResultLocationViewModel;
  weightAtEntry: HealthSystemDALModelDoubleWeightWithDate;
  weightAtExit: HealthSystemDALModelDoubleWeightWithDate;
  /** @format double */
  weightGainGrams?: number | null;
}

export interface HealthSystemDomainAnimalsCommandsRecalculateAnimalWeightCommand {
  /** @format uuid */
  animalId?: string | null;
  number?: string | null;
}

export interface HealthSystemDomainAnimalsCommandsSearchAnimalsTrendDataQuery {
  animalTrendDataType: HealthSystemDALEnumsAnimalTrendDataType;
  searchQuery: HealthSystemDomainAnimalsResultAnimalsFarmSearchRequest;
}

export interface HealthSystemDomainAnimalsCommandsSearchCompareAnimalsTrendDataQuery {
  animalTrendDataType: HealthSystemDALEnumsAnimalTrendDataType;
  queries: Record<
    string,
    HealthSystemDomainAnimalsResultAnimalsFarmSearchRequest
  >;
}

export interface HealthSystemDomainAnimalsCommandsSetAnimalWeightsCommand {
  /** @format uuid */
  animalId?: string | null;
  /** @format uuid */
  farmId: string;
  number?: string | null;
  weight: HealthSystemDALModelAnimalsDataAnimalWeight;
  weightCategory: HealthSystemDALEnumsAnimalWeightCategory;
}

export interface HealthSystemDomainAnimalsCommandsUpdateAnimalCommand {
  animalType: HealthSystemDALEnumsAnimalType;
  /** @format uuid */
  diseaseId?: string | null;
  /** @format uuid */
  employeeRegisteredId?: string | null;
  /** @format uuid */
  farmId: string;
  gender: HealthSystemDALEnumsAnimalGender;
  genetics?: string | null;
  /** @format uuid */
  id: string;
  isDied: boolean;
  isSoftDeleted: boolean;
  /** @format uuid */
  locationId?: string | null;
  metadata: Record<string, any>;
  /** @format uuid */
  mortalityReasonId?: string | null;
  nipples: HealthSystemDALModelAnimalsDataAnimalNipples;
  weight: HealthSystemDALModelAnimalsDataAnimalWeight;
}

export interface HealthSystemDomainAnimalsModelsAnimalExternalIdentifierViewModel {
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  id: string;
  name: string;
  /**
   * Available values: PlasticNumber, Tattoo, BirthId, HerdbookId, SlaughterId, Rfid, ExternalSystemId, Other
   * @example "PlasticNumber"
   */
  type: string;
  /** @format date-time */
  updatedAt: string;
  value: string;
}

export interface HealthSystemDomainAnimalsModelsAnimalHealthLogViewModel {
  comment: string | null;
  /** @format int32 */
  count: number | null;
  /** @format date-time */
  dateTime: string;
  disease: string | null;
  diseaseColour: string | null;
  /** @format uuid */
  id: string;
  isTreated: boolean;
  location: string | null;
  medicalSupply: string | null;
  mortalityReason: string | null;
  /** @format date-time */
  notBefore: string;
  type: HealthSystemDALEnumsAnimalHealthLogType;
}

export interface HealthSystemDomainAnimalsModelsAnimalObservationViewModel {
  /** @format int32 */
  age: number;
  /** @format uuid */
  animalId: string;
  animalNumber: string;
  animalType: HealthSystemDALEnumsAnimalType;
  /**
   * Available values: GeneticFailure, Biter, BiteVictim
   * @example "GeneticFailure"
   */
  category: string;
  comment: string | null;
  /**
   * Available values: BornDefect, InternalBoar, ClosedAnus, TooFewTeats, Other
   * @example "BornDefect"
   */
  geneticFailure: string | null;
  geneticFailureOther: string | null;
  /** @format uuid */
  id: string;
  location: string | null;
  /** @format date-time */
  registeredAt: string;
  registeredBy: string | null;
}

export interface HealthSystemDomainAnimalsModelsWeightWithDateModel {
  /** @format date-time */
  date: string;
  unit: HealthSystemDALEnumsWeightType;
  /** @format double */
  value: number;
}

export interface HealthSystemDomainAnimalsQueriesAnimalObservationCategoryOption {
  /**
   * Available values: GeneticFailure, Biter, BiteVictim
   * @example "GeneticFailure"
   */
  category: string;
  description: string | null;
  geneticFailures: HealthSystemDomainAnimalsQueriesGeneticFailureTypeOption[];
}

export interface HealthSystemDomainAnimalsQueriesGeneticFailureTypeOption {
  description: string | null;
  /**
   * Available values: BornDefect, InternalBoar, ClosedAnus, TooFewTeats, Other
   * @example "BornDefect"
   */
  geneticFailure: string;
}

export interface HealthSystemDomainAnimalsResultAnimalBirthCycleAnimalViewModel {
  animalType: HealthSystemDALEnumsAnimalType;
  disease: HealthSystemDomainDiseasesDiseaseViewModel;
  fosterMotherHistory: HealthSystemDomainAnimalsResultAnimalFosterMotherHistoryItemViewModel[];
  /** @format uuid */
  fosterMotherId?: string | null;
  fosterMotherNumber?: string | null;
  /** @format date-time */
  fosterMotherTransferredAt?: string | null;
  /** @format uuid */
  id: string;
  isDied: boolean;
  isSoftDeleted: boolean;
  mortalityReason: HealthSystemDomainMortalityReasonsMortalityReasonViewModel;
  /** @format uuid */
  motherId?: string | null;
  motherNumber?: string | null;
  number?: string | null;
  slaughterhouseData: HealthSystemDALModelAnimalsDataAnimalSlaughterhouseData;
  weight: HealthSystemDALModelAnimalsDataAnimalWeight;
  weightAtFosterTransfer: HealthSystemDALModelDoubleWeightWithDate;
}

export interface HealthSystemDomainAnimalsResultAnimalBirthCycleViewModel {
  animals: HealthSystemDomainAnimalsResultAnimalBirthCycleAnimalViewModel[];
  /** @format int32 */
  birthCycleNumber: number;
  /** @format double */
  dailyGrowthAverage: number;
  /** @format date-time */
  dateOfBirth: string;
  feedConversion: HealthSystemDomainAnimalsResultBirthCycleFeedConversionModel;
  /** @format double */
  slaughterhouseDailyGrowthAverage?: number | null;
  slaughterhouseDataAverage: HealthSystemDALModelAnimalsDataAnimalSlaughterhouseData;
  /** @format double */
  slaughterhouseWeight?: number | null;
  /** @format int32 */
  total: number;
  /** @format int32 */
  totalDead: number;
  /** @format int32 */
  totalSlaughtered: number;
  weaned: HealthSystemDomainAnimalsResultWeanedAnimalViewModel;
  weightAverage: HealthSystemDALModelAnimalsDataAnimalWeight;
}

export interface HealthSystemDomainAnimalsResultAnimalFosterMotherHistoryItemViewModel {
  /** @format uuid */
  fosterMotherId: string;
  fosterMotherNumber?: string | null;
  /** @format uuid */
  id: string;
  /** @format date-time */
  transferredAt: string;
  weightAtTransfer: HealthSystemDALModelDoubleWeightWithDate;
}

export interface HealthSystemDomainAnimalsResultAnimalNoteViewModel {
  /** @format date-time */
  created: string;
  /** @format uuid */
  id: string;
  text?: string | null;
}

export interface HealthSystemDomainAnimalsResultAnimalPigletBirthCyclesPageableQueryResult {
  /** @format uuid */
  animalId: string;
  data: HealthSystemDomainAnimalsResultAnimalBirthCycleViewModel[];
  /** @format int32 */
  totalPiglets: number;
}

export interface HealthSystemDomainAnimalsResultAnimalSearchResult {
  animalType: HealthSystemDALEnumsAnimalType;
  /** @format int32 */
  childrenCount?: number | null;
  crossbreed?: string | null;
  /** @format date-time */
  dateOfBirth: string;
  /** @format date-time */
  deathDate?: string | null;
  deathReason?: string | null;
  disease: HealthSystemDomainDiseasesDiseaseViewModel;
  fatherGenetics?: string | null;
  /** @format uuid */
  fatherId?: string | null;
  fatherNumber?: string | null;
  gender: HealthSystemDALEnumsAnimalGender;
  genetics?: string | null;
  healthIndicator: HealthSystemDALEnumsAnimalHealthIndicator;
  /** @format uuid */
  id: string;
  injectionHistory: HealthSystemDomainInjectionsResultInjectionHistoryViewModel[];
  isDied: boolean;
  isNotFound: boolean;
  isSoftDeleted: boolean;
  /** @format uuid */
  locationId?: string | null;
  mortalityReason: HealthSystemDomainMortalityReasonsMortalityReasonViewModel;
  motherGenetics?: string | null;
  /** @format uuid */
  motherId?: string | null;
  motherNumber?: string | null;
  number: string;
  plasticNumber?: string | null;
  /** @format date-time */
  slaughteredDate?: string | null;
  weight: HealthSystemDALModelAnimalsDataAnimalWeight;
  weightCategory: HealthSystemDALEnumsAnimalWeightCategory;
}

export interface HealthSystemDomainAnimalsResultAnimalTrendDataViewModel {
  slaughterhouseDataAverage: HealthSystemDALModelAnimalsDataAnimalSlaughterhouseData;
  trendData: HealthSystemDomainAnimalsResultTrendDataInfo[];
  weightAverage: HealthSystemDALModelAnimalsDataAnimalWeight;
}

export interface HealthSystemDomainAnimalsResultAnimalViewModel {
  animalType: HealthSystemDALEnumsAnimalType;
  /** @format date-time */
  dateOfBirth: string;
  /** @format date-time */
  deathDate?: string | null;
  disease: HealthSystemDomainDiseasesDiseaseViewModel;
  /** @format uuid */
  diseaseId?: string | null;
  /** @format uuid */
  employeeRegisteredId?: string | null;
  /** @format uuid */
  farmId: string;
  /** @format uuid */
  fatherId?: string | null;
  fosterMotherHistory: HealthSystemDomainAnimalsResultAnimalFosterMotherHistoryItemViewModel[];
  /** @format uuid */
  fosterMotherId?: string | null;
  gender: HealthSystemDALEnumsAnimalGender;
  genetics?: string | null;
  /** @format uuid */
  id: string;
  isDied: boolean;
  isSoftDeleted: boolean;
  location: HealthSystemDomainLocationsResultLocationViewModel;
  /** @format uuid */
  locationId?: string | null;
  metadata: Record<string, any>;
  mortalityReason: HealthSystemDomainMortalityReasonsMortalityReasonViewModel;
  /** @format uuid */
  mortalityReasonId?: string | null;
  /** @format uuid */
  motherId?: string | null;
  nipples: HealthSystemDALModelAnimalsDataAnimalNipples;
  notes: HealthSystemDomainAnimalsResultAnimalNoteViewModel[];
  number?: string | null;
  slaughterhouseData: HealthSystemDALModelAnimalsDataAnimalSlaughterhouseData;
  weight: HealthSystemDALModelAnimalsDataAnimalWeight;
  weightAnalytics: HealthSystemDomainAnimalsResultWeightAnalyticModel[];
  weightCategory: HealthSystemDALEnumsAnimalWeightCategory;
}

export interface HealthSystemDomainAnimalsResultAnimalsFarmSearchRequest {
  animalType: HealthSystemDALEnumsAnimalType;
  birthCycleSearch: HealthSystemDomainAnimalsResultRangeSearchDto;
  chipNumbers?: string[] | null;
  climateControlSearch: HealthSystemDomainAnimalsResultClimateControlSearchQuery;
  /**
   * Available values: PigExpert, ePigs, Whysor
   * @example "PigExpert"
   */
  configurationProviderType?: string | null;
  /** @format date-time */
  dateFrom?: string | null;
  /** @format date-time */
  dateTo?: string | null;
  /** @format uuid */
  diseaseId?: string | null;
  excludeImported?: boolean | null;
  /** @format uuid */
  farmId?: string | null;
  fatherNumbers?: string[] | null;
  /**
   * Available values: DateOfBirth, RegisteredAt, DeathDate, SlaughteredDate
   * @example "DateOfBirth"
   */
  filterDateBy?: string | null;
  findByExternalIds?: boolean | null;
  gender: HealthSystemDALEnumsAnimalGender;
  genetics?: string | null;
  includeChildrenCount?: boolean | null;
  includeInjectionHistory: boolean;
  includeWithoutFather: boolean;
  includeWithoutMother: boolean;
  injectionMethod: HealthSystemDALEnumsMedicalSupplyMethod;
  injectionSearchAgeRange?: number[] | null;
  isAnimalObservationSearch: boolean;
  isAntibioticFreeSearch: boolean;
  isBirthCycleSearch: boolean;
  isClimateControlSearch: boolean;
  isDeathSearch: boolean;
  isInjectionSearch: boolean;
  isLactating?: boolean | null;
  isMortalityReasonSearch: boolean;
  isPregnant?: boolean | null;
  isSlaughterhouseSearch: boolean;
  isSquareMetersPerPigSearch: boolean;
  isWeanedDaysSearch: boolean;
  isWeightCategorySearch: boolean;
  isWeightGroupSearch: boolean;
  /** @format uuid */
  locationId?: string | null;
  /** @format uuid */
  medicalSupplyId?: string | null;
  /** @format uuid */
  mortalityReasonId?: string | null;
  motherNumbers?: string[] | null;
  number?: string | null;
  observationCategories?: string[] | null;
  observationGeneticFailures?: string[] | null;
  order?: string | null;
  orderBy?: string | null;
  slaughterhouseSearch: HealthSystemDomainAnimalsResultSlaughterhouseSearchQuery;
  squareMetersPerPigRange?: number[] | null;
  /** @format uuid */
  userId?: string | null;
  weanedDays?: number[] | null;
  weightCategorySearch?: HealthSystemDALEnumsAnimalWeightCategory[] | null;
  weightGroupSearch: HealthSystemDomainAnimalsResultWeightGroupSearchQuery;
  weightPerDay?: number[] | null;
}

export interface HealthSystemDomainAnimalsResultAnimalsSearchQueryResult {
  data: HealthSystemDomainAnimalsResultAnimalSearchResult[];
  /** @format int32 */
  page: number;
  /** @format int32 */
  size: number;
  /** @format int64 */
  total: number;
}

export interface HealthSystemDomainAnimalsResultAnimalsSearchRequest {
  animalType: HealthSystemDALEnumsAnimalType;
  birthCycleSearch: HealthSystemDomainAnimalsResultRangeSearchDto;
  chipNumbers?: string[] | null;
  climateControlSearch: HealthSystemDomainAnimalsResultClimateControlSearchQuery;
  /**
   * Available values: PigExpert, ePigs, Whysor
   * @example "PigExpert"
   */
  configurationProviderType?: string | null;
  /** @format date-time */
  dateFrom?: string | null;
  /** @format date-time */
  dateTo?: string | null;
  /** @format uuid */
  diseaseId?: string | null;
  excludeImported?: boolean | null;
  fatherNumbers?: string[] | null;
  /**
   * Available values: DateOfBirth, RegisteredAt, DeathDate, SlaughteredDate
   * @example "DateOfBirth"
   */
  filterDateBy?: string | null;
  findByExternalIds?: boolean | null;
  gender: HealthSystemDALEnumsAnimalGender;
  genetics?: string | null;
  includeChildrenCount?: boolean | null;
  includeInjectionHistory: boolean;
  includeWithoutFather: boolean;
  includeWithoutMother: boolean;
  injectionMethod: HealthSystemDALEnumsMedicalSupplyMethod;
  injectionSearchAgeRange?: number[] | null;
  isAnimalObservationSearch: boolean;
  isAntibioticFreeSearch: boolean;
  isBirthCycleSearch: boolean;
  isClimateControlSearch: boolean;
  isDeathSearch: boolean;
  isInjectionSearch: boolean;
  isLactating?: boolean | null;
  isMortalityReasonSearch: boolean;
  isPregnant?: boolean | null;
  isSlaughterhouseSearch: boolean;
  isSquareMetersPerPigSearch: boolean;
  isWeanedDaysSearch: boolean;
  isWeightCategorySearch: boolean;
  isWeightGroupSearch: boolean;
  /** @format uuid */
  locationId?: string | null;
  /** @format uuid */
  medicalSupplyId?: string | null;
  /** @format uuid */
  mortalityReasonId?: string | null;
  motherNumbers?: string[] | null;
  number?: string | null;
  observationCategories?: string[] | null;
  observationGeneticFailures?: string[] | null;
  order?: string | null;
  orderBy?: string | null;
  slaughterhouseSearch: HealthSystemDomainAnimalsResultSlaughterhouseSearchQuery;
  squareMetersPerPigRange?: number[] | null;
  /** @format uuid */
  userId?: string | null;
  weanedDays?: number[] | null;
  weightCategorySearch?: HealthSystemDALEnumsAnimalWeightCategory[] | null;
  weightGroupSearch: HealthSystemDomainAnimalsResultWeightGroupSearchQuery;
  weightPerDay?: number[] | null;
}

export interface HealthSystemDomainAnimalsResultAntibioticFreeAnimalQueryResult {
  message?: string | null;
  result?: boolean | null;
}

export interface HealthSystemDomainAnimalsResultBirthCycleFeedConversionModel {
  gestationFeed: HealthSystemDomainFeedFeedConversionsModelsGestationFeedModel;
  lactationFeed: HealthSystemDomainFeedFeedConversionsModelsLactationFeedModel;
  summary: HealthSystemDomainFeedFeedConversionsModelsSummaryFeedConversionModel;
}

export interface HealthSystemDomainAnimalsResultClimateControlSearchQuery {
  amonia?: number[] | null;
  carbon?: number[] | null;
  humidity?: number[] | null;
  temperatureDelta?: number[] | null;
}

export interface HealthSystemDomainAnimalsResultCreateAnimalModel {
  animalType: HealthSystemDALEnumsAnimalType;
  /** @format date-time */
  dateOfBirth: string;
  deviceMacAddress?: string | null;
  fatherNumber?: string | null;
  fosterMotherNumber?: string | null;
  gender: HealthSystemDALEnumsAnimalGender;
  genetics?: string | null;
  /** @format uuid */
  id: string;
  locationNumber?: string | null;
  motherNumber?: string | null;
  nipples: HealthSystemDALModelAnimalsDataAnimalNipples;
  /** @minLength 1 */
  number: string;
  weight: HealthSystemDALModelDoubleWeightWithDate;
  weightCategory: HealthSystemDALEnumsAnimalWeightCategory;
}

export interface HealthSystemDomainAnimalsResultCreateAnimalViaInjectionResult {
  /** @format uuid */
  animalId?: string | null;
  errors: HealthSystemDomainCommonResultEntityEvent[];
  /** @format uuid */
  injectionId?: string | null;
  successAnimal: boolean;
  successInjection: boolean;
  warning: HealthSystemDomainCommonResultEntityEvent[];
}

export interface HealthSystemDomainAnimalsResultRangeSearchDto {
  /** @format int32 */
  max: number;
  /** @format int32 */
  min: number;
}

export interface HealthSystemDomainAnimalsResultSlaughterhouseSearchQuery {
  baconCutlet?: number[] | null;
  belly?: number[] | null;
  fat?: number[] | null;
  ham?: number[] | null;
  leanMeat?: number[] | null;
  money?: number[] | null;
  shoulder?: number[] | null;
  spine?: number[] | null;
  weight?: number[] | null;
}

export interface HealthSystemDomainAnimalsResultTrendDataInfo {
  /** @format int32 */
  animalCount: number;
  name?: string | null;
  /**
   * Available values: Grams, Millimeters, Kilograms, Percentage, MoneyEuro
   * @example "Grams"
   */
  unit?: string | null;
  /** @format int32 */
  value: number;
}

export interface HealthSystemDomainAnimalsResultWeanedAnimalViewModel {
  /** @format int32 */
  totalFoster: number;
  /** @format int32 */
  totalOwn: number;
}

export interface HealthSystemDomainAnimalsResultWeightAnalyticChartData {
  /** @format int32 */
  daysAge: number;
  /** @format int32 */
  totalCount: number;
  /** @format double */
  value: number;
}

export interface HealthSystemDomainAnimalsResultWeightAnalyticModel {
  chartData: HealthSystemDomainAnimalsResultWeightAnalyticChartData[];
  name: string;
  weights: HealthSystemDALModelDoubleWeightWithDate[];
}

export interface HealthSystemDomainAnimalsResultWeightGroupSearchQuery {
  birth?: number[] | null;
  tenWeeks?: number[] | null;
  weaned?: number[] | null;
}

export interface HealthSystemDomainCarbonFootPrintResultCarbonFootprintPerYearViewModel {
  /** @format double */
  kgCo2ePerKgMeat: number;
  /** @format double */
  totalFeedCo2: number;
  /** @format double */
  totalKgCo2e: number;
  /** @format int32 */
  year: number;
}

export interface HealthSystemDomainChipNumbersCommandRemoveChipNumberCommand {
  /** @format uuid */
  id: string;
}

export interface HealthSystemDomainChipNumbersCommandUpsertChipNumberCommand {
  /** @format int64 */
  end: number;
  /** @format uuid */
  farmId?: string | null;
  gender: HealthSystemDALEnumsAnimalGender;
  /** @format uuid */
  id?: string | null;
  /** @format int64 */
  start: number;
}

export interface HealthSystemDomainChipNumbersResultChipNumberConflict {
  first: HealthSystemDomainChipNumbersResultChipNumberViewModel;
  second: HealthSystemDomainChipNumbersResultChipNumberViewModel;
}

export interface HealthSystemDomainChipNumbersResultChipNumberInfoViewModel {
  farm: HealthSystemDomainFarmsResultFarmViewModel;
}

export interface HealthSystemDomainChipNumbersResultChipNumberListResult {
  data: HealthSystemDomainChipNumbersResultChipNumberViewModel[];
  hasOverlappingRanges: boolean;
  overlappingRanges: HealthSystemDomainChipNumbersResultChipNumberConflict[];
  /** @format int32 */
  page: number;
  /** @format int32 */
  size: number;
  /** @format int64 */
  total: number;
}

export interface HealthSystemDomainChipNumbersResultChipNumberViewModel {
  /** @format date-time */
  created: string;
  /** @format int64 */
  end: number;
  farm: HealthSystemDomainFarmsResultFarmViewModel;
  gender: HealthSystemDALEnumsAnimalGender;
  /** @format uuid */
  id: string;
  /** @format int64 */
  start: number;
}

export interface HealthSystemDomainCommonQueryResultPageableResultHealthSystemDALModelAnimalActivity {
  data: HealthSystemDALModelAnimalActivity[];
  /** @format int32 */
  page: number;
  /** @format int32 */
  size: number;
  /** @format int64 */
  total: number;
}

export interface HealthSystemDomainCommonQueryResultPageableResultHealthSystemDALModelLogAppEventLog {
  data: HealthSystemDALModelLogAppEventLog[];
  /** @format int32 */
  page: number;
  /** @format int32 */
  size: number;
  /** @format int64 */
  total: number;
}

export interface HealthSystemDomainCommonQueryResultPageableResultHealthSystemDALModelMedicalSuppliesLabelPrintTask {
  data: HealthSystemDALModelMedicalSuppliesLabelPrintTask[];
  /** @format int32 */
  page: number;
  /** @format int32 */
  size: number;
  /** @format int64 */
  total: number;
}

export interface HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainDiseasesDiseaseViewModel {
  data: HealthSystemDomainDiseasesDiseaseViewModel[];
  /** @format int32 */
  page: number;
  /** @format int32 */
  size: number;
  /** @format int64 */
  total: number;
}

export interface HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainDocumentsResultFarmDocumentViewModel {
  data: HealthSystemDomainDocumentsResultFarmDocumentViewModel[];
  /** @format int32 */
  page: number;
  /** @format int32 */
  size: number;
  /** @format int64 */
  total: number;
}

export interface HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainEmissionSourceUsageEntriesViewModelsEmissionSourceUsageEntryViewModel {
  data: HealthSystemDomainEmissionSourceUsageEntriesViewModelsEmissionSourceUsageEntryViewModel[];
  /** @format int32 */
  page: number;
  /** @format int32 */
  size: number;
  /** @format int64 */
  total: number;
}

export interface HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainEmissionSourcesViewModelsEmissionSourceViewModel {
  data: HealthSystemDomainEmissionSourcesViewModelsEmissionSourceViewModel[];
  /** @format int32 */
  page: number;
  /** @format int32 */
  size: number;
  /** @format int64 */
  total: number;
}

export interface HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainFarmsResultFarmViewModel {
  data: HealthSystemDomainFarmsResultFarmViewModel[];
  /** @format int32 */
  page: number;
  /** @format int32 */
  size: number;
  /** @format int64 */
  total: number;
}

export interface HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainFeedFeedSuppliersFeedSupplierViewModel {
  data: HealthSystemDomainFeedFeedSuppliersFeedSupplierViewModel[];
  /** @format int32 */
  page: number;
  /** @format int32 */
  size: number;
  /** @format int64 */
  total: number;
}

export interface HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainMedicalSuppliesResultMedicalSupplyBottleViewModel {
  data: HealthSystemDomainMedicalSuppliesResultMedicalSupplyBottleViewModel[];
  /** @format int32 */
  page: number;
  /** @format int32 */
  size: number;
  /** @format int64 */
  total: number;
}

export interface HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainMedicalSuppliesResultMedicalSupplyOrderViewModel {
  data: HealthSystemDomainMedicalSuppliesResultMedicalSupplyOrderViewModel[];
  /** @format int32 */
  page: number;
  /** @format int32 */
  size: number;
  /** @format int64 */
  total: number;
}

export interface HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainMedicalSuppliesResultMedicalSupplyViewModel {
  data: HealthSystemDomainMedicalSuppliesResultMedicalSupplyViewModel[];
  /** @format int32 */
  page: number;
  /** @format int32 */
  size: number;
  /** @format int64 */
  total: number;
}

export interface HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainMedicalSuppliesResultVeterinaryOrderViewModel {
  data: HealthSystemDomainMedicalSuppliesResultVeterinaryOrderViewModel[];
  /** @format int32 */
  page: number;
  /** @format int32 */
  size: number;
  /** @format int64 */
  total: number;
}

export interface HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainMortalityReasonsMortalityReasonViewModel {
  data: HealthSystemDomainMortalityReasonsMortalityReasonViewModel[];
  /** @format int32 */
  page: number;
  /** @format int32 */
  size: number;
  /** @format int64 */
  total: number;
}

export interface HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainNotificationRulesResultNotificationRuleViewModel {
  data: HealthSystemDomainNotificationRulesResultNotificationRuleViewModel[];
  /** @format int32 */
  page: number;
  /** @format int32 */
  size: number;
  /** @format int64 */
  total: number;
}

export interface HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainNotificationsResultNotificationViewModel {
  data: HealthSystemDomainNotificationsResultNotificationViewModel[];
  /** @format int32 */
  page: number;
  /** @format int32 */
  size: number;
  /** @format int64 */
  total: number;
}

export interface HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainSlaughterPreparationsResultPreOrdersSummariesViewModel {
  data: HealthSystemDomainSlaughterPreparationsResultPreOrdersSummariesViewModel[];
  /** @format int32 */
  page: number;
  /** @format int32 */
  size: number;
  /** @format int64 */
  total: number;
}

export interface HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainTaskLibraryResultTaskOccurrenceViewModel {
  data: HealthSystemDomainTaskLibraryResultTaskOccurrenceViewModel[];
  /** @format int32 */
  page: number;
  /** @format int32 */
  size: number;
  /** @format int64 */
  total: number;
}

export interface HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainTaskListsResultTaskListRuleViewModel {
  data: HealthSystemDomainTaskListsResultTaskListRuleViewModel[];
  /** @format int32 */
  page: number;
  /** @format int32 */
  size: number;
  /** @format int64 */
  total: number;
}

export interface HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainTaskListsResultTaskListViewModel {
  data: HealthSystemDomainTaskListsResultTaskListViewModel[];
  /** @format int32 */
  page: number;
  /** @format int32 */
  size: number;
  /** @format int64 */
  total: number;
}

export interface HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainUsersResultUserActionLogViewModel {
  data: HealthSystemDomainUsersResultUserActionLogViewModel[];
  /** @format int32 */
  page: number;
  /** @format int32 */
  size: number;
  /** @format int64 */
  total: number;
}

export interface HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainVaccinationRulesResultVaccinationRuleViewModel {
  data: HealthSystemDomainVaccinationRulesResultVaccinationRuleViewModel[];
  /** @format int32 */
  page: number;
  /** @format int32 */
  size: number;
  /** @format int64 */
  total: number;
}

export interface HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainVetsResultVeterinaryViewModel {
  data: HealthSystemDomainVetsResultVeterinaryViewModel[];
  /** @format int32 */
  page: number;
  /** @format int32 */
  size: number;
  /** @format int64 */
  total: number;
}

export interface HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainWeightDiagnosticQueriesWeightDiagnosticRecordViewModel {
  data: HealthSystemDomainWeightDiagnosticQueriesWeightDiagnosticRecordViewModel[];
  /** @format int32 */
  page: number;
  /** @format int32 */
  size: number;
  /** @format int64 */
  total: number;
}

export interface HealthSystemDomainCommonResultEntityBatchResult {
  errors: HealthSystemDomainCommonResultEntityEvent[];
  success: string[];
}

export interface HealthSystemDomainCommonResultEntityEvent {
  codes: string[];
  /** @format uuid */
  id: string;
}

export type HealthSystemDomainDashboardsQueryVeterinaryDashboardQuery = object;

export interface HealthSystemDomainDashboardsResultDashboardAnimalChartData {
  /** @format int32 */
  countA: number;
  /** @format int32 */
  countB: number;
  /** @format int32 */
  countC: number;
  /** @format int32 */
  weekNumber: number;
}

export interface HealthSystemDomainDashboardsResultDashboardAnimalData {
  animalType: HealthSystemDALEnumsAnimalType;
  chartData: HealthSystemDomainDashboardsResultDashboardAnimalChartData[];
  /** @format double */
  dailyDose: number;
  vaccineA?: string | null;
  vaccineB?: string | null;
  vaccineC?: string | null;
}

export interface HealthSystemDomainDashboardsResultDashboardViewModel {
  calfData: HealthSystemDomainDashboardsResultDashboardAnimalData;
  cowData: HealthSystemDomainDashboardsResultDashboardAnimalData;
  farmType: HealthSystemDALEnumsFarmType;
  fatteningData: HealthSystemDomainDashboardsResultDashboardAnimalData;
  giltData: HealthSystemDomainDashboardsResultDashboardAnimalData;
  goatData: HealthSystemDomainDashboardsResultDashboardAnimalData;
  pigletData: HealthSystemDomainDashboardsResultDashboardAnimalData;
  sowData: HealthSystemDomainDashboardsResultDashboardAnimalData;
}

export interface HealthSystemDomainDashboardsResultVeterinaryDashboardViewModel {
  /** @format date-time */
  dateTime: string;
  test?: string | null;
}

export interface HealthSystemDomainDataImportResultSlaughterImportAnimalDto {
  /** @format uuid */
  id: string;
  number: string;
}

export interface HealthSystemDomainDataImportResultSlaughterImportFarmDto {
  /** @format uuid */
  id: string;
  name?: string | null;
  number: string;
}

export interface HealthSystemDomainDataImportResultSlaughterImportHistoryItemDto {
  animal: HealthSystemDomainDataImportResultSlaughterImportAnimalDto;
  eventId: string;
  farm: HealthSystemDomainDataImportResultSlaughterImportFarmDto;
  /** @format uuid */
  id: string;
  /** @format date-time */
  importedAt: string;
  payloadJson: string;
  slaughterEarTag: string;
}

export interface HealthSystemDomainDeviceCommandsCreateHealthInjectorCommand {
  comment?: string | null;
  /** @format uuid */
  farmId?: string | null;
  /** @minLength 1 */
  macAddress: string;
  manufacturer: HealthSystemDomainHealthInjectorsDtosHealthInjectorManufacturerDto;
}

export interface HealthSystemDomainDeviceCommandsCreateReaderActionCommand {
  apiKey?: string | null;
  details: HealthSystemDALModelDeviceReaderActionDetails;
  hookId?: string | null;
  metadata?: Record<string, any> | null;
  number?: string | null;
  /** @format uuid */
  slaughterhouseId?: string | null;
}

export type HealthSystemDomainDeviceCommandsLatestFirmwareQuery = object;

export interface HealthSystemDomainDeviceCommandsReaderActionsQuery {
  calculateReadRate: boolean;
  /** @format date-time */
  dateFrom: string;
  /** @format date-time */
  dateTo: string;
  detailsMessage?: string | null;
  excludeZeroHooks: boolean;
  excludeZeroNumbers: boolean;
  /** @format uuid */
  farmId?: string | null;
  hook?: string | null;
  id?: string | null;
  number?: string | null;
  /** @format int32 */
  page: number;
  /** @format int32 */
  size: number;
  slaughterhouseIds: string[];
  sort?: string | null;
}

export interface HealthSystemDomainDeviceCommandsRecordReaderHeartbeatResult {
  isNewReader: boolean;
  /** @format date-time */
  lastHeartbeatAt: string;
  /** @format uuid */
  readerId: string;
}

export interface HealthSystemDomainDeviceCommandsUpdateHealthInjectorCommand {
  comment?: string | null;
  disabled?: boolean | null;
  /** @format uuid */
  farmId?: string | null;
  hasErrors?: boolean | null;
  /** @format uuid */
  id?: string | null;
  /** @minLength 1 */
  macAddress: string;
  manufacturer: HealthSystemDomainHealthInjectorsDtosHealthInjectorManufacturerDto;
}

export interface HealthSystemDomainDeviceCommandsUpdateHealthInjectorVersionCommand {
  /** @minLength 1 */
  macAddress: string;
  version: HealthSystemDALModelHealthInjectorsHealthInjectorVersion;
}

export interface HealthSystemDomainDeviceResultCreateReaderActionViewModel {
  hasAnimalMatch: boolean;
  hasChipNumbersMatch: boolean;
  /** @format uuid */
  readerActionId: string;
}

export interface HealthSystemDomainDeviceResultDeviceFirmwareQueryResult {
  data: HealthSystemDomainDeviceResultDeviceFirmwareViewModel[];
  /** @format int32 */
  page: number;
  /** @format int32 */
  size: number;
  /** @format int64 */
  total: number;
}

export interface HealthSystemDomainDeviceResultDeviceFirmwareViewModel {
  /** @format date-time */
  dateTime: string;
  deviceFirmwareType: HealthSystemDALEnumsDeviceFirmwareType;
  fileName?: string | null;
  /** @format uuid */
  id: string;
  info?: string | null;
  isDeprecated: boolean;
  releaseNotes?: string | null;
  version?: string | null;
}

export interface HealthSystemDomainDeviceResultHealthInjectorViewModel {
  comment?: string | null;
  /** @format date-time */
  created: string;
  disabled: boolean;
  farm: HealthSystemDomainFarmsResultFarmViewModel;
  hasErrors: boolean;
  /** @format uuid */
  id: string;
  macAddress?: string | null;
  manufacturer: HealthSystemDomainHealthInjectorsDtosHealthInjectorManufacturerDto;
  /** @format date-time */
  updated?: string | null;
  version: HealthSystemDALModelHealthInjectorsHealthInjectorVersion;
}

export interface HealthSystemDomainDeviceResultHealthInjectorsQueryResult {
  data: HealthSystemDomainDeviceResultHealthInjectorViewModel[];
  /** @format int32 */
  page: number;
  /** @format int32 */
  size: number;
  /** @format int64 */
  total: number;
}

export interface HealthSystemDomainDeviceResultReaderActionSlaughterhouseViewModel {
  /** @format uuid */
  id: string;
  name: string;
}

export interface HealthSystemDomainDeviceResultReaderActionViewModel {
  /** @format date-time */
  dateTime: string;
  details: HealthSystemDALModelDeviceReaderActionDetails;
  eventMessage?: string | null;
  hookId?: string | null;
  isWarning: boolean;
  number?: string | null;
  slaughterhouse: HealthSystemDomainDeviceResultReaderActionSlaughterhouseViewModel;
}

export interface HealthSystemDomainDeviceResultReaderActionsQueryResult {
  data: HealthSystemDomainDeviceResultReaderActionViewModel[];
  /** @format int32 */
  hookReadRate: number;
  /** @format int32 */
  numberReadRate: number;
  /** @format int32 */
  page: number;
  /** @format int32 */
  size: number;
  /** @format int64 */
  total: number;
}

export interface HealthSystemDomainDeviceResultReaderSlaughterhouseViewModel {
  /** @format uuid */
  id: string;
  name: string;
}

export interface HealthSystemDomainDeviceResultReaderViewModel {
  /** @format date-time */
  createdAt: string;
  /** @format int32 */
  heartbeatIntervalSeconds: number;
  /** @format uuid */
  id: string;
  isStaleAlertSent: boolean;
  lastFirmwareVersion?: string | null;
  /** @format date-time */
  lastHeartbeatAt?: string | null;
  macAddress: string;
  slaughterhouse: HealthSystemDomainDeviceResultReaderSlaughterhouseViewModel;
}

export interface HealthSystemDomainDeviceResultReadersQueryResult {
  data: HealthSystemDomainDeviceResultReaderViewModel[];
  /** @format int32 */
  page: number;
  /** @format int32 */
  size: number;
  /** @format int64 */
  total: number;
}

/** @format int32 */
export type HealthSystemDomainDigitalTwinModelsAnimalEconomicStatus =
  | 0
  | 1
  | 2
  | 3
  | 4;

export interface HealthSystemDomainDigitalTwinModelsAntibioticImpact {
  activeWithdrawals: HealthSystemDomainDigitalTwinModelsAntibioticWithdrawalDetail[];
  /** @format int32 */
  daysUntilClearance: number;
  /** @format int32 */
  delayDays: number;
  hasActiveWithdrawal: boolean;
  /** @format date-time */
  latestClearanceDate?: string | null;
  /** @format int32 */
  requiredWithdrawalDays: number;
  slaughterDateIncludesWithdrawal: boolean;
}

export interface HealthSystemDomainDigitalTwinModelsAntibioticWithdrawalDetail {
  /** @format date-time */
  clearanceDate: string;
  /** @format date-time */
  injectionDate: string;
  isCleared: boolean;
  supplyName: string;
  /** @format int32 */
  waitingTimeDays: number;
}

export interface HealthSystemDomainDigitalTwinModelsFactorAttribution {
  /** @format double */
  eurImpact: number;
  factor: string;
  /** @format double */
  weightImpactKg: number;
}

export interface HealthSystemDomainDigitalTwinModelsGrowthProjectionPoint {
  /** @format date-time */
  date: string;
  isActual: boolean;
  /** @format double */
  measuredWeightKg?: number | null;
  /** @format double */
  weightKg: number;
}

export interface HealthSystemDomainDigitalTwinModelsLifecycleMilestone {
  /** @format date-time */
  date: string;
  isActual: boolean;
  isEstimated: boolean;
  isPast: boolean;
  phase: string;
  /** @format double */
  weightKg: number;
}

export interface HealthSystemDomainDigitalTwinModelsLifecyclePrediction {
  /** @format uuid */
  animalId: string;
  antibioticImpact: HealthSystemDomainDigitalTwinModelsAntibioticImpact;
  baselineProfile: string;
  birth: HealthSystemDomainDigitalTwinModelsLifecycleMilestone;
  confidenceLevel: string;
  /** @format date-time */
  createdAt: string;
  /** @format double */
  currentADGKgPerDay: number;
  /** @format double */
  currentWeightKg: number;
  dataCompleteness: string;
  /** @format int32 */
  dataPointsUsed: number;
  /** @format int32 */
  daysToSlaughter?: number | null;
  economicForecast: HealthSystemDomainDigitalTwinModelsSlaughterEconomicForecast;
  fitSource: string;
  growthCurve: HealthSystemDomainDigitalTwinModelsGrowthProjectionPoint[];
  modelVersion: string;
  modifiersApplied: string[];
  predictionTier: string;
  /** @format double */
  readinessScore: number;
  slaughterReady: HealthSystemDomainDigitalTwinModelsLifecycleMilestone;
  /** @format double */
  targetWeightKg: number;
  tenWeeks: HealthSystemDomainDigitalTwinModelsLifecycleMilestone;
  warnings: string[];
  weaned: HealthSystemDomainDigitalTwinModelsLifecycleMilestone;
}

export interface HealthSystemDomainDigitalTwinModelsProjectedSlaughterDateResult {
  /** @format uuid */
  animalId: string;
  isEstimated: boolean;
  modelVersion: string;
  /** @format date-time */
  projectedSlaughterDate: string;
}

export interface HealthSystemDomainDigitalTwinModelsSlaughterEconomicForecast {
  /** @format double */
  actualValueEur?: number | null;
  attribution: HealthSystemDomainDigitalTwinModelsFactorAttribution[];
  /** @format double */
  biologicalGapKg: number;
  /** @format double */
  deltaEur?: number | null;
  /** @format double */
  deltaKg?: number | null;
  isReliable: boolean;
  /** @format double */
  lossForecastEur: number;
  /** @format double */
  predictedValueEur: number;
  /** @format double */
  pricePerKgEur: number;
  status: HealthSystemDomainDigitalTwinModelsAnimalEconomicStatus;
  /** @format double */
  totalLossEur?: number | null;
}

export interface HealthSystemDomainDiseasesCommandsCreateDiseaseCommand {
  /** @format int32 */
  daysToTreat: number;
  /** @format double */
  dose: number;
  /** @format uuid */
  medicalSupplyId: string;
  name: string;
  stableColours: HealthSystemDALModelDiseasesStableColour[];
}

export type HealthSystemDomainDiseasesCommandsGetAllDiseasesQuery = object;

export interface HealthSystemDomainDiseasesCommandsRemoveDiseaseCommand {
  /** @format uuid */
  id: string;
}

export interface HealthSystemDomainDiseasesDiseaseViewModel {
  /** @format uuid */
  farmId: string;
  /** @format uuid */
  id: string;
  medicalSupply: HealthSystemDALModelDiseasesDiseaseMedicalSupply;
  name?: string | null;
  stableColours: HealthSystemDALModelDiseasesStableColour[];
}

export interface HealthSystemDomainDocumentsCommandsDeleteFarmDocumentCommand {
  /** @format uuid */
  id: string;
}

export interface HealthSystemDomainDocumentsResultFarmDocumentViewModel {
  /** @format date-time */
  created: string;
  createdBy: string;
  /** @format uuid */
  farmId: string;
  fileName: string;
  /** @format uuid */
  id: string;
  type: HealthSystemDALEnumsExportDocumentType;
}

export interface HealthSystemDomainEmissionSourceUsageEntriesCommandHandlersAddEmissionSourceUsageEntryCommand {
  /** @format double */
  amount: number;
  /** @format date */
  date: string;
  /** @format uuid */
  emissionSourceId: string;
  notes: string;
}

export interface HealthSystemDomainEmissionSourceUsageEntriesCommandHandlersDeleteEmissionSourceUsageEntryCommand {
  /** @format uuid */
  id: string;
}

export interface HealthSystemDomainEmissionSourceUsageEntriesCommandHandlersUpdateEmissionSourceUsageEntryCommand {
  /** @format double */
  amount: number;
  /** @format uuid */
  id: string;
  notes?: string | null;
}

export interface HealthSystemDomainEmissionSourceUsageEntriesViewModelsEmissionSourceUsageEntryViewModel {
  /** @format double */
  co2PerUnit: number;
  /** @format double */
  co2Value: number;
  /** @format double */
  amount: number;
  /** @format date */
  date: string;
  /** @format uuid */
  emissionSourceId: string;
  emissionSourceName: string;
  /** @format uuid */
  id: string;
  notes?: string | null;
  unit: string;
}

export interface HealthSystemDomainEmissionSourcesCommandHandlersCreateEmissionSourceCommand {
  /** @format double */
  co2PerUnit: number;
  name: string;
  sourceRole: HealthSystemDALEnumsEmissionSourceRole;
  unitOfMeasure: string;
}

export interface HealthSystemDomainEmissionSourcesCommandHandlersDeleteEmissionSourceCommand {
  /** @format uuid */
  id: string;
}

export interface HealthSystemDomainEmissionSourcesCommandHandlersUpdateEmissionSourceCommand {
  /** @format double */
  co2PerUnit: number;
  /** @format uuid */
  id: string;
  name: string;
  sourceRole: HealthSystemDALEnumsEmissionSourceRole;
  unitOfMeasure: string;
}

export interface HealthSystemDomainEmissionSourcesViewModelsEmissionSourceViewModel {
  /** @format double */
  co2PerUnit: number;
  /** @format uuid */
  id: string;
  name: string;
  sourceRole: HealthSystemDALEnumsEmissionSourceRole;
  unitOfMeasure: string;
}

export interface HealthSystemDomainFarmsCommandsAuthFarmCommand {
  name: string;
  password: string;
}

export interface HealthSystemDomainFarmsCommandsCreateFarmCommand {
  address?: string | null;
  cultureName?: string | null;
  farmType: HealthSystemDALEnumsFarmType;
  /** @format double */
  latitude?: number | null;
  /** @format double */
  longitude?: number | null;
  metadata: HealthSystemDomainFarmsResultFarmMetadata;
  /** @minLength 1 */
  name: string;
  /** @minLength 1 */
  number: string;
  /** @minLength 1 */
  password: string;
  timezoneId: string;
  users: HealthSystemDomainUsersCommandsCreateUserCommand[];
}

export interface HealthSystemDomainFarmsCommandsUpdateFarmCommand {
  address?: string | null;
  cultureName?: string | null;
  farmType: HealthSystemDALEnumsFarmType;
  /** @format uuid */
  id: string;
  isSoftDeleted: boolean;
  /** @format double */
  latitude?: number | null;
  /** @format double */
  longitude?: number | null;
  metadata: HealthSystemDomainFarmsResultFarmMetadata;
  name?: string | null;
  number: string;
  password?: string | null;
}

export interface HealthSystemDomainFarmsResultFarmAuthResult {
  employee: HealthSystemDomainUsersResultFarmEmployeeViewModel[];
  /** @format uuid */
  farmId: string;
  name?: string | null;
}

export interface HealthSystemDomainFarmsResultFarmMetadata {
  temperatureUnit: HealthSystemDALEnumsTemperatureUnit;
  weightUnit: HealthSystemDALEnumsWeightType;
}

export interface HealthSystemDomainFarmsResultFarmViewModel {
  address?: string | null;
  cultureName?: string | null;
  /** @format uuid */
  farmSettingsId: string;
  /** @format uuid */
  id: string;
  isSoftDeleted: boolean;
  /** @format double */
  latitude?: number | null;
  /** @format double */
  longitude?: number | null;
  metadata: HealthSystemDomainFarmsResultFarmMetadata;
  name?: string | null;
  number?: string | null;
  timezoneId: string;
  type: HealthSystemDALEnumsFarmType;
}

export interface HealthSystemDomainFeedFeedConversionsModelsGestationFeedModel {
  /** @format double */
  averageFeedPerAnimal: number;
  /** @format double */
  averageLitterBirthWeight: number;
  /** @format double */
  feedConversionRatio: number;
  /** @format int32 */
  numberOfAnimals: number;
  /** @format double */
  weight: number;
  weightType: HealthSystemDALEnumsWeightType;
}

export interface HealthSystemDomainFeedFeedConversionsModelsLactationFeedModel {
  /** @format double */
  averageFeedPerAnimal: number;
  /** @format double */
  averageLitterBirthWeight: number;
  /** @format double */
  averageWeanedWeight: number;
  /** @format double */
  feedConversionRatio: number;
  /** @format double */
  netWeightGain: number;
  /** @format int32 */
  numberOfAnimals: number;
  /** @format double */
  weight: number;
  weightType: HealthSystemDALEnumsWeightType;
}

export interface HealthSystemDomainFeedFeedConversionsModelsNurseryFeedModel {
  /** @format double */
  averageFeedPerAnimal: number;
  /** @format double */
  averageTenWeeksWeight: number;
  /** @format double */
  averageWeanedWeight: number;
  /** @format double */
  feedConversionRatio: number;
  /** @format double */
  netWeightGain: number;
  /** @format int32 */
  numberOfAnimals: number;
  /** @format double */
  weight: number;
  weightType: HealthSystemDALEnumsWeightType;
}

export interface HealthSystemDomainFeedFeedConversionsModelsSummaryFeedConversionModel {
  /** @format double */
  averageFeedConversionRatio: number;
  /** @format int32 */
  totalAnimalsCount: number;
  /** @format double */
  totalFeed: number;
  /** @format double */
  totalWeightGain: number;
  weightType: HealthSystemDALEnumsWeightType;
}

export interface HealthSystemDomainFeedFeedSuppliersFeedSupplierViewModel {
  companyAddress?: string | null;
  companyName?: string | null;
  country?: string | null;
  registrationNumber?: string | null;
}

export interface HealthSystemDomainFeedSupplyCommandsCreateFeedBatchResult {
  /** @format double */
  co2ePerKg?: number | null;
  /** @format date-time */
  createdAt: string;
  /** @format date */
  deliveryDate: string;
  feedType: string;
  /** @format uuid */
  id: string;
  /** @format double */
  quantityKg: number;
  source: string;
}

export interface HealthSystemDomainFeedSupplyCommandsCreateFeedSiloResult {
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  id: string;
  isActive: boolean;
  name?: string | null;
  /** @format int32 */
  siloNumber: number;
}

export interface HealthSystemDomainFeedSupplyCommandsCreateFeedSupplierResult {
  companyName: string;
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  id: string;
}

export interface HealthSystemDomainFeedSupplyCommandsUpdateFeedBatchResult {
  /** @format double */
  co2ePerKg?: number | null;
  /** @format date */
  deliveryDate: string;
  feedType: string;
  /** @format uuid */
  id: string;
  /** @format double */
  quantityKg: number;
  /** @format date-time */
  updatedAt: string;
}

export interface HealthSystemDomainFeedSupplyCommandsUpdateFeedSiloResult {
  /** @format uuid */
  id: string;
  isActive: boolean;
  name?: string | null;
  /** @format int32 */
  siloNumber: number;
  /** @format date-time */
  updatedAt: string;
}

export interface HealthSystemDomainFeedSupplyCommandsUpdateFeedSupplierResult {
  companyName: string;
  /** @format uuid */
  id: string;
  /** @format date-time */
  updatedAt: string;
}

export interface HealthSystemDomainFeedSupplyQueriesFeedBatchResult {
  /** @format double */
  co2ePerKg?: number | null;
  /** @format date-time */
  createdAt: string;
  /** @format date */
  deliveryDate: string;
  /** @format uuid */
  feedSiloId: string;
  /** @format uuid */
  feedSupplierId?: string | null;
  feedSupplierName?: string | null;
  /**
   * Available values: Gestation, Lactation, Nursery, Fattening, Other
   * @example "Gestation"
   */
  feedType: string;
  /** @format uuid */
  id: string;
  /** @format double */
  quantityKg: number;
  source: string;
  transportDocRef?: string | null;
}

export interface HealthSystemDomainFeedSupplyQueriesFeedSupplierResult {
  companyName: string;
  contact: HealthSystemDomainValueObjectsContactDto;
  /** @format uuid */
  id: string;
  invoicingAddress: HealthSystemDomainValueObjectsAddressDto;
  legalBusinessRegistration?: string | null;
  physicalAddress: HealthSystemDomainValueObjectsAddressDto;
  registrationNumber?: string | null;
  website?: string | null;
}

export interface HealthSystemDomainFeedSupplyQueriesGetFeedBatchesResult {
  items: HealthSystemDomainFeedSupplyQueriesFeedBatchResult[];
  /** @format int32 */
  pageIndex: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
}

export interface HealthSystemDomainFeedSupplyQueriesGetFeedSuppliersResult {
  items: HealthSystemDomainFeedSupplyQueriesFeedSupplierResult[];
  /** @format int32 */
  pageIndex: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
}

export interface HealthSystemDomainHealthInjectorsCommandsConnectHealthInjectorMetadataDto {
  deviceInfo?: string | null;
  firmwareVersion?: string | null;
}

export interface HealthSystemDomainHealthInjectorsDtosAppEventLogDto {
  applicationType: string | null;
  applicationVersion: string | null;
  /** @format date-time */
  dateTime: string;
  /** @format uuid */
  id: string;
  payload: HealthSystemDomainHealthInjectorsDtosAppEventLogPayloadDto;
  user: HealthSystemDomainHealthInjectorsDtosAppEventLogUserInfoDto;
}

export interface HealthSystemDomainHealthInjectorsDtosAppEventLogPayloadDto {
  action?: string | null;
  additionalInfo?: string | null;
  currentUrl?: string | null;
  isError: boolean;
  message?: string | null;
  stackTrace?: string | null;
}

export interface HealthSystemDomainHealthInjectorsDtosAppEventLogUserDto {
  /** @format uuid */
  farmId: string;
  name?: string | null;
  role?: string | null;
  /** @format uuid */
  userId: string;
  /** @format uuid */
  veterinaryId?: string | null;
}

export interface HealthSystemDomainHealthInjectorsDtosAppEventLogUserInfoDto {
  injector: HealthSystemDomainHealthInjectorsDtosInjectorInfoDto;
  mobile: HealthSystemDomainHealthInjectorsDtosMobileInfoDto;
  requestIpAddress?: string | null;
  user: HealthSystemDomainHealthInjectorsDtosAppEventLogUserDto;
}

export interface HealthSystemDomainHealthInjectorsDtosHealthInjectorActivityMetadataDto {
  deviceInfo?: string | null;
  firmwareVersion?: string | null;
  ipAddress?: string | null;
  previousFirmwareVersion?: string | null;
}

export interface HealthSystemDomainHealthInjectorsDtosHealthInjectorManufacturerDto {
  aluminumCoated?: boolean | null;
  description?: string | null;
  model?: string | null;
  motorType?: string | null;
  /**
   * Available values: Nano, Chainway
   * @example "Nano"
   */
  pcbType?: string | null;
  /** @format int32 */
  rssiDbm?: number | null;
}

export interface HealthSystemDomainHealthInjectorsDtosInjectorInfoDto {
  application?: string | null;
  bluetooth?: string | null;
  bootloader?: string | null;
  macAddress?: string | null;
  name?: string | null;
}

export interface HealthSystemDomainHealthInjectorsDtosMobileInfoDto {
  hardwareModel?: string | null;
  operatingSystemVersion?: string | null;
}

export interface HealthSystemDomainImportResultAcceptedValueGroup {
  field: string;
  values: HealthSystemDomainImportResultAcceptedValueMapping[];
}

export interface HealthSystemDomainImportResultAcceptedValueMapping {
  input: string;
  mapsTo: string;
  numericValue: string;
}

export interface HealthSystemDomainImportResultCsvExampleFormat {
  description: string;
  key: string;
  name: string;
}

export interface HealthSystemDomainImportResultCsvExampleFormatsResponse {
  formats: HealthSystemDomainImportResultCsvExampleFormat[];
}

export interface HealthSystemDomainImportResultDocumentationExample {
  content: string;
  description: string;
  title: string;
}

export interface HealthSystemDomainImportResultImportColumnInfo {
  description: string;
  examples: string[];
  format: string;
  name: string;
}

export interface HealthSystemDomainImportResultImportDataFromCsvFileResult {
  columns: string[];
  /** @format int32 */
  createdCount: number;
  errorMessage?: string | null;
  errors: HealthSystemDomainImportResultValidationItem[];
  fileName: string;
  isSuccess: boolean;
  records: Record<string, string>[];
  /** @format int32 */
  skippedCount: number;
  /** @format int32 */
  totalRecords: number;
  /** @format int32 */
  validRows: number;
  warnings: HealthSystemDomainImportResultValidationItem[];
}

export interface HealthSystemDomainImportResultImportDocumentationResponse {
  acceptedValues: HealthSystemDomainImportResultAcceptedValueGroup[];
  bestPractices: string[];
  description: string;
  errorMessages: string[];
  examples: HealthSystemDomainImportResultDocumentationExample[];
  optionalColumns: HealthSystemDomainImportResultImportColumnInfo[];
  requiredColumns: HealthSystemDomainImportResultImportColumnInfo[];
  title: string;
  validationRules: HealthSystemDomainImportResultValidationRule[];
}

export interface HealthSystemDomainImportResultValidationItem {
  field: string;
  isError: boolean;
  message: string;
  /** @format int32 */
  rowIndex: number;
}

export interface HealthSystemDomainImportResultValidationRule {
  category: string;
  rules: string[];
}

export interface HealthSystemDomainInjectionsCommandsCreateInjectionCommand {
  /** @minLength 1 */
  chipNumber: string;
  /** @format date-time */
  dateTime: string;
  /** @format double */
  dose: number;
  /** @format uuid */
  employeeId: string;
  /** @format uuid */
  id: string;
  lotNumber?: string | null;
  medicalSupplyNumber?: string | null;
  treatmentNumber?: string | null;
}

export interface HealthSystemDomainInjectionsCommandsCreateInjectionModel {
  /** @minLength 1 */
  chipNumber: string;
  /** @format date-time */
  dateTime: string;
  /** @format double */
  dose: number;
  /** @format uuid */
  id: string;
  lotNumber?: string | null;
  medicalSupplyNumber?: string | null;
  treatmentNumber?: string | null;
}

export interface HealthSystemDomainInjectionsCommandsCreateInjectionsBatchCommand {
  /** @format uuid */
  employeeId: string;
  injections: HealthSystemDomainInjectionsCommandsCreateInjectionModel[];
}

export interface HealthSystemDomainInjectionsCommandsCreateOralFeedInjectionCommand {
  /** @format double */
  dose: number;
  /** @format uuid */
  farmSupplyId: string;
  locationsIds: string[];
  /** @format int32 */
  repeatDays: number;
}

export interface HealthSystemDomainInjectionsResultAnimalAgeTrendDataInfo {
  /** @format int32 */
  ageInDays: number;
  /** @format int32 */
  ageInWeeks: number;
  /** @format uuid */
  animalId: string;
  isDead: boolean;
  /** @format uuid */
  supplyId: string;
}

export interface HealthSystemDomainInjectionsResultInjectionHistoryQueryResult {
  data: HealthSystemDomainInjectionsResultInjectionHistoryViewModel[];
  /** @format int32 */
  page: number;
  /** @format int32 */
  size: number;
  /** @format int64 */
  total: number;
}

export interface HealthSystemDomainInjectionsResultInjectionHistoryStrategyViewModel {
  animalType: HealthSystemDALEnumsAnimalType;
  /** @format uuid */
  locationId?: string | null;
  supplyInfo: HealthSystemDomainInjectionsResultSupplyInfo[];
  /** @format int32 */
  weekNumber: number;
  /** @format int32 */
  weekStart?: number | null;
}

export interface HealthSystemDomainInjectionsResultInjectionHistoryTrendDataViewModel {
  animalType: HealthSystemDALEnumsAnimalType;
  trendData: HealthSystemDomainInjectionsResultTrendDataInfo[];
}

export interface HealthSystemDomainInjectionsResultInjectionHistoryViewModel {
  /** @format uuid */
  animalId: string;
  /** @format date-time */
  dateTime: string;
  /** @format int32 */
  dayNumber: number;
  /** @format double */
  dose: number;
  employee: HealthSystemDomainUsersResultUserViewModel;
  /** @format uuid */
  id: string;
  lotNumber?: string | null;
  medicalSupply: HealthSystemDomainMedicalSuppliesResultMedicalSupplyViewModel;
  treatmentNumber?: string | null;
  veterinary: HealthSystemDomainVetsResultVeterinaryViewModel;
  /** @format int32 */
  waitingTime: number;
  /** @format int32 */
  weekNumber: number;
}

export interface HealthSystemDomainInjectionsResultSupplyInfo {
  /** @format double */
  averageAge?: number | null;
  /** @format double */
  averageCCDoseUsed?: number | null;
  /** @format int32 */
  lactatingDay?: number | null;
  /** @format int32 */
  pregnancyDay?: number | null;
  supply: HealthSystemDomainMedicalSuppliesResultMedicalSupplyViewModel;
  /** @format double */
  totalCCDoseUsed?: number | null;
  /** @format int32 */
  totalInjections?: number | null;
}

export interface HealthSystemDomainInjectionsResultTrendDataInfo {
  /** @format int32 */
  animalCount: number;
  /** @format double */
  averageAge?: number | null;
  /** @format int32 */
  diedAnimalCount: number;
  /** @format int32 */
  weekNumber: number;
  /** @format int32 */
  year: number;
}

export interface HealthSystemDomainJobsResultJobReportTableViewModel {
  columns: string[];
  rows: string[][];
}

export interface HealthSystemDomainJobsResultJobReportViewModel {
  tables: HealthSystemDomainJobsResultJobReportTableViewModel[];
}

export interface HealthSystemDomainJobsResultJobRunSummaryViewModel {
  displayName: string;
  /** @format double */
  durationSeconds?: number | null;
  errorMessage?: string | null;
  /** @format date-time */
  finishedAt?: string | null;
  hasResult: boolean;
  /** @format uuid */
  id: string;
  jobName: string;
  outcome: string;
  /** @format date-time */
  startedAt: string;
  trigger: string;
}

export interface HealthSystemDomainLocationCyclesCreateLocationCyclesCommand {
  animalNumbers: string[];
  currentLocationNumber: string;
  /** @format uuid */
  id: string;
  newLocationNumber: string;
}

export interface HealthSystemDomainLocationCyclesResultLocationCycleAnimalViewModel {
  animalNumber: string;
  animalType: HealthSystemDALEnumsAnimalType;
  /** @format date-time */
  dateOfBirth: string;
  gender: HealthSystemDALEnumsAnimalGender;
  /** @format uuid */
  id: string;
}

export interface HealthSystemDomainLocationCyclesResultLocationCyclesSearchPageableQueryResult {
  data: HealthSystemDomainLocationCyclesResultLocationCyclesSearchResult[];
  /** @format int32 */
  page: number;
  /** @format int32 */
  size: number;
  /** @format int64 */
  total: number;
}

export interface HealthSystemDomainLocationCyclesResultLocationCyclesSearchResult {
  /** @format int32 */
  animalTotal: number;
  /** @format int32 */
  cycleNumber: number;
  /** @format date-time */
  endPeriod?: string | null;
  /** @format uuid */
  id: string;
  /** @format date-time */
  startPeriod: string;
}

export interface HealthSystemDomainLocationsCommandsAnimalInLocationViewModel {
  animalType: HealthSystemDALEnumsAnimalType;
  /** @format date-time */
  dateOfBirth: string;
  /** @format int32 */
  daysInLocation: number;
  /** @format date-time */
  enteredAt: string;
  /** @format date-time */
  exitedAt?: string | null;
  /** @format uuid */
  id: string;
  isCurrentlyInLocation: boolean;
  number: string;
  weightAtEntry: HealthSystemDALModelDoubleWeightWithDate;
  weightAtExit: HealthSystemDALModelDoubleWeightWithDate;
}

export interface HealthSystemDomainLocationsCommandsCreateLocationCommand {
  animalType: HealthSystemDALEnumsAnimalType;
  area: HealthSystemDALModelLocationsLocationArea;
  metadata: HealthSystemDomainLocationsResultLocationMetadata;
  number: string;
  pen?: string | null;
  positioning: HealthSystemDALEnumsLocationPosition;
  room?: string | null;
  stable: HealthSystemDALEnumsLocationStableType;
}

export interface HealthSystemDomainLocationsCommandsDiedLocationAnimalCommand {
  /** @format int32 */
  age: number;
  animalType: HealthSystemDALEnumsAnimalType;
  comment?: string | null;
  /** @format uuid */
  diseaseId: string;
  /** @minLength 1 */
  number: string;
}

export interface HealthSystemDomainLocationsCommandsLocationHistoryDateGroupViewModel {
  animals: HealthSystemDomainLocationsCommandsAnimalInLocationViewModel[];
  /** @format date */
  entryDate: string;
}

export interface HealthSystemDomainLocationsCommandsSickAnimalCommand {
  comment?: string | null;
  /** @format int32 */
  count: number;
  /** @format uuid */
  diseaseId: string;
  locationData: HealthSystemDALModelLocationsLocationData;
  number?: string | null;
}

export interface HealthSystemDomainLocationsCommandsUpdateLocationCommand {
  animalType: HealthSystemDALEnumsAnimalType;
  area: HealthSystemDALModelLocationsLocationArea;
  /** @format uuid */
  id: string;
  isSoftDeleted: boolean;
  metadata: HealthSystemDomainLocationsResultLocationMetadata;
  number?: string | null;
  pen?: string | null;
  positioning: HealthSystemDALEnumsLocationPosition;
  room?: string | null;
  stable: HealthSystemDALEnumsLocationStableType;
}

export interface HealthSystemDomainLocationsCommandsUpdateLocationCycleCommand {
  /** @format int32 */
  animalsCount?: number | null;
  locationsIds: string[];
  /** @format date-time */
  startDate: string;
}

export interface HealthSystemDomainLocationsModelsLocationClimateViewModel {
  /** @format double */
  humidity?: number | null;
  sensorData: HealthSystemDomainLocationsModelsSensorData;
  temperature: string;
  temperatureUnit: HealthSystemDALEnumsTemperatureUnit;
  timeSeriesData: HealthSystemDomainLocationsModelsTimeSeriesCollectionsData;
  /** @format int32 */
  windDegree: number;
  windDirection: string;
  windSpeed: string;
}

export interface HealthSystemDomainLocationsModelsSensorData {
  /** @format double */
  co2?: number | null;
  /** @format double */
  nh3?: number | null;
  /** @format double */
  heatStressIndex?: number | null;
  /** @format double */
  humidity?: number | null;
  insideTemperature?: string | null;
}

export interface HealthSystemDomainLocationsModelsTemperatureDayData {
  averageTemperature: string;
  /** @format date */
  date: string;
  hourData: HealthSystemDomainLocationsModelsTemperatureHourData[];
  maxTemperature: string;
  minTemperature: string;
}

export interface HealthSystemDomainLocationsModelsTemperatureHourData {
  temperature: string;
  /** @format date-time */
  time: string;
}

export interface HealthSystemDomainLocationsModelsTimeSeriesCollectionsData {
  co2: HealthSystemDomainLocationsModelsTimeSeriesData;
  nh3: HealthSystemDomainLocationsModelsTimeSeriesData;
  heatStressIndex: HealthSystemDomainLocationsModelsTimeSeriesData;
  humidity: HealthSystemDomainLocationsModelsTimeSeriesData;
  outsideTemperature?:
    | HealthSystemDomainLocationsModelsTemperatureDayData[]
    | null;
  sensorTemperature: HealthSystemDomainLocationsModelsTimeSeriesData;
}

export interface HealthSystemDomainLocationsModelsTimeSeriesData {
  data: HealthSystemDomainLocationsModelsTimeSeriesPoint[];
  /** @format date-time */
  from: string;
  /** @format date-time */
  to: string;
}

export interface HealthSystemDomainLocationsModelsTimeSeriesPoint {
  /** @format double */
  max?: number | null;
  /** @format double */
  min?: number | null;
  /** @format date-time */
  time: string;
  /** @format double */
  value?: number | null;
}

export interface HealthSystemDomainLocationsResultLocationAnimal {
  animalType: HealthSystemDALEnumsAnimalType;
  /** @format date-time */
  dateOfBirth: string;
  /** @format uuid */
  id: string;
  number?: string | null;
}

export interface HealthSystemDomainLocationsResultLocationAnimalsResult {
  animals: HealthSystemDomainLocationsResultLocationAnimal[];
  /** @format uuid */
  locationId: string;
  room?: string | null;
}

export interface HealthSystemDomainLocationsResultLocationHierarchyResult {
  stables: HealthSystemDomainLocationsResultStableGroup[];
}

/** @format int32 */
export type HealthSystemDomainLocationsResultLocationInjectionDataSource =
  | 0
  | 1
  | 2;

export interface HealthSystemDomainLocationsResultLocationMetadata {
  climateDeviceNumber?: string | null;
  climateProvider?: string | null;
}

export interface HealthSystemDomainLocationsResultLocationSearchPageableQueryResult {
  data: HealthSystemDomainLocationsResultLocationViewModel[];
  /** @format int32 */
  page: number;
  /** @format int32 */
  size: number;
  /** @format int64 */
  total: number;
}

export interface HealthSystemDomainLocationsResultLocationSensorDeviceViewModel {
  /** @format uuid */
  id: string;
  /** @format date-time */
  lastSeenAt?: string | null;
  measuredTags: string[];
  name: string;
}

export interface HealthSystemDomainLocationsResultLocationViewModel {
  animalType: HealthSystemDALEnumsAnimalType;
  /** @format int32 */
  animalsCount?: number | null;
  area: HealthSystemDALModelLocationsLocationArea;
  /** @format int32 */
  averageAge?: number | null;
  /** @format date-time */
  cycleStartDate?: string | null;
  farm: HealthSystemDomainFarmsResultFarmViewModel;
  /** @format uuid */
  farmId: string;
  hasSensorDevice: boolean;
  /** @format uuid */
  id: string;
  injectionDataSource: HealthSystemDomainLocationsResultLocationInjectionDataSource;
  isAreaCompliant: boolean;
  isSoftDeleted: boolean;
  metadata: HealthSystemDomainLocationsResultLocationMetadata;
  number?: string | null;
  pen?: string | null;
  positioning: HealthSystemDALEnumsLocationPosition;
  room?: string | null;
  sensorDevice: HealthSystemDomainLocationsResultLocationSensorDeviceViewModel;
  stable: HealthSystemDALEnumsLocationStableType;
}

export interface HealthSystemDomainLocationsResultRoomGroup {
  locations: HealthSystemDomainLocationsResultLocationViewModel[];
  room?: string | null;
}

export interface HealthSystemDomainLocationsResultStableGroup {
  rooms: HealthSystemDomainLocationsResultRoomGroup[];
  stable: HealthSystemDALEnumsLocationStableType;
}

export interface HealthSystemDomainMedicalSuppliesCommandsCompleteMedicalSupplyOrderCommand {
  items: HealthSystemDomainMedicalSuppliesCommandsCompleteMedicalSupplyOrderItem[];
  /** @format uuid */
  orderId: string;
}

export interface HealthSystemDomainMedicalSuppliesCommandsCompleteMedicalSupplyOrderItem {
  delivered: boolean;
  /** @format date-time */
  expire?: string | null;
  /** @format uuid */
  id: string;
  /** @format int32 */
  realAmount: number;
}

export interface HealthSystemDomainMedicalSuppliesCommandsCreateFarmMedicalSupplyCommand {
  /** @format double */
  inStock: number;
  /** @format uuid */
  medicalSupplyId: string;
}

export interface HealthSystemDomainMedicalSuppliesCommandsCreateMedicalSupplyBottleCommand {
  animalType: HealthSystemDALEnumsAnimalType;
  /** @format double */
  ccPerDose?: number | null;
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  daysToUse: number;
  /** @format double */
  dosePerAnimal?: number | null;
  /** @format double */
  incrementStep: number;
  /** @format double */
  kgPerOneCC?: number | null;
  /** @minLength 1 */
  lotNumber: string;
  /** @format double */
  maxVolumeCC: number;
  /** @format uuid */
  medicalSupplyId: string;
  /** @format double */
  minVolumeCC: number;
  /** @format int32 */
  size: number;
  /** @format double */
  startVolume: number;
  treatmentNumber?: string | null;
}

export interface HealthSystemDomainMedicalSuppliesCommandsCreateMedicalSupplyCommand {
  method: HealthSystemDALEnumsMedicalSupplyMethod;
  /** @minLength 1 */
  number: string;
  /** @minLength 1 */
  producer: string;
  registrationNumber?: string | null;
  supplyType: HealthSystemDALEnumsMedicalSupplyType;
  /** @format int32 */
  waitingTime: number;
}

export interface HealthSystemDomainMedicalSuppliesCommandsCreateMedicalSupplyOrderCommand {
  details: HealthSystemDomainMedicalSuppliesCommandsCreateMedicalSupplyOrderDetails;
  items: HealthSystemDomainMedicalSuppliesCommandsCreateMedicalSupplyOrderItem[];
}

export interface HealthSystemDomainMedicalSuppliesCommandsCreateMedicalSupplyOrderDetails {
  comments?: string | null;
}

export interface HealthSystemDomainMedicalSuppliesCommandsCreateMedicalSupplyOrderItem {
  /** @format int32 */
  amount: number;
  /** @format uuid */
  bottleId: string;
  details: HealthSystemDALModelMedicalSuppliesMedicalSupplyOrderItemDetails;
  locations: HealthSystemDALModelMedicalSuppliesMedicalSupplyOrderItemLocation[];
  symptoms?: string | null;
}

export type HealthSystemDomainMedicalSuppliesCommandsGetAllMedicalSuppliesCommand =
  object;

export interface HealthSystemDomainMedicalSuppliesCommandsMedicalSupplyBottleVisibilityCommand {
  /** @format uuid */
  id: string;
  isHidden: boolean;
}

export interface HealthSystemDomainMedicalSuppliesCommandsMedicalSupplyOrderConfirmCommand {
  animalsVaccinability: boolean;
  items: HealthSystemDomainMedicalSuppliesResultMedicalSupplyOrderItemViewModel[];
  /** @format uuid */
  orderId: string;
  successTreatment: boolean;
  successVaccination: boolean;
}

export interface HealthSystemDomainMedicalSuppliesCommandsUpdateFarmMedicalSupplyCommand {
  /** @format uuid */
  farmMedicalSupplyId: string;
  /** @format double */
  inStock: number;
}

export interface HealthSystemDomainMedicalSuppliesQueryUpdateLabelPrintTaskStatusCommand {
  /** @format uuid */
  id: string;
  message?: any | null;
  overriddenLotNumber?: string | null;
  overriddenTreatmentNumber?: string | null;
  /** @format int32 */
  printedCount: number;
  status: HealthSystemDALEnumsLabelPrintTaskStatus;
}

export interface HealthSystemDomainMedicalSuppliesResultFarmMedicalSupplyViewModel {
  animalType: HealthSystemDALEnumsAnimalType;
  /** @format double */
  ccPerDose?: number | null;
  /** @format uuid */
  farmId: string;
  /** @format uuid */
  id: string;
  /** @format double */
  inStock: number;
  isSoftDeleted: boolean;
  /** @format double */
  kgPerOneCC?: number | null;
  /** @format date-time */
  lastUsedAt?: string | null;
  /** @format uuid */
  medicalSupplyId: string;
  method: HealthSystemDALEnumsMedicalSupplyMethod;
  number?: string | null;
  producer?: string | null;
  registrationNumber?: string | null;
  supplyType: HealthSystemDALEnumsMedicalSupplyType;
  /** @format int32 */
  waitingTime: number;
}

export interface HealthSystemDomainMedicalSuppliesResultMedicalSupplyBottleViewModel {
  animalType: HealthSystemDALEnumsAnimalType;
  /** @format double */
  ccPerDose?: number | null;
  /** @format date-time */
  created?: string | null;
  /** @format int32 */
  daysToUse: number;
  /** @format double */
  dosePerAnimal?: number | null;
  /** @format uuid */
  id: string;
  /** @format double */
  incrementStep: number;
  isHidden: boolean;
  /** @format double */
  kgPerOneCC?: number | null;
  /** @format date-time */
  lastOrderDate?: string | null;
  /** @format date-time */
  lastUsedAt?: string | null;
  lotNumber?: string | null;
  /** @format double */
  maxVolumeCC: number;
  medicalSupply: HealthSystemDomainMedicalSuppliesResultMedicalSupplyViewModel;
  /** @format double */
  minVolumeCC: number;
  registrationNumber?: string | null;
  /** @format int32 */
  size: number;
  /** @format double */
  startVolume: number;
  treatmentNumber?: string | null;
  /** @format uuid */
  veterinaryId: string;
}

export interface HealthSystemDomainMedicalSuppliesResultMedicalSupplyOrderItemViewModel {
  /** @format int32 */
  amount: number;
  delivered: boolean;
  details: HealthSystemDALModelMedicalSuppliesMedicalSupplyOrderItemDetails;
  /** @format uuid */
  id: string;
  locations: HealthSystemDALModelMedicalSuppliesMedicalSupplyOrderItemLocation[];
  medicalSupplyBottle: HealthSystemDomainMedicalSuppliesResultMedicalSupplyBottleViewModel;
  /** @format uuid */
  medicalSupplyOrderId: string;
  /** @format int32 */
  realAmount: number;
}

export interface HealthSystemDomainMedicalSuppliesResultMedicalSupplyOrderViewModel {
  /** @format date-time */
  completed?: string | null;
  confirmation: HealthSystemDALModelMedicalSuppliesMedicalSupplyOrderConfirmation;
  /** @format date-time */
  created: string;
  details: HealthSystemDALModelMedicalSuppliesMedicalSupplyOrderDetails;
  /** @format uuid */
  farmId: string;
  /** @format uuid */
  id: string;
  items: HealthSystemDomainMedicalSuppliesResultMedicalSupplyOrderItemViewModel[];
  /** @format int32 */
  number: number;
  status: HealthSystemDALEnumsMedicalSupplyOrderStatus;
}

export interface HealthSystemDomainMedicalSuppliesResultMedicalSupplyViewModel {
  /** @format double */
  ccPerDose?: number | null;
  /** @format uuid */
  id: string;
  isSoftDeleted: boolean;
  /** @format double */
  kgPerOneCC?: number | null;
  /** @format date-time */
  lastUsedAt?: string | null;
  method: HealthSystemDALEnumsMedicalSupplyMethod;
  number?: string | null;
  producer?: string | null;
  registrationNumber?: string | null;
  supplyType: HealthSystemDALEnumsMedicalSupplyType;
  /** @format int32 */
  waitingTime: number;
}

export interface HealthSystemDomainMedicalSuppliesResultMedicationMatrixAnimalTypeViewModel {
  animalType: HealthSystemDALEnumsAnimalType;
  /** @format double */
  ccPerKg?: number | null;
  /** @format int32 */
  withdrawalDays?: number | null;
}

export interface HealthSystemDomainMedicalSuppliesResultMedicationMatrixSupplyViewModel {
  animalTypes: HealthSystemDomainMedicalSuppliesResultMedicationMatrixAnimalTypeViewModel[];
  /** @format uuid */
  id: string;
  method: HealthSystemDALEnumsMedicalSupplyMethod;
  number?: string | null;
  producer?: string | null;
  registrationNumber?: string | null;
  supplyType: HealthSystemDALEnumsMedicalSupplyType;
}

export interface HealthSystemDomainMedicalSuppliesResultVeterinaryOrderViewModel {
  /** @format date-time */
  completed?: string | null;
  confirmation: HealthSystemDALModelMedicalSuppliesMedicalSupplyOrderConfirmation;
  /** @format date-time */
  created: string;
  details: HealthSystemDALModelMedicalSuppliesMedicalSupplyOrderDetails;
  /** @format uuid */
  farmId: string;
  farmName?: string | null;
  /** @format uuid */
  id: string;
  items: HealthSystemDomainMedicalSuppliesResultMedicalSupplyOrderItemViewModel[];
  /** @format int32 */
  number: number;
  status: HealthSystemDALEnumsMedicalSupplyOrderStatus;
}

export interface HealthSystemDomainMedicationsCommandsImportMedicationRejection {
  internalCodes: number[];
  reason: string;
  shortName: string;
}

export interface HealthSystemDomainMedicationsCommandsImportMedicationsResult {
  /** @format int32 */
  medicationsCreated: number;
  /** @format int32 */
  medicationsUpdated: number;
  /** @format int32 */
  packsCreated: number;
  /** @format int32 */
  packsUpdated: number;
  rejected: HealthSystemDomainMedicationsCommandsImportMedicationRejection[];
  /** @format int32 */
  substancesWritten: number;
  /** @format int32 */
  withdrawalConflictsResolved: number;
  /** @format int32 */
  withdrawalPeriodsRemoved: number;
  /** @format int32 */
  withdrawalPeriodsWritten: number;
}

export interface HealthSystemDomainMedicationsQueriesGetMedicationsResult {
  items: HealthSystemDomainMedicationsQueriesMedicationResult[];
  /** @format int32 */
  pageIndex: number;
  /** @format int32 */
  pageSize: number;
  /** @format int32 */
  totalCount: number;
}

export interface HealthSystemDomainMedicationsQueriesMedicationPackResult {
  eanCode?: string | null;
  /** @format uuid */
  id: string;
  /** @format int64 */
  internalCode: number;
  packaging?: string | null;
  /** @format double */
  packagingCount?: number | null;
  producer?: string | null;
  productName: string;
  registrationNumber: string;
}

export interface HealthSystemDomainMedicationsQueriesMedicationResult {
  atcCodes?: string | null;
  channelling?: string | null;
  dosageForm?: string | null;
  hasUnestablishedWithdrawalPeriod: boolean;
  /** @format uuid */
  id: string;
  officialName: string;
  packs: HealthSystemDomainMedicationsQueriesMedicationPackResult[];
  route?: string | null;
  shortName: string;
  source: string;
  /** @format int32 */
  sourceVersion?: number | null;
  substances: HealthSystemDomainMedicationsQueriesMedicationSubstanceResult[];
  /** @format date-time */
  verifiedAt?: string | null;
  withdrawalPeriods: HealthSystemDomainMedicationsQueriesMedicationWithdrawalPeriodResult[];
}

export interface HealthSystemDomainMedicationsQueriesMedicationSubstanceResult {
  /** @format double */
  amount?: number | null;
  dosageForm?: string | null;
  /** @format uuid */
  id: string;
  name: string;
  unit?: string | null;
}

export interface HealthSystemDomainMedicationsQueriesMedicationWithdrawalPeriodResult {
  animalType: HealthSystemDALEnumsAnimalType;
  complexText?: string | null;
  /** @format int32 */
  days?: number | null;
  daysRaw: string;
  /** @format uuid */
  id: string;
  isComplex: boolean;
  /** @format int32 */
  sourceGroupId: number;
  sourceGroupLabel: string;
}

export interface HealthSystemDomainMortalityReasonsCommandsCreateMortalityReasonCommand {
  name: string;
  stableColours: HealthSystemDALModelDiseasesStableColour[];
}

export type HealthSystemDomainMortalityReasonsCommandsGetAllMortalityReasonsQuery =
  object;

export interface HealthSystemDomainMortalityReasonsCommandsRemoveMortalityReasonCommand {
  /** @format uuid */
  id: string;
}

export interface HealthSystemDomainMortalityReasonsMortalityReasonViewModel {
  /** @format uuid */
  farmId: string;
  /** @format uuid */
  id: string;
  name?: string | null;
  stableColours: HealthSystemDALModelDiseasesStableColour[];
}

export interface HealthSystemDomainNotificationRulesCommandCreateNotificationRuleCommand {
  emailSettings: HealthSystemDALModelNotificationRulesEmailSettings;
  periodData: HealthSystemDomainNotificationRulesCommandValidationPeriodDataForCreation;
  ruleData: HealthSystemDomainNotificationRulesCommandRuleDataForCreation;
  ruleType: HealthSystemDALEnumsRuleType;
}

export interface HealthSystemDomainNotificationRulesCommandCreateNotificationRulesCommand {
  /** @minItems 1 */
  notificationRules: HealthSystemDomainNotificationRulesCommandCreateNotificationRuleCommand[];
}

export interface HealthSystemDomainNotificationRulesCommandLungWeatherRuleDataForCreation {
  animalType: HealthSystemDALEnumsAnimalType;
  /** @format uuid */
  farmDiseaseId: string;
  /** @format uuid */
  farmMedicalSupplyId?: string | null;
  /**
   * @format int32
   * @min 2
   * @max 16
   */
  forecastDays?: number | null;
  isLactating?: boolean | null;
  isPregnant?: boolean | null;
  /**
   * @format int32
   * @min 1
   * @max 30
   */
  lookbackDays?: number | null;
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  peakThreshold: number;
  sensitivity?: string | null;
}

export interface HealthSystemDomainNotificationRulesCommandMinRegAnimalsRuleDataForCreation {
  animalType: HealthSystemDALEnumsAnimalType;
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  minRegistered: number;
}

export interface HealthSystemDomainNotificationRulesCommandNumRuleDataForCreation {
  animalType: HealthSystemDALEnumsAnimalType;
  /** @format uuid */
  farmDiseaseId?: string | null;
  /** @format uuid */
  farmMedicalSupplyId?: string | null;
  isLactating?: boolean | null;
  isPregnant?: boolean | null;
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  minInjected: number;
}

export interface HealthSystemDomainNotificationRulesCommandPercentageRuleDataForCreation {
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  ageFrom: number;
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  ageTill: number;
  animalType: HealthSystemDALEnumsAnimalType;
  /** @format uuid */
  farmDiseaseId?: string | null;
  /** @format uuid */
  farmMedicalSupplyId?: string | null;
  isLactating?: boolean | null;
  isPregnant?: boolean | null;
  /**
   * @format double
   * @min 0.001
   * @max 100
   */
  percentage: number;
}

export interface HealthSystemDomainNotificationRulesCommandRuleDataForCreation {
  lungWeatherRuleData: HealthSystemDomainNotificationRulesCommandLungWeatherRuleDataForCreation;
  minRegAnimalsRuleData: HealthSystemDomainNotificationRulesCommandMinRegAnimalsRuleDataForCreation;
  numRuleData: HealthSystemDomainNotificationRulesCommandNumRuleDataForCreation;
  percentageRuleData: HealthSystemDomainNotificationRulesCommandPercentageRuleDataForCreation;
}

export interface HealthSystemDomainNotificationRulesCommandUpdateNotificationRuleCommand {
  emailSettings: HealthSystemDALModelNotificationRulesEmailSettings;
  /** @format uuid */
  id: string;
  periodData: HealthSystemDomainNotificationRulesCommandValidationPeriodDataForCreation;
  ruleData: HealthSystemDomainNotificationRulesCommandRuleDataForCreation;
  ruleType: HealthSystemDALEnumsRuleType;
}

export interface HealthSystemDomainNotificationRulesCommandUpdateNotificationRulesCommand {
  /** @minItems 1 */
  notificationRules: HealthSystemDomainNotificationRulesCommandUpdateNotificationRuleCommand[];
}

export interface HealthSystemDomainNotificationRulesCommandValidationPeriodDataForCreation {
  weeksData: HealthSystemDomainNotificationRulesCommandWeeksDataForCreation;
}

export interface HealthSystemDomainNotificationRulesCommandWeeksDataForCreation {
  dayOfWeek: SystemDayOfWeek;
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  weekCount: number;
}

export interface HealthSystemDomainNotificationRulesResultEmailSettingsViewModel {
  userIds: string[];
  users: HealthSystemDomainUsersResultUserViewModel[];
}

export interface HealthSystemDomainNotificationRulesResultLungWeatherRuleDataViewModel {
  animalType: HealthSystemDALEnumsAnimalType;
  farmDisease: HealthSystemDomainDiseasesDiseaseViewModel;
  /** @format uuid */
  farmDiseaseId?: string | null;
  farmMedicalSupply: HealthSystemDomainMedicalSuppliesResultFarmMedicalSupplyViewModel;
  /** @format uuid */
  farmMedicalSupplyId?: string | null;
  /** @format int32 */
  forecastDays: number;
  isLactating?: boolean | null;
  isPregnant?: boolean | null;
  /** @format int32 */
  lookbackDays: number;
  /** @format int32 */
  peakThreshold: number;
  sensitivity?: string | null;
}

export interface HealthSystemDomainNotificationRulesResultMinRegAnimalsRuleDataViewModel {
  animalType: HealthSystemDALEnumsAnimalType;
  /** @format int32 */
  minRegistered: number;
}

export interface HealthSystemDomainNotificationRulesResultNotificationRuleViewModel {
  /** @format date-time */
  created: string;
  emailSettings: HealthSystemDomainNotificationRulesResultEmailSettingsViewModel;
  /** @format uuid */
  farmId: string;
  /** @format uuid */
  id: string;
  isDisabled: boolean;
  /** @format date-time */
  lastForecastMatchedAt?: string | null;
  /** @format date-time */
  lastTimeValidated?: string | null;
  periodData: HealthSystemDALModelNotificationRulesValidationPeriodData;
  ruleData: HealthSystemDomainNotificationRulesResultRuleDataViewModel;
  ruleType: HealthSystemDALEnumsRuleType;
  /** @format date-time */
  updated?: string | null;
  validationPeriodType: HealthSystemDALModelNotificationRulesValidationPeriodType;
}

export interface HealthSystemDomainNotificationRulesResultNumRuleDataViewModel {
  animalType: HealthSystemDALEnumsAnimalType;
  farmDisease: HealthSystemDomainDiseasesDiseaseViewModel;
  /** @format uuid */
  farmDiseaseId?: string | null;
  farmMedicalSupply: HealthSystemDomainMedicalSuppliesResultFarmMedicalSupplyViewModel;
  /** @format uuid */
  farmMedicalSupplyId?: string | null;
  isLactating?: boolean | null;
  isPregnant?: boolean | null;
  /** @format int32 */
  minInjected: number;
}

export interface HealthSystemDomainNotificationRulesResultPercentageRuleDataViewModel {
  /** @format int32 */
  ageFrom: number;
  /** @format int32 */
  ageTill: number;
  animalType: HealthSystemDALEnumsAnimalType;
  farmDisease: HealthSystemDomainDiseasesDiseaseViewModel;
  /** @format uuid */
  farmDiseaseId?: string | null;
  farmMedicalSupply: HealthSystemDomainMedicalSuppliesResultFarmMedicalSupplyViewModel;
  /** @format uuid */
  farmMedicalSupplyId?: string | null;
  isLactating?: boolean | null;
  isPregnant?: boolean | null;
  /** @format double */
  percentage: number;
}

export interface HealthSystemDomainNotificationRulesResultRuleDataViewModel {
  lungWeatherRuleData: HealthSystemDomainNotificationRulesResultLungWeatherRuleDataViewModel;
  minRegAnimalsRuleData: HealthSystemDomainNotificationRulesResultMinRegAnimalsRuleDataViewModel;
  numRuleData: HealthSystemDomainNotificationRulesResultNumRuleDataViewModel;
  percentageRuleData: HealthSystemDomainNotificationRulesResultPercentageRuleDataViewModel;
}

export interface HealthSystemDomainNotificationsResultNotificationViewModel {
  /** @format date-time */
  dateTime: string;
  /** @format uuid */
  farmId: string;
  /** @format uuid */
  id: string;
  info?: string | null;
  isViewed: boolean;
  message?: string | null;
}

export interface HealthSystemDomainNotificationsViewNotificationsCommand {
  ids: string[];
}

export interface HealthSystemDomainReportsResultScheduledReportSourceSnapshot {
  name: string;
  query: any;
  /** @format uuid */
  savedSearchId?: string | null;
}

export interface HealthSystemDomainSavedComparisonQueriesSavedComparisonResult {
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  createdByUserId: string;
  /** @format uuid */
  farmId: string;
  /** @format uuid */
  id: string;
  name: string;
  query: any;
}

export interface HealthSystemDomainSettingsCreateEventLogCommand {
  application: HealthSystemDALModelLogAppEventLogApplication;
  /** @format date-time */
  dateTime: string;
  /** @format uuid */
  healthInjectorId?: string | null;
  /** @format uuid */
  id: string;
  isAnalyzed: boolean;
  payload: HealthSystemDALModelLogAppEventLogPayload;
  processMessage?: string | null;
  userInfo: HealthSystemDALModelLogAppEventLogUserInfo;
}

export interface HealthSystemDomainSettingsCreateTranslationCommand {
  isoCode: string;
  language: string;
}

export type HealthSystemDomainSettingsFarmSettingsQuery = object;

export interface HealthSystemDomainSettingsResultAnimalCapacityViewModel {
  /** @format int32 */
  calf: number;
  /** @format int32 */
  cow: number;
  /** @format int32 */
  fattening: number;
  /** @format int32 */
  gilt: number;
  /** @format int32 */
  goat: number;
  /** @format int32 */
  piglet: number;
  /** @format int32 */
  sow: number;
}

export interface HealthSystemDomainSettingsResultConfigViewModel {
  /** @format date-time */
  serverTime: string;
  /** @format date-time */
  serverTimeUtc: string;
  user?: string | null;
  version?: string | null;
}

export interface HealthSystemDomainSettingsResultFarmSettingsViewModel {
  contacts: HealthSystemDALModelFarmsFarmSettingsContact[];
  dashboardBarChartSettings: HealthSystemDALModelFarmsBarChartData[];
  /** @format uuid */
  farmId: string;
  farmType: HealthSystemDALEnumsFarmType;
  options: HealthSystemDALModelFarmsFarmSettingsOptions;
  timeZoneId: string;
}

export interface HealthSystemDomainSettingsResultHoldingRoomLocationViewModel {
  animalType: HealthSystemDALEnumsAnimalType;
  /** @format uuid */
  id: string;
  number: string;
  pen?: string | null;
  room?: string | null;
  stable: HealthSystemDALEnumsLocationStableType;
}

export interface HealthSystemDomainSettingsResultTranslationViewModel {
  /** @format uuid */
  id: string;
  isoCode: string;
  language: string;
  /** @format date-time */
  updated?: string | null;
}

export interface HealthSystemDomainSettingsUpdateFarmSettingsCommand {
  barChartData?: HealthSystemDALModelFarmsBarChartData[] | null;
  contacts: HealthSystemDALModelFarmsFarmSettingsContact[];
  options: HealthSystemDALModelFarmsFarmSettingsOptions;
  timeZoneId?: string | null;
}

export interface HealthSystemDomainSettingsUpdateTranslationCommand {
  /** @format uuid */
  id: string;
  language: string;
  translations: string;
}

export interface HealthSystemDomainSlaughterPreparationsResultPreOrderDetailsViewModel {
  /** @format int32 */
  amount: number;
  answers: Record<string, boolean | null>;
  /** @format date-time */
  createdAt: string;
  createdBy: string;
  feedSuppliers: HealthSystemDALModelSlaughterPreDeliveriesPreDeliveryFeedSupplier[];
  pigletsSuppliers: HealthSystemDALModelSlaughterPreDeliveriesPigletSupplier[];
  veterinaryAdress?: string | null;
  veterinaryPracticeName?: string | null;
}

export interface HealthSystemDomainSlaughterPreparationsResultPreOrdersSummariesViewModel {
  /** @format int32 */
  amount: number;
  /** @format date-time */
  createdAt: string;
  createdBy?: string | null;
  /** @format uuid */
  id: string;
  /** @format int32 */
  weekOfTheYear: number;
}

export interface HealthSystemDomainSlaughterPreparationsResultSlaughterPreparationViewModel {
  /** @format int32 */
  eligibleAnimalsCount: number;
  previousFeedSuppliers?:
    | HealthSystemDALModelSlaughterPreDeliveriesPreDeliveryFeedSupplier[]
    | null;
  previousPigletsSuppliers?:
    | HealthSystemDALModelSlaughterPreDeliveriesPigletSupplier[]
    | null;
  veterinaryAdress?: string | null;
  /** @format uuid */
  veterinaryId?: string | null;
  veterinaryPracticeName?: string | null;
}

export interface HealthSystemDomainSlaughterPreparationsSlaughterPreDeliveryCommand {
  /** @format int32 */
  amount: number;
  answers: Record<string, boolean | null>;
  /** @format date-time */
  createdAt: string;
  feedSuppliers: HealthSystemDALModelSlaughterPreDeliveriesPreDeliveryFeedSupplier[];
  pigletsSuppliers: HealthSystemDALModelSlaughterPreDeliveriesPigletSupplier[];
  /** @format uuid */
  veterinaryId?: string | null;
}

export interface HealthSystemDomainSlaughterhouseCommandsCreateSlaughterhouseResult {
  /** @format uuid */
  id: string;
}

export interface HealthSystemDomainSlaughterhouseModelsSlaughterhouseApiKeyViewModel {
  /** @format date-time */
  createdAt: string;
  description?: string | null;
  /** @format date-time */
  expiresAt?: string | null;
  /** @format uuid */
  id: string;
  isActive: boolean;
  /** @format date-time */
  lastUsedAt?: string | null;
  name: string;
}

export interface HealthSystemDomainSlaughterhouseModelsSlaughterhouseListResult {
  data: HealthSystemDomainSlaughterhouseModelsSlaughterhouseViewModel[];
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  /** @format int32 */
  page: number;
  /** @format int32 */
  size: number;
  /** @format int64 */
  total: number;
  /** @format int32 */
  totalPages: number;
}

export interface HealthSystemDomainSlaughterhouseModelsSlaughterhouseViewModel {
  address?: string | null;
  apiKeys: HealthSystemDomainSlaughterhouseModelsSlaughterhouseApiKeyViewModel[];
  code?: string | null;
  contactEmail?: string | null;
  contactPhone?: string | null;
  /** @format uuid */
  id: string;
  isActive: boolean;
  name: string;
}

export interface HealthSystemDomainTaskLibraryCommandCreateTaskScheduleViewModel {
  dayOfWeek: SystemDayOfWeek;
  /** @format uuid */
  employeeId?: string | null;
  /** @format uuid */
  id: string;
  stable: HealthSystemDALEnumsLocationStableType;
  /** @format time */
  startOfWorkingDay?: string | null;
  taskItems: HealthSystemDomainTaskLibraryResultTaskTemplateViewModel[];
  /** @format int32 */
  weekCycle: number;
}

export interface HealthSystemDomainTaskLibraryCommandUpsertTaskScheduleCommand {
  lists: Record<
    string,
    HealthSystemDomainTaskLibraryCommandCreateTaskScheduleViewModel
  >;
  stable: HealthSystemDALEnumsLocationStableType;
  /** @format int32 */
  weekCycle: number;
}

export interface HealthSystemDomainTaskLibraryCommandUpsertTaskTemplateCommand {
  attachments: HealthSystemDomainTaskLibraryCommandUpsertTaskTemplateCommandAttachmentDto[];
  duration?: string | null;
  durationUnit?: string | null;
  /** @format uuid */
  id?: string | null;
  instructions?: string | null;
  name: string;
  scheduled?: string | null;
  stables: HealthSystemDALEnumsLocationStableType[];
}

export interface HealthSystemDomainTaskLibraryCommandUpsertTaskTemplateCommandAttachmentDto {
  blobUrl: string;
  contentType: string;
  fileName: string;
  /** @format int64 */
  fileSizeBytes: number;
}

export interface HealthSystemDomainTaskLibraryResultTaskOccurrenceViewModel {
  /** @format date-time */
  completedAt?: string | null;
  /** @format date-time */
  created: string;
  employee: HealthSystemDomainUsersResultUserViewModel;
  /** @format uuid */
  farmId: string;
  /** @format uuid */
  id: string;
  items: HealthSystemDALModelTaskLibraryTaskPlanTaskOccurrenceItem[];
  /** @format date */
  plannedDate: string;
  stable: HealthSystemDALEnumsLocationStableType;
  /** @format date-time */
  startedAt?: string | null;
  status: HealthSystemDALEnumsTaskListStatus;
  /** @format uuid */
  taskScheduleId: string;
}

export interface HealthSystemDomainTaskLibraryResultTaskScheduleViewModel {
  dayOfWeek: SystemDayOfWeek;
  /** @format uuid */
  employeeId?: string | null;
  /** @format uuid */
  id: string;
  stable: HealthSystemDALEnumsLocationStableType;
  /** @format time */
  startOfWorkingDay?: string | null;
  taskItems: HealthSystemDomainTaskLibraryResultTaskTemplateViewModel[];
  /** @format int32 */
  weekCycle: number;
}

export interface HealthSystemDomainTaskLibraryResultTaskTemplateAttachmentViewModel {
  blobUrl: string;
  contentType: string;
  /** @format date-time */
  createdAt: string;
  fileName: string;
  /** @format int64 */
  fileSizeBytes: number;
  /** @format uuid */
  id: string;
}

export interface HealthSystemDomainTaskLibraryResultTaskTemplateViewModel {
  attachments: HealthSystemDomainTaskLibraryResultTaskTemplateAttachmentViewModel[];
  /** @format date-time */
  created: string;
  duration?: string | null;
  durationUnit?: string | null;
  /** @format uuid */
  id: string;
  instructions?: string | null;
  name?: string | null;
  scheduled?: string | null;
  stables: HealthSystemDALEnumsLocationStableType[];
  /** @format uuid */
  taskLibraryId?: string | null;
  type: HealthSystemDALModelTaskLibraryTaskSchedulesTaskLibraryListType;
  vaccinationRule: HealthSystemDomainVaccinationRulesResultVaccinationRuleViewModel;
  /** @format uuid */
  vaccinationRuleId?: string | null;
}

export interface HealthSystemDomainTaskLibraryResultUserTaskOccurrencesViewModel {
  employee: HealthSystemDomainUsersResultUserViewModel;
  occurrences: HealthSystemDomainTaskLibraryResultTaskOccurrenceViewModel[];
}

export interface HealthSystemDomainTaskListsCommandCreateTaskListCommand {
  animalType: HealthSystemDALEnumsAnimalType;
  sickOnly: boolean;
  stableType: HealthSystemDALEnumsLocationStableType;
}

export interface HealthSystemDomainTaskListsCommandCreateTaskListRuleCommand {
  /** @format int32 */
  ageFrom: number;
  /** @format int32 */
  ageTo: number;
  animalType: HealthSystemDALEnumsAnimalType;
  /** @format double */
  dose: number;
  isGast: boolean;
  isLactating: boolean;
  isPregnant: boolean;
  /** @format uuid */
  medicalSupplyId: string;
}

export interface HealthSystemDomainTaskListsCommandFinishTaskListCommand {
  /** @format uuid */
  id: string;
}

export interface HealthSystemDomainTaskListsCommandRemoveTaskListRuleCommand {
  /** @format uuid */
  id: string;
}

export interface HealthSystemDomainTaskListsCommandStartTaskListCommand {
  /** @format uuid */
  id: string;
}

export interface HealthSystemDomainTaskListsCommandTaskListItemCommand {
  /** @format uuid */
  id: string;
  subtasks: HealthSystemDomainTaskListsCommandTaskListSubtaskCommand[];
}

export interface HealthSystemDomainTaskListsCommandTaskListSubtaskCommand {
  completed: boolean;
  /** @format double */
  completedDose: number;
  /** @format uuid */
  id: string;
}

export interface HealthSystemDomainTaskListsCommandUpdateTaskListCommand {
  /** @format uuid */
  id: string;
  taskListItems: HealthSystemDomainTaskListsCommandTaskListItemCommand[];
}

export interface HealthSystemDomainTaskListsResultTaskListRuleViewModel {
  /** @format int32 */
  ageFrom: number;
  /** @format int32 */
  ageTo: number;
  animalType: HealthSystemDALEnumsAnimalType;
  /** @format double */
  dose: number;
  /** @format uuid */
  farmId: string;
  /** @format uuid */
  id: string;
  isGast: boolean;
  isLactating: boolean;
  isPregnant: boolean;
  medicalSupply: HealthSystemDomainMedicalSuppliesResultMedicalSupplyViewModel;
}

export interface HealthSystemDomainTaskListsResultTaskListViewModel {
  /** @format date-time */
  completedAt?: string | null;
  /** @format date-time */
  created: string;
  /** @format uuid */
  farmId: string;
  /** @format uuid */
  id: string;
  name?: string | null;
  /** @format date-time */
  startedAt?: string | null;
  status: HealthSystemDALEnumsTaskListStatus;
  taskListItems?: HealthSystemDALModelTaskListsTaskListItem[] | null;
  user: HealthSystemDomainUsersResultUserViewModel;
}

export interface HealthSystemDomainUsersCommandsAddUserActionLogCommand {
  actionLogs: HealthSystemDomainUsersCommandsCreateUserActionLogModel[];
  /** @format uuid */
  userId: string;
}

export interface HealthSystemDomainUsersCommandsAuthUserCommand {
  /** @format uuid */
  farmId: string;
  /** @minLength 1 */
  password: string;
  /** @format uuid */
  userId: string;
}

export interface HealthSystemDomainUsersCommandsAuthVeterinaryCommand {
  /** @minLength 1 */
  email: string;
  /** @minLength 1 */
  number: string;
  /** @minLength 1 */
  password: string;
}

export interface HealthSystemDomainUsersCommandsAuthWebUserCommand {
  /** @minLength 1 */
  email: string;
  /** @minLength 1 */
  farmNumber: string;
  /** @minLength 1 */
  password: string;
}

export interface HealthSystemDomainUsersCommandsCreateUserActionLogModel {
  data?: any | null;
  /** @format date-time */
  dateTime: string;
  /** @format uuid */
  id: string;
  macAddress?: string | null;
  number?: string | null;
  type: HealthSystemDALEnumsUserActionLogType;
}

export interface HealthSystemDomainUsersCommandsCreateUserCommand {
  availability: SystemDayOfWeek[];
  /**
   * @format email
   * @minLength 1
   */
  email: string;
  /** @format uuid */
  farmId?: string | null;
  languageIso: string;
  /** @minLength 1 */
  name: string;
  role: string;
  stables: HealthSystemDALEnumsLocationStableType[];
}

export type HealthSystemDomainUsersCommandsGetUserAllQuery = object;

export type HealthSystemDomainUsersCommandsGetUserBusinessUnitCommand = object;

export interface HealthSystemDomainUsersCommandsLinkBusinessUnitToUserCommand {
  /** @format uuid */
  businessUnitId: string;
  role: string;
  /** @format uuid */
  userId: string;
}

export interface HealthSystemDomainUsersCommandsRefreshAuthCommand {
  /** @minLength 1 */
  refreshToken: string;
}

export interface HealthSystemDomainUsersCommandsUnlinkBusinessUnitFromUserCommand {
  /** @format uuid */
  businessUnitId: string;
  /** @format uuid */
  userId: string;
}

export interface HealthSystemDomainUsersCommandsUpdateUserCommand {
  availability: SystemDayOfWeek[];
  email?: string | null;
  /** @format uuid */
  id: string;
  languageIso?: string | null;
  name?: string | null;
  password?: string | null;
  role?: string | null;
  stables: HealthSystemDALEnumsLocationStableType[];
}

export interface HealthSystemDomainUsersCommandsUpdateUserLanguageCommand {
  /** @format uuid */
  id: string;
  /** @minLength 1 */
  languageIsoCode: string;
}

export interface HealthSystemDomainUsersCommandsUserBusinessUnitLoginCommand {
  /** @format uuid */
  businessUnitId: string;
  email: string;
  password: string;
}

export interface HealthSystemDomainUsersCommandsUserLoginChangeBusinessUnitCommand {
  /** @format uuid */
  businessUnitId: string;
}

export interface HealthSystemDomainUsersCommandsUserLoginCommand {
  email: string;
  password: string;
}

export interface HealthSystemDomainUsersQueryUserActionLogQuery {
  actionType: HealthSystemDALEnumsUserActionLogType;
  /** @format date-time */
  dateFrom?: string | null;
  /** @format date-time */
  dateTo?: string | null;
  macAddress?: string | null;
  number?: string | null;
  /** @format int32 */
  page: number;
  /** @format int32 */
  size: number;
  sort?: string | null;
  /** @format uuid */
  userId: string;
}

export interface HealthSystemDomainUsersResultAuthResultBase {
  refreshToken: string;
  token: string;
}

export interface HealthSystemDomainUsersResultAuthVeterinaryResult {
  /** @format uuid */
  contactId: string;
  refreshToken: string;
  token: string;
  /** @format uuid */
  veterinaryId: string;
}

export interface HealthSystemDomainUsersResultAuthWebUserResult {
  /** @format uuid */
  farmId: string;
  refreshToken: string;
  /** @format date-time */
  refreshTokenExpirationTime: string;
  token: string;
  /** @format date-time */
  tokenExpirationTime: string;
  /** @format uuid */
  userId: string;
}

export interface HealthSystemDomainUsersResultAuthenticationResponse {
  businessUnits: HealthSystemDomainUsersResultBusinessUnitResponse[];
  refreshToken: string;
  token: string;
  /** @format uuid */
  userId: string;
}

export interface HealthSystemDomainUsersResultBusinessUnitResponse {
  address?: string | null;
  /** @format uuid */
  id: string;
  name?: string | null;
  number: string;
  role?: string | null;
  type: HealthSystemDALEnumsBusinessUnitType;
}

export interface HealthSystemDomainUsersResultBusinessUnitUserViewModel {
  email?: string | null;
  /** @format uuid */
  id: string;
  languageIso?: string | null;
  name?: string | null;
  /** @format int32 */
  totalBusinessUnits: number;
}

export interface HealthSystemDomainUsersResultFarmEmployeeViewModel {
  /** @format uuid */
  farmId: string;
  /** @format uuid */
  id: string;
  name?: string | null;
}

export interface HealthSystemDomainUsersResultManagementUserViewModel {
  businessUnits: HealthSystemDomainUsersResultBusinessUnitResponse[];
  email?: string | null;
  /** @format uuid */
  id: string;
  languageIso?: string | null;
  name?: string | null;
  /** @format int32 */
  totalBusinessUnits: number;
}

export interface HealthSystemDomainUsersResultManagementUserViewPageableQueryResult {
  data: HealthSystemDomainUsersResultBusinessUnitUserViewModel[];
  /** @format int32 */
  page: number;
  /** @format int32 */
  size: number;
  /** @format int64 */
  total: number;
}

export interface HealthSystemDomainUsersResultUserActionLogViewModel {
  data?: any | null;
  /** @format date-time */
  dateTime: string;
  /** @format uuid */
  id: string;
  macAddress?: string | null;
  number?: string | null;
  type: HealthSystemDALEnumsUserActionLogType;
  /** @format uuid */
  userId: string;
}

export interface HealthSystemDomainUsersResultUserAuthResult {
  /** @format uuid */
  farmId: string;
  name?: string | null;
  refreshToken: string;
  /** @format date-time */
  refreshTokenExpirationTime: string;
  token: string;
  /** @format date-time */
  tokenExpirationTime: string;
  /** @format uuid */
  userId: string;
}

export interface HealthSystemDomainUsersResultUserViewModel {
  availability: SystemDayOfWeek[];
  email?: string | null;
  /** @format uuid */
  farmId: string;
  /** @format uuid */
  id: string;
  isActivated: boolean;
  isDeactivated: boolean;
  languageIso?: string | null;
  name?: string | null;
  role?: string | null;
  stables: HealthSystemDALEnumsLocationStableType[];
}

export interface HealthSystemDomainUsersResultUsersSearchQueryResult {
  data: HealthSystemDomainUsersResultUserViewModel[];
  /** @format int32 */
  page: number;
  /** @format int32 */
  size: number;
  /** @format int64 */
  total: number;
}

export interface HealthSystemDomainVaccinationRulesCreateVaccinationRuleCommand {
  /** @format int32 */
  ageFrom: number;
  /** @format int32 */
  ageTo: number;
  animalType: HealthSystemDALEnumsAnimalType;
  /** @format double */
  dose: number;
  isGast: boolean;
  isLactating: boolean;
  isPregnant: boolean;
  /** @format uuid */
  medicalSupplyId: string;
}

export type HealthSystemDomainVaccinationRulesGetAllVaccinationRulesCommand =
  object;

export interface HealthSystemDomainVaccinationRulesRemoveVaccinationRuleCommand {
  /** @format uuid */
  id: string;
}

export interface HealthSystemDomainVaccinationRulesResultVaccinationRuleViewModel {
  /** @format int32 */
  ageFrom: number;
  /** @format int32 */
  ageTo: number;
  animalType: HealthSystemDALEnumsAnimalType;
  /** @format double */
  dose: number;
  /** @format uuid */
  farmId: string;
  /** @format uuid */
  id: string;
  isGast: boolean;
  isLactating: boolean;
  isPregnant: boolean;
  medicalSupply: HealthSystemDomainMedicalSuppliesResultMedicalSupplyViewModel;
}

export interface HealthSystemDomainValueObjectsAddressDto {
  city?: string | null;
  country?: string | null;
  state?: string | null;
  street: string;
  zipCode?: string | null;
}

export interface HealthSystemDomainValueObjectsContactDto {
  email?: string | null;
  fax?: string | null;
  phone?: string | null;
}

export interface HealthSystemDomainVetsCommandsAddFarmToVetCommand {
  /** @format uuid */
  farmId: string;
  /** @format uuid */
  veterinaryId: string;
}

export interface HealthSystemDomainVetsCommandsAddVetContactCommand {
  contact: HealthSystemDomainVetsCommandsAddVetContactModel;
  /** @format uuid */
  id: string;
}

export interface HealthSystemDomainVetsCommandsAddVetContactModel {
  /** @minLength 1 */
  email: string;
  isPrimary: boolean;
  languageIso?: string | null;
  name?: string | null;
  password?: string | null;
  phone?: string | null;
  udaNumber?: string | null;
}

export interface HealthSystemDomainVetsCommandsCreateVeterinaryCommand {
  name?: string | null;
  number?: string | null;
  settings: HealthSystemDALModelVetVeterinarySettings;
}

export interface HealthSystemDomainVetsCommandsDeleteVetContactCommand {
  /** @format uuid */
  id: string;
  /** @format uuid */
  veterinaryId: string;
}

export interface HealthSystemDomainVetsCommandsRemoveFarmFromVetCommand {
  /** @format uuid */
  farmId: string;
  /** @format uuid */
  veterinaryId: string;
}

export interface HealthSystemDomainVetsCommandsUpdateVetContactCommand {
  contact: HealthSystemDomainVetsCommandsUpdateVetContactModel;
  /** @format uuid */
  id: string;
}

export interface HealthSystemDomainVetsCommandsUpdateVetContactModel {
  /** @minLength 1 */
  email: string;
  /** @format uuid */
  id: string;
  isPrimary: boolean;
  languageIso?: string | null;
  name?: string | null;
  password?: string | null;
  phone?: string | null;
  udaNumber?: string | null;
}

export interface HealthSystemDomainVetsCommandsUpdateVeterinaryCommand {
  /** @format uuid */
  id: string;
  name?: string | null;
  number?: string | null;
  settings: HealthSystemDALModelVetVeterinarySettings;
}

export interface HealthSystemDomainVetsQueryVeterinaryCreateOralFeedInjectionCommand {
  /** @format double */
  dose: number;
  /** @format uuid */
  farmSupplyId: string;
  /** @format uuid */
  locationId: string;
  /** @format int32 */
  repeatDays: number;
}

export interface HealthSystemDomainVetsQueryVeterinaryCreateVaccinationInjectionCommand {
  /** @format double */
  dose: number;
  /** @format uuid */
  farmSupplyId: string;
  /** @format uuid */
  locationId: string;
  /** @format int32 */
  repeatDays: number;
}

export interface HealthSystemDomainVetsResultVeterinaryContactViewModel {
  email?: string | null;
  /** @format uuid */
  id: string;
  isPrimary: boolean;
  languageIso?: string | null;
  name?: string | null;
  phone?: string | null;
  udaNumber?: string | null;
}

export interface HealthSystemDomainVetsResultVeterinaryLocationSearchPageableQueryResult {
  data: HealthSystemDomainLocationsResultLocationViewModel[];
  /** @format int32 */
  page: number;
  /** @format int32 */
  size: number;
  /** @format int64 */
  total: number;
}

export interface HealthSystemDomainVetsResultVeterinaryViewModel {
  contacts: HealthSystemDomainVetsResultVeterinaryContactViewModel[];
  /** @format date-time */
  created: string;
  farms: HealthSystemDomainFarmsResultFarmViewModel[];
  /** @format uuid */
  id: string;
  name?: string | null;
  number?: string | null;
  settings: HealthSystemDALModelVetVeterinarySettings;
}

export interface HealthSystemDomainVitalityTrackerRequestsAnimalActivityAverage {
  type: HealthSystemDALModelFloorPlanAreaType;
  value?: any | null;
}

export interface HealthSystemDomainVitalityTrackerRequestsAnimalActivityDetails {
  /** @format date-time */
  from?: string | null;
  /** @format date-time */
  to?: string | null;
  type: HealthSystemDALModelFloorPlanAreaType;
}

export interface HealthSystemDomainVitalityTrackerRequestsAnimalGroupAnalyticDetails {
  /** @format uuid */
  animalId: string;
  data: HealthSystemDomainVitalityTrackerRequestsAnimalActivityDetails[];
  number?: string | null;
}

export interface HealthSystemDomainVitalityTrackerRequestsAnimalGroupAnalytics {
  activities: HealthSystemDomainVitalityTrackerRequestsAnimalActivityAverage[];
  /** @format uuid */
  locationId: string;
  locationName?: string | null;
}

export interface HealthSystemDomainVitalityTrackerRequestsAnimalGroupAnalyticsDetailedQuery {
  animalIds: string[];
  /** @format date-time */
  from: string;
  /** @format date-time */
  to: string;
}

export interface HealthSystemDomainVitalityTrackerRequestsAnimalGroupAnalyticsDetailedResult {
  data: HealthSystemDomainVitalityTrackerRequestsAnimalGroupAnalyticDetails[];
}

export interface HealthSystemDomainVitalityTrackerRequestsAnimalGroupAnalyticsQuery {
  /** @format date-time */
  from: string;
  isAvgTime: boolean;
  locationIds: string[];
  /** @format date-time */
  to: string;
}

export interface HealthSystemDomainVitalityTrackerRequestsAnimalGroupAnalyticsResult {
  data: HealthSystemDomainVitalityTrackerRequestsAnimalGroupAnalytics[];
  isAvgTime: boolean;
}

export interface HealthSystemDomainVitalityTrackerRequestsPushAnimalActivitiesCommand {
  items: HealthSystemDALModelAnimalActivity[];
}

export interface HealthSystemDomainWeatherResultLungWeatherCheckViewModel {
  /** @format date-time */
  checkedAt: string;
  /** @format double */
  confidence: number;
  /** @format double */
  confidenceFloor: number;
  forecast: HealthSystemDomainWeatherResultLungWeatherWindViewModel;
  /** @format date-time */
  forecastFrom?: string | null;
  /** @format date-time */
  forecastTill?: string | null;
  /** @format uuid */
  id: string;
  /** @format double */
  matchScore: number;
  /** @format double */
  matchThreshold: number;
  /** @format uuid */
  matchedPatternId?: string | null;
  measures: HealthSystemDomainWeatherResultLungWeatherMeasureViewModel[];
  notificationDispatched: boolean;
  notificationError?: string | null;
  skipReason?: string | null;
  verdict: string;
}

export interface HealthSystemDomainWeatherResultLungWeatherHistoryPointViewModel {
  /** @format date-time */
  checkedAt: string;
  /** @format double */
  confidence: number;
  /** @format date-time */
  confirmedAt?: string | null;
  /** @format uuid */
  id: string;
  /** @format double */
  matchScore: number;
  verdict: string;
}

export interface HealthSystemDomainWeatherResultLungWeatherMeasureViewModel {
  /** @format double */
  appliedWeight: number;
  /** @format double */
  deviation: number;
  /** @format double */
  forecastValue: number;
  measure: string;
  /** @format double */
  patternValue: number;
  /** @format double */
  referenceSpread: number;
  /** @format double */
  similarity: number;
}

export interface HealthSystemDomainWeatherResultLungWeatherPatternViewModel {
  /** @format int32 */
  attributedViaAnimalHistory: number;
  /** @format int32 */
  attributedViaLocation: number;
  /** @format date-time */
  detectedAt: string;
  /** @format double */
  evidenceWeight: number;
  /** @format uuid */
  id: string;
  isClosestMatch: boolean;
  /** @format int32 */
  peakInjectionCount: number;
  /** @format int32 */
  peakThreshold: number;
  /** @format date-time */
  peakWindowFrom: string;
  /** @format date-time */
  peakWindowTill: string;
  /** @format double */
  scoreAgainstForecast?: number | null;
  /** @format int32 */
  unattributed: number;
  /** @format date-time */
  weatherFrom: string;
  /** @format date-time */
  weatherTill: string;
  wind: HealthSystemDomainWeatherResultLungWeatherWindViewModel;
}

export interface HealthSystemDomainWeatherResultLungWeatherReviewViewModel {
  /** @format double */
  confidenceFloor: number;
  /** @format uuid */
  diseaseId: string;
  diseaseName: string;
  /** @format uuid */
  farmId: string;
  farmName: string;
  /** @format double */
  matchThreshold: number;
  /** @format uuid */
  notificationRuleId?: string | null;
  /** @format int32 */
  patternsForConfidence: number;
  sensitivity?: string | null;
  stables: HealthSystemDomainWeatherResultLungWeatherStableViewModel[];
}

export interface HealthSystemDomainWeatherResultLungWeatherStableViewModel {
  history: HealthSystemDomainWeatherResultLungWeatherHistoryPointViewModel[];
  isFarmWide: boolean;
  latest: HealthSystemDomainWeatherResultLungWeatherCheckViewModel;
  patterns: HealthSystemDomainWeatherResultLungWeatherPatternViewModel[];
  stable: HealthSystemDALEnumsLocationStableType;
}

export interface HealthSystemDomainWeatherResultLungWeatherWindViewModel {
  /** @format double */
  dominantWindDirectionDegrees: number;
  /** @format double */
  maxWindGustKmh: number;
  /** @format double */
  maxWindSpeedKmh: number;
  /** @format double */
  meanWindSpeedKmh: number;
  /** @format int32 */
  windDirectionChangeCount: number;
  /** @format double */
  windDirectionConstancy: number;
}

export interface HealthSystemDomainWeightCurvesResultWeightCurvePointResult {
  /** @format int32 */
  day: number;
  /** @format double */
  weightGrams: number;
}

export interface HealthSystemDomainWeightCurvesResultWeightCurveResult {
  /** @format int32 */
  birthWeightGrams: number;
  points: HealthSystemDomainWeightCurvesResultWeightCurvePointResult[];
}

export interface HealthSystemDomainWeightDiagnosticQueriesWeightDataViewModel {
  /** @format double */
  algWeight: number;
  deviceId?: string | null;
  deviceType?: string | null;
  returnWeights: number[];
}

export interface HealthSystemDomainWeightDiagnosticQueriesWeightDiagnosticRecordViewModel {
  /** @format date-time */
  createdAt: string;
  data: HealthSystemDomainWeightDiagnosticQueriesWeightDataViewModel;
  /** @format uuid */
  farmId: string;
  /** @format uuid */
  id: string;
  /** @format uuid */
  locationId?: string | null;
  /** @format date-time */
  recordedAt: string;
}

export interface HealthSystemDomainWeightDiagnosticWeightDataModel {
  /** @format double */
  algWeight: number;
  deviceId?: string | null;
  deviceType?: string | null;
  returnWeights: number[];
}

export interface ImportDownloadCsvExampleParams {
  /**
   * Format type: 'basic', 'complete', or 'numeric'
   * @default "basic"
   */
  format?: string;
}

export interface ImportImportAnimalsPayload {
  /** @format binary */
  file?: File;
}

export interface ImportValidateAnimalsPayload {
  /** @format binary */
  file?: File;
}

export interface InjectionsCreateOralFeedInjectionRecordByLocationParams {
  /** @format uuid */
  locationId: string;
}

export interface InjectionsCreateVaccinationInjectionRecordByLocationParams {
  /** @format uuid */
  locationId: string;
}

export interface InjectionsGetInjectionAgeTrendDataParams {
  AnimalType?: HealthSystemDALEnumsAnimalType;
  LactatingOnly?: boolean;
  PregnantOnly?: boolean;
  /** @format uuid */
  SupplyId?: string;
  /** @format int32 */
  WeekNumber?: number;
  /** @format int32 */
  Year?: number;
}

export interface InjectionsGetInjectionStrategyParams {
  AnimalType?: HealthSystemDALEnumsAnimalType;
  /** @format uuid */
  LocationId?: string;
  /** @format int32 */
  WeekNumber?: number;
  /** @format int32 */
  WeekStart?: number;
  /** @format int32 */
  Year?: number;
}

export interface InjectionsGetInjectionTrendDataParams {
  /** @format int32 */
  "Week.End"?: number;
  /** @format int32 */
  "Week.Start"?: number;
  /** @format int32 */
  "Years.End"?: number;
  /** @format int32 */
  "Years.Start"?: number;
  AnimalType?: HealthSystemDALEnumsAnimalType;
  LactatingOnly?: boolean;
  PregnantOnly?: boolean;
  /** @format uuid */
  SupplyId?: string;
  /** @format int32 */
  Year?: number;
}

export interface InjectionsGetLocationInjectionStrategyParams {
  /** @format int32 */
  "Week.End"?: number;
  /** @format int32 */
  "Week.Start"?: number;
  LactatingOnly?: boolean;
  PregnantOnly?: boolean;
  ShowDied?: boolean;
  /** @format uuid */
  SupplyId?: string;
  /** @format int32 */
  Year?: number;
  /** @format uuid */
  locationId: string;
}

export interface InjectionsQueryInjectionHistoriesParams {
  /** @format uuid */
  EntityId: string;
  /** @format int32 */
  Page?: number;
  /** @format int32 */
  Size?: number;
  Sort?: string;
}

export interface LabelPrintGetLabelPrintTasksParams {
  /** @format uuid */
  FarmId?: string;
  /** @format int32 */
  Page?: number;
  /** @format int32 */
  Size?: number;
  Sort?: string;
}

export interface LocationCyclesGetLocationCycleAnimalsParams {
  /** @format uuid */
  LocationCycleId?: string;
}

export interface LocationCyclesGetLocationCyclesParams {
  /** @format date-time */
  EndPeriod?: string;
  /** @format uuid */
  LocationId?: string;
  /** @format int32 */
  Page?: number;
  /** @format int32 */
  Size?: number;
  Sort?: string;
  /** @format date-time */
  StartPeriod?: string;
}

export interface LocationsGetLocationAnimalsParams {
  /** @format uuid */
  LocationId?: string;
}

export interface LocationsGetLocationHistoryParams {
  /** @default false */
  currentOnly?: boolean;
  /** @format date */
  from?: string;
  /** @format uuid */
  id: string;
  /** @format date */
  to?: string;
}

export interface LocationsGetLocationsHierarchyParams {
  AnimalType?: HealthSystemDALEnumsAnimalType;
  Stable?: HealthSystemDALEnumsLocationStableType;
}

export interface LocationsSearchLocationsParams {
  AnimalType?: HealthSystemDALEnumsAnimalType;
  Number?: string;
  /** @format int32 */
  Page?: number;
  Pen?: string;
  Position?: HealthSystemDALEnumsLocationPosition;
  Room?: string;
  /** @format int32 */
  Size?: number;
  Sort?: string;
  Stable?: HealthSystemDALEnumsLocationStableType;
}

export interface LocationsViewClimateLocationParams {
  /** @format date-time */
  ClimateDate?: string;
  /** @format uuid */
  Id?: string;
  /** @format date-time */
  SeriesFrom?: string;
  /** @format date-time */
  SeriesTo?: string;
}

export interface LocationsViewLocationParams {
  /** @format uuid */
  Id?: string;
}

export interface LungWeatherGetReviewParams {
  /** @format uuid */
  diseaseId: string;
  /**
   * @format int32
   * @default 90
   */
  historyDays?: number;
}

export interface MedicalSuppliesDeleteMedicalSupplyParams {
  /** @format uuid */
  Id?: string;
}

export interface MedicalSuppliesGetAllMedicalSuppliesParams {
  query?: HealthSystemDomainMedicalSuppliesCommandsGetAllMedicalSuppliesCommand;
}

export interface MedicalSuppliesGetFarmMedicalSuppliesParams {
  SupplyMethods?: HealthSystemDALEnumsMedicalSupplyMethod[];
  SupplyTypes?: HealthSystemDALEnumsMedicalSupplyType[];
}

export interface MedicalSuppliesGetMedicalSuppliesParams {
  Number?: string;
  /** @format int32 */
  Page?: number;
  /** @format int32 */
  Size?: number;
  Sort?: string;
  SupplyType?: HealthSystemDALEnumsMedicalSupplyType;
}

export interface MedicalSuppliesGetMedicalSupplyBottlesParams {
  AnimalType?: HealthSystemDALEnumsAnimalType;
  LotNumber?: string;
  MedicalSupplyNumber?: string;
  /** @format int32 */
  Page?: number;
  ShowHidden?: boolean;
  /** @format int32 */
  Size?: number;
  Sort?: string;
}

export interface MedicalSuppliesGetMedicalSupplyOrderByIdParams {
  /** @format uuid */
  id: string;
}

export interface MedicalSuppliesGetMedicalSupplyOrdersParams {
  /** @format int32 */
  Page?: number;
  /** @format int32 */
  Size?: number;
  Sort?: string;
}

export interface MedicalSuppliesGetMedicationMatrixParams {
  /** Narrows every supply's entries to that animal type. */
  AnimalType?: HealthSystemDALEnumsAnimalType;
}

export interface MedicalSuppliesRemoveMedicalSupplyBottleParams {
  /** @format uuid */
  id: string;
}

export interface MedicalSuppliesUpdateMedicalSupplyBottleParams {
  /** @format uuid */
  id: string;
}

export interface MedicalSuppliesUpdateMedicalSupplyParams {
  /** @format uuid */
  id: string;
}

export interface MedicationsGetAllParams {
  /**
   * One-based page number.
   * @format int32
   */
  Page?: number;
  /**
   * Matches the short name, the official name, and a pack's product name, registration number or
   * barcode.
   */
  SearchTerm?: string;
  /**
   * Page size.
   * @format int32
   */
  Size?: number;
}

export interface MicrosoftAspNetCoreMvcProblemDetails {
  detail?: string | null;
  instance?: string | null;
  /** @format int32 */
  status?: number | null;
  title?: string | null;
  type?: string | null;
  [key: string]: any;
}

export interface MortalityReasonsGetAllDiseasesParams {
  query?: HealthSystemDomainMortalityReasonsCommandsGetAllMortalityReasonsQuery;
}

export interface MortalityReasonsMortalityReasonsSearchParams {
  /** @format int32 */
  Page?: number;
  /** @format int32 */
  Size?: number;
  Sort?: string;
}

export interface NotificationRulesDeleteNotificationRuleParams {
  /** @format uuid */
  Id: string;
}

export interface NotificationRulesViewNotificationRulesParams {
  /** @format int32 */
  Page?: number;
  /** @format int32 */
  Size?: number;
  Sort?: string;
}

export interface NotificationsGetNotificationsParams {
  /** @format int32 */
  Page?: number;
  /** @format int32 */
  Size?: number;
  Sort?: string;
}

export interface SavedComparisonsDeleteParams {
  /** @format uuid */
  id: string;
}

export interface ScheduledReportsDeleteParams {
  /** @format uuid */
  id: string;
}

export interface ScheduledReportsSendNowParams {
  /** @format uuid */
  id: string;
}

export interface ScheduledReportsSetActiveParams {
  /** @format uuid */
  id: string;
}

export interface ScheduledReportsUpdateParams {
  /** @format uuid */
  id: string;
}

export interface SensorDevicesAssignLocationParams {
  /** @format uuid */
  farmId: string;
  /** @format uuid */
  sensorDeviceId: string;
}

export interface SensorDevicesDiscoverParams {
  /** @format uuid */
  farmId: string;
}

export interface SensorDevicesGetAllParams {
  /** @format uuid */
  farmId: string;
}

export interface SensorDevicesUnassignLocationParams {
  /** @format uuid */
  farmId: string;
  /** @format uuid */
  sensorDeviceId: string;
}

export interface SettingsGetAnimalCapacityParams {
  /** @format date-time */
  From?: string;
  /** @format date-time */
  To?: string;
}

export interface SettingsGetFarmSettingsParams {
  query?: HealthSystemDomainSettingsFarmSettingsQuery;
}

export interface SettingsGetTranslationByIsoCodeParams {
  isoCode: string;
}

export interface SettingsSearchEventLogsParams {
  ErrorOnly?: boolean;
  /** @format uuid */
  FarmId?: string;
  NotAnalyzedOnly?: boolean;
  /** @format int32 */
  Page?: number;
  /** @format int32 */
  Size?: number;
  Sort?: string;
  Type?: HealthSystemDALModelLogAppEventLogApplicationType;
}

export interface SlaughterPreparationGetPreOrderDetailsParams {
  /** @format uuid */
  Id?: string;
}

export interface SlaughterPreparationGetPreOrdersSummariesParams {
  /** @format date-time */
  From?: string;
  /** @format int32 */
  Page?: number;
  /** @format int32 */
  Size?: number;
  Sort?: string;
  /** @format date-time */
  To?: string;
}

export interface SlaughterhousesDeleteApiKeyParams {
  /** @format uuid */
  apiKeyId: string;
  /** @format uuid */
  id: string;
}

export interface SlaughterhousesGenerateApiKeyParams {
  /** @format uuid */
  id: string;
}

export interface SlaughterhousesGetAllParams {
  IsActive?: boolean;
  /** @format int32 */
  Page?: number;
  SearchTerm?: string;
  /** @format int32 */
  Size?: number;
}

export interface SlaughterhousesGetByIdParams {
  /** @format uuid */
  id: string;
}

export interface SlaughterhousesUpdateApiKeyParams {
  /** @format uuid */
  apiKeyId: string;
  /** @format uuid */
  id: string;
}

export interface SlaughterhousesUpdateParams {
  /** @format uuid */
  id: string;
}

/** @format int32 */
export type SystemDayOfWeek = 0 | 1 | 2 | 3 | 4 | 5 | 6;

export interface TaskListGetAttachmentDownloadUrlParams {
  BlobName?: string;
}

export interface TaskListGetAttachmentUploadUrlParams {
  FileName?: string;
}

export interface TaskListGetDailyTaskPlanParams {
  /** @format date-time */
  DateFrom?: string;
  /** @format date-time */
  DateTo?: string;
  EmployeeIds?: string[];
}

export interface TaskListGetDailyUserOccurrencesParams {
  /** @format date */
  Date?: string;
}

export interface TaskListGetProductionScheduleParams {
  /** @format date */
  Date?: string;
}

export interface TaskListGetTaskLibraryListParams {
  /** @format date */
  Date: string;
  Stables: HealthSystemDALEnumsLocationStableType[];
  /** @format int32 */
  WeekCycle: number;
}

export interface TaskListGetTaskLibraryParams {
  Name?: string;
  Stables?: HealthSystemDALEnumsLocationStableType[];
}

export interface TaskListGetTaskPlansParams {
  IncludeCompleted?: boolean;
  /** @format int32 */
  Page?: number;
  /** @format int32 */
  Size?: number;
  Sort?: string;
}

export interface TasksGetTaskListsParams {
  AssignedToMe?: boolean;
  IncludeCompleted?: boolean;
  /** @format int32 */
  Page?: number;
  /** @format int32 */
  Size?: number;
  Sort?: string;
}

export interface TasksGetTaskListsRulesParams {
  /** @format int32 */
  Page?: number;
  /** @format int32 */
  Size?: number;
  Sort?: string;
}

export interface UserAccountsCreateInvitationLinkParams {
  /** @format uuid */
  id: string;
}

export interface UserAccountsResendInvitationParams {
  /** @format uuid */
  id: string;
}

export interface UsersActivateUserParams {
  /** @format uuid */
  userId: string;
}

export interface UsersDeactivateUserParams {
  /** @format uuid */
  userId: string;
}

export interface UsersGetUserViewParams {
  /** @format uuid */
  Id?: string;
}

export interface UsersGetUsersAllParams {
  command?: HealthSystemDomainUsersCommandsGetUserAllQuery;
}

export interface UsersGetUsersParams {
  /** @format int32 */
  Page?: number;
  /** @format int32 */
  Size?: number;
  Sort?: string;
}

export interface VaccinationRulesGetAllVaccinationRulesParams {
  command?: HealthSystemDomainVaccinationRulesGetAllVaccinationRulesCommand;
}

export interface VaccinationRulesVaccinationRulesSearchParams {
  /** @format int32 */
  Page?: number;
  /** @format int32 */
  Size?: number;
  Sort?: string;
}

export interface VeterinaryGetFarmMedicalSuppliesParams {
  /** @format uuid */
  FarmId?: string;
}

export interface VeterinaryGetVetByIdParams {
  /** @format uuid */
  id: string;
}

export interface VeterinaryGetVeterinaryDashboardParams {
  query?: HealthSystemDomainDashboardsQueryVeterinaryDashboardQuery;
}

export interface VeterinaryGetVeterinaryOrdersParams {
  /** @format int32 */
  Page?: number;
  /** @format int32 */
  Size?: number;
  Sort?: string;
}

export interface VeterinaryGetVetsParams {
  /** @format int32 */
  Page?: number;
  SearchText?: string;
  /** @format int32 */
  Size?: number;
  Sort?: string;
}

export interface VeterinarySearchLocationsParams {
  AnimalType?: HealthSystemDALEnumsAnimalType;
  Number?: string;
  /** @format int32 */
  Page?: number;
  Pen?: string;
  Position?: HealthSystemDALEnumsLocationPosition;
  Room?: string;
  /** @format int32 */
  Size?: number;
  Sort?: string;
  Stable?: HealthSystemDALEnumsLocationStableType;
}

export interface VitalityTrackerGetAnimalActivitiesParams {
  Number?: string;
  /** @format int32 */
  Page?: number;
  /** @format int32 */
  Size?: number;
  Sort?: string;
}

export interface WeightDiagnosticGetRecordsParams {
  /** @format date-time */
  DateFrom?: string;
  /** @format date-time */
  DateTo?: string;
  DeviceType?: string;
  /** @format uuid */
  LocationId?: string;
  /** @format int32 */
  Page?: number;
  /** @format int32 */
  Size?: number;
  Sort?: string;
}

export namespace Admin {
  /**
   * No description
   * @tags Admin
   * @name AdminGetFeatures
   * @request GET:/admin/features
   * @response `200` `Record<string,boolean>` OK
   */
  export namespace AdminGetFeatures {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Record<string, boolean>;
  }

  /**
   * No description
   * @tags Admin
   * @name AdminGetUserBusinessUnitAccessById
   * @request GET:/admin/users/{id}
   * @secure
   * @response `200` `HealthSystemDomainUsersResultManagementUserViewModel` OK
   * @response `401` `void` Unauthorized
   */
  export namespace AdminGetUserBusinessUnitAccessById {
    export type RequestParams = {
      /** @format uuid */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainUsersResultManagementUserViewModel;
  }

  /**
   * No description
   * @tags Admin
   * @name AdminGetUsers
   * @request GET:/admin/users
   * @secure
   * @response `200` `HealthSystemDomainUsersResultManagementUserViewPageableQueryResult` OK
   * @response `401` `void` Unauthorized
   */
  export namespace AdminGetUsers {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format int32 */
      Page?: number;
      SearchText?: string;
      /** @format int32 */
      Size?: number;
      Sort?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainUsersResultManagementUserViewPageableQueryResult;
  }

  /**
   * No description
   * @tags Admin
   * @name AdminLinkBusinessUnitToUser
   * @request PUT:/admin/users/farm
   * @secure
   * @response `200` `string` OK
   * @response `401` `void` Unauthorized
   */
  export namespace AdminLinkBusinessUnitToUser {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainUsersCommandsLinkBusinessUnitToUserCommand;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }

  /**
   * No description
   * @tags Admin
   * @name AdminUnlinkBusinessUnitFromUser
   * @request DELETE:/admin/users/farm
   * @secure
   * @response `200` `void` OK
   * @response `401` `void` Unauthorized
   */
  export namespace AdminUnlinkBusinessUnitFromUser {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainUsersCommandsUnlinkBusinessUnitFromUserCommand;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }
}

export namespace AdminDashboards {
  /**
   * @description A farm that is registering what it should be is on the list too, carrying an on-track status. Narrow with HealthSystem.API.Controllers.Dashboards.Requests.AdminPigletRegistrationRequest.Status to read only the farms that need a call.
   * @tags AdminDashboards
   * @name AdminDashboardsGetPigletRegistrationOverview
   * @summary Lists every farm and where it stands on piglet registration, worst first unless HealthSystem.API.Controllers.Dashboards.Requests.AdminPigletRegistrationRequest.Sort says otherwise, with the counts across every monitored farm above them.
   * @request GET:/admin/dashboard/piglets
   * @secure
   * @response `200` `HealthSystemAPIControllersDashboardsResponsesAdminPigletRegistrationResponse` OK
   * @response `401` `void` Unauthorized
   * @response `403` `HSAPIHostingApiResponseApiErrorResult` Forbidden
   */
  export namespace AdminDashboardsGetPigletRegistrationOverview {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format int32 */
      Page?: number;
      /** Restricts the queue to one rule, by its identifier. */
      Rule?: string;
      /** Matches a farm's UBN or its name, case-insensitively. */
      Search?: string;
      /** Restricts the queue to one severity, by its identifier. */
      Severity?: string;
      /** @format int32 */
      Size?: number;
      /**
       * Orders the queue: a field name optionally followed by `-desc`, for instance
       * `registered-desc` for the busiest farms first or `registered` for the quietest, and
       * `weighed-desc` / `weighed` for the share of registrations really weighed.
       * Defaults to worst first.
       */
      Sort?: string;
      /**
       * Restricts the queue to one status, by its identifier - `Critical`, `Warning`,
       * `OnTrack` or `NotMonitored`.
       */
      Status?: string;
      /**
       * Restricts the queue to one weighing state, by its identifier - `OnTrack`, `Behind` or
       * `NoScale`. Combines with Status rather than replacing it.
       */
      Weighing?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemAPIControllersDashboardsResponsesAdminPigletRegistrationResponse;
  }
}

export namespace AdminJobs {
  /**
   * No description
   * @tags AdminJobs
   * @name AdminJobsGetJobRun
   * @summary One run, with the report it produced.
   * @request GET:/admin/jobs/{jobName}/runs/{runId}
   * @secure
   * @response `200` `HealthSystemAPIControllersJobsResponsesGetJobRunResponse` OK
   * @response `401` `void` Unauthorized
   * @response `403` `HSAPIHostingApiResponseApiErrorResult` Forbidden
   * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
   */
  export namespace AdminJobsGetJobRun {
    export type RequestParams = {
      jobName: string;
      /** @format uuid */
      runId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemAPIControllersJobsResponsesGetJobRunResponse;
  }

  /**
   * @description A job that has never run returns an empty page rather than a 404 — it is indistinguishable from a job that does not exist, and the question was about runs either way.
   * @tags AdminJobs
   * @name AdminJobsGetJobRunHistory
   * @summary One job's run history, newest first.
   * @request GET:/admin/jobs/{jobName}/runs
   * @secure
   * @response `200` `HealthSystemAPIControllersJobsResponsesGetJobRunHistoryResponse` OK
   * @response `401` `void` Unauthorized
   * @response `403` `HSAPIHostingApiResponseApiErrorResult` Forbidden
   */
  export namespace AdminJobsGetJobRunHistory {
    export type RequestParams = {
      jobName: string;
    };
    export type RequestQuery = {
      /** @format int32 */
      Page?: number;
      /** @format int32 */
      Size?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemAPIControllersJobsResponsesGetJobRunHistoryResponse;
  }

  /**
   * @description Includes jobs no longer registered anywhere: one that used to run and has quietly stopped is exactly what somebody would be looking for.
   * @tags AdminJobs
   * @name AdminJobsGetJobsOverview
   * @summary Every job that has ever run, with its most recent run.
   * @request GET:/admin/jobs
   * @secure
   * @response `200` `HealthSystemAPIControllersJobsResponsesGetJobsOverviewResponse` OK
   * @response `401` `void` Unauthorized
   * @response `403` `HSAPIHostingApiResponseApiErrorResult` Forbidden
   */
  export namespace AdminJobsGetJobsOverview {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemAPIControllersJobsResponsesGetJobsOverviewResponse;
  }
}

export namespace Animals {
  /**
   * No description
   * @tags Animals
   * @name AnimalsAddAnimalWeight
   * @request POST:/animals/weights/register
   * @secure
   * @response `200` `HealthSystemDomainAnimalsResultAnimalViewModel` OK
   * @response `401` `void` Unauthorized
   */
  export namespace AnimalsAddAnimalWeight {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainAnimalsCommandsAddAnimalWeightCommand;
    export type RequestHeaders = {};
    export type ResponseBody = HealthSystemDomainAnimalsResultAnimalViewModel;
  }

  /**
   * No description
   * @tags Animals
   * @name AnimalsBatchUpdateAnimal
   * @request PUT:/animals/update-batch
   * @secure
   * @response `200` `HealthSystemDomainCommonResultEntityBatchResult` OK
   * @response `401` `void` Unauthorized
   * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
   * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
   */
  export namespace AnimalsBatchUpdateAnimal {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemAPIControllersAnimalsRequestsBatchUpdateRequest;
    export type RequestHeaders = {};
    export type ResponseBody = HealthSystemDomainCommonResultEntityBatchResult;
  }

  /**
   * No description
   * @tags Animals
   * @name AnimalsBatchUpdateAnimalFosterMother
   * @request PUT:/animals/foster-mother/batch
   * @secure
   * @response `200` `HealthSystemDomainCommonResultEntityBatchResult` OK
   * @response `401` `void` Unauthorized
   * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
   * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
   */
  export namespace AnimalsBatchUpdateAnimalFosterMother {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemAPIControllersAnimalsRequestsBatchUpdateAnimalFosterMotherRequest;
    export type RequestHeaders = {};
    export type ResponseBody = HealthSystemDomainCommonResultEntityBatchResult;
  }

  /**
   * No description
   * @tags Animals
   * @name AnimalsCreateAnimal
   * @request POST:/animals/register
   * @secure
   * @response `200` `HealthSystemDomainCommonResultEntityBatchResult` OK
   * @response `401` `void` Unauthorized
   */
  export namespace AnimalsCreateAnimal {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainAnimalsCommandsCreateAnimalCommand;
    export type RequestHeaders = {};
    export type ResponseBody = HealthSystemDomainCommonResultEntityBatchResult;
  }

  /**
   * No description
   * @tags Animals
   * @name AnimalsCreateAnimalNote
   * @request POST:/animals/note
   * @secure
   * @response `200` `string` OK
   * @response `401` `void` Unauthorized
   */
  export namespace AnimalsCreateAnimalNote {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainAnimalsCommandsCreateAnimalNoteCommand;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }

  /**
   * No description
   * @tags Animals
   * @name AnimalsCreateAnimalsBatch
   * @request POST:/animals/register-batch
   * @secure
   * @response `200` `HealthSystemDomainCommonResultEntityBatchResult` OK
   * @response `401` `void` Unauthorized
   */
  export namespace AnimalsCreateAnimalsBatch {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainAnimalsCommandsCreateAnimalsBatchCommand;
    export type RequestHeaders = {};
    export type ResponseBody = HealthSystemDomainCommonResultEntityBatchResult;
  }

  /**
   * No description
   * @tags Animals
   * @name AnimalsCreateAnimalViaInjection
   * @request POST:/animals/register-injection
   * @secure
   * @response `200` `HealthSystemDomainAnimalsResultCreateAnimalViaInjectionResult` OK
   * @response `401` `void` Unauthorized
   */
  export namespace AnimalsCreateAnimalViaInjection {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainAnimalsCommandsCreateAnimalViaInjectionCommand;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainAnimalsResultCreateAnimalViaInjectionResult;
  }

  /**
   * No description
   * @tags Animals
   * @name AnimalsCreateExternalIdentifier
   * @request POST:/animals/{id}/external-identifiers
   * @secure
   * @response `204` `void` No Content
   * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
   * @response `401` `void` Unauthorized
   * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
   * @response `409` `HSAPIHostingApiResponseApiErrorResult` Conflict
   * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
   */
  export namespace AnimalsCreateExternalIdentifier {
    export type RequestParams = {
      /** @format uuid */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemAPIControllersAnimalsRequestsCreateAnimalExternalIdentifierRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Animals
   * @name AnimalsCreateObservation
   * @summary Registers a non-fatal observation (genetic failure, biter, victim of a biter) against a live animal. The animal is not culled and stays in the herd.
   * @request POST:/animals/{id}/observations
   * @secure
   * @response `200` `HealthSystemAPIControllersAnimalsResponsesCreateAnimalObservationResponse` OK
   * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
   * @response `401` `void` Unauthorized
   * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
   * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
   */
  export namespace AnimalsCreateObservation {
    export type RequestParams = {
      /** @format uuid */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemAPIControllersAnimalsRequestsCreateAnimalObservationRequest;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemAPIControllersAnimalsResponsesCreateAnimalObservationResponse;
  }

  /**
   * No description
   * @tags Animals
   * @name AnimalsDeleteAnimalNote
   * @request DELETE:/animals/note
   * @secure
   * @response `200` `string` OK
   * @response `401` `void` Unauthorized
   */
  export namespace AnimalsDeleteAnimalNote {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format uuid */
      NoteId?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }

  /**
   * No description
   * @tags Animals
   * @name AnimalsDeleteExternalIdentifier
   * @request DELETE:/animals/{id}/external-identifiers/{externalIdentifierId}
   * @secure
   * @response `204` `void` No Content
   * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
   * @response `401` `void` Unauthorized
   * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
   * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
   */
  export namespace AnimalsDeleteExternalIdentifier {
    export type RequestParams = {
      /** @format uuid */
      externalIdentifierId: string;
      /** @format uuid */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Animals
   * @name AnimalsDeleteObservation
   * @summary Soft-deletes a registered observation. Observations are not editable - a mistake is removed and registered again, so the surviving rows keep their original timestamps.
   * @request DELETE:/animals/{id}/observations/{observationId}
   * @secure
   * @response `204` `void` No Content
   * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
   * @response `401` `void` Unauthorized
   * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
   * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
   */
  export namespace AnimalsDeleteObservation {
    export type RequestParams = {
      /** @format uuid */
      id: string;
      /** @format uuid */
      observationId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Animals
   * @name AnimalsDiedAnimal
   * @request PUT:/animals/died
   * @secure
   * @response `200` `string` OK
   * @response `401` `void` Unauthorized
   */
  export namespace AnimalsDiedAnimal {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainAnimalsCommandsDiedAnimalCommand;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }

  /**
   * No description
   * @tags Animals
   * @name AnimalsGetAnimalAntibioticFreeResult
   * @request GET:/animals/antibiotic-free
   * @secure
   * @response `200` `HealthSystemDomainAnimalsResultAntibioticFreeAnimalQueryResult` OK
   * @response `401` `void` Unauthorized
   */
  export namespace AnimalsGetAnimalAntibioticFreeResult {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format uuid */
      Id?: string;
      Number?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainAnimalsResultAntibioticFreeAnimalQueryResult;
  }

  /**
   * No description
   * @tags Animals
   * @name AnimalsGetAnimalAntibioticFreeResultObsolete
   * @request GET:/animals/antibioticfree
   * @deprecated
   * @secure
   * @response `200` `HealthSystemDomainAnimalsResultAntibioticFreeAnimalQueryResult` OK
   * @response `401` `void` Unauthorized
   */
  export namespace AnimalsGetAnimalAntibioticFreeResultObsolete {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format uuid */
      Id?: string;
      Number?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainAnimalsResultAntibioticFreeAnimalQueryResult;
  }

  /**
   * No description
   * @tags Animals
   * @name AnimalsGetAnimalById
   * @request GET:/animals
   * @secure
   * @response `200` `HealthSystemDomainAnimalsResultAnimalViewModel` OK
   * @response `401` `void` Unauthorized
   */
  export namespace AnimalsGetAnimalById {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format uuid */
      Id?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = HealthSystemDomainAnimalsResultAnimalViewModel;
  }

  /**
   * No description
   * @tags Animals
   * @name AnimalsGetAnimalFeedHistory
   * @request GET:/animals/{id}/feed-history
   * @secure
   * @response `200` `HealthSystemAPIControllersAnimalsResponsesAnimalFeedHistoryResponse` OK
   * @response `401` `void` Unauthorized
   * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
   * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
   */
  export namespace AnimalsGetAnimalFeedHistory {
    export type RequestParams = {
      /** @format uuid */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemAPIControllersAnimalsResponsesAnimalFeedHistoryResponse;
  }

  /**
   * No description
   * @tags Animals
   * @name AnimalsGetAnimalLocationHistoryTimeline
   * @request GET:/animals/{id}/location-history-timeline
   * @secure
   * @response `200` `HealthSystemAPIControllersAnimalsResponsesAnimalLocationHistoryTimelineResponse` OK
   * @response `401` `void` Unauthorized
   * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
   * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
   */
  export namespace AnimalsGetAnimalLocationHistoryTimeline {
    export type RequestParams = {
      /** @format uuid */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemAPIControllersAnimalsResponsesAnimalLocationHistoryTimelineResponse;
  }

  /**
   * No description
   * @tags Animals
   * @name AnimalsGetAnimalPiglets
   * @request GET:/animals/piglets
   * @secure
   * @response `200` `(HealthSystemDomainAnimalsResultAnimalViewModel)[]` OK
   * @response `401` `void` Unauthorized
   */
  export namespace AnimalsGetAnimalPiglets {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format uuid */
      AnimalId?: string;
      AnimalType?: HealthSystemDALEnumsAnimalType;
      /** @format int32 */
      Page?: number;
      /** @format int32 */
      Size?: number;
      Sort?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = HealthSystemDomainAnimalsResultAnimalViewModel[];
  }

  /**
   * No description
   * @tags Animals
   * @name AnimalsGetAnimalPigletsBirthCycles
   * @request GET:/animals/piglets/cycles
   * @secure
   * @response `200` `HealthSystemDomainAnimalsResultAnimalPigletBirthCyclesPageableQueryResult` OK
   * @response `401` `void` Unauthorized
   */
  export namespace AnimalsGetAnimalPigletsBirthCycles {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format uuid */
      AnimalId?: string;
      AnimalType?: HealthSystemDALEnumsAnimalType;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainAnimalsResultAnimalPigletBirthCyclesPageableQueryResult;
  }

  /**
   * No description
   * @tags Animals
   * @name AnimalsGetAnimalTrendData
   * @request GET:/animals/trend-data
   * @secure
   * @response `200` `HealthSystemDomainAnimalsResultAnimalTrendDataViewModel` OK
   * @response `401` `void` Unauthorized
   */
  export namespace AnimalsGetAnimalTrendData {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format uuid */
      AnimalId?: string;
      AnimalTrendDataType?: HealthSystemDALEnumsAnimalTrendDataType;
      AnimalType?: HealthSystemDALEnumsAnimalType;
      /** @format date-time */
      DateOfBirth?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainAnimalsResultAnimalTrendDataViewModel;
  }

  /**
   * No description
   * @tags Animals
   * @name AnimalsGetCompareSearchAnimalsTrendData
   * @request POST:/animals/search/trend-data/compare
   * @secure
   * @response `200` `Record<string,HealthSystemDomainAnimalsResultAnimalTrendDataViewModel>` OK
   * @response `401` `void` Unauthorized
   */
  export namespace AnimalsGetCompareSearchAnimalsTrendData {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainAnimalsCommandsSearchCompareAnimalsTrendDataQuery;
    export type RequestHeaders = {};
    export type ResponseBody = Record<
      string,
      HealthSystemDomainAnimalsResultAnimalTrendDataViewModel
    >;
  }

  /**
   * No description
   * @tags Animals
   * @name AnimalsGetExternalIdentifiers
   * @request GET:/animals/{id}/external-identifiers
   * @secure
   * @response `200` `HealthSystemAPIControllersAnimalsResponsesGetAnimalExternalIdentifiersResponse` OK
   * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
   * @response `401` `void` Unauthorized
   * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
   */
  export namespace AnimalsGetExternalIdentifiers {
    export type RequestParams = {
      /** @format uuid */
      id: string;
    };
    export type RequestQuery = {
      /**
       * @format int32
       * @default 1
       */
      pageIndex?: number;
      /**
       * @format int32
       * @default 100
       */
      pageSize?: number;
      searchTerm?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemAPIControllersAnimalsResponsesGetAnimalExternalIdentifiersResponse;
  }

  /**
   * No description
   * @tags Animals
   * @name AnimalsGetHealthLogs
   * @request GET:/animals/{id}/health-logs
   * @secure
   * @response `200` `HealthSystemAPIControllersAnimalsResponsesGetAnimalHealthLogsResponse` OK
   * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
   * @response `401` `void` Unauthorized
   */
  export namespace AnimalsGetHealthLogs {
    export type RequestParams = {
      /** @format uuid */
      id: string;
    };
    export type RequestQuery = {
      /**
       * @format int32
       * @default 1
       */
      pageIndex?: number;
      /**
       * @format int32
       * @default 100
       */
      pageSize?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemAPIControllersAnimalsResponsesGetAnimalHealthLogsResponse;
  }

  /**
   * No description
   * @tags Animals
   * @name AnimalsGetLifecyclePrediction
   * @request GET:/animals/{id}/lifecycle-prediction
   * @secure
   * @response `200` `HealthSystemDomainDigitalTwinModelsLifecyclePrediction` OK
   * @response `401` `void` Unauthorized
   * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
   */
  export namespace AnimalsGetLifecyclePrediction {
    export type RequestParams = {
      /** @format uuid */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainDigitalTwinModelsLifecyclePrediction;
  }

  /**
   * No description
   * @tags Animals
   * @name AnimalsGetObservationOptions
   * @summary The values for the observation dropdown, so web and mobile do not hard-code them.
   * @request GET:/animals/observations/options
   * @secure
   * @response `200` `HealthSystemAPIControllersAnimalsResponsesGetAnimalObservationOptionsResponse` OK
   * @response `401` `void` Unauthorized
   */
  export namespace AnimalsGetObservationOptions {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemAPIControllersAnimalsResponsesGetAnimalObservationOptionsResponse;
  }

  /**
   * No description
   * @tags Animals
   * @name AnimalsGetObservationRegistrations
   * @summary The farm-wide registrations list behind the "Genetic failures and bites" page - one row per registration, newest first, date-bounded on the registration itself.
   * @request GET:/animals/observations
   * @secure
   * @response `200` `HealthSystemAPIControllersAnimalsResponsesGetAnimalObservationsResponse` OK
   * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
   * @response `401` `void` Unauthorized
   */
  export namespace AnimalsGetObservationRegistrations {
    export type RequestParams = {};
    export type RequestQuery = {
      categories?: string[];
      geneticFailures?: string[];
      /**
       * @format int32
       * @default 1
       */
      pageIndex?: number;
      /**
       * @format int32
       * @default 100
       */
      pageSize?: number;
      /** @format date-time */
      registeredFrom?: string;
      /** @format date-time */
      registeredTo?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemAPIControllersAnimalsResponsesGetAnimalObservationsResponse;
  }

  /**
   * No description
   * @tags Animals
   * @name AnimalsGetObservations
   * @summary The observations registered against one animal, newest first.
   * @request GET:/animals/{id}/observations
   * @secure
   * @response `200` `HealthSystemAPIControllersAnimalsResponsesGetAnimalObservationsResponse` OK
   * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
   * @response `401` `void` Unauthorized
   */
  export namespace AnimalsGetObservations {
    export type RequestParams = {
      /** @format uuid */
      id: string;
    };
    export type RequestQuery = {
      /**
       * @format int32
       * @default 1
       */
      pageIndex?: number;
      /**
       * @format int32
       * @default 100
       */
      pageSize?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemAPIControllersAnimalsResponsesGetAnimalObservationsResponse;
  }

  /**
   * No description
   * @tags Animals
   * @name AnimalsGetProjectedSlaughterDate
   * @request GET:/animals/{id}/projected-slaughter-date
   * @secure
   * @response `200` `HealthSystemDomainDigitalTwinModelsProjectedSlaughterDateResult` OK
   * @response `401` `void` Unauthorized
   * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
   * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
   */
  export namespace AnimalsGetProjectedSlaughterDate {
    export type RequestParams = {
      /** @format uuid */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainDigitalTwinModelsProjectedSlaughterDateResult;
  }

  /**
   * No description
   * @tags Animals
   * @name AnimalsGetSearchAnimalsParentNumbers
   * @summary The values behind the sow or boar column's filter menu on the search table: the distinct parent numbers of the whole filtered search, not only of the page on screen.
   * @request POST:/animals/search/parent-numbers
   * @secure
   * @response `200` `HealthSystemAPIControllersAnimalsResponsesAnimalParentNumbersResponse` OK
   * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
   * @response `401` `void` Unauthorized
   * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
   */
  export namespace AnimalsGetSearchAnimalsParentNumbers {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemAPIControllersAnimalsRequestsAnimalParentNumbersRequest;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemAPIControllersAnimalsResponsesAnimalParentNumbersResponse;
  }

  /**
   * No description
   * @tags Animals
   * @name AnimalsGetSearchAnimalsTrendData
   * @request POST:/animals/search/trend-data
   * @secure
   * @response `200` `HealthSystemDomainAnimalsResultAnimalTrendDataViewModel` OK
   * @response `401` `void` Unauthorized
   */
  export namespace AnimalsGetSearchAnimalsTrendData {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainAnimalsCommandsSearchAnimalsTrendDataQuery;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainAnimalsResultAnimalTrendDataViewModel;
  }

  /**
   * No description
   * @tags Animals
   * @name AnimalsMoveSowWithPiglets
   * @summary Assigns a sow to a location and moves the piglets of her most recent birth cycle with her. Piglets that are in a quarantine location stay behind and are reported as skipped.
   * @request PUT:/animals/sow/move-with-piglets
   * @secure
   * @response `200` `HealthSystemAPIControllersAnimalsResponsesMoveSowWithPigletsResponse` OK
   * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
   * @response `401` `void` Unauthorized
   * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
   * @response `409` `HSAPIHostingApiResponseApiErrorResult` Conflict
   * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
   */
  export namespace AnimalsMoveSowWithPiglets {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemAPIControllersAnimalsRequestsMoveSowWithPigletsRequest;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemAPIControllersAnimalsResponsesMoveSowWithPigletsResponse;
  }

  /**
   * No description
   * @tags Animals
   * @name AnimalsRecalculateAnimalWeights
   * @request PUT:/animals/weights/recalculate-weights
   * @secure
   * @response `200` `HealthSystemDomainAnimalsResultAnimalViewModel` OK
   * @response `401` `void` Unauthorized
   */
  export namespace AnimalsRecalculateAnimalWeights {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainAnimalsCommandsRecalculateAnimalWeightCommand;
    export type RequestHeaders = {};
    export type ResponseBody = HealthSystemDomainAnimalsResultAnimalViewModel;
  }

  /**
   * No description
   * @tags Animals
   * @name AnimalsSearchAnimals
   * @request POST:/animals/search
   * @secure
   * @response `200` `HealthSystemDomainAnimalsResultAnimalsSearchQueryResult` OK
   * @response `401` `void` Unauthorized
   */
  export namespace AnimalsSearchAnimals {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainAnimalsCommandsAnimalsSearchQuery;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainAnimalsResultAnimalsSearchQueryResult;
  }

  /**
   * No description
   * @tags Animals
   * @name AnimalsSetAnimalWeights
   * @request PUT:/animals/weights
   * @deprecated
   * @secure
   * @response `200` `HealthSystemDomainAnimalsResultAnimalViewModel` OK
   * @response `401` `void` Unauthorized
   */
  export namespace AnimalsSetAnimalWeights {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainAnimalsCommandsSetAnimalWeightsCommand;
    export type RequestHeaders = {};
    export type ResponseBody = HealthSystemDomainAnimalsResultAnimalViewModel;
  }

  /**
   * No description
   * @tags Animals
   * @name AnimalsUpdateAnimal
   * @request POST:/animals/update
   * @secure
   * @response `200` `HealthSystemDomainCommonResultEntityBatchResult` OK
   * @response `401` `void` Unauthorized
   */
  export namespace AnimalsUpdateAnimal {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainAnimalsCommandsUpdateAnimalCommand;
    export type RequestHeaders = {};
    export type ResponseBody = HealthSystemDomainCommonResultEntityBatchResult;
  }

  /**
   * No description
   * @tags Animals
   * @name AnimalsUpdateAnimalSetInseminated
   * @request POST:/animals/inseminate
   * @secure
   * @response `200` `string` OK
   * @response `401` `void` Unauthorized
   */
  export namespace AnimalsUpdateAnimalSetInseminated {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format uuid */
      AnimalId?: string;
      /** @format date-time */
      DateTime?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }
}

export namespace Auth {
  /**
   * No description
   * @tags Auth
   * @name AuthAcceptInvitation
   * @request POST:/auth/accept-invitation
   * @response `204` `void` No Content
   * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
   */
  export namespace AuthAcceptInvitation {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemAPIControllersAuthRequestsAcceptInvitationRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Auth
   * @name AuthAuthFarm
   * @request POST:/auth/farm
   * @response `200` `HealthSystemDomainFarmsResultFarmAuthResult` OK
   * @response `400` `HealthSystemCommonExceptionsValidationResult` Bad Request
   */
  export namespace AuthAuthFarm {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = HealthSystemDomainFarmsCommandsAuthFarmCommand;
    export type RequestHeaders = {};
    export type ResponseBody = HealthSystemDomainFarmsResultFarmAuthResult;
  }

  /**
   * No description
   * @tags Auth
   * @name AuthAuthUser
   * @request POST:/auth/user
   * @response `200` `HealthSystemDomainUsersResultUserAuthResult` OK
   * @response `400` `HealthSystemCommonExceptionsValidationResult` Bad Request
   */
  export namespace AuthAuthUser {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = HealthSystemDomainUsersCommandsAuthUserCommand;
    export type RequestHeaders = {};
    export type ResponseBody = HealthSystemDomainUsersResultUserAuthResult;
  }

  /**
   * No description
   * @tags Auth
   * @name AuthAuthVeterinary
   * @request POST:/auth/vet
   * @response `200` `HealthSystemDomainUsersResultAuthVeterinaryResult` OK
   * @response `400` `HealthSystemCommonExceptionsValidationResult` Bad Request
   */
  export namespace AuthAuthVeterinary {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainUsersCommandsAuthVeterinaryCommand;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainUsersResultAuthVeterinaryResult;
  }

  /**
   * No description
   * @tags Auth
   * @name AuthAuthWebUser
   * @request POST:/auth/webuser
   * @response `200` `HealthSystemDomainUsersResultAuthWebUserResult` OK
   * @response `400` `HealthSystemCommonExceptionsValidationResult` Bad Request
   */
  export namespace AuthAuthWebUser {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = HealthSystemDomainUsersCommandsAuthWebUserCommand;
    export type RequestHeaders = {};
    export type ResponseBody = HealthSystemDomainUsersResultAuthWebUserResult;
  }

  /**
   * No description
   * @tags Auth
   * @name AuthForgotPassword
   * @request POST:/auth/forgot-password
   * @response `204` `void` No Content
   */
  export namespace AuthForgotPassword {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemAPIControllersAuthRequestsForgotPasswordRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Auth
   * @name AuthGetInvitationDetails
   * @request GET:/auth/invitations/{token}
   * @response `200` `HealthSystemAPIControllersAuthResponsesInvitationDetailsResponse` OK
   * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
   */
  export namespace AuthGetInvitationDetails {
    export type RequestParams = {
      token: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemAPIControllersAuthResponsesInvitationDetailsResponse;
  }

  /**
   * No description
   * @tags Auth
   * @name AuthLogin
   * @request POST:/auth/login
   * @response `200` `HealthSystemDomainUsersResultAuthenticationResponse` OK
   * @response `400` `HealthSystemCommonExceptionsValidationResult` Bad Request
   */
  export namespace AuthLogin {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = HealthSystemDomainUsersCommandsUserLoginCommand;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainUsersResultAuthenticationResponse;
  }

  /**
   * No description
   * @tags Auth
   * @name AuthLoginBusinessUnit
   * @request POST:/auth/login/business-unit
   * @response `200` `HealthSystemDomainUsersResultAuthenticationResponse` OK
   * @response `400` `HealthSystemCommonExceptionsValidationResult` Bad Request
   */
  export namespace AuthLoginBusinessUnit {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainUsersCommandsUserBusinessUnitLoginCommand;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainUsersResultAuthenticationResponse;
  }

  /**
   * No description
   * @tags Auth
   * @name AuthLoginChangeBusinessUnit
   * @request POST:/auth/login/business-unit/change
   * @secure
   * @response `200` `HealthSystemDomainUsersResultAuthenticationResponse` OK
   * @response `400` `HealthSystemCommonExceptionsValidationResult` Bad Request
   * @response `401` `void` Unauthorized
   */
  export namespace AuthLoginChangeBusinessUnit {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainUsersCommandsUserLoginChangeBusinessUnitCommand;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainUsersResultAuthenticationResponse;
  }

  /**
   * No description
   * @tags Auth
   * @name AuthRefreshAuthToken
   * @request POST:/auth/refresh
   * @response `200` `HealthSystemDomainUsersResultAuthResultBase` OK
   */
  export namespace AuthRefreshAuthToken {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = HealthSystemDomainUsersCommandsRefreshAuthCommand;
    export type RequestHeaders = {};
    export type ResponseBody = HealthSystemDomainUsersResultAuthResultBase;
  }

  /**
   * No description
   * @tags Auth
   * @name AuthResetPassword
   * @request POST:/auth/reset-password
   * @response `204` `void` No Content
   * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
   */
  export namespace AuthResetPassword {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemAPIControllersAuthRequestsResetPasswordRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }
}

export namespace CarbonFootprint {
  /**
   * No description
   * @tags CarbonFootprint
   * @name CarbonFootprintGetCarbonFootprintByYear
   * @request GET:/carbon-footprint
   * @secure
   * @response `200` `HealthSystemDomainCarbonFootPrintResultCarbonFootprintPerYearViewModel` OK
   * @response `401` `void` Unauthorized
   */
  export namespace CarbonFootprintGetCarbonFootprintByYear {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format date */
      From?: string;
      /** @format date */
      To?: string;
      /** @format int32 */
      Year?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainCarbonFootPrintResultCarbonFootprintPerYearViewModel;
  }
}

export namespace ChipNumbers {
  /**
   * No description
   * @tags ChipNumbers
   * @name ChipNumbersCreateChipNumber
   * @request POST:/chip-mumbers/v1
   * @secure
   * @response `200` `string` OK
   * @response `401` `void` Unauthorized
   */
  export namespace ChipNumbersCreateChipNumber {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainChipNumbersCommandUpsertChipNumberCommand;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }

  /**
   * No description
   * @tags ChipNumbers
   * @name ChipNumbersDeleteChipNumber
   * @request DELETE:/chip-mumbers/v1
   * @secure
   * @response `200` `string` OK
   * @response `401` `void` Unauthorized
   */
  export namespace ChipNumbersDeleteChipNumber {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainChipNumbersCommandRemoveChipNumberCommand;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }

  /**
   * No description
   * @tags ChipNumbers
   * @name ChipNumbersGetChipNumber
   * @request GET:/chip-mumbers/v1
   * @secure
   * @response `200` `HealthSystemDomainChipNumbersResultChipNumberListResult` OK
   * @response `401` `void` Unauthorized
   */
  export namespace ChipNumbersGetChipNumber {
    export type RequestParams = {};
    export type RequestQuery = {
      "Filter.FarmIds"?: string[];
      "Filter.Genders"?: HealthSystemDALEnumsAnimalGender[];
      /** @format int64 */
      "Filter.RangeFrom"?: number;
      /** @format int64 */
      "Filter.RangeTo"?: number;
      /** @format int32 */
      Page?: number;
      /** @format int32 */
      Size?: number;
      Sort?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainChipNumbersResultChipNumberListResult;
  }

  /**
   * No description
   * @tags ChipNumbers
   * @name ChipNumbersGetChipNumberInfo
   * @request GET:/chip-mumbers/v1/info
   * @secure
   * @response `200` `(HealthSystemDomainChipNumbersResultChipNumberInfoViewModel)[]` OK
   * @response `401` `void` Unauthorized
   */
  export namespace ChipNumbersGetChipNumberInfo {
    export type RequestParams = {};
    export type RequestQuery = {
      ChipNumber: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainChipNumbersResultChipNumberInfoViewModel[];
  }
}

export namespace Dashboards {
  /**
   * No description
   * @tags Dashboards
   * @name DashboardsGetDashboard
   * @summary Reports on the caller's own farm, or on the farm named by farmId. Naming another farm requires the admin role.
   * @request GET:/dashboard
   * @secure
   * @response `200` `HealthSystemDomainDashboardsResultDashboardViewModel` OK
   * @response `401` `void` Unauthorized
   * @response `403` `HSAPIHostingApiResponseApiErrorResult` Forbidden
   * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
   */
  export namespace DashboardsGetDashboard {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format uuid */
      farmId?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainDashboardsResultDashboardViewModel;
  }

  /**
   * No description
   * @tags Dashboards
   * @name DashboardsGetPigletRegistrationDashboard
   * @summary Reports on the caller's own farm, or on the farm named by farmId. Naming another farm requires the admin role, and reports on it even when that farm turned the widget off on its own dashboard.
   * @request GET:/dashboard/piglets
   * @secure
   * @response `200` `HealthSystemAPIControllersDashboardsResponsesPigletRegistrationDashboardResponse` OK
   * @response `401` `void` Unauthorized
   * @response `403` `HSAPIHostingApiResponseApiErrorResult` Forbidden
   * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
   */
  export namespace DashboardsGetPigletRegistrationDashboard {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format uuid */
      farmId?: string;
      /** @format int32 */
      weeks?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemAPIControllersDashboardsResponsesPigletRegistrationDashboardResponse;
  }

  /**
   * @description Separate from `/dashboard/piglets` on purpose - that widget answers how many piglets were registered, this one how heavy they were - but both bucket by the animal's date of birth, so the two charts on the same screen describe the same weeks.
   * @tags Dashboards
   * @name DashboardsGetWeightMilestoneDashboard
   * @summary Weight milestone chart for the caller's own farm, or for the farm named by farmId. Naming another farm requires the admin role.
   * @request GET:/dashboard/weights
   * @secure
   * @response `200` `HealthSystemAPIControllersDashboardsResponsesWeightMilestoneDashboardResponse` OK
   * @response `401` `void` Unauthorized
   * @response `403` `HSAPIHostingApiResponseApiErrorResult` Forbidden
   * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
   */
  export namespace DashboardsGetWeightMilestoneDashboard {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format uuid */
      farmId?: string;
      /** @format int32 */
      weeks?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemAPIControllersDashboardsResponsesWeightMilestoneDashboardResponse;
  }
}

export namespace DataImport {
  /**
   * No description
   * @tags DataImport
   * @name DataImportGetSlaughterImportHistory
   * @request GET:/data-import/slaughter-history
   * @secure
   * @response `200` `HealthSystemAPIControllersDataImportResponsesSlaughterImportHistoryResponse` OK
   * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
   * @response `401` `void` Unauthorized
   * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
   */
  export namespace DataImportGetSlaughterImportHistory {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * Filter imports from this date (inclusive).
       * @format date-time
       */
      FromDate?: string;
      /**
       * Page number (1-based). Defaults to 1.
       * @format int32
       */
      PageIndex?: number;
      /**
       * Page size.
       * @format int32
       */
      PageSize?: number;
      /**
       * Filter imports to this date (inclusive).
       * @format date-time
       */
      ToDate?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemAPIControllersDataImportResponsesSlaughterImportHistoryResponse;
  }
}

export namespace Device {
  /**
   * @description This endpoint allows mobile users to connect a HealthInjector device to a farm. If the device is already connected to a different farm, the farm association will be updated.
   * @tags Device
   * @name DeviceConnectHealthInjector
   * @summary Connect a HealthInjector device to a farm (mobile endpoint)
   * @request POST:/device/injector/connect
   * @secure
   * @response `200` `HealthSystemAPIControllersDeviceResponsesHealthInjectorConnectionResponse` OK
   * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
   * @response `401` `void` Unauthorized
   * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
   * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
   */
  export namespace DeviceConnectHealthInjector {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemAPIControllersDeviceRequestsConnectHealthInjectorRequest;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemAPIControllersDeviceResponsesHealthInjectorConnectionResponse;
  }

  /**
   * No description
   * @tags Device
   * @name DeviceDownloadDeviceFirmware
   * @summary Download device firmware
   * @request GET:/device/firmware/file
   * @secure
   * @response `200` `File` OK
   * @response `401` `void` Unauthorized
   */
  export namespace DeviceDownloadDeviceFirmware {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format uuid */
      Id?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = File;
  }

  /**
   * @description Exports reader actions matching the given filters to a CSV file. Use the Columns list to select which fields to include; if empty, all columns are exported. Valid column names: Number, HookId, DateTime, FarmId, Farm, Weight, TradingClass, BaconCutlet, Fat, LeanMeat, Belly, Ham, Spine, Shoulder, Money, EventMessage, Slaughterhouse
   * @tags Device
   * @name DeviceExportReaderActions
   * @summary Export reader actions to CSV
   * @request POST:/device/reader/action/export
   * @secure
   * @response `200` `File` OK
   * @response `401` `void` Unauthorized
   */
  export namespace DeviceExportReaderActions {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemAPIControllersDeviceRequestsExportReaderActionsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = File;
  }

  /**
   * No description
   * @tags Device
   * @name DeviceGetDeviceFirmwareVersions
   * @summary Get device firmware versions
   * @request GET:/device/firmware
   * @secure
   * @response `200` `HealthSystemDomainDeviceResultDeviceFirmwareQueryResult` OK
   * @response `401` `void` Unauthorized
   */
  export namespace DeviceGetDeviceFirmwareVersions {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format int32 */
      Page?: number;
      ReleaseType?: string;
      RfidType?: string;
      /** @format int32 */
      Size?: number;
      Sort?: string;
      Type?: HealthSystemDALEnumsDeviceFirmwareType;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainDeviceResultDeviceFirmwareQueryResult;
  }

  /**
   * @description The read side of the sync reports the mobile app files below. Each device is represented by its latest report, so this is the farm's current backlog rather than a log: `totalPendingCount` is what has not reached the backend yet, and `pendingSince` says how long a device has been sitting on it - a queue that never drops is what separates a stuck device from a busy one. `farmId` defaults to the caller's own farm; naming another one requires admin. `pendingOnly` narrows the device list to the ones that are behind, and never changes the counts.
   * @tags Device
   * @name DeviceGetDeviceSyncStatus
   * @summary List the mobile devices that still have unsent animals queued
   * @request GET:/device/sync-status
   * @secure
   * @response `200` `HealthSystemAPIControllersDeviceResponsesDeviceSyncStatusOverviewResponse` OK
   * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
   * @response `401` `void` Unauthorized
   * @response `403` `HSAPIHostingApiResponseApiErrorResult` Forbidden
   * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
   */
  export namespace DeviceGetDeviceSyncStatus {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format uuid */
      farmId?: string;
      /**
       * @format int32
       * @default 30
       */
      historyDays?: number;
      /** @default false */
      pendingOnly?: boolean;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemAPIControllersDeviceResponsesDeviceSyncStatusOverviewResponse;
  }

  /**
   * @description Returns a paginated list of activity events for a specific HealthInjector device. Supports filtering by activity type and date range.
   * @tags Device
   * @name DeviceGetHealthInjectorActivities
   * @summary Get paginated HealthInjector activities
   * @request GET:/device/injector/{id}/activities
   * @secure
   * @response `200` `HealthSystemAPIControllersDeviceResponsesHealthInjectorActivitiesResponse` OK
   * @response `401` `void` Unauthorized
   * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
   * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
   */
  export namespace DeviceGetHealthInjectorActivities {
    export type RequestParams = {
      /** @format uuid */
      id: string;
    };
    export type RequestQuery = {
      /**
       * Available values: DeviceRegistered, FarmAttached, FarmDetached, FarmChanged, MobileConnection, FirmwareUpdated, ManualUpdate, DeviceDisabled, DeviceEnabled, ConfigurationChanged
       * @example "DeviceRegistered"
       */
      activityType?: string;
      /** @format date-time */
      fromDate?: string;
      /**
       * @format int32
       * @default 1
       */
      page?: number;
      /**
       * @format int32
       * @default 20
       */
      size?: number;
      /** @format date-time */
      toDate?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemAPIControllersDeviceResponsesHealthInjectorActivitiesResponse;
  }

  /**
   * @description Returns detailed information about a specific HealthInjector device including farm association, firmware versions, and operational status.
   * @tags Device
   * @name DeviceGetHealthInjectorDetails
   * @summary Get HealthInjector details by ID
   * @request GET:/device/injector/{id}
   * @secure
   * @response `200` `HealthSystemAPIControllersDeviceResponsesHealthInjectorDetailsResponse` OK
   * @response `401` `void` Unauthorized
   * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
   * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
   */
  export namespace DeviceGetHealthInjectorDetails {
    export type RequestParams = {
      /** @format uuid */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemAPIControllersDeviceResponsesHealthInjectorDetailsResponse;
  }

  /**
   * @description Returns a paginated list of application events linked to a specific HealthInjector device. Events are automatically linked by MAC address when created. Supports filtering by date range and error status.
   * @tags Device
   * @name DeviceGetHealthInjectorEvents
   * @summary Get paginated AppEventLog entries for a HealthInjector
   * @request GET:/device/injector/{id}/events
   * @secure
   * @response `200` `HealthSystemAPIControllersDeviceResponsesHealthInjectorEventsResponse` OK
   * @response `401` `void` Unauthorized
   * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
   * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
   */
  export namespace DeviceGetHealthInjectorEvents {
    export type RequestParams = {
      /** @format uuid */
      id: string;
    };
    export type RequestQuery = {
      /** @format date-time */
      fromDate?: string;
      isError?: boolean;
      /**
       * @format int32
       * @default 1
       */
      page?: number;
      /**
       * @format int32
       * @default 20
       */
      size?: number;
      /** @format date-time */
      toDate?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemAPIControllersDeviceResponsesHealthInjectorEventsResponse;
  }

  /**
   * No description
   * @tags Device
   * @name DeviceGetHealthInjectors
   * @request GET:/device/injector
   * @secure
   * @response `200` `HealthSystemDomainDeviceResultHealthInjectorsQueryResult` OK
   * @response `401` `void` Unauthorized
   */
  export namespace DeviceGetHealthInjectors {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format uuid */
      FarmId?: string;
      MacAddress?: string;
      /** @format int32 */
      Page?: number;
      /** @format int32 */
      Size?: number;
      Sort?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainDeviceResultHealthInjectorsQueryResult;
  }

  /**
   * No description
   * @tags Device
   * @name DeviceGetLatestDeviceFirmwareVersion
   * @summary Get latest device firmware version
   * @request GET:/device/firmware/latest
   * @secure
   * @response `200` `HealthSystemDomainDeviceResultDeviceFirmwareViewModel` OK
   * @response `401` `void` Unauthorized
   */
  export namespace DeviceGetLatestDeviceFirmwareVersion {
    export type RequestParams = {};
    export type RequestQuery = {
      query?: HealthSystemDomainDeviceCommandsLatestFirmwareQuery;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainDeviceResultDeviceFirmwareViewModel;
  }

  /**
   * No description
   * @tags Device
   * @name DeviceGetReaderActions
   * @request POST:/device/reader/action/search
   * @secure
   * @response `200` `HealthSystemDomainDeviceResultReaderActionsQueryResult` OK
   * @response `401` `void` Unauthorized
   */
  export namespace DeviceGetReaderActions {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainDeviceCommandsReaderActionsQuery;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainDeviceResultReaderActionsQueryResult;
  }

  /**
   * No description
   * @tags Device
   * @name DeviceGetReaders
   * @request GET:/device/reader
   * @secure
   * @response `200` `HealthSystemDomainDeviceResultReadersQueryResult` OK
   * @response `401` `void` Unauthorized
   */
  export namespace DeviceGetReaders {
    export type RequestParams = {};
    export type RequestQuery = {
      MacAddress?: string;
      /** @format int32 */
      Page?: number;
      /** @format int32 */
      Size?: number;
      /** @format uuid */
      SlaughterhouseId?: string;
      Sort?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = HealthSystemDomainDeviceResultReadersQueryResult;
  }

  /**
   * @description Called periodically by the mobile app while it drains its offline queue, so a device sitting on unsent animals is visible on the backend. Each call appends a new record rather than replacing the previous one. The MAC address identifies the health injector the phone is paired with. If it matches no registered device the report is still stored, with a null HealthInjectorId and `injectorMatched: false` in the response.
   * @tags Device
   * @name DevicePostDeviceSyncStatus
   * @summary Report the state of a mobile device's offline sync queue
   * @request POST:/device/sync-status
   * @secure
   * @response `200` `HealthSystemAPIControllersDeviceResponsesDeviceSyncStatusResponse` OK
   * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
   * @response `401` `void` Unauthorized
   * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
   * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
   */
  export namespace DevicePostDeviceSyncStatus {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemAPIControllersDeviceRequestsPostDeviceSyncStatusRequest;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemAPIControllersDeviceResponsesDeviceSyncStatusResponse;
  }

  /**
   * No description
   * @tags Device
   * @name DevicePostReaderActions
   * @request POST:/device/reader/action
   * @secure
   * @response `200` `HealthSystemDomainDeviceResultCreateReaderActionViewModel` OK
   * @response `401` `void` Unauthorized
   */
  export namespace DevicePostReaderActions {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainDeviceCommandsCreateReaderActionCommand;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainDeviceResultCreateReaderActionViewModel;
  }

  /**
   * No description
   * @tags Device
   * @name DevicePostReaderHeartbeat
   * @request POST:/device/reader/heartbeat
   * @secure
   * @response `200` `HealthSystemDomainDeviceCommandsRecordReaderHeartbeatResult` OK
   * @response `401` `HSAPIHostingApiResponseApiErrorResult` Unauthorized
   * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
   */
  export namespace DevicePostReaderHeartbeat {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemAPIControllersDeviceRequestsPostReaderHeartbeatRequest;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainDeviceCommandsRecordReaderHeartbeatResult;
  }

  /**
   * No description
   * @tags Device
   * @name DeviceRegisterHealthInjector
   * @request POST:/device/injector
   * @secure
   * @response `200` `string` OK
   * @response `401` `void` Unauthorized
   */
  export namespace DeviceRegisterHealthInjector {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainDeviceCommandsCreateHealthInjectorCommand;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }

  /**
   * No description
   * @tags Device
   * @name DeviceRemoveDeviceFirmware
   * @summary Remove device firmware
   * @request DELETE:/device/firmware
   * @secure
   * @response `200` `string` OK
   * @response `401` `void` Unauthorized
   */
  export namespace DeviceRemoveDeviceFirmware {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format uuid */
      Id: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }

  /**
   * @description Both values are replaced: send the current short description to keep it, and an empty release log to clear it.
   * @tags Device
   * @name DeviceUpdateDeviceFirmwareDescription
   * @summary Update the description and the markdown release log of an uploaded device firmware
   * @request PATCH:/device/firmware/{id}
   * @secure
   * @response `200` `HealthSystemAPIControllersDeviceResponsesDeviceFirmwareDescriptionResponse` OK
   * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
   * @response `401` `void` Unauthorized
   * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
   */
  export namespace DeviceUpdateDeviceFirmwareDescription {
    export type RequestParams = {
      /** @format uuid */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemAPIControllersDeviceRequestsUpdateDeviceFirmwareDescriptionRequest;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemAPIControllersDeviceResponsesDeviceFirmwareDescriptionResponse;
  }

  /**
   * No description
   * @tags Device
   * @name DeviceUpdateHealthInjector
   * @request PUT:/device/injector
   * @secure
   * @response `200` `string` OK
   * @response `401` `void` Unauthorized
   */
  export namespace DeviceUpdateHealthInjector {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainDeviceCommandsUpdateHealthInjectorCommand;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }

  /**
   * No description
   * @tags Device
   * @name DeviceUpdateHealthInjectorVersion
   * @request POST:/device/injector/version
   * @secure
   * @response `200` `string` OK
   * @response `401` `void` Unauthorized
   */
  export namespace DeviceUpdateHealthInjectorVersion {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainDeviceCommandsUpdateHealthInjectorVersionCommand;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }

  /**
   * No description
   * @tags Device
   * @name DeviceUploadDeviceFirmware
   * @summary Upload device firmware
   * @request POST:/device/firmware
   * @secure
   * @response `200` `string` OK
   * @response `401` `void` Unauthorized
   */
  export namespace DeviceUploadDeviceFirmware {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DeviceUploadDeviceFirmwarePayload;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }
}

export namespace DeviceDailyReports {
  /**
   * @description The body is the report document the device produced, taken as is - there is deliberately no request model mirroring its fields yet.
   * @tags DeviceDailyReports
   * @name DeviceDailyReportsCreate
   * @request POST:/farms/{farmId}/device-daily-reports
   * @secure
   * @response `200` `HealthSystemAPIControllersDeviceDailyReportsResponsesCreateDeviceDailyReportResponse` OK
   * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
   * @response `401` `void` Unauthorized
   * @response `403` `HSAPIHostingApiResponseApiErrorResult` Forbidden
   * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
   * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
   */
  export namespace DeviceDailyReportsCreate {
    export type RequestParams = {
      /** @format uuid */
      farmId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = DeviceDailyReportsCreatePayload;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemAPIControllersDeviceDailyReportsResponsesCreateDeviceDailyReportResponse;
  }

  /**
   * No description
   * @tags DeviceDailyReports
   * @name DeviceDailyReportsGetByFarm
   * @request GET:/farms/{farmId}/device-daily-reports
   * @secure
   * @response `200` `(HealthSystemAPIControllersDeviceDailyReportsResponsesDeviceDailyReportResponse)[]` OK
   * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
   * @response `401` `void` Unauthorized
   * @response `403` `HSAPIHostingApiResponseApiErrorResult` Forbidden
   * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
   */
  export namespace DeviceDailyReportsGetByFarm {
    export type RequestParams = {
      /** @format uuid */
      farmId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemAPIControllersDeviceDailyReportsResponsesDeviceDailyReportResponse[];
  }
}

export namespace Diseases {
  /**
   * No description
   * @tags Diseases
   * @name DiseasesCreateDisease
   * @request POST:/diseases
   * @secure
   * @response `200` `string` OK
   * @response `401` `void` Unauthorized
   */
  export namespace DiseasesCreateDisease {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainDiseasesCommandsCreateDiseaseCommand;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }

  /**
   * No description
   * @tags Diseases
   * @name DiseasesDiseasesSearch
   * @request GET:/diseases
   * @secure
   * @response `200` `HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainDiseasesDiseaseViewModel` OK
   * @response `401` `void` Unauthorized
   */
  export namespace DiseasesDiseasesSearch {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format int32 */
      Page?: number;
      /** @format int32 */
      Size?: number;
      Sort?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainDiseasesDiseaseViewModel;
  }

  /**
   * No description
   * @tags Diseases
   * @name DiseasesGetAllDiseases
   * @request GET:/diseases/all
   * @secure
   * @response `200` `(HealthSystemDomainDiseasesDiseaseViewModel)[]` OK
   * @response `401` `void` Unauthorized
   */
  export namespace DiseasesGetAllDiseases {
    export type RequestParams = {};
    export type RequestQuery = {
      query?: HealthSystemDomainDiseasesCommandsGetAllDiseasesQuery;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = HealthSystemDomainDiseasesDiseaseViewModel[];
  }

  /**
   * No description
   * @tags Diseases
   * @name DiseasesRemoveDisease
   * @request DELETE:/diseases
   * @secure
   * @response `200` `string` OK
   * @response `401` `void` Unauthorized
   */
  export namespace DiseasesRemoveDisease {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainDiseasesCommandsRemoveDiseaseCommand;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }
}

export namespace Documents {
  /**
   * No description
   * @tags Documents
   * @name DocumentsCreateAnimalChipNumbersExport
   * @request POST:/export/animals/chip-numbers
   * @secure
   * @response `200` `boolean` OK
   * @response `401` `void` Unauthorized
   */
  export namespace DocumentsCreateAnimalChipNumbersExport {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemAPIControllersDocumentsRequestsExportAnimalsByChipNumbersRequest;
    export type RequestHeaders = {};
    export type ResponseBody = boolean;
  }

  /**
   * No description
   * @tags Documents
   * @name DocumentsCreateAnimalSearchExport
   * @request POST:/export/animals
   * @secure
   * @response `200` `boolean` OK
   * @response `401` `void` Unauthorized
   */
  export namespace DocumentsCreateAnimalSearchExport {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainAnimalsCommandsExportAnimalSearchCommand;
    export type RequestHeaders = {};
    export type ResponseBody = boolean;
  }

  /**
   * No description
   * @tags Documents
   * @name DocumentsCreateLivestockBalanceCardExport
   * @request POST:/export/livestock-balance-card
   * @secure
   * @response `200` `boolean` OK
   * @response `401` `void` Unauthorized
   */
  export namespace DocumentsCreateLivestockBalanceCardExport {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemAPIControllersDocumentsRequestsExportLivestockBalanceCardRequest;
    export type RequestHeaders = {};
    export type ResponseBody = boolean;
  }

  /**
   * No description
   * @tags Documents
   * @name DocumentsDeleteFarmDocument
   * @request DELETE:/documents
   * @secure
   * @response `200` `string` OK
   * @response `401` `void` Unauthorized
   */
  export namespace DocumentsDeleteFarmDocument {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainDocumentsCommandsDeleteFarmDocumentCommand;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }

  /**
   * No description
   * @tags Documents
   * @name DocumentsDownloadExportDocument
   * @request GET:/export/animals
   * @secure
   * @response `200` `File` OK
   * @response `401` `void` Unauthorized
   */
  export namespace DocumentsDownloadExportDocument {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format uuid */
      Id?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = File;
  }

  /**
   * No description
   * @tags Documents
   * @name DocumentsSearchDocuments
   * @request GET:/documents
   * @secure
   * @response `200` `HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainDocumentsResultFarmDocumentViewModel` OK
   * @response `401` `void` Unauthorized
   */
  export namespace DocumentsSearchDocuments {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format int32 */
      Page?: number;
      /** @format int32 */
      Size?: number;
      Sort?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainDocumentsResultFarmDocumentViewModel;
  }
}

export namespace EmissionSourceSettings {
  /**
   * No description
   * @tags EmissionSourceSettings
   * @name EmissionSourceSettingsAddEmissionSourceUsage
   * @request POST:/emission-sources/usage-entries
   * @secure
   * @response `201` `string` Created
   * @response `401` `void` Unauthorized
   */
  export namespace EmissionSourceSettingsAddEmissionSourceUsage {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainEmissionSourceUsageEntriesCommandHandlersAddEmissionSourceUsageEntryCommand;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }

  /**
   * No description
   * @tags EmissionSourceSettings
   * @name EmissionSourceSettingsCreateEmissionSource
   * @summary Create a new emission source.
   * @request POST:/emission-sources/settings
   * @secure
   * @response `200` `string` OK
   * @response `401` `void` Unauthorized
   */
  export namespace EmissionSourceSettingsCreateEmissionSource {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainEmissionSourcesCommandHandlersCreateEmissionSourceCommand;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }

  /**
   * No description
   * @tags EmissionSourceSettings
   * @name EmissionSourceSettingsDelete
   * @summary Delete an emission source by ID.
   * @request DELETE:/emission-sources/settings
   * @secure
   * @response `204` `void` No Content
   * @response `401` `void` Unauthorized
   */
  export namespace EmissionSourceSettingsDelete {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainEmissionSourcesCommandHandlersDeleteEmissionSourceCommand;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags EmissionSourceSettings
   * @name EmissionSourceSettingsDeleteEmissionSourceUsageEntry
   * @request DELETE:/emission-sources/usage-entries
   * @secure
   * @response `204` `string` No Content
   * @response `401` `void` Unauthorized
   */
  export namespace EmissionSourceSettingsDeleteEmissionSourceUsageEntry {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainEmissionSourceUsageEntriesCommandHandlersDeleteEmissionSourceUsageEntryCommand;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }

  /**
   * No description
   * @tags EmissionSourceSettings
   * @name EmissionSourceSettingsGet
   * @request GET:/emission-sources/usage-entries
   * @secure
   * @response `200` `HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainEmissionSourceUsageEntriesViewModelsEmissionSourceUsageEntryViewModel` OK
   * @response `401` `void` Unauthorized
   */
  export namespace EmissionSourceSettingsGet {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format int32 */
      Page?: number;
      /** @format int32 */
      Size?: number;
      Sort?: string;
      /** @format int32 */
      Year?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainEmissionSourceUsageEntriesViewModelsEmissionSourceUsageEntryViewModel;
  }

  /**
   * No description
   * @tags EmissionSourceSettings
   * @name EmissionSourceSettingsGetAll
   * @summary Get all emission sources with pagination.
   * @request GET:/emission-sources/settings
   * @secure
   * @response `200` `HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainEmissionSourcesViewModelsEmissionSourceViewModel` OK
   * @response `401` `void` Unauthorized
   */
  export namespace EmissionSourceSettingsGetAll {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format int32 */
      Page?: number;
      /** @format int32 */
      Size?: number;
      Sort?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainEmissionSourcesViewModelsEmissionSourceViewModel;
  }

  /**
   * No description
   * @tags EmissionSourceSettings
   * @name EmissionSourceSettingsUpdateEmissionSource
   * @summary Update an existing emission source.
   * @request PUT:/emission-sources/settings
   * @secure
   * @response `204` `void` No Content
   * @response `401` `void` Unauthorized
   */
  export namespace EmissionSourceSettingsUpdateEmissionSource {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainEmissionSourcesCommandHandlersUpdateEmissionSourceCommand;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags EmissionSourceSettings
   * @name EmissionSourceSettingsUpdateEmissionSourceUsage
   * @request PUT:/emission-sources/usage-entries
   * @secure
   * @response `204` `string` No Content
   * @response `401` `void` Unauthorized
   */
  export namespace EmissionSourceSettingsUpdateEmissionSourceUsage {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainEmissionSourceUsageEntriesCommandHandlersUpdateEmissionSourceUsageEntryCommand;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }
}

export namespace FarmConfigurationProviders {
  /**
   * No description
   * @tags FarmConfigurationProviders
   * @name FarmConfigurationProvidersDisable
   * @request POST:/farms/{farmId}/configuration-providers/{type}/disable
   * @secure
   * @response `204` `void` No Content
   * @response `401` `void` Unauthorized
   * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
   * @response `409` `HSAPIHostingApiResponseApiErrorResult` Conflict
   * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
   */
  export namespace FarmConfigurationProvidersDisable {
    export type RequestParams = {
      /** @format uuid */
      farmId: string;
      type: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags FarmConfigurationProviders
   * @name FarmConfigurationProvidersEnable
   * @request POST:/farms/{farmId}/configuration-providers/{type}/enable
   * @secure
   * @response `204` `void` No Content
   * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
   * @response `401` `void` Unauthorized
   * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
   * @response `409` `HSAPIHostingApiResponseApiErrorResult` Conflict
   * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
   */
  export namespace FarmConfigurationProvidersEnable {
    export type RequestParams = {
      /** @format uuid */
      farmId: string;
      type: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags FarmConfigurationProviders
   * @name FarmConfigurationProvidersGetAll
   * @request GET:/farms/{farmId}/configuration-providers
   * @secure
   * @response `200` `(HealthSystemAPIControllersFarmConfigurationProvidersResponsesFarmConfigurationProviderResponse)[]` OK
   * @response `401` `void` Unauthorized
   * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
   */
  export namespace FarmConfigurationProvidersGetAll {
    export type RequestParams = {
      /** @format uuid */
      farmId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemAPIControllersFarmConfigurationProvidersResponsesFarmConfigurationProviderResponse[];
  }

  /**
   * No description
   * @tags FarmConfigurationProviders
   * @name FarmConfigurationProvidersUpsert
   * @request PUT:/farms/{farmId}/configuration-providers/{type}
   * @secure
   * @response `204` `void` No Content
   * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
   * @response `401` `void` Unauthorized
   * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
   */
  export namespace FarmConfigurationProvidersUpsert {
    export type RequestParams = {
      /** @format uuid */
      farmId: string;
      type: string;
    };
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemAPIControllersFarmConfigurationProvidersRequestsUpsertFarmConfigurationProviderRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }
}

export namespace Farms {
  /**
   * No description
   * @tags Farms
   * @name FarmsCreateFarm
   * @request POST:/farms
   * @secure
   * @response `200` `string` OK
   * @response `401` `void` Unauthorized
   */
  export namespace FarmsCreateFarm {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = HealthSystemDomainFarmsCommandsCreateFarmCommand;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }

  /**
   * No description
   * @tags Farms
   * @name FarmsGetCurrentUserFarm
   * @request GET:/farms/current-user
   * @secure
   * @response `200` `HealthSystemDomainFarmsResultFarmViewModel` OK
   * @response `401` `void` Unauthorized
   */
  export namespace FarmsGetCurrentUserFarm {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = HealthSystemDomainFarmsResultFarmViewModel;
  }

  /**
   * No description
   * @tags Farms
   * @name FarmsGetFarms
   * @request GET:/farms
   * @secure
   * @response `200` `HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainFarmsResultFarmViewModel` OK
   * @response `401` `void` Unauthorized
   */
  export namespace FarmsGetFarms {
    export type RequestParams = {};
    export type RequestQuery = {
      Ids?: string[];
      /** @format int32 */
      Page?: number;
      SearchText?: string;
      /** @format int32 */
      Size?: number;
      Sort?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainFarmsResultFarmViewModel;
  }

  /**
   * No description
   * @tags Farms
   * @name FarmsUpdateFarm
   * @request PUT:/farms
   * @secure
   * @response `200` `string` OK
   * @response `401` `void` Unauthorized
   */
  export namespace FarmsUpdateFarm {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = HealthSystemDomainFarmsCommandsUpdateFarmCommand;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }
}

export namespace FeedConversion {
  /**
   * No description
   * @tags FeedConversion
   * @name FeedConversionGetFeedConversion
   * @request GET:/feed-conversions
   * @secure
   * @response `200` `HealthSystemAPIControllersFeedResponsesGetFeedConversionResponse` OK
   * @response `401` `void` Unauthorized
   * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
   */
  export namespace FeedConversionGetFeedConversion {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format uuid */
      FarmId?: string;
      /** @format date-time */
      From?: string;
      /** @format date-time */
      To?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemAPIControllersFeedResponsesGetFeedConversionResponse;
  }
}

export namespace FeedRegistrations {
  /**
   * No description
   * @tags FeedRegistrations
   * @name FeedRegistrationsCreate
   * @request POST:/farms/{farmId}/feed-registrations
   * @secure
   * @response `200` `(HealthSystemAPIControllersFeedSupplyResponsesFeedRegistrationResponse)[]` OK
   * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
   * @response `401` `void` Unauthorized
   * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
   */
  export namespace FeedRegistrationsCreate {
    export type RequestParams = {
      /** @format uuid */
      farmId: string;
    };
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemAPIControllersFeedSupplyRequestsCreateFeedRegistrationRequest;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemAPIControllersFeedSupplyResponsesFeedRegistrationResponse[];
  }

  /**
   * No description
   * @tags FeedRegistrations
   * @name FeedRegistrationsDelete
   * @request DELETE:/farms/{farmId}/feed-registrations/{registrationId}
   * @secure
   * @response `204` `void` No Content
   * @response `401` `void` Unauthorized
   * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
   */
  export namespace FeedRegistrationsDelete {
    export type RequestParams = {
      /** @format uuid */
      farmId: string;
      /** @format uuid */
      registrationId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags FeedRegistrations
   * @name FeedRegistrationsGet
   * @request GET:/farms/{farmId}/feed-registrations
   * @secure
   * @response `200` `HealthSystemAPIControllersFeedSupplyResponsesFeedRegistrationsPageResponse` OK
   * @response `401` `void` Unauthorized
   */
  export namespace FeedRegistrationsGet {
    export type RequestParams = {
      /** @format uuid */
      farmId: string;
    };
    export type RequestQuery = {
      /** @format date */
      EndDate?: string;
      LocationIds?: string[];
      /** @format int32 */
      Page?: number;
      /** @format int32 */
      Size?: number;
      /** @format date */
      StartDate?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemAPIControllersFeedSupplyResponsesFeedRegistrationsPageResponse;
  }

  /**
   * No description
   * @tags FeedRegistrations
   * @name FeedRegistrationsUpdate
   * @request PUT:/farms/{farmId}/feed-registrations/{registrationId}
   * @secure
   * @response `200` `HealthSystemAPIControllersFeedSupplyResponsesFeedRegistrationResponse` OK
   * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
   * @response `401` `void` Unauthorized
   * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
   */
  export namespace FeedRegistrationsUpdate {
    export type RequestParams = {
      /** @format uuid */
      farmId: string;
      /** @format uuid */
      registrationId: string;
    };
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemAPIControllersFeedSupplyRequestsUpdateFeedRegistrationRequest;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemAPIControllersFeedSupplyResponsesFeedRegistrationResponse;
  }
}

export namespace FeedSilos {
  /**
   * No description
   * @tags FeedSilos
   * @name FeedSilosCreate
   * @request POST:/farms/{farmId}/feed-silos
   * @secure
   * @response `200` `HealthSystemDomainFeedSupplyCommandsCreateFeedSiloResult` OK
   * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
   * @response `401` `void` Unauthorized
   * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
   * @response `409` `HSAPIHostingApiResponseApiErrorResult` Conflict
   */
  export namespace FeedSilosCreate {
    export type RequestParams = {
      /** @format uuid */
      farmId: string;
    };
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemAPIControllersFeedSupplyRequestsCreateFeedSiloRequest;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainFeedSupplyCommandsCreateFeedSiloResult;
  }

  /**
   * No description
   * @tags FeedSilos
   * @name FeedSilosCreateBatch
   * @request POST:/farms/{farmId}/feed-silos/{siloId}/batches
   * @secure
   * @response `200` `HealthSystemDomainFeedSupplyCommandsCreateFeedBatchResult` OK
   * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
   * @response `401` `void` Unauthorized
   * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
   */
  export namespace FeedSilosCreateBatch {
    export type RequestParams = {
      /** @format uuid */
      farmId: string;
      /** @format uuid */
      siloId: string;
    };
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemAPIControllersFeedSupplyRequestsCreateFeedBatchRequest;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainFeedSupplyCommandsCreateFeedBatchResult;
  }

  /**
   * No description
   * @tags FeedSilos
   * @name FeedSilosDelete
   * @request DELETE:/farms/{farmId}/feed-silos/{siloId}
   * @secure
   * @response `204` `void` No Content
   * @response `401` `void` Unauthorized
   * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
   */
  export namespace FeedSilosDelete {
    export type RequestParams = {
      /** @format uuid */
      farmId: string;
      /** @format uuid */
      siloId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags FeedSilos
   * @name FeedSilosDeleteBatch
   * @request DELETE:/farms/{farmId}/feed-silos/{siloId}/batches/{batchId}
   * @secure
   * @response `204` `void` No Content
   * @response `401` `void` Unauthorized
   * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
   */
  export namespace FeedSilosDeleteBatch {
    export type RequestParams = {
      /** @format uuid */
      batchId: string;
      /** @format uuid */
      farmId: string;
      /** @format uuid */
      siloId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags FeedSilos
   * @name FeedSilosGetBatches
   * @request GET:/farms/{farmId}/feed-silos/{siloId}/batches
   * @secure
   * @response `200` `HealthSystemDomainFeedSupplyQueriesGetFeedBatchesResult` OK
   * @response `401` `void` Unauthorized
   * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
   */
  export namespace FeedSilosGetBatches {
    export type RequestParams = {
      /** @format uuid */
      farmId: string;
      /** @format uuid */
      siloId: string;
    };
    export type RequestQuery = {
      /** @format date */
      EndDate?: string;
      /** @format int32 */
      Page?: number;
      /** @format int32 */
      Size?: number;
      /** @format date */
      StartDate?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainFeedSupplyQueriesGetFeedBatchesResult;
  }

  /**
   * No description
   * @tags FeedSilos
   * @name FeedSilosGetByFarm
   * @request GET:/farms/{farmId}/feed-silos
   * @secure
   * @response `200` `(HealthSystemAPIControllersFeedSupplyResponsesFeedSiloResponse)[]` OK
   * @response `401` `void` Unauthorized
   */
  export namespace FeedSilosGetByFarm {
    export type RequestParams = {
      /** @format uuid */
      farmId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemAPIControllersFeedSupplyResponsesFeedSiloResponse[];
  }

  /**
   * No description
   * @tags FeedSilos
   * @name FeedSilosUpdate
   * @request PUT:/farms/{farmId}/feed-silos/{siloId}
   * @secure
   * @response `200` `HealthSystemDomainFeedSupplyCommandsUpdateFeedSiloResult` OK
   * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
   * @response `401` `void` Unauthorized
   * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
   * @response `409` `HSAPIHostingApiResponseApiErrorResult` Conflict
   */
  export namespace FeedSilosUpdate {
    export type RequestParams = {
      /** @format uuid */
      farmId: string;
      /** @format uuid */
      siloId: string;
    };
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemAPIControllersFeedSupplyRequestsUpdateFeedSiloRequest;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainFeedSupplyCommandsUpdateFeedSiloResult;
  }

  /**
   * No description
   * @tags FeedSilos
   * @name FeedSilosUpdateBatch
   * @request PUT:/farms/{farmId}/feed-silos/{siloId}/batches/{batchId}
   * @secure
   * @response `200` `HealthSystemDomainFeedSupplyCommandsUpdateFeedBatchResult` OK
   * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
   * @response `401` `void` Unauthorized
   * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
   */
  export namespace FeedSilosUpdateBatch {
    export type RequestParams = {
      /** @format uuid */
      batchId: string;
      /** @format uuid */
      farmId: string;
      /** @format uuid */
      siloId: string;
    };
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemAPIControllersFeedSupplyRequestsUpdateFeedBatchRequest;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainFeedSupplyCommandsUpdateFeedBatchResult;
  }
}

export namespace FeedSupplier {
  /**
   * No description
   * @tags FeedSupplier
   * @name FeedSupplierGetFeedSuppliers
   * @request GET:/feed-supplier
   * @secure
   * @response `200` `HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainFeedFeedSuppliersFeedSupplierViewModel` OK
   * @response `401` `void` Unauthorized
   */
  export namespace FeedSupplierGetFeedSuppliers {
    export type RequestParams = {};
    export type RequestQuery = {
      Address?: string;
      Country?: string;
      Name?: string;
      /** @format int32 */
      Page?: number;
      RegistrationNumber?: string;
      /** @format int32 */
      Size?: number;
      Sort?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainFeedFeedSuppliersFeedSupplierViewModel;
  }
}

export namespace FeedSuppliers {
  /**
   * No description
   * @tags FeedSuppliers
   * @name FeedSuppliersCreate
   * @request POST:/feed-suppliers
   * @secure
   * @response `200` `HealthSystemDomainFeedSupplyCommandsCreateFeedSupplierResult` OK
   * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
   * @response `401` `void` Unauthorized
   */
  export namespace FeedSuppliersCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemAPIControllersFeedSupplyRequestsCreateFeedSupplierRequest;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainFeedSupplyCommandsCreateFeedSupplierResult;
  }

  /**
   * No description
   * @tags FeedSuppliers
   * @name FeedSuppliersDelete
   * @request DELETE:/feed-suppliers/{id}
   * @secure
   * @response `204` `void` No Content
   * @response `401` `void` Unauthorized
   * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
   */
  export namespace FeedSuppliersDelete {
    export type RequestParams = {
      /** @format uuid */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags FeedSuppliers
   * @name FeedSuppliersGetAll
   * @request GET:/feed-suppliers
   * @secure
   * @response `200` `HealthSystemDomainFeedSupplyQueriesGetFeedSuppliersResult` OK
   * @response `401` `void` Unauthorized
   */
  export namespace FeedSuppliersGetAll {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format int32 */
      Page?: number;
      SearchTerm?: string;
      /** @format int32 */
      Size?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainFeedSupplyQueriesGetFeedSuppliersResult;
  }

  /**
   * No description
   * @tags FeedSuppliers
   * @name FeedSuppliersUpdate
   * @request PUT:/feed-suppliers/{id}
   * @secure
   * @response `200` `HealthSystemDomainFeedSupplyCommandsUpdateFeedSupplierResult` OK
   * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
   * @response `401` `void` Unauthorized
   * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
   */
  export namespace FeedSuppliersUpdate {
    export type RequestParams = {
      /** @format uuid */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemAPIControllersFeedSupplyRequestsUpdateFeedSupplierRequest;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainFeedSupplyCommandsUpdateFeedSupplierResult;
  }
}

export namespace Import {
  /**
   * No description
   * @tags Import
   * @name ImportDownloadCsvExample
   * @summary Downloads a sample CSV file template for animal import
   * @request GET:/import/csv-example
   * @secure
   * @response `200` `void` OK
   * @response `401` `void` Unauthorized
   */
  export namespace ImportDownloadCsvExample {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * Format type: 'basic', 'complete', or 'numeric'
       * @default "basic"
       */
      format?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Import
   * @name ImportGetCsvExampleFormats
   * @summary Gets available CSV example formats
   * @request GET:/import/csv-examples
   * @secure
   * @response `200` `HealthSystemDomainImportResultCsvExampleFormatsResponse` OK
   * @response `401` `void` Unauthorized
   */
  export namespace ImportGetCsvExampleFormats {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainImportResultCsvExampleFormatsResponse;
  }

  /**
   * No description
   * @tags Import
   * @name ImportGetImportDocumentation
   * @summary Gets the animal import documentation for display in the UI
   * @request GET:/import/documentation
   * @secure
   * @response `200` `HealthSystemDomainImportResultImportDocumentationResponse` OK
   * @response `401` `void` Unauthorized
   */
  export namespace ImportGetImportDocumentation {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainImportResultImportDocumentationResponse;
  }

  /**
   * No description
   * @tags Import
   * @name ImportImportAnimals
   * @request POST:/import
   * @secure
   * @response `200` `HealthSystemDomainImportResultImportDataFromCsvFileResult` OK
   * @response `401` `void` Unauthorized
   */
  export namespace ImportImportAnimals {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ImportImportAnimalsPayload;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainImportResultImportDataFromCsvFileResult;
  }

  /**
   * No description
   * @tags Import
   * @name ImportValidateAnimals
   * @request POST:/import/validate
   * @secure
   * @response `200` `HealthSystemDomainImportResultImportDataFromCsvFileResult` OK
   * @response `401` `void` Unauthorized
   */
  export namespace ImportValidateAnimals {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ImportValidateAnimalsPayload;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainImportResultImportDataFromCsvFileResult;
  }
}

export namespace Injections {
  /**
   * No description
   * @tags Injections
   * @name InjectionsCreateInjectionRecord
   * @request POST:/injections/register
   * @secure
   * @response `200` `HealthSystemDomainCommonResultEntityBatchResult` OK
   * @response `401` `void` Unauthorized
   */
  export namespace InjectionsCreateInjectionRecord {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainInjectionsCommandsCreateInjectionCommand;
    export type RequestHeaders = {};
    export type ResponseBody = HealthSystemDomainCommonResultEntityBatchResult;
  }

  /**
   * No description
   * @tags Injections
   * @name InjectionsCreateInjectionRecordBatch
   * @request POST:/injections/register-batch
   * @secure
   * @response `200` `HealthSystemDomainCommonResultEntityBatchResult` OK
   * @response `401` `void` Unauthorized
   */
  export namespace InjectionsCreateInjectionRecordBatch {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainInjectionsCommandsCreateInjectionsBatchCommand;
    export type RequestHeaders = {};
    export type ResponseBody = HealthSystemDomainCommonResultEntityBatchResult;
  }

  /**
   * No description
   * @tags Injections
   * @name InjectionsCreateOralFeedInjectionRecord
   * @request POST:/injections/oralfeed
   * @secure
   * @response `200` `(string)[]` OK
   * @response `401` `void` Unauthorized
   */
  export namespace InjectionsCreateOralFeedInjectionRecord {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainInjectionsCommandsCreateOralFeedInjectionCommand;
    export type RequestHeaders = {};
    export type ResponseBody = string[];
  }

  /**
   * No description
   * @tags Injections
   * @name InjectionsCreateOralFeedInjectionRecordByLocation
   * @request POST:/injections/oralfeed/location/{locationId}
   * @secure
   * @response `200` `HealthSystemAPIControllersInjectionsResponsesCreateLocationOralFeedInjectionResponse` OK
   * @response `401` `void` Unauthorized
   */
  export namespace InjectionsCreateOralFeedInjectionRecordByLocation {
    export type RequestParams = {
      /** @format uuid */
      locationId: string;
    };
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemAPIControllersInjectionsRequestsCreateLocationOralFeedInjectionRequest;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemAPIControllersInjectionsResponsesCreateLocationOralFeedInjectionResponse;
  }

  /**
   * No description
   * @tags Injections
   * @name InjectionsCreateVaccinationInjectionRecordByLocation
   * @request POST:/injections/vaccination/location/{locationId}
   * @secure
   * @response `200` `HealthSystemAPIControllersInjectionsResponsesCreateLocationVaccinationInjectionResponse` OK
   * @response `401` `void` Unauthorized
   */
  export namespace InjectionsCreateVaccinationInjectionRecordByLocation {
    export type RequestParams = {
      /** @format uuid */
      locationId: string;
    };
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemAPIControllersInjectionsRequestsCreateLocationVaccinationInjectionRequest;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemAPIControllersInjectionsResponsesCreateLocationVaccinationInjectionResponse;
  }

  /**
   * No description
   * @tags Injections
   * @name InjectionsGetInjectionAgeTrendData
   * @request GET:/injections/age-trend-data
   * @secure
   * @response `200` `HealthSystemAPIControllersInjectionsResponsesInjectionHistoryAgeTrendDataResponse` OK
   * @response `401` `void` Unauthorized
   */
  export namespace InjectionsGetInjectionAgeTrendData {
    export type RequestParams = {};
    export type RequestQuery = {
      AnimalType?: HealthSystemDALEnumsAnimalType;
      LactatingOnly?: boolean;
      PregnantOnly?: boolean;
      /** @format uuid */
      SupplyId?: string;
      /** @format int32 */
      WeekNumber?: number;
      /** @format int32 */
      Year?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemAPIControllersInjectionsResponsesInjectionHistoryAgeTrendDataResponse;
  }

  /**
   * No description
   * @tags Injections
   * @name InjectionsGetInjectionStrategy
   * @request GET:/injections/strategy
   * @secure
   * @response `200` `HealthSystemDomainInjectionsResultInjectionHistoryStrategyViewModel` OK
   * @response `401` `void` Unauthorized
   */
  export namespace InjectionsGetInjectionStrategy {
    export type RequestParams = {};
    export type RequestQuery = {
      AnimalType?: HealthSystemDALEnumsAnimalType;
      /** @format uuid */
      LocationId?: string;
      /** @format int32 */
      WeekNumber?: number;
      /** @format int32 */
      WeekStart?: number;
      /** @format int32 */
      Year?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainInjectionsResultInjectionHistoryStrategyViewModel;
  }

  /**
   * No description
   * @tags Injections
   * @name InjectionsGetInjectionTrendData
   * @request GET:/injections/trend-data
   * @secure
   * @response `200` `HealthSystemDomainInjectionsResultInjectionHistoryTrendDataViewModel` OK
   * @response `401` `void` Unauthorized
   */
  export namespace InjectionsGetInjectionTrendData {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format int32 */
      "Week.End"?: number;
      /** @format int32 */
      "Week.Start"?: number;
      /** @format int32 */
      "Years.End"?: number;
      /** @format int32 */
      "Years.Start"?: number;
      AnimalType?: HealthSystemDALEnumsAnimalType;
      LactatingOnly?: boolean;
      PregnantOnly?: boolean;
      /** @format uuid */
      SupplyId?: string;
      /** @format int32 */
      Year?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainInjectionsResultInjectionHistoryTrendDataViewModel;
  }

  /**
   * No description
   * @tags Injections
   * @name InjectionsGetLocationInjectionStrategy
   * @request GET:/injections/location/{locationId}/strategy
   * @secure
   * @response `200` `HealthSystemAPIControllersInjectionsResponsesInjectionHistoryLocationStrategyResponse` OK
   * @response `401` `void` Unauthorized
   */
  export namespace InjectionsGetLocationInjectionStrategy {
    export type RequestParams = {
      /** @format uuid */
      locationId: string;
    };
    export type RequestQuery = {
      /** @format int32 */
      "Week.End"?: number;
      /** @format int32 */
      "Week.Start"?: number;
      LactatingOnly?: boolean;
      PregnantOnly?: boolean;
      ShowDied?: boolean;
      /** @format uuid */
      SupplyId?: string;
      /** @format int32 */
      Year?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemAPIControllersInjectionsResponsesInjectionHistoryLocationStrategyResponse;
  }

  /**
   * No description
   * @tags Injections
   * @name InjectionsQueryInjectionHistories
   * @request GET:/injections
   * @secure
   * @response `200` `HealthSystemDomainInjectionsResultInjectionHistoryQueryResult` OK
   * @response `401` `void` Unauthorized
   */
  export namespace InjectionsQueryInjectionHistories {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format uuid */
      EntityId: string;
      /** @format int32 */
      Page?: number;
      /** @format int32 */
      Size?: number;
      Sort?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainInjectionsResultInjectionHistoryQueryResult;
  }
}

export namespace LabelPrint {
  /**
   * No description
   * @tags LabelPrint
   * @name LabelPrintGetLabelPrintTasks
   * @request GET:/labelprint/tasks
   * @secure
   * @response `200` `HealthSystemDomainCommonQueryResultPageableResultHealthSystemDALModelMedicalSuppliesLabelPrintTask` OK
   * @response `401` `void` Unauthorized
   */
  export namespace LabelPrintGetLabelPrintTasks {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format uuid */
      FarmId?: string;
      /** @format int32 */
      Page?: number;
      /** @format int32 */
      Size?: number;
      Sort?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainCommonQueryResultPageableResultHealthSystemDALModelMedicalSuppliesLabelPrintTask;
  }

  /**
   * No description
   * @tags LabelPrint
   * @name LabelPrintUpdateLabelPrintTaskStatus
   * @request PUT:/labelprint/tasks
   * @secure
   * @response `200` `string` OK
   * @response `401` `void` Unauthorized
   */
  export namespace LabelPrintUpdateLabelPrintTaskStatus {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainMedicalSuppliesQueryUpdateLabelPrintTaskStatusCommand;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }
}

export namespace LocationCycles {
  /**
   * No description
   * @tags LocationCycles
   * @name LocationCyclesCreateLocationCycles
   * @request POST:/location-cycles
   * @deprecated
   * @secure
   * @response `200` `HealthSystemDomainCommonResultEntityBatchResult` OK
   * @response `401` `void` Unauthorized
   */
  export namespace LocationCyclesCreateLocationCycles {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainLocationCyclesCreateLocationCyclesCommand;
    export type RequestHeaders = {};
    export type ResponseBody = HealthSystemDomainCommonResultEntityBatchResult;
  }

  /**
   * No description
   * @tags LocationCycles
   * @name LocationCyclesGetLocationCycleAnimals
   * @request GET:/location-cycles/animals
   * @deprecated
   * @secure
   * @response `200` `(HealthSystemDomainLocationCyclesResultLocationCycleAnimalViewModel)[]` OK
   * @response `401` `void` Unauthorized
   */
  export namespace LocationCyclesGetLocationCycleAnimals {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format uuid */
      LocationCycleId?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainLocationCyclesResultLocationCycleAnimalViewModel[];
  }

  /**
   * No description
   * @tags LocationCycles
   * @name LocationCyclesGetLocationCycles
   * @request GET:/location-cycles
   * @deprecated
   * @secure
   * @response `200` `HealthSystemDomainLocationCyclesResultLocationCyclesSearchPageableQueryResult` OK
   * @response `401` `void` Unauthorized
   */
  export namespace LocationCyclesGetLocationCycles {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format date-time */
      EndPeriod?: string;
      /** @format uuid */
      LocationId?: string;
      /** @format int32 */
      Page?: number;
      /** @format int32 */
      Size?: number;
      Sort?: string;
      /** @format date-time */
      StartPeriod?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainLocationCyclesResultLocationCyclesSearchPageableQueryResult;
  }
}

export namespace Locations {
  /**
   * No description
   * @tags Locations
   * @name LocationsAnimalDiedByLocation
   * @request PUT:/locations/died
   * @secure
   * @response `200` `string` OK
   * @response `401` `void` Unauthorized
   */
  export namespace LocationsAnimalDiedByLocation {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainLocationsCommandsDiedLocationAnimalCommand;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }

  /**
   * No description
   * @tags Locations
   * @name LocationsCreateLocation
   * @request POST:/locations
   * @secure
   * @response `200` `HealthSystemDomainCommonResultEntityBatchResult` OK
   * @response `401` `void` Unauthorized
   */
  export namespace LocationsCreateLocation {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainLocationsCommandsCreateLocationCommand;
    export type RequestHeaders = {};
    export type ResponseBody = HealthSystemDomainCommonResultEntityBatchResult;
  }

  /**
   * No description
   * @tags Locations
   * @name LocationsGetLocationAnimals
   * @request GET:/locations/animals
   * @secure
   * @response `200` `HealthSystemDomainLocationsResultLocationAnimalsResult` OK
   * @response `401` `void` Unauthorized
   */
  export namespace LocationsGetLocationAnimals {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format uuid */
      LocationId?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainLocationsResultLocationAnimalsResult;
  }

  /**
   * No description
   * @tags Locations
   * @name LocationsGetLocationHistory
   * @request GET:/locations/{id}/history
   * @secure
   * @response `200` `HealthSystemAPIControllersLocationsResponsesLocationHistoryResponse` OK
   * @response `401` `void` Unauthorized
   * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
   * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
   */
  export namespace LocationsGetLocationHistory {
    export type RequestParams = {
      /** @format uuid */
      id: string;
    };
    export type RequestQuery = {
      /** @default false */
      currentOnly?: boolean;
      /** @format date */
      from?: string;
      /** @format date */
      to?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemAPIControllersLocationsResponsesLocationHistoryResponse;
  }

  /**
   * No description
   * @tags Locations
   * @name LocationsGetLocationsHierarchy
   * @request GET:/locations/hierarchy
   * @secure
   * @response `200` `HealthSystemDomainLocationsResultLocationHierarchyResult` OK
   * @response `401` `void` Unauthorized
   */
  export namespace LocationsGetLocationsHierarchy {
    export type RequestParams = {};
    export type RequestQuery = {
      AnimalType?: HealthSystemDALEnumsAnimalType;
      Stable?: HealthSystemDALEnumsLocationStableType;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainLocationsResultLocationHierarchyResult;
  }

  /**
   * No description
   * @tags Locations
   * @name LocationsSearchLocations
   * @request GET:/locations/search
   * @secure
   * @response `200` `HealthSystemDomainLocationsResultLocationSearchPageableQueryResult` OK
   * @response `401` `void` Unauthorized
   */
  export namespace LocationsSearchLocations {
    export type RequestParams = {};
    export type RequestQuery = {
      AnimalType?: HealthSystemDALEnumsAnimalType;
      Number?: string;
      /** @format int32 */
      Page?: number;
      Pen?: string;
      Position?: HealthSystemDALEnumsLocationPosition;
      Room?: string;
      /** @format int32 */
      Size?: number;
      Sort?: string;
      Stable?: HealthSystemDALEnumsLocationStableType;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainLocationsResultLocationSearchPageableQueryResult;
  }

  /**
   * No description
   * @tags Locations
   * @name LocationsSickAnimal
   * @request PUT:/locations/sick
   * @secure
   * @response `200` `HealthSystemDomainCommonResultEntityBatchResult` OK
   * @response `401` `void` Unauthorized
   */
  export namespace LocationsSickAnimal {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainLocationsCommandsSickAnimalCommand;
    export type RequestHeaders = {};
    export type ResponseBody = HealthSystemDomainCommonResultEntityBatchResult;
  }

  /**
   * No description
   * @tags Locations
   * @name LocationsUpdateLocation
   * @request PUT:/locations
   * @secure
   * @response `200` `string` OK
   * @response `401` `void` Unauthorized
   */
  export namespace LocationsUpdateLocation {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainLocationsCommandsUpdateLocationCommand;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }

  /**
   * No description
   * @tags Locations
   * @name LocationsUpdateLocationCycle
   * @request PUT:/locations/cycle
   * @deprecated
   * @secure
   * @response `200` `(string)[]` OK
   * @response `401` `void` Unauthorized
   */
  export namespace LocationsUpdateLocationCycle {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainLocationsCommandsUpdateLocationCycleCommand;
    export type RequestHeaders = {};
    export type ResponseBody = string[];
  }

  /**
   * No description
   * @tags Locations
   * @name LocationsViewClimateLocation
   * @request GET:/locations/climate
   * @secure
   * @response `200` `HealthSystemDomainLocationsModelsLocationClimateViewModel` OK
   * @response `401` `void` Unauthorized
   */
  export namespace LocationsViewClimateLocation {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format date-time */
      ClimateDate?: string;
      /** @format uuid */
      Id?: string;
      /** @format date-time */
      SeriesFrom?: string;
      /** @format date-time */
      SeriesTo?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainLocationsModelsLocationClimateViewModel;
  }

  /**
   * No description
   * @tags Locations
   * @name LocationsViewLocation
   * @request GET:/locations
   * @secure
   * @response `200` `HealthSystemDomainLocationsResultLocationViewModel` OK
   * @response `401` `void` Unauthorized
   */
  export namespace LocationsViewLocation {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format uuid */
      Id?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainLocationsResultLocationViewModel;
  }
}

export namespace LungWeather {
  /**
   * @description Scoped to the caller's own farm rather than taking a farm id, like the rest of the farm-facing API. Returns a payload with an empty `stables` list when no peak has been detected yet - that is the normal state for a farm in its first season, not an error.
   * @tags LungWeather
   * @name LungWeatherGetReview
   * @summary The review for one lung disease on the current user's farm: this week's verdict, every stored wind pattern scored against it, and the track record.
   * @request GET:/lung-weather/diseases/{diseaseId}
   * @secure
   * @response `200` `HealthSystemDomainWeatherResultLungWeatherReviewViewModel` OK
   * @response `401` `void` Unauthorized
   * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
   * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
   */
  export namespace LungWeatherGetReview {
    export type RequestParams = {
      /** @format uuid */
      diseaseId: string;
    };
    export type RequestQuery = {
      /**
       * @format int32
       * @default 90
       */
      historyDays?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainWeatherResultLungWeatherReviewViewModel;
  }
}

export namespace MedicalSupplies {
  /**
   * No description
   * @tags MedicalSupplies
   * @name MedicalSuppliesCompleteMedicalSupplyOrder
   * @request POST:/medical-supplies/orders/complete
   * @secure
   * @response `200` `string` OK
   * @response `401` `void` Unauthorized
   */
  export namespace MedicalSuppliesCompleteMedicalSupplyOrder {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainMedicalSuppliesCommandsCompleteMedicalSupplyOrderCommand;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }

  /**
   * No description
   * @tags MedicalSupplies
   * @name MedicalSuppliesConfirmMedicalSupplyOrder
   * @request POST:/medical-supplies/orders/confirm
   * @secure
   * @response `200` `string` OK
   * @response `401` `void` Unauthorized
   */
  export namespace MedicalSuppliesConfirmMedicalSupplyOrder {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainMedicalSuppliesCommandsMedicalSupplyOrderConfirmCommand;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }

  /**
   * No description
   * @tags MedicalSupplies
   * @name MedicalSuppliesCreateFarmMedicalSupply
   * @request POST:/farm/medical-supplies
   * @secure
   * @response `200` `string` OK
   * @response `401` `void` Unauthorized
   */
  export namespace MedicalSuppliesCreateFarmMedicalSupply {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainMedicalSuppliesCommandsCreateFarmMedicalSupplyCommand;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }

  /**
   * No description
   * @tags MedicalSupplies
   * @name MedicalSuppliesCreateMedicalSupply
   * @request POST:/medical-supplies
   * @secure
   * @response `200` `string` OK
   * @response `401` `void` Unauthorized
   */
  export namespace MedicalSuppliesCreateMedicalSupply {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainMedicalSuppliesCommandsCreateMedicalSupplyCommand;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }

  /**
   * No description
   * @tags MedicalSupplies
   * @name MedicalSuppliesCreateMedicalSupplyBottle
   * @request POST:/medical-supplies/bottles
   * @secure
   * @response `200` `string` OK
   * @response `400` `HealthSystemCommonExceptionsValidationResult` Bad Request
   * @response `401` `void` Unauthorized
   */
  export namespace MedicalSuppliesCreateMedicalSupplyBottle {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainMedicalSuppliesCommandsCreateMedicalSupplyBottleCommand;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }

  /**
   * No description
   * @tags MedicalSupplies
   * @name MedicalSuppliesCreateMedicalSupplyOrder
   * @request POST:/medical-supplies/orders
   * @secure
   * @response `200` `string` OK
   * @response `401` `void` Unauthorized
   */
  export namespace MedicalSuppliesCreateMedicalSupplyOrder {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainMedicalSuppliesCommandsCreateMedicalSupplyOrderCommand;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }

  /**
   * No description
   * @tags MedicalSupplies
   * @name MedicalSuppliesDeleteMedicalSupply
   * @request DELETE:/medical-supplies
   * @secure
   * @response `200` `void` OK
   * @response `401` `void` Unauthorized
   */
  export namespace MedicalSuppliesDeleteMedicalSupply {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format uuid */
      Id?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags MedicalSupplies
   * @name MedicalSuppliesGetAllMedicalSupplies
   * @request GET:/medical-supplies/all
   * @secure
   * @response `200` `(HealthSystemDomainMedicalSuppliesResultMedicalSupplyViewModel)[]` OK
   * @response `401` `void` Unauthorized
   */
  export namespace MedicalSuppliesGetAllMedicalSupplies {
    export type RequestParams = {};
    export type RequestQuery = {
      query?: HealthSystemDomainMedicalSuppliesCommandsGetAllMedicalSuppliesCommand;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainMedicalSuppliesResultMedicalSupplyViewModel[];
  }

  /**
   * No description
   * @tags MedicalSupplies
   * @name MedicalSuppliesGetFarmMedicalSupplies
   * @request GET:/farm/medical-supplies
   * @secure
   * @response `200` `(HealthSystemDomainMedicalSuppliesResultFarmMedicalSupplyViewModel)[]` OK
   * @response `401` `void` Unauthorized
   */
  export namespace MedicalSuppliesGetFarmMedicalSupplies {
    export type RequestParams = {};
    export type RequestQuery = {
      SupplyMethods?: HealthSystemDALEnumsMedicalSupplyMethod[];
      SupplyTypes?: HealthSystemDALEnumsMedicalSupplyType[];
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainMedicalSuppliesResultFarmMedicalSupplyViewModel[];
  }

  /**
   * No description
   * @tags MedicalSupplies
   * @name MedicalSuppliesGetMedicalSupplies
   * @request GET:/medical-supplies
   * @secure
   * @response `200` `HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainMedicalSuppliesResultMedicalSupplyViewModel` OK
   * @response `401` `void` Unauthorized
   */
  export namespace MedicalSuppliesGetMedicalSupplies {
    export type RequestParams = {};
    export type RequestQuery = {
      Number?: string;
      /** @format int32 */
      Page?: number;
      /** @format int32 */
      Size?: number;
      Sort?: string;
      SupplyType?: HealthSystemDALEnumsMedicalSupplyType;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainMedicalSuppliesResultMedicalSupplyViewModel;
  }

  /**
   * No description
   * @tags MedicalSupplies
   * @name MedicalSuppliesGetMedicalSupplyBottles
   * @request GET:/medical-supplies/bottles
   * @secure
   * @response `200` `HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainMedicalSuppliesResultMedicalSupplyBottleViewModel` OK
   * @response `401` `void` Unauthorized
   */
  export namespace MedicalSuppliesGetMedicalSupplyBottles {
    export type RequestParams = {};
    export type RequestQuery = {
      AnimalType?: HealthSystemDALEnumsAnimalType;
      LotNumber?: string;
      MedicalSupplyNumber?: string;
      /** @format int32 */
      Page?: number;
      ShowHidden?: boolean;
      /** @format int32 */
      Size?: number;
      Sort?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainMedicalSuppliesResultMedicalSupplyBottleViewModel;
  }

  /**
   * No description
   * @tags MedicalSupplies
   * @name MedicalSuppliesGetMedicalSupplyOrderById
   * @request GET:/medical-supplies/orders/{id}
   * @secure
   * @response `200` `HealthSystemDomainMedicalSuppliesResultMedicalSupplyOrderViewModel` OK
   * @response `401` `void` Unauthorized
   */
  export namespace MedicalSuppliesGetMedicalSupplyOrderById {
    export type RequestParams = {
      /** @format uuid */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainMedicalSuppliesResultMedicalSupplyOrderViewModel;
  }

  /**
   * No description
   * @tags MedicalSupplies
   * @name MedicalSuppliesGetMedicalSupplyOrders
   * @request GET:/medical-supplies/orders
   * @secure
   * @response `200` `HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainMedicalSuppliesResultMedicalSupplyOrderViewModel` OK
   * @response `401` `void` Unauthorized
   */
  export namespace MedicalSuppliesGetMedicalSupplyOrders {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format int32 */
      Page?: number;
      /** @format int32 */
      Size?: number;
      Sort?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainMedicalSuppliesResultMedicalSupplyOrderViewModel;
  }

  /**
   * No description
   * @tags MedicalSupplies
   * @name MedicalSuppliesGetMedicationMatrix
   * @summary Medication matrix for the mobile auto-dose flow: every medical supply with its withdrawal period and CC per kilogram per animal type. A single unfiltered call is enough for the offline sync.
   * @request GET:/medical-supplies/medication-matrix
   * @secure
   * @response `200` `HealthSystemAPIControllersMedicalSuppliesResponsesMedicationMatrixResponse` OK
   * @response `401` `void` Unauthorized
   */
  export namespace MedicalSuppliesGetMedicationMatrix {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Narrows every supply's entries to that animal type. */
      AnimalType?: HealthSystemDALEnumsAnimalType;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemAPIControllersMedicalSuppliesResponsesMedicationMatrixResponse;
  }

  /**
   * No description
   * @tags MedicalSupplies
   * @name MedicalSuppliesRemoveMedicalSupplyBottle
   * @request DELETE:/medical-supplies/bottles/{id}
   * @secure
   * @response `204` `void` No Content
   * @response `401` `void` Unauthorized
   * @response `403` `HSAPIHostingApiResponseApiErrorResult` Forbidden
   * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
   */
  export namespace MedicalSuppliesRemoveMedicalSupplyBottle {
    export type RequestParams = {
      /** @format uuid */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags MedicalSupplies
   * @name MedicalSuppliesUpdateBottleVisibility
   * @request PUT:/farm/medical-supplies/bottles/visibility
   * @secure
   * @response `200` `string` OK
   * @response `401` `void` Unauthorized
   */
  export namespace MedicalSuppliesUpdateBottleVisibility {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainMedicalSuppliesCommandsMedicalSupplyBottleVisibilityCommand;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }

  /**
   * No description
   * @tags MedicalSupplies
   * @name MedicalSuppliesUpdateFarmMedicalSupplyStock
   * @request PUT:/farm/medical-supplies
   * @secure
   * @response `200` `string` OK
   * @response `401` `void` Unauthorized
   */
  export namespace MedicalSuppliesUpdateFarmMedicalSupplyStock {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainMedicalSuppliesCommandsUpdateFarmMedicalSupplyCommand;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }

  /**
   * No description
   * @tags MedicalSupplies
   * @name MedicalSuppliesUpdateMedicalSupply
   * @request PUT:/medical-supplies/{id}
   * @secure
   * @response `204` `void` No Content
   * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
   * @response `401` `void` Unauthorized
   * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
   */
  export namespace MedicalSuppliesUpdateMedicalSupply {
    export type RequestParams = {
      /** @format uuid */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemAPIControllersMedicalSuppliesRequestsUpdateMedicalSupplyRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags MedicalSupplies
   * @name MedicalSuppliesUpdateMedicalSupplyBottle
   * @request PUT:/medical-supplies/bottles/{id}
   * @secure
   * @response `204` `void` No Content
   * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
   * @response `401` `void` Unauthorized
   * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
   */
  export namespace MedicalSuppliesUpdateMedicalSupplyBottle {
    export type RequestParams = {
      /** @format uuid */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemAPIControllersMedicalSuppliesRequestsUpdateMedicalSupplyBottleRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }
}

export namespace Medications {
  /**
   * No description
   * @tags Medications
   * @name MedicationsGetAll
   * @summary Lists medications with their packs and withdrawal periods.
   * @request GET:/medications
   * @secure
   * @response `200` `HealthSystemDomainMedicationsQueriesGetMedicationsResult` OK
   * @response `401` `void` Unauthorized
   */
  export namespace MedicationsGetAll {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * One-based page number.
       * @format int32
       */
      Page?: number;
      /**
       * Matches the short name, the official name, and a pack's product name, registration number or
       * barcode.
       */
      SearchTerm?: string;
      /**
       * Page size.
       * @format int32
       */
      Size?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainMedicationsQueriesGetMedicationsResult;
  }

  /**
   * @description Idempotent — packs match on their register code and medications on their short name, so the same batch can be sent twice. A medication whose packs disagree on a withdrawal period is reported in `Rejected` and not written; the rest of the batch still loads. Admin only, deliberately: a veterinarian reads the catalogue but does not load it, and this writes the numbers their labels will print.
   * @tags Medications
   * @name MedicationsImport
   * @summary Loads a batch of catalogue packs.
   * @request POST:/medications/import
   * @secure
   * @response `200` `HealthSystemDomainMedicationsCommandsImportMedicationsResult` OK
   * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
   * @response `401` `void` Unauthorized
   */
  export namespace MedicationsImport {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemAPIControllersMedicationsRequestsImportMedicationsRequest;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainMedicationsCommandsImportMedicationsResult;
  }
}

export namespace MortalityReasons {
  /**
   * No description
   * @tags MortalityReasons
   * @name MortalityReasonsCreateMortalityReason
   * @request POST:/mortality-reasons
   * @secure
   * @response `200` `string` OK
   * @response `401` `void` Unauthorized
   */
  export namespace MortalityReasonsCreateMortalityReason {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainMortalityReasonsCommandsCreateMortalityReasonCommand;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }

  /**
   * No description
   * @tags MortalityReasons
   * @name MortalityReasonsGetAllDiseases
   * @request GET:/mortality-reasons/all
   * @secure
   * @response `200` `(HealthSystemDomainMortalityReasonsMortalityReasonViewModel)[]` OK
   * @response `401` `void` Unauthorized
   */
  export namespace MortalityReasonsGetAllDiseases {
    export type RequestParams = {};
    export type RequestQuery = {
      query?: HealthSystemDomainMortalityReasonsCommandsGetAllMortalityReasonsQuery;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainMortalityReasonsMortalityReasonViewModel[];
  }

  /**
   * No description
   * @tags MortalityReasons
   * @name MortalityReasonsMortalityReasonsSearch
   * @request GET:/mortality-reasons
   * @secure
   * @response `200` `HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainMortalityReasonsMortalityReasonViewModel` OK
   * @response `401` `void` Unauthorized
   */
  export namespace MortalityReasonsMortalityReasonsSearch {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format int32 */
      Page?: number;
      /** @format int32 */
      Size?: number;
      Sort?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainMortalityReasonsMortalityReasonViewModel;
  }

  /**
   * No description
   * @tags MortalityReasons
   * @name MortalityReasonsRemoveMortalityReason
   * @request DELETE:/mortality-reasons
   * @secure
   * @response `200` `string` OK
   * @response `401` `void` Unauthorized
   */
  export namespace MortalityReasonsRemoveMortalityReason {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainMortalityReasonsCommandsRemoveMortalityReasonCommand;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }
}

export namespace NotificationRules {
  /**
   * No description
   * @tags NotificationRules
   * @name NotificationRulesCreateNotificationRule
   * @request POST:/notification-rules
   * @secure
   * @response `200` `string` OK
   * @response `401` `void` Unauthorized
   */
  export namespace NotificationRulesCreateNotificationRule {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainNotificationRulesCommandCreateNotificationRuleCommand;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }

  /**
   * No description
   * @tags NotificationRules
   * @name NotificationRulesCreateNotificationRules
   * @request POST:/notification-rules/multiple
   * @secure
   * @response `200` `(string)[]` OK
   * @response `401` `void` Unauthorized
   */
  export namespace NotificationRulesCreateNotificationRules {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainNotificationRulesCommandCreateNotificationRulesCommand;
    export type RequestHeaders = {};
    export type ResponseBody = string[];
  }

  /**
   * No description
   * @tags NotificationRules
   * @name NotificationRulesDeleteNotificationRule
   * @request DELETE:/notification-rules
   * @secure
   * @response `200` `string` OK
   * @response `401` `void` Unauthorized
   */
  export namespace NotificationRulesDeleteNotificationRule {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format uuid */
      Id: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }

  /**
   * No description
   * @tags NotificationRules
   * @name NotificationRulesUpdateNotificationRule
   * @request PUT:/notification-rules
   * @secure
   * @response `200` `string` OK
   * @response `401` `void` Unauthorized
   */
  export namespace NotificationRulesUpdateNotificationRule {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainNotificationRulesCommandUpdateNotificationRuleCommand;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }

  /**
   * No description
   * @tags NotificationRules
   * @name NotificationRulesUpdateNotificationRules
   * @request PUT:/notification-rules/multiple
   * @secure
   * @response `200` `(string)[]` OK
   * @response `401` `void` Unauthorized
   */
  export namespace NotificationRulesUpdateNotificationRules {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainNotificationRulesCommandUpdateNotificationRulesCommand;
    export type RequestHeaders = {};
    export type ResponseBody = string[];
  }

  /**
   * No description
   * @tags NotificationRules
   * @name NotificationRulesViewNotificationRules
   * @request GET:/notification-rules
   * @secure
   * @response `200` `HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainNotificationRulesResultNotificationRuleViewModel` OK
   * @response `401` `void` Unauthorized
   */
  export namespace NotificationRulesViewNotificationRules {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format int32 */
      Page?: number;
      /** @format int32 */
      Size?: number;
      Sort?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainNotificationRulesResultNotificationRuleViewModel;
  }
}

export namespace Notifications {
  /**
   * No description
   * @tags Notifications
   * @name NotificationsGetNotifications
   * @request GET:/notifications
   * @secure
   * @response `200` `HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainNotificationsResultNotificationViewModel` OK
   * @response `401` `void` Unauthorized
   */
  export namespace NotificationsGetNotifications {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format int32 */
      Page?: number;
      /** @format int32 */
      Size?: number;
      Sort?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainNotificationsResultNotificationViewModel;
  }

  /**
   * No description
   * @tags Notifications
   * @name NotificationsViewNotifications
   * @request POST:/notifications/view
   * @secure
   * @response `200` `(string)[]` OK
   * @response `401` `void` Unauthorized
   */
  export namespace NotificationsViewNotifications {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainNotificationsViewNotificationsCommand;
    export type RequestHeaders = {};
    export type ResponseBody = string[];
  }
}

export namespace SavedComparisons {
  /**
   * No description
   * @tags SavedComparisons
   * @name SavedComparisonsCreate
   * @request POST:/saved-comparisons
   * @secure
   * @response `204` `void` No Content
   * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
   * @response `401` `void` Unauthorized
   * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
   */
  export namespace SavedComparisonsCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemAPIControllersSavedComparisonsRequestsCreateSavedComparisonRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags SavedComparisons
   * @name SavedComparisonsDelete
   * @request DELETE:/saved-comparisons/{id}
   * @secure
   * @response `204` `void` No Content
   * @response `401` `void` Unauthorized
   * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
   * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
   */
  export namespace SavedComparisonsDelete {
    export type RequestParams = {
      /** @format uuid */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags SavedComparisons
   * @name SavedComparisonsGetAll
   * @request GET:/saved-comparisons
   * @secure
   * @response `200` `(HealthSystemDomainSavedComparisonQueriesSavedComparisonResult)[]` OK
   * @response `401` `void` Unauthorized
   * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
   */
  export namespace SavedComparisonsGetAll {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainSavedComparisonQueriesSavedComparisonResult[];
  }
}

export namespace ScheduledReports {
  /**
   * No description
   * @tags ScheduledReports
   * @name ScheduledReportsCreate
   * @request POST:/scheduled-reports
   * @secure
   * @response `200` `HealthSystemAPIControllersScheduledReportsResponsesScheduledReportResponse` OK
   * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
   * @response `401` `void` Unauthorized
   * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
   */
  export namespace ScheduledReportsCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemAPIControllersScheduledReportsRequestsCreateScheduledReportRequest;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemAPIControllersScheduledReportsResponsesScheduledReportResponse;
  }

  /**
   * No description
   * @tags ScheduledReports
   * @name ScheduledReportsDelete
   * @request DELETE:/scheduled-reports/{id}
   * @secure
   * @response `204` `void` No Content
   * @response `401` `void` Unauthorized
   * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
   * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
   */
  export namespace ScheduledReportsDelete {
    export type RequestParams = {
      /** @format uuid */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags ScheduledReports
   * @name ScheduledReportsGetAll
   * @request GET:/scheduled-reports
   * @secure
   * @response `200` `(HealthSystemAPIControllersScheduledReportsResponsesScheduledReportResponse)[]` OK
   * @response `401` `void` Unauthorized
   * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
   */
  export namespace ScheduledReportsGetAll {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemAPIControllersScheduledReportsResponsesScheduledReportResponse[];
  }

  /**
   * No description
   * @tags ScheduledReports
   * @name ScheduledReportsSendNow
   * @request POST:/scheduled-reports/{id}/send-now
   * @secure
   * @response `200` `HealthSystemAPIControllersScheduledReportsResponsesSendScheduledReportNowResponse` OK
   * @response `401` `void` Unauthorized
   * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
   * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
   */
  export namespace ScheduledReportsSendNow {
    export type RequestParams = {
      /** @format uuid */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemAPIControllersScheduledReportsResponsesSendScheduledReportNowResponse;
  }

  /**
   * No description
   * @tags ScheduledReports
   * @name ScheduledReportsSetActive
   * @request PUT:/scheduled-reports/{id}/active
   * @secure
   * @response `204` `void` No Content
   * @response `401` `void` Unauthorized
   * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
   * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
   */
  export namespace ScheduledReportsSetActive {
    export type RequestParams = {
      /** @format uuid */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemAPIControllersScheduledReportsRequestsSetScheduledReportActiveRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags ScheduledReports
   * @name ScheduledReportsUpdate
   * @request PUT:/scheduled-reports/{id}
   * @secure
   * @response `200` `HealthSystemAPIControllersScheduledReportsResponsesScheduledReportResponse` OK
   * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
   * @response `401` `void` Unauthorized
   * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
   * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
   */
  export namespace ScheduledReportsUpdate {
    export type RequestParams = {
      /** @format uuid */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemAPIControllersScheduledReportsRequestsUpdateScheduledReportRequest;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemAPIControllersScheduledReportsResponsesScheduledReportResponse;
  }
}

export namespace SensorDevices {
  /**
   * No description
   * @tags SensorDevices
   * @name SensorDevicesAssignLocation
   * @request PUT:/farms/{farmId}/sensor-devices/{sensorDeviceId}/location
   * @secure
   * @response `204` `void` No Content
   * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
   * @response `401` `void` Unauthorized
   * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
   * @response `409` `HSAPIHostingApiResponseApiErrorResult` Conflict
   * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
   */
  export namespace SensorDevicesAssignLocation {
    export type RequestParams = {
      /** @format uuid */
      farmId: string;
      /** @format uuid */
      sensorDeviceId: string;
    };
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemAPIControllersSensorDevicesRequestsAssignSensorDeviceLocationRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description Registers and binds devices only; readings still arrive with the sync worker.
   * @tags SensorDevices
   * @name SensorDevicesDiscover
   * @summary Asks the farm's sensor provider what devices it has now, rather than waiting for the daily sync.
   * @request POST:/farms/{farmId}/sensor-devices/discover
   * @secure
   * @response `200` `HealthSystemAPIControllersSensorDevicesResponsesDiscoverSensorDevicesResponse` OK
   * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
   * @response `401` `void` Unauthorized
   * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
   */
  export namespace SensorDevicesDiscover {
    export type RequestParams = {
      /** @format uuid */
      farmId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemAPIControllersSensorDevicesResponsesDiscoverSensorDevicesResponse;
  }

  /**
   * @description Devices the provider has stopped reporting are left out: they hold no pen and will send nothing further, so there is nothing here to do about them. Their rows and readings are kept.
   * @tags SensorDevices
   * @name SensorDevicesGetAll
   * @summary The farm's devices and the pen each is bound to.
   * @request GET:/farms/{farmId}/sensor-devices
   * @secure
   * @response `200` `(HealthSystemAPIControllersSensorDevicesResponsesSensorDeviceResponse)[]` OK
   * @response `401` `void` Unauthorized
   * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
   */
  export namespace SensorDevicesGetAll {
    export type RequestParams = {
      /** @format uuid */
      farmId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemAPIControllersSensorDevicesResponsesSensorDeviceResponse[];
  }

  /**
   * No description
   * @tags SensorDevices
   * @name SensorDevicesUnassignLocation
   * @request DELETE:/farms/{farmId}/sensor-devices/{sensorDeviceId}/location
   * @secure
   * @response `204` `void` No Content
   * @response `401` `void` Unauthorized
   * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
   * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
   */
  export namespace SensorDevicesUnassignLocation {
    export type RequestParams = {
      /** @format uuid */
      farmId: string;
      /** @format uuid */
      sensorDeviceId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }
}

export namespace Settings {
  /**
   * No description
   * @tags Settings
   * @name SettingsCreateEventLog
   * @request POST:/eventlog
   * @secure
   * @response `200` `string` OK
   * @response `401` `void` Unauthorized
   */
  export namespace SettingsCreateEventLog {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = HealthSystemDomainSettingsCreateEventLogCommand;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }

  /**
   * No description
   * @tags Settings
   * @name SettingsCreateTranslation
   * @request POST:/locales
   * @secure
   * @response `200` `string` OK
   * @response `401` `void` Unauthorized
   */
  export namespace SettingsCreateTranslation {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainSettingsCreateTranslationCommand;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }

  /**
   * No description
   * @tags Settings
   * @name SettingsGetAnimalCapacity
   * @request GET:/settings/animalcapacity
   * @secure
   * @response `200` `HealthSystemDomainSettingsResultAnimalCapacityViewModel` OK
   * @response `401` `void` Unauthorized
   */
  export namespace SettingsGetAnimalCapacity {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format date-time */
      From?: string;
      /** @format date-time */
      To?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainSettingsResultAnimalCapacityViewModel;
  }

  /**
   * No description
   * @tags Settings
   * @name SettingsGetConfig
   * @request GET:/config
   * @response `200` `HealthSystemDomainSettingsResultConfigViewModel` OK
   */
  export namespace SettingsGetConfig {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = HealthSystemDomainSettingsResultConfigViewModel;
  }

  /**
   * No description
   * @tags Settings
   * @name SettingsGetFarmSettings
   * @request GET:/settings/farm
   * @secure
   * @response `200` `HealthSystemDomainSettingsResultFarmSettingsViewModel` OK
   * @response `401` `void` Unauthorized
   */
  export namespace SettingsGetFarmSettings {
    export type RequestParams = {};
    export type RequestQuery = {
      query?: HealthSystemDomainSettingsFarmSettingsQuery;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainSettingsResultFarmSettingsViewModel;
  }

  /**
   * No description
   * @tags Settings
   * @name SettingsGetHoldingRoomLocations
   * @request GET:/settings/farm/holding-room-locations
   * @secure
   * @response `200` `(HealthSystemDomainSettingsResultHoldingRoomLocationViewModel)[]` OK
   * @response `401` `void` Unauthorized
   */
  export namespace SettingsGetHoldingRoomLocations {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainSettingsResultHoldingRoomLocationViewModel[];
  }

  /**
   * No description
   * @tags Settings
   * @name SettingsGetTranslationByIsoCode
   * @summary This method is used with i18next backend plugin api call
   * @request GET:/locales/{isoCode}
   * @response `200` `void` OK
   */
  export namespace SettingsGetTranslationByIsoCode {
    export type RequestParams = {
      isoCode: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Settings
   * @name SettingsGetTranslations
   * @request GET:/locales
   * @secure
   * @response `200` `(HealthSystemDomainSettingsResultTranslationViewModel)[]` OK
   * @response `401` `void` Unauthorized
   */
  export namespace SettingsGetTranslations {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainSettingsResultTranslationViewModel[];
  }

  /**
   * No description
   * @tags Settings
   * @name SettingsSearchEventLogs
   * @request GET:/eventlog
   * @secure
   * @response `200` `HealthSystemDomainCommonQueryResultPageableResultHealthSystemDALModelLogAppEventLog` OK
   * @response `401` `void` Unauthorized
   */
  export namespace SettingsSearchEventLogs {
    export type RequestParams = {};
    export type RequestQuery = {
      ErrorOnly?: boolean;
      /** @format uuid */
      FarmId?: string;
      NotAnalyzedOnly?: boolean;
      /** @format int32 */
      Page?: number;
      /** @format int32 */
      Size?: number;
      Sort?: string;
      Type?: HealthSystemDALModelLogAppEventLogApplicationType;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainCommonQueryResultPageableResultHealthSystemDALModelLogAppEventLog;
  }

  /**
   * No description
   * @tags Settings
   * @name SettingsUpdateFarmSettings
   * @request POST:/settings/farm
   * @secure
   * @response `200` `string` OK
   * @response `401` `void` Unauthorized
   */
  export namespace SettingsUpdateFarmSettings {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainSettingsUpdateFarmSettingsCommand;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }

  /**
   * No description
   * @tags Settings
   * @name SettingsUpdateTranslation
   * @request PUT:/locales
   * @secure
   * @response `200` `string` OK
   * @response `401` `void` Unauthorized
   */
  export namespace SettingsUpdateTranslation {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainSettingsUpdateTranslationCommand;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }
}

export namespace Slaughterhouses {
  /**
   * No description
   * @tags Slaughterhouses
   * @name SlaughterhousesCreate
   * @request POST:/slaughterhouses
   * @secure
   * @response `200` `HealthSystemDomainSlaughterhouseCommandsCreateSlaughterhouseResult` OK
   * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
   * @response `401` `void` Unauthorized
   */
  export namespace SlaughterhousesCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemAPIControllersSlaughterhousesRequestsCreateSlaughterhouseRequest;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainSlaughterhouseCommandsCreateSlaughterhouseResult;
  }

  /**
   * No description
   * @tags Slaughterhouses
   * @name SlaughterhousesDeleteApiKey
   * @request DELETE:/slaughterhouses/{id}/api-keys/{apiKeyId}
   * @secure
   * @response `204` `void` No Content
   * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
   * @response `401` `void` Unauthorized
   * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
   */
  export namespace SlaughterhousesDeleteApiKey {
    export type RequestParams = {
      /** @format uuid */
      apiKeyId: string;
      /** @format uuid */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Slaughterhouses
   * @name SlaughterhousesGenerateApiKey
   * @request POST:/slaughterhouses/{id}/api-keys
   * @secure
   * @response `200` `HealthSystemAPIControllersSlaughterhousesResponsesGenerateSlaughterhouseApiKeyResponse` OK
   * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
   * @response `401` `void` Unauthorized
   * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
   */
  export namespace SlaughterhousesGenerateApiKey {
    export type RequestParams = {
      /** @format uuid */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemAPIControllersSlaughterhousesRequestsGenerateApiKeyRequest;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemAPIControllersSlaughterhousesResponsesGenerateSlaughterhouseApiKeyResponse;
  }

  /**
   * No description
   * @tags Slaughterhouses
   * @name SlaughterhousesGetAll
   * @request GET:/slaughterhouses
   * @secure
   * @response `200` `HealthSystemDomainSlaughterhouseModelsSlaughterhouseListResult` OK
   * @response `401` `void` Unauthorized
   */
  export namespace SlaughterhousesGetAll {
    export type RequestParams = {};
    export type RequestQuery = {
      IsActive?: boolean;
      /** @format int32 */
      Page?: number;
      SearchTerm?: string;
      /** @format int32 */
      Size?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainSlaughterhouseModelsSlaughterhouseListResult;
  }

  /**
   * No description
   * @tags Slaughterhouses
   * @name SlaughterhousesGetById
   * @request GET:/slaughterhouses/{id}
   * @secure
   * @response `200` `HealthSystemDomainSlaughterhouseModelsSlaughterhouseViewModel` OK
   * @response `401` `void` Unauthorized
   * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
   */
  export namespace SlaughterhousesGetById {
    export type RequestParams = {
      /** @format uuid */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainSlaughterhouseModelsSlaughterhouseViewModel;
  }

  /**
   * No description
   * @tags Slaughterhouses
   * @name SlaughterhousesUpdate
   * @request PUT:/slaughterhouses/{id}
   * @secure
   * @response `204` `void` No Content
   * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
   * @response `401` `void` Unauthorized
   * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
   */
  export namespace SlaughterhousesUpdate {
    export type RequestParams = {
      /** @format uuid */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemAPIControllersSlaughterhousesRequestsUpdateSlaughterhouseRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Slaughterhouses
   * @name SlaughterhousesUpdateApiKey
   * @request PUT:/slaughterhouses/{id}/api-keys/{apiKeyId}
   * @secure
   * @response `204` `void` No Content
   * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
   * @response `401` `void` Unauthorized
   * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
   */
  export namespace SlaughterhousesUpdateApiKey {
    export type RequestParams = {
      /** @format uuid */
      apiKeyId: string;
      /** @format uuid */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemAPIControllersSlaughterhousesRequestsUpdateApiKeyRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }
}

export namespace SlaughterPreparation {
  /**
   * No description
   * @tags SlaughterPreparation
   * @name SlaughterPreparationGetPreOrderDetails
   * @request GET:/slaughter-preparation/pre-order-details
   * @secure
   * @response `200` `HealthSystemDomainSlaughterPreparationsResultPreOrderDetailsViewModel` OK
   * @response `401` `void` Unauthorized
   */
  export namespace SlaughterPreparationGetPreOrderDetails {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format uuid */
      Id?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainSlaughterPreparationsResultPreOrderDetailsViewModel;
  }

  /**
   * No description
   * @tags SlaughterPreparation
   * @name SlaughterPreparationGetPreOrdersSummaries
   * @request GET:/slaughter-preparation/pre-orders-summaries
   * @secure
   * @response `200` `HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainSlaughterPreparationsResultPreOrdersSummariesViewModel` OK
   * @response `401` `void` Unauthorized
   */
  export namespace SlaughterPreparationGetPreOrdersSummaries {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format date-time */
      From?: string;
      /** @format int32 */
      Page?: number;
      /** @format int32 */
      Size?: number;
      Sort?: string;
      /** @format date-time */
      To?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainSlaughterPreparationsResultPreOrdersSummariesViewModel;
  }

  /**
   * No description
   * @tags SlaughterPreparation
   * @name SlaughterPreparationGetSummaryInfo
   * @request GET:/slaughter-preparation
   * @secure
   * @response `200` `HealthSystemDomainSlaughterPreparationsResultSlaughterPreparationViewModel` OK
   * @response `401` `void` Unauthorized
   */
  export namespace SlaughterPreparationGetSummaryInfo {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainSlaughterPreparationsResultSlaughterPreparationViewModel;
  }

  /**
   * No description
   * @tags SlaughterPreparation
   * @name SlaughterPreparationSavePreDelivery
   * @request POST:/slaughter-preparation
   * @secure
   * @response `200` `string` OK
   * @response `401` `void` Unauthorized
   */
  export namespace SlaughterPreparationSavePreDelivery {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainSlaughterPreparationsSlaughterPreDeliveryCommand;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }
}

export namespace TaskList {
  /**
   * No description
   * @tags TaskList
   * @name TaskListCreateProductionSchedule
   * @request POST:/tasks/v1/production-schedule
   * @secure
   * @response `200` `HealthSystemAPIControllersTaskV1ResponsesProductionScheduleResponse` OK
   * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
   * @response `401` `void` Unauthorized
   * @response `409` `HSAPIHostingApiResponseApiErrorResult` Conflict
   * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
   */
  export namespace TaskListCreateProductionSchedule {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemAPIControllersTaskV1RequestsCreateProductionScheduleRequest;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemAPIControllersTaskV1ResponsesProductionScheduleResponse;
  }

  /**
   * No description
   * @tags TaskList
   * @name TaskListGetAllProductionSchedules
   * @request GET:/tasks/v1/production-schedules
   * @secure
   * @response `200` `(HealthSystemAPIControllersTaskV1ResponsesProductionScheduleResponse)[]` OK
   * @response `401` `void` Unauthorized
   */
  export namespace TaskListGetAllProductionSchedules {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemAPIControllersTaskV1ResponsesProductionScheduleResponse[];
  }

  /**
   * No description
   * @tags TaskList
   * @name TaskListGetAttachmentDownloadUrl
   * @request GET:/tasks/v1/library/attachment-download-url
   * @secure
   * @response `200` `HealthSystemAPIControllersTaskV1ResponsesGetAttachmentDownloadUrlResponse` OK
   * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
   * @response `401` `void` Unauthorized
   * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
   */
  export namespace TaskListGetAttachmentDownloadUrl {
    export type RequestParams = {};
    export type RequestQuery = {
      BlobName?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemAPIControllersTaskV1ResponsesGetAttachmentDownloadUrlResponse;
  }

  /**
   * No description
   * @tags TaskList
   * @name TaskListGetAttachmentUploadUrl
   * @request GET:/tasks/v1/library/attachment-upload-url
   * @secure
   * @response `200` `HealthSystemAPIControllersTaskV1ResponsesGetAttachmentUploadUrlResponse` OK
   * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
   * @response `401` `void` Unauthorized
   * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
   */
  export namespace TaskListGetAttachmentUploadUrl {
    export type RequestParams = {};
    export type RequestQuery = {
      FileName?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemAPIControllersTaskV1ResponsesGetAttachmentUploadUrlResponse;
  }

  /**
   * No description
   * @tags TaskList
   * @name TaskListGetDailyTaskPlan
   * @request GET:/tasks/v1/plans/daily
   * @secure
   * @response `200` `(HealthSystemDomainTaskLibraryResultTaskOccurrenceViewModel)[]` OK
   * @response `401` `void` Unauthorized
   */
  export namespace TaskListGetDailyTaskPlan {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format date-time */
      DateFrom?: string;
      /** @format date-time */
      DateTo?: string;
      EmployeeIds?: string[];
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainTaskLibraryResultTaskOccurrenceViewModel[];
  }

  /**
   * No description
   * @tags TaskList
   * @name TaskListGetDailyUserOccurrences
   * @request GET:/tasks/v1/plans/daily/users
   * @secure
   * @response `200` `(HealthSystemDomainTaskLibraryResultUserTaskOccurrencesViewModel)[]` OK
   * @response `401` `void` Unauthorized
   */
  export namespace TaskListGetDailyUserOccurrences {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format date */
      Date?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainTaskLibraryResultUserTaskOccurrencesViewModel[];
  }

  /**
   * No description
   * @tags TaskList
   * @name TaskListGetProductionSchedule
   * @request GET:/tasks/v1/production-schedule
   * @secure
   * @response `200` `HealthSystemAPIControllersTaskV1ResponsesProductionScheduleResponse` OK
   * @response `401` `void` Unauthorized
   * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
   */
  export namespace TaskListGetProductionSchedule {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format date */
      Date?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemAPIControllersTaskV1ResponsesProductionScheduleResponse;
  }

  /**
   * No description
   * @tags TaskList
   * @name TaskListGetTaskLibrary
   * @request GET:/tasks/v1/library
   * @secure
   * @response `200` `(HealthSystemDomainTaskLibraryResultTaskTemplateViewModel)[]` OK
   * @response `401` `void` Unauthorized
   */
  export namespace TaskListGetTaskLibrary {
    export type RequestParams = {};
    export type RequestQuery = {
      Name?: string;
      Stables?: HealthSystemDALEnumsLocationStableType[];
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainTaskLibraryResultTaskTemplateViewModel[];
  }

  /**
   * No description
   * @tags TaskList
   * @name TaskListGetTaskLibraryList
   * @request GET:/tasks/v1/lists
   * @secure
   * @response `200` `Record<string,HealthSystemDomainTaskLibraryResultTaskScheduleViewModel>` OK
   * @response `401` `void` Unauthorized
   */
  export namespace TaskListGetTaskLibraryList {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format date */
      Date: string;
      Stables: HealthSystemDALEnumsLocationStableType[];
      /** @format int32 */
      WeekCycle: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Record<
      string,
      HealthSystemDomainTaskLibraryResultTaskScheduleViewModel
    >;
  }

  /**
   * No description
   * @tags TaskList
   * @name TaskListGetTaskPlans
   * @request GET:/tasks/v1/plans
   * @secure
   * @response `200` `HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainTaskLibraryResultTaskOccurrenceViewModel` OK
   * @response `401` `void` Unauthorized
   */
  export namespace TaskListGetTaskPlans {
    export type RequestParams = {};
    export type RequestQuery = {
      IncludeCompleted?: boolean;
      /** @format int32 */
      Page?: number;
      /** @format int32 */
      Size?: number;
      Sort?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainTaskLibraryResultTaskOccurrenceViewModel;
  }

  /**
   * No description
   * @tags TaskList
   * @name TaskListUpdateTaskOccurrence
   * @request PUT:/tasks/v1/plans/update
   * @secure
   * @response `200` `HealthSystemAPIControllersTaskV1ResponsesUpdateTaskOccurrenceResponse` OK
   * @response `401` `HSAPIHostingApiResponseApiErrorResult` Unauthorized
   * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
   * @response `409` `HSAPIHostingApiResponseApiErrorResult` Conflict
   */
  export namespace TaskListUpdateTaskOccurrence {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemAPIControllersTaskV1RequestsUpdateTaskOccurrenceRequest;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemAPIControllersTaskV1ResponsesUpdateTaskOccurrenceResponse;
  }

  /**
   * No description
   * @tags TaskList
   * @name TaskListUpsertTaskLibrary
   * @request POST:/tasks/v1/library
   * @secure
   * @response `200` `string` OK
   * @response `401` `void` Unauthorized
   */
  export namespace TaskListUpsertTaskLibrary {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainTaskLibraryCommandUpsertTaskTemplateCommand;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }

  /**
   * No description
   * @tags TaskList
   * @name TaskListUpsertTaskLibraryList
   * @request POST:/tasks/v1/lists
   * @secure
   * @response `200` `void` OK
   * @response `401` `void` Unauthorized
   * @response `409` `HSAPIHostingApiResponseApiErrorResult` Conflict
   */
  export namespace TaskListUpsertTaskLibraryList {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainTaskLibraryCommandUpsertTaskScheduleCommand;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }
}

export namespace Tasks {
  /**
   * No description
   * @tags Tasks
   * @name TasksCreateTaskList
   * @request POST:/tasks
   * @secure
   * @response `200` `string` OK
   * @response `401` `void` Unauthorized
   */
  export namespace TasksCreateTaskList {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainTaskListsCommandCreateTaskListCommand;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }

  /**
   * No description
   * @tags Tasks
   * @name TasksCreateTaskListRule
   * @request POST:/tasks/rules
   * @secure
   * @response `200` `string` OK
   * @response `401` `void` Unauthorized
   */
  export namespace TasksCreateTaskListRule {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainTaskListsCommandCreateTaskListRuleCommand;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }

  /**
   * No description
   * @tags Tasks
   * @name TasksDeleteTaskListRule
   * @request DELETE:/tasks/rules
   * @secure
   * @response `200` `string` OK
   * @response `401` `void` Unauthorized
   */
  export namespace TasksDeleteTaskListRule {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainTaskListsCommandRemoveTaskListRuleCommand;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }

  /**
   * No description
   * @tags Tasks
   * @name TasksFinishTaskList
   * @request PUT:/tasks/finish
   * @secure
   * @response `200` `string` OK
   * @response `401` `void` Unauthorized
   */
  export namespace TasksFinishTaskList {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainTaskListsCommandFinishTaskListCommand;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }

  /**
   * No description
   * @tags Tasks
   * @name TasksGetTaskLists
   * @request GET:/tasks
   * @secure
   * @response `200` `HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainTaskListsResultTaskListViewModel` OK
   * @response `401` `void` Unauthorized
   */
  export namespace TasksGetTaskLists {
    export type RequestParams = {};
    export type RequestQuery = {
      AssignedToMe?: boolean;
      IncludeCompleted?: boolean;
      /** @format int32 */
      Page?: number;
      /** @format int32 */
      Size?: number;
      Sort?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainTaskListsResultTaskListViewModel;
  }

  /**
   * No description
   * @tags Tasks
   * @name TasksGetTaskListsRules
   * @request GET:/tasks/rules
   * @secure
   * @response `200` `HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainTaskListsResultTaskListRuleViewModel` OK
   * @response `401` `void` Unauthorized
   */
  export namespace TasksGetTaskListsRules {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format int32 */
      Page?: number;
      /** @format int32 */
      Size?: number;
      Sort?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainTaskListsResultTaskListRuleViewModel;
  }

  /**
   * No description
   * @tags Tasks
   * @name TasksStartTaskList
   * @request PUT:/tasks/start
   * @secure
   * @response `200` `string` OK
   * @response `401` `void` Unauthorized
   */
  export namespace TasksStartTaskList {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainTaskListsCommandStartTaskListCommand;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }

  /**
   * No description
   * @tags Tasks
   * @name TasksUpdateTaskList
   * @request PUT:/tasks
   * @secure
   * @response `200` `string` OK
   * @response `401` `void` Unauthorized
   */
  export namespace TasksUpdateTaskList {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainTaskListsCommandUpdateTaskListCommand;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }
}

export namespace UserAccounts {
  /**
   * No description
   * @tags UserAccounts
   * @name UserAccountsChangePassword
   * @request PUT:/users/me/change-password
   * @secure
   * @response `204` `void` No Content
   * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
   * @response `401` `void` Unauthorized
   * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
   */
  export namespace UserAccountsChangePassword {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemAPIControllersUserAccountsRequestsChangePasswordRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * @description A link that was mailed earlier keeps working: this adds one rather than replacing it. Only the hash of a token is stored, so a link is shown exactly once - here - and a caller who loses it has to generate another.
   * @tags UserAccounts
   * @name UserAccountsCreateInvitationLink
   * @summary Generates an invitation link for a user who has not activated their account yet, so it can be shared by hand when the invitation email never arrived.
   * @request POST:/users/{id}/invitation-link
   * @secure
   * @response `200` `HealthSystemAPIControllersUserAccountsResponsesInvitationLinkResponse` OK
   * @response `401` `void` Unauthorized
   * @response `403` `HSAPIHostingApiResponseApiErrorResult` Forbidden
   * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
   * @response `409` `HSAPIHostingApiResponseApiErrorResult` Conflict
   */
  export namespace UserAccountsCreateInvitationLink {
    export type RequestParams = {
      /** @format uuid */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemAPIControllersUserAccountsResponsesInvitationLinkResponse;
  }

  /**
   * No description
   * @tags UserAccounts
   * @name UserAccountsResendInvitation
   * @request POST:/users/{id}/resend-invitation
   * @secure
   * @response `204` `void` No Content
   * @response `401` `void` Unauthorized
   * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
   */
  export namespace UserAccountsResendInvitation {
    export type RequestParams = {
      /** @format uuid */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags UserAccounts
   * @name UserAccountsSendInvitation
   * @request POST:/users/invite
   * @secure
   * @response `200` `string` OK
   * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
   * @response `401` `void` Unauthorized
   * @response `409` `HSAPIHostingApiResponseApiErrorResult` Conflict
   */
  export namespace UserAccountsSendInvitation {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemAPIControllersUserAccountsRequestsSendInvitationRequest;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }
}

export namespace Users {
  /**
   * No description
   * @tags Users
   * @name UsersActivateUser
   * @summary Restores access for a user deactivated earlier. Their password and role are unchanged.
   * @request POST:/users/{userId}/activate
   * @secure
   * @response `204` `void` No Content
   * @response `401` `void` Unauthorized
   * @response `403` `MicrosoftAspNetCoreMvcProblemDetails` Forbidden
   * @response `404` `MicrosoftAspNetCoreMvcProblemDetails` Not Found
   */
  export namespace UsersActivateUser {
    export type RequestParams = {
      /** @format uuid */
      userId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Users
   * @name UsersCreateUser
   * @request POST:/users
   * @secure
   * @response `200` `string` OK
   * @response `401` `void` Unauthorized
   */
  export namespace UsersCreateUser {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = HealthSystemDomainUsersCommandsCreateUserCommand;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }

  /**
   * No description
   * @tags Users
   * @name UsersDeactivateUser
   * @summary Revokes a user's access to this farm. Their history is kept and the account can be restored with M:HealthSystem.API.Controllers.UsersController.ActivateUser(System.Guid,System.Threading.CancellationToken).
   * @request POST:/users/{userId}/deactivate
   * @secure
   * @response `204` `void` No Content
   * @response `400` `MicrosoftAspNetCoreMvcProblemDetails` Bad Request
   * @response `401` `void` Unauthorized
   * @response `403` `MicrosoftAspNetCoreMvcProblemDetails` Forbidden
   * @response `404` `MicrosoftAspNetCoreMvcProblemDetails` Not Found
   */
  export namespace UsersDeactivateUser {
    export type RequestParams = {
      /** @format uuid */
      userId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags Users
   * @name UsersGetUserActionLog
   * @request POST:/users/actions/search
   * @secure
   * @response `200` `HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainUsersResultUserActionLogViewModel` OK
   * @response `401` `void` Unauthorized
   * @response `403` `MicrosoftAspNetCoreMvcProblemDetails` Forbidden
   */
  export namespace UsersGetUserActionLog {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = HealthSystemDomainUsersQueryUserActionLogQuery;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainUsersResultUserActionLogViewModel;
  }

  /**
   * No description
   * @tags Users
   * @name UsersGetUsers
   * @request GET:/users/search
   * @secure
   * @response `200` `HealthSystemDomainUsersResultUsersSearchQueryResult` OK
   * @response `401` `void` Unauthorized
   * @response `403` `MicrosoftAspNetCoreMvcProblemDetails` Forbidden
   */
  export namespace UsersGetUsers {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format int32 */
      Page?: number;
      /** @format int32 */
      Size?: number;
      Sort?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainUsersResultUsersSearchQueryResult;
  }

  /**
   * No description
   * @tags Users
   * @name UsersGetUsersAll
   * @request GET:/users/all
   * @secure
   * @response `200` `(HealthSystemDomainUsersResultUserViewModel)[]` OK
   * @response `401` `void` Unauthorized
   * @response `403` `MicrosoftAspNetCoreMvcProblemDetails` Forbidden
   */
  export namespace UsersGetUsersAll {
    export type RequestParams = {};
    export type RequestQuery = {
      command?: HealthSystemDomainUsersCommandsGetUserAllQuery;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = HealthSystemDomainUsersResultUserViewModel[];
  }

  /**
   * No description
   * @tags Users
   * @name UsersGetUserView
   * @request GET:/users
   * @secure
   * @response `200` `HealthSystemDomainUsersResultUserViewModel` OK
   * @response `401` `void` Unauthorized
   * @response `403` `MicrosoftAspNetCoreMvcProblemDetails` Forbidden
   */
  export namespace UsersGetUserView {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format uuid */
      Id?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = HealthSystemDomainUsersResultUserViewModel;
  }

  /**
   * No description
   * @tags Users
   * @name UsersLoginBusinessUnit
   * @request GET:/users/business-units
   * @secure
   * @response `200` `(HealthSystemDomainUsersResultBusinessUnitResponse)[]` OK
   * @response `401` `void` Unauthorized
   * @response `403` `MicrosoftAspNetCoreMvcProblemDetails` Forbidden
   */
  export namespace UsersLoginBusinessUnit {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainUsersCommandsGetUserBusinessUnitCommand;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainUsersResultBusinessUnitResponse[];
  }

  /**
   * No description
   * @tags Users
   * @name UsersPutUserActionLogs
   * @request PUT:/users/actions
   * @secure
   * @response `200` `HealthSystemDomainCommonResultEntityBatchResult` OK
   * @response `401` `void` Unauthorized
   * @response `403` `MicrosoftAspNetCoreMvcProblemDetails` Forbidden
   */
  export namespace UsersPutUserActionLogs {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainUsersCommandsAddUserActionLogCommand;
    export type RequestHeaders = {};
    export type ResponseBody = HealthSystemDomainCommonResultEntityBatchResult;
  }

  /**
   * No description
   * @tags Users
   * @name UsersUpdateUser
   * @request PUT:/users
   * @secure
   * @response `200` `string` OK
   * @response `401` `void` Unauthorized
   * @response `403` `MicrosoftAspNetCoreMvcProblemDetails` Forbidden
   */
  export namespace UsersUpdateUser {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = HealthSystemDomainUsersCommandsUpdateUserCommand;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }

  /**
   * No description
   * @tags Users
   * @name UsersUpdateUserLanguage
   * @request PUT:/users/language
   * @secure
   * @response `200` `string` OK
   * @response `401` `void` Unauthorized
   * @response `403` `MicrosoftAspNetCoreMvcProblemDetails` Forbidden
   */
  export namespace UsersUpdateUserLanguage {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainUsersCommandsUpdateUserLanguageCommand;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }
}

export namespace VaccinationRules {
  /**
   * No description
   * @tags VaccinationRules
   * @name VaccinationRulesCreateVaccinationRule
   * @request POST:/farm/vaccination-rules/v1
   * @secure
   * @response `200` `string` OK
   * @response `401` `void` Unauthorized
   */
  export namespace VaccinationRulesCreateVaccinationRule {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainVaccinationRulesCreateVaccinationRuleCommand;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }

  /**
   * No description
   * @tags VaccinationRules
   * @name VaccinationRulesGetAllVaccinationRules
   * @request GET:/farm/vaccination-rules/v1/all
   * @secure
   * @response `200` `(HealthSystemDomainVaccinationRulesResultVaccinationRuleViewModel)[]` OK
   * @response `401` `void` Unauthorized
   */
  export namespace VaccinationRulesGetAllVaccinationRules {
    export type RequestParams = {};
    export type RequestQuery = {
      command?: HealthSystemDomainVaccinationRulesGetAllVaccinationRulesCommand;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainVaccinationRulesResultVaccinationRuleViewModel[];
  }

  /**
   * No description
   * @tags VaccinationRules
   * @name VaccinationRulesRemoveVaccinationRule
   * @request DELETE:/farm/vaccination-rules/v1
   * @secure
   * @response `200` `string` OK
   * @response `401` `void` Unauthorized
   */
  export namespace VaccinationRulesRemoveVaccinationRule {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainVaccinationRulesRemoveVaccinationRuleCommand;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }

  /**
   * No description
   * @tags VaccinationRules
   * @name VaccinationRulesVaccinationRulesSearch
   * @request GET:/farm/vaccination-rules/v1
   * @secure
   * @response `200` `HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainVaccinationRulesResultVaccinationRuleViewModel` OK
   * @response `401` `void` Unauthorized
   */
  export namespace VaccinationRulesVaccinationRulesSearch {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format int32 */
      Page?: number;
      /** @format int32 */
      Size?: number;
      Sort?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainVaccinationRulesResultVaccinationRuleViewModel;
  }
}

export namespace Veterinary {
  /**
   * No description
   * @tags Veterinary
   * @name VeterinaryAddVeterinaryContact
   * @request POST:/vets/contact
   * @secure
   * @response `200` `string` OK
   * @response `401` `void` Unauthorized
   */
  export namespace VeterinaryAddVeterinaryContact {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainVetsCommandsAddVetContactCommand;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }

  /**
   * No description
   * @tags Veterinary
   * @name VeterinaryAssignFarmToVeterinary
   * @request PUT:/vets/farm
   * @secure
   * @response `200` `string` OK
   * @response `401` `void` Unauthorized
   */
  export namespace VeterinaryAssignFarmToVeterinary {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = HealthSystemDomainVetsCommandsAddFarmToVetCommand;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }

  /**
   * No description
   * @tags Veterinary
   * @name VeterinaryCreateOralFeedInjectionRecord
   * @request POST:/vets/injections/oralfeed
   * @secure
   * @response `200` `(string)[]` OK
   * @response `401` `void` Unauthorized
   */
  export namespace VeterinaryCreateOralFeedInjectionRecord {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainVetsQueryVeterinaryCreateOralFeedInjectionCommand;
    export type RequestHeaders = {};
    export type ResponseBody = string[];
  }

  /**
   * No description
   * @tags Veterinary
   * @name VeterinaryCreateVaccinationInjectionRecord
   * @request POST:/vets/injections/vaccination
   * @secure
   * @response `200` `(string)[]` OK
   * @response `401` `void` Unauthorized
   */
  export namespace VeterinaryCreateVaccinationInjectionRecord {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainVetsQueryVeterinaryCreateVaccinationInjectionCommand;
    export type RequestHeaders = {};
    export type ResponseBody = string[];
  }

  /**
   * No description
   * @tags Veterinary
   * @name VeterinaryCreateVeterinary
   * @request POST:/vets
   * @secure
   * @response `200` `string` OK
   * @response `401` `void` Unauthorized
   */
  export namespace VeterinaryCreateVeterinary {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainVetsCommandsCreateVeterinaryCommand;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }

  /**
   * No description
   * @tags Veterinary
   * @name VeterinaryDeleteVeterinaryContact
   * @request DELETE:/vets/contact
   * @secure
   * @response `200` `string` OK
   * @response `401` `void` Unauthorized
   */
  export namespace VeterinaryDeleteVeterinaryContact {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainVetsCommandsDeleteVetContactCommand;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }

  /**
   * No description
   * @tags Veterinary
   * @name VeterinaryGetFarmMedicalSupplies
   * @request GET:/vets/medical-supplies
   * @secure
   * @response `200` `(HealthSystemDomainMedicalSuppliesResultFarmMedicalSupplyViewModel)[]` OK
   * @response `401` `void` Unauthorized
   */
  export namespace VeterinaryGetFarmMedicalSupplies {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format uuid */
      FarmId?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainMedicalSuppliesResultFarmMedicalSupplyViewModel[];
  }

  /**
   * No description
   * @tags Veterinary
   * @name VeterinaryGetVetById
   * @request GET:/vets/{id}
   * @secure
   * @response `200` `HealthSystemDomainVetsResultVeterinaryViewModel` OK
   * @response `401` `void` Unauthorized
   */
  export namespace VeterinaryGetVetById {
    export type RequestParams = {
      /** @format uuid */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = HealthSystemDomainVetsResultVeterinaryViewModel;
  }

  /**
   * No description
   * @tags Veterinary
   * @name VeterinaryGetVeterinaryDashboard
   * @request GET:/vets/dashboard
   * @secure
   * @response `200` `HealthSystemDomainDashboardsResultVeterinaryDashboardViewModel` OK
   * @response `401` `void` Unauthorized
   */
  export namespace VeterinaryGetVeterinaryDashboard {
    export type RequestParams = {};
    export type RequestQuery = {
      query?: HealthSystemDomainDashboardsQueryVeterinaryDashboardQuery;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainDashboardsResultVeterinaryDashboardViewModel;
  }

  /**
   * No description
   * @tags Veterinary
   * @name VeterinaryGetVeterinaryOrders
   * @request GET:/vets/orders
   * @secure
   * @response `200` `HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainMedicalSuppliesResultVeterinaryOrderViewModel` OK
   * @response `401` `void` Unauthorized
   */
  export namespace VeterinaryGetVeterinaryOrders {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format int32 */
      Page?: number;
      /** @format int32 */
      Size?: number;
      Sort?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainMedicalSuppliesResultVeterinaryOrderViewModel;
  }

  /**
   * No description
   * @tags Veterinary
   * @name VeterinaryGetVets
   * @request GET:/vets
   * @secure
   * @response `200` `HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainVetsResultVeterinaryViewModel` OK
   * @response `401` `void` Unauthorized
   */
  export namespace VeterinaryGetVets {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format int32 */
      Page?: number;
      SearchText?: string;
      /** @format int32 */
      Size?: number;
      Sort?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainVetsResultVeterinaryViewModel;
  }

  /**
   * No description
   * @tags Veterinary
   * @name VeterinarySearchLocations
   * @request GET:/vets/locations/search
   * @secure
   * @response `200` `HealthSystemDomainVetsResultVeterinaryLocationSearchPageableQueryResult` OK
   * @response `401` `void` Unauthorized
   */
  export namespace VeterinarySearchLocations {
    export type RequestParams = {};
    export type RequestQuery = {
      AnimalType?: HealthSystemDALEnumsAnimalType;
      Number?: string;
      /** @format int32 */
      Page?: number;
      Pen?: string;
      Position?: HealthSystemDALEnumsLocationPosition;
      Room?: string;
      /** @format int32 */
      Size?: number;
      Sort?: string;
      Stable?: HealthSystemDALEnumsLocationStableType;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainVetsResultVeterinaryLocationSearchPageableQueryResult;
  }

  /**
   * No description
   * @tags Veterinary
   * @name VeterinaryUnlinkFarmFromVeterinary
   * @request DELETE:/vets/farm
   * @secure
   * @response `200` `string` OK
   * @response `401` `void` Unauthorized
   */
  export namespace VeterinaryUnlinkFarmFromVeterinary {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainVetsCommandsRemoveFarmFromVetCommand;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }

  /**
   * No description
   * @tags Veterinary
   * @name VeterinaryUpdateVeterinary
   * @request PUT:/vets
   * @secure
   * @response `200` `string` OK
   * @response `401` `void` Unauthorized
   */
  export namespace VeterinaryUpdateVeterinary {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainVetsCommandsUpdateVeterinaryCommand;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }

  /**
   * No description
   * @tags Veterinary
   * @name VeterinaryUpdateVeterinaryContact
   * @request PUT:/vets/contact
   * @secure
   * @response `200` `string` OK
   * @response `401` `void` Unauthorized
   */
  export namespace VeterinaryUpdateVeterinaryContact {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainVetsCommandsUpdateVetContactCommand;
    export type RequestHeaders = {};
    export type ResponseBody = string;
  }
}

export namespace VitalityTracker {
  /**
   * No description
   * @tags VitalityTracker
   * @name VitalityTrackerGetAnimalActivities
   * @request GET:/vitality/actions
   * @secure
   * @response `200` `HealthSystemDomainCommonQueryResultPageableResultHealthSystemDALModelAnimalActivity` OK
   * @response `401` `void` Unauthorized
   */
  export namespace VitalityTrackerGetAnimalActivities {
    export type RequestParams = {};
    export type RequestQuery = {
      Number?: string;
      /** @format int32 */
      Page?: number;
      /** @format int32 */
      Size?: number;
      Sort?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainCommonQueryResultPageableResultHealthSystemDALModelAnimalActivity;
  }

  /**
   * No description
   * @tags VitalityTracker
   * @name VitalityTrackerGetDetailedGroupAnalytics
   * @request POST:/vitality/analytics/detailed
   * @secure
   * @response `200` `HealthSystemDomainVitalityTrackerRequestsAnimalGroupAnalyticsDetailedResult` OK
   * @response `401` `void` Unauthorized
   */
  export namespace VitalityTrackerGetDetailedGroupAnalytics {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainVitalityTrackerRequestsAnimalGroupAnalyticsDetailedQuery;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainVitalityTrackerRequestsAnimalGroupAnalyticsDetailedResult;
  }

  /**
   * No description
   * @tags VitalityTracker
   * @name VitalityTrackerGetGroupAnalytics
   * @request POST:/vitality/analytics
   * @secure
   * @response `200` `HealthSystemDomainVitalityTrackerRequestsAnimalGroupAnalyticsResult` OK
   * @response `401` `void` Unauthorized
   */
  export namespace VitalityTrackerGetGroupAnalytics {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainVitalityTrackerRequestsAnimalGroupAnalyticsQuery;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainVitalityTrackerRequestsAnimalGroupAnalyticsResult;
  }

  /**
   * No description
   * @tags VitalityTracker
   * @name VitalityTrackerPushAnimalActivities
   * @request POST:/vitality/actions
   * @secure
   * @response `200` `(string)[]` OK
   * @response `401` `void` Unauthorized
   */
  export namespace VitalityTrackerPushAnimalActivities {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemDomainVitalityTrackerRequestsPushAnimalActivitiesCommand;
    export type RequestHeaders = {};
    export type ResponseBody = string[];
  }
}

export namespace WeightCurves {
  /**
   * @description The whole set comes back in a single unfiltered call, which is what the offline sync makes: the app looks up the animal's age itself and multiplies the weight by the CC per kilogram it holds from the medication matrix. Nothing here is farm-specific.
   * @tags WeightCurves
   * @name WeightCurvesGetWeightCurves
   * @summary The growth curves behind the mobile auto-dose flow: the expected weight of a pig on every day of its life, one curve per birth weight, plus the age past which no dose may be estimated.
   * @request GET:/weight-curves
   * @secure
   * @response `200` `HealthSystemAPIControllersWeightCurvesResponsesWeightCurvesResponse` OK
   * @response `401` `void` Unauthorized
   */
  export namespace WeightCurvesGetWeightCurves {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemAPIControllersWeightCurvesResponsesWeightCurvesResponse;
  }
}

export namespace WeightDiagnostic {
  /**
   * No description
   * @tags WeightDiagnostic
   * @name WeightDiagnosticCreateRecord
   * @request POST:/weight-diagnostic
   * @secure
   * @response `204` `void` No Content
   * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
   * @response `401` `void` Unauthorized
   * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
   * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
   */
  export namespace WeightDiagnosticCreateRecord {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody =
      HealthSystemAPIControllersWeightDiagnosticRequestsCreateWeightDiagnosticRecordRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }

  /**
   * No description
   * @tags WeightDiagnostic
   * @name WeightDiagnosticGetRecords
   * @request GET:/weight-diagnostic
   * @secure
   * @response `200` `HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainWeightDiagnosticQueriesWeightDiagnosticRecordViewModel` OK
   * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
   * @response `401` `void` Unauthorized
   */
  export namespace WeightDiagnosticGetRecords {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format date-time */
      DateFrom?: string;
      /** @format date-time */
      DateTo?: string;
      DeviceType?: string;
      /** @format uuid */
      LocationId?: string;
      /** @format int32 */
      Page?: number;
      /** @format int32 */
      Size?: number;
      Sort?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody =
      HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainWeightDiagnosticQueriesWeightDiagnosticRecordViewModel;
  }
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
  extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export type ContentType =
  | "application/json"
  | "application/vnd.api+json"
  | "multipart/form-data"
  | "application/x-www-form-urlencoded"
  | "text/plain";

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "http://localhost:5023";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      (key) => "undefined" !== typeof query[key],
    );
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    ["application/json"]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    ["application/vnd.api+json"]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    ["text/plain"]: (input: any) =>
      input !== null && typeof input !== "string"
        ? JSON.stringify(input)
        : input,
    ["multipart/form-data"]: (input: any) => {
      if (input instanceof FormData) {
        return input;
      }

      return Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData());
    },
    ["application/x-www-form-urlencoded"]: (input: any) =>
      this.toQueryString(input),
  };

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams,
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (
    cancelToken: CancelToken,
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || "application/json"];
    const responseFormat = format || requestParams.format;

    return this.customFetch(
      `${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== "multipart/form-data"
            ? { "Content-Type": type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === "undefined" || body === null
            ? null
            : payloadFormatter(body),
      },
    ).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const responseToParse = responseFormat ? response.clone() : response;
      const data = !responseFormat
        ? r
        : await responseToParse[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title Health System Backend API
 * @version v1
 * @baseUrl http://localhost:5023
 *
 * Health System Backend API documentation.
 */
export class HealthSystemApi<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  admin = {
    /**
     * No description
     *
     * @tags Admin
     * @name AdminGetFeatures
     * @request GET:/admin/features
     * @response `200` `Record<string,boolean>` OK
     */
    adminGetFeatures: (params: RequestParams = {}) =>
      this.request<Record<string, boolean>, any>({
        path: `/admin/features`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminGetUserBusinessUnitAccessById
     * @request GET:/admin/users/{id}
     * @secure
     * @response `200` `HealthSystemDomainUsersResultManagementUserViewModel` OK
     * @response `401` `void` Unauthorized
     */
    adminGetUserBusinessUnitAccessById: (
      { id }: AdminGetUserBusinessUnitAccessByIdParams,
      params: RequestParams = {},
    ) =>
      this.request<HealthSystemDomainUsersResultManagementUserViewModel, void>({
        path: `/admin/users/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminGetUsers
     * @request GET:/admin/users
     * @secure
     * @response `200` `HealthSystemDomainUsersResultManagementUserViewPageableQueryResult` OK
     * @response `401` `void` Unauthorized
     */
    adminGetUsers: (
      query: AdminGetUsersParams = {},
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainUsersResultManagementUserViewPageableQueryResult,
        void
      >({
        path: `/admin/users`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminLinkBusinessUnitToUser
     * @request PUT:/admin/users/farm
     * @secure
     * @response `200` `string` OK
     * @response `401` `void` Unauthorized
     */
    adminLinkBusinessUnitToUser: (
      data: HealthSystemDomainUsersCommandsLinkBusinessUnitToUserCommand,
      params: RequestParams = {},
    ) =>
      this.request<string, void>({
        path: `/admin/users/farm`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Admin
     * @name AdminUnlinkBusinessUnitFromUser
     * @request DELETE:/admin/users/farm
     * @secure
     * @response `200` `void` OK
     * @response `401` `void` Unauthorized
     */
    adminUnlinkBusinessUnitFromUser: (
      data: HealthSystemDomainUsersCommandsUnlinkBusinessUnitFromUserCommand,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/admin/users/farm`,
        method: "DELETE",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),
  };
  adminDashboards = {
    /**
     * @description A farm that is registering what it should be is on the list too, carrying an on-track status. Narrow with HealthSystem.API.Controllers.Dashboards.Requests.AdminPigletRegistrationRequest.Status to read only the farms that need a call.
     *
     * @tags AdminDashboards
     * @name AdminDashboardsGetPigletRegistrationOverview
     * @summary Lists every farm and where it stands on piglet registration, worst first unless HealthSystem.API.Controllers.Dashboards.Requests.AdminPigletRegistrationRequest.Sort says otherwise, with the counts across every monitored farm above them.
     * @request GET:/admin/dashboard/piglets
     * @secure
     * @response `200` `HealthSystemAPIControllersDashboardsResponsesAdminPigletRegistrationResponse` OK
     * @response `401` `void` Unauthorized
     * @response `403` `HSAPIHostingApiResponseApiErrorResult` Forbidden
     */
    adminDashboardsGetPigletRegistrationOverview: (
      query: AdminDashboardsGetPigletRegistrationOverviewParams = {},
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemAPIControllersDashboardsResponsesAdminPigletRegistrationResponse,
        void | HSAPIHostingApiResponseApiErrorResult
      >({
        path: `/admin/dashboard/piglets`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  adminJobs = {
    /**
     * No description
     *
     * @tags AdminJobs
     * @name AdminJobsGetJobRun
     * @summary One run, with the report it produced.
     * @request GET:/admin/jobs/{jobName}/runs/{runId}
     * @secure
     * @response `200` `HealthSystemAPIControllersJobsResponsesGetJobRunResponse` OK
     * @response `401` `void` Unauthorized
     * @response `403` `HSAPIHostingApiResponseApiErrorResult` Forbidden
     * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
     */
    adminJobsGetJobRun: (
      { jobName, runId }: AdminJobsGetJobRunParams,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemAPIControllersJobsResponsesGetJobRunResponse,
        void | HSAPIHostingApiResponseApiErrorResult
      >({
        path: `/admin/jobs/${jobName}/runs/${runId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description A job that has never run returns an empty page rather than a 404 — it is indistinguishable from a job that does not exist, and the question was about runs either way.
     *
     * @tags AdminJobs
     * @name AdminJobsGetJobRunHistory
     * @summary One job's run history, newest first.
     * @request GET:/admin/jobs/{jobName}/runs
     * @secure
     * @response `200` `HealthSystemAPIControllersJobsResponsesGetJobRunHistoryResponse` OK
     * @response `401` `void` Unauthorized
     * @response `403` `HSAPIHostingApiResponseApiErrorResult` Forbidden
     */
    adminJobsGetJobRunHistory: (
      { jobName, ...query }: AdminJobsGetJobRunHistoryParams,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemAPIControllersJobsResponsesGetJobRunHistoryResponse,
        void | HSAPIHostingApiResponseApiErrorResult
      >({
        path: `/admin/jobs/${jobName}/runs`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Includes jobs no longer registered anywhere: one that used to run and has quietly stopped is exactly what somebody would be looking for.
     *
     * @tags AdminJobs
     * @name AdminJobsGetJobsOverview
     * @summary Every job that has ever run, with its most recent run.
     * @request GET:/admin/jobs
     * @secure
     * @response `200` `HealthSystemAPIControllersJobsResponsesGetJobsOverviewResponse` OK
     * @response `401` `void` Unauthorized
     * @response `403` `HSAPIHostingApiResponseApiErrorResult` Forbidden
     */
    adminJobsGetJobsOverview: (params: RequestParams = {}) =>
      this.request<
        HealthSystemAPIControllersJobsResponsesGetJobsOverviewResponse,
        void | HSAPIHostingApiResponseApiErrorResult
      >({
        path: `/admin/jobs`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  animals = {
    /**
     * No description
     *
     * @tags Animals
     * @name AnimalsAddAnimalWeight
     * @request POST:/animals/weights/register
     * @secure
     * @response `200` `HealthSystemDomainAnimalsResultAnimalViewModel` OK
     * @response `401` `void` Unauthorized
     */
    animalsAddAnimalWeight: (
      data: HealthSystemDomainAnimalsCommandsAddAnimalWeightCommand,
      params: RequestParams = {},
    ) =>
      this.request<HealthSystemDomainAnimalsResultAnimalViewModel, void>({
        path: `/animals/weights/register`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Animals
     * @name AnimalsBatchUpdateAnimal
     * @request PUT:/animals/update-batch
     * @secure
     * @response `200` `HealthSystemDomainCommonResultEntityBatchResult` OK
     * @response `401` `void` Unauthorized
     * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
     * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
     */
    animalsBatchUpdateAnimal: (
      data: HealthSystemAPIControllersAnimalsRequestsBatchUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainCommonResultEntityBatchResult,
        void | HSAPIHostingApiResponseApiErrorResult
      >({
        path: `/animals/update-batch`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Animals
     * @name AnimalsBatchUpdateAnimalFosterMother
     * @request PUT:/animals/foster-mother/batch
     * @secure
     * @response `200` `HealthSystemDomainCommonResultEntityBatchResult` OK
     * @response `401` `void` Unauthorized
     * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
     * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
     */
    animalsBatchUpdateAnimalFosterMother: (
      data: HealthSystemAPIControllersAnimalsRequestsBatchUpdateAnimalFosterMotherRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainCommonResultEntityBatchResult,
        void | HSAPIHostingApiResponseApiErrorResult
      >({
        path: `/animals/foster-mother/batch`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Animals
     * @name AnimalsCreateAnimal
     * @request POST:/animals/register
     * @secure
     * @response `200` `HealthSystemDomainCommonResultEntityBatchResult` OK
     * @response `401` `void` Unauthorized
     */
    animalsCreateAnimal: (
      data: HealthSystemDomainAnimalsCommandsCreateAnimalCommand,
      params: RequestParams = {},
    ) =>
      this.request<HealthSystemDomainCommonResultEntityBatchResult, void>({
        path: `/animals/register`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Animals
     * @name AnimalsCreateAnimalNote
     * @request POST:/animals/note
     * @secure
     * @response `200` `string` OK
     * @response `401` `void` Unauthorized
     */
    animalsCreateAnimalNote: (
      data: HealthSystemDomainAnimalsCommandsCreateAnimalNoteCommand,
      params: RequestParams = {},
    ) =>
      this.request<string, void>({
        path: `/animals/note`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Animals
     * @name AnimalsCreateAnimalsBatch
     * @request POST:/animals/register-batch
     * @secure
     * @response `200` `HealthSystemDomainCommonResultEntityBatchResult` OK
     * @response `401` `void` Unauthorized
     */
    animalsCreateAnimalsBatch: (
      data: HealthSystemDomainAnimalsCommandsCreateAnimalsBatchCommand,
      params: RequestParams = {},
    ) =>
      this.request<HealthSystemDomainCommonResultEntityBatchResult, void>({
        path: `/animals/register-batch`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Animals
     * @name AnimalsCreateAnimalViaInjection
     * @request POST:/animals/register-injection
     * @secure
     * @response `200` `HealthSystemDomainAnimalsResultCreateAnimalViaInjectionResult` OK
     * @response `401` `void` Unauthorized
     */
    animalsCreateAnimalViaInjection: (
      data: HealthSystemDomainAnimalsCommandsCreateAnimalViaInjectionCommand,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainAnimalsResultCreateAnimalViaInjectionResult,
        void
      >({
        path: `/animals/register-injection`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Animals
     * @name AnimalsCreateExternalIdentifier
     * @request POST:/animals/{id}/external-identifiers
     * @secure
     * @response `204` `void` No Content
     * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
     * @response `401` `void` Unauthorized
     * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
     * @response `409` `HSAPIHostingApiResponseApiErrorResult` Conflict
     * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
     */
    animalsCreateExternalIdentifier: (
      { id }: AnimalsCreateExternalIdentifierParams,
      data: HealthSystemAPIControllersAnimalsRequestsCreateAnimalExternalIdentifierRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, HSAPIHostingApiResponseApiErrorResult | void>({
        path: `/animals/${id}/external-identifiers`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Animals
     * @name AnimalsCreateObservation
     * @summary Registers a non-fatal observation (genetic failure, biter, victim of a biter) against a live animal. The animal is not culled and stays in the herd.
     * @request POST:/animals/{id}/observations
     * @secure
     * @response `200` `HealthSystemAPIControllersAnimalsResponsesCreateAnimalObservationResponse` OK
     * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
     * @response `401` `void` Unauthorized
     * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
     * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
     */
    animalsCreateObservation: (
      { id }: AnimalsCreateObservationParams,
      data: HealthSystemAPIControllersAnimalsRequestsCreateAnimalObservationRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemAPIControllersAnimalsResponsesCreateAnimalObservationResponse,
        HSAPIHostingApiResponseApiErrorResult | void
      >({
        path: `/animals/${id}/observations`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Animals
     * @name AnimalsDeleteAnimalNote
     * @request DELETE:/animals/note
     * @secure
     * @response `200` `string` OK
     * @response `401` `void` Unauthorized
     */
    animalsDeleteAnimalNote: (
      query: AnimalsDeleteAnimalNoteParams = {},
      params: RequestParams = {},
    ) =>
      this.request<string, void>({
        path: `/animals/note`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Animals
     * @name AnimalsDeleteExternalIdentifier
     * @request DELETE:/animals/{id}/external-identifiers/{externalIdentifierId}
     * @secure
     * @response `204` `void` No Content
     * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
     * @response `401` `void` Unauthorized
     * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
     * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
     */
    animalsDeleteExternalIdentifier: (
      { id, externalIdentifierId }: AnimalsDeleteExternalIdentifierParams,
      params: RequestParams = {},
    ) =>
      this.request<void, HSAPIHostingApiResponseApiErrorResult | void>({
        path: `/animals/${id}/external-identifiers/${externalIdentifierId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Animals
     * @name AnimalsDeleteObservation
     * @summary Soft-deletes a registered observation. Observations are not editable - a mistake is removed and registered again, so the surviving rows keep their original timestamps.
     * @request DELETE:/animals/{id}/observations/{observationId}
     * @secure
     * @response `204` `void` No Content
     * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
     * @response `401` `void` Unauthorized
     * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
     * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
     */
    animalsDeleteObservation: (
      { id, observationId }: AnimalsDeleteObservationParams,
      params: RequestParams = {},
    ) =>
      this.request<void, HSAPIHostingApiResponseApiErrorResult | void>({
        path: `/animals/${id}/observations/${observationId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Animals
     * @name AnimalsDiedAnimal
     * @request PUT:/animals/died
     * @secure
     * @response `200` `string` OK
     * @response `401` `void` Unauthorized
     */
    animalsDiedAnimal: (
      data: HealthSystemDomainAnimalsCommandsDiedAnimalCommand,
      params: RequestParams = {},
    ) =>
      this.request<string, void>({
        path: `/animals/died`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Animals
     * @name AnimalsGetAnimalAntibioticFreeResult
     * @request GET:/animals/antibiotic-free
     * @secure
     * @response `200` `HealthSystemDomainAnimalsResultAntibioticFreeAnimalQueryResult` OK
     * @response `401` `void` Unauthorized
     */
    animalsGetAnimalAntibioticFreeResult: (
      query: AnimalsGetAnimalAntibioticFreeResultParams = {},
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainAnimalsResultAntibioticFreeAnimalQueryResult,
        void
      >({
        path: `/animals/antibiotic-free`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Animals
     * @name AnimalsGetAnimalAntibioticFreeResultObsolete
     * @request GET:/animals/antibioticfree
     * @deprecated
     * @secure
     * @response `200` `HealthSystemDomainAnimalsResultAntibioticFreeAnimalQueryResult` OK
     * @response `401` `void` Unauthorized
     */
    animalsGetAnimalAntibioticFreeResultObsolete: (
      query: AnimalsGetAnimalAntibioticFreeResultObsoleteParams = {},
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainAnimalsResultAntibioticFreeAnimalQueryResult,
        void
      >({
        path: `/animals/antibioticfree`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Animals
     * @name AnimalsGetAnimalById
     * @request GET:/animals
     * @secure
     * @response `200` `HealthSystemDomainAnimalsResultAnimalViewModel` OK
     * @response `401` `void` Unauthorized
     */
    animalsGetAnimalById: (
      query: AnimalsGetAnimalByIdParams = {},
      params: RequestParams = {},
    ) =>
      this.request<HealthSystemDomainAnimalsResultAnimalViewModel, void>({
        path: `/animals`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Animals
     * @name AnimalsGetAnimalFeedHistory
     * @request GET:/animals/{id}/feed-history
     * @secure
     * @response `200` `HealthSystemAPIControllersAnimalsResponsesAnimalFeedHistoryResponse` OK
     * @response `401` `void` Unauthorized
     * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
     * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
     */
    animalsGetAnimalFeedHistory: (
      { id }: AnimalsGetAnimalFeedHistoryParams,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemAPIControllersAnimalsResponsesAnimalFeedHistoryResponse,
        void | HSAPIHostingApiResponseApiErrorResult
      >({
        path: `/animals/${id}/feed-history`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Animals
     * @name AnimalsGetAnimalLocationHistoryTimeline
     * @request GET:/animals/{id}/location-history-timeline
     * @secure
     * @response `200` `HealthSystemAPIControllersAnimalsResponsesAnimalLocationHistoryTimelineResponse` OK
     * @response `401` `void` Unauthorized
     * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
     * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
     */
    animalsGetAnimalLocationHistoryTimeline: (
      { id }: AnimalsGetAnimalLocationHistoryTimelineParams,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemAPIControllersAnimalsResponsesAnimalLocationHistoryTimelineResponse,
        void | HSAPIHostingApiResponseApiErrorResult
      >({
        path: `/animals/${id}/location-history-timeline`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Animals
     * @name AnimalsGetAnimalPiglets
     * @request GET:/animals/piglets
     * @secure
     * @response `200` `(HealthSystemDomainAnimalsResultAnimalViewModel)[]` OK
     * @response `401` `void` Unauthorized
     */
    animalsGetAnimalPiglets: (
      query: AnimalsGetAnimalPigletsParams = {},
      params: RequestParams = {},
    ) =>
      this.request<HealthSystemDomainAnimalsResultAnimalViewModel[], void>({
        path: `/animals/piglets`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Animals
     * @name AnimalsGetAnimalPigletsBirthCycles
     * @request GET:/animals/piglets/cycles
     * @secure
     * @response `200` `HealthSystemDomainAnimalsResultAnimalPigletBirthCyclesPageableQueryResult` OK
     * @response `401` `void` Unauthorized
     */
    animalsGetAnimalPigletsBirthCycles: (
      query: AnimalsGetAnimalPigletsBirthCyclesParams = {},
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainAnimalsResultAnimalPigletBirthCyclesPageableQueryResult,
        void
      >({
        path: `/animals/piglets/cycles`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Animals
     * @name AnimalsGetAnimalTrendData
     * @request GET:/animals/trend-data
     * @secure
     * @response `200` `HealthSystemDomainAnimalsResultAnimalTrendDataViewModel` OK
     * @response `401` `void` Unauthorized
     */
    animalsGetAnimalTrendData: (
      query: AnimalsGetAnimalTrendDataParams = {},
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainAnimalsResultAnimalTrendDataViewModel,
        void
      >({
        path: `/animals/trend-data`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Animals
     * @name AnimalsGetCompareSearchAnimalsTrendData
     * @request POST:/animals/search/trend-data/compare
     * @secure
     * @response `200` `Record<string,HealthSystemDomainAnimalsResultAnimalTrendDataViewModel>` OK
     * @response `401` `void` Unauthorized
     */
    animalsGetCompareSearchAnimalsTrendData: (
      data: HealthSystemDomainAnimalsCommandsSearchCompareAnimalsTrendDataQuery,
      params: RequestParams = {},
    ) =>
      this.request<
        Record<string, HealthSystemDomainAnimalsResultAnimalTrendDataViewModel>,
        void
      >({
        path: `/animals/search/trend-data/compare`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Animals
     * @name AnimalsGetExternalIdentifiers
     * @request GET:/animals/{id}/external-identifiers
     * @secure
     * @response `200` `HealthSystemAPIControllersAnimalsResponsesGetAnimalExternalIdentifiersResponse` OK
     * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
     * @response `401` `void` Unauthorized
     * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
     */
    animalsGetExternalIdentifiers: (
      { id, ...query }: AnimalsGetExternalIdentifiersParams,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemAPIControllersAnimalsResponsesGetAnimalExternalIdentifiersResponse,
        HSAPIHostingApiResponseApiErrorResult | void
      >({
        path: `/animals/${id}/external-identifiers`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Animals
     * @name AnimalsGetHealthLogs
     * @request GET:/animals/{id}/health-logs
     * @secure
     * @response `200` `HealthSystemAPIControllersAnimalsResponsesGetAnimalHealthLogsResponse` OK
     * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
     * @response `401` `void` Unauthorized
     */
    animalsGetHealthLogs: (
      { id, ...query }: AnimalsGetHealthLogsParams,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemAPIControllersAnimalsResponsesGetAnimalHealthLogsResponse,
        HSAPIHostingApiResponseApiErrorResult | void
      >({
        path: `/animals/${id}/health-logs`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Animals
     * @name AnimalsGetLifecyclePrediction
     * @request GET:/animals/{id}/lifecycle-prediction
     * @secure
     * @response `200` `HealthSystemDomainDigitalTwinModelsLifecyclePrediction` OK
     * @response `401` `void` Unauthorized
     * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
     */
    animalsGetLifecyclePrediction: (
      { id }: AnimalsGetLifecyclePredictionParams,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainDigitalTwinModelsLifecyclePrediction,
        void | HSAPIHostingApiResponseApiErrorResult
      >({
        path: `/animals/${id}/lifecycle-prediction`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Animals
     * @name AnimalsGetObservationOptions
     * @summary The values for the observation dropdown, so web and mobile do not hard-code them.
     * @request GET:/animals/observations/options
     * @secure
     * @response `200` `HealthSystemAPIControllersAnimalsResponsesGetAnimalObservationOptionsResponse` OK
     * @response `401` `void` Unauthorized
     */
    animalsGetObservationOptions: (params: RequestParams = {}) =>
      this.request<
        HealthSystemAPIControllersAnimalsResponsesGetAnimalObservationOptionsResponse,
        void
      >({
        path: `/animals/observations/options`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Animals
     * @name AnimalsGetObservationRegistrations
     * @summary The farm-wide registrations list behind the "Genetic failures and bites" page - one row per registration, newest first, date-bounded on the registration itself.
     * @request GET:/animals/observations
     * @secure
     * @response `200` `HealthSystemAPIControllersAnimalsResponsesGetAnimalObservationsResponse` OK
     * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
     * @response `401` `void` Unauthorized
     */
    animalsGetObservationRegistrations: (
      query: AnimalsGetObservationRegistrationsParams = {},
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemAPIControllersAnimalsResponsesGetAnimalObservationsResponse,
        HSAPIHostingApiResponseApiErrorResult | void
      >({
        path: `/animals/observations`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Animals
     * @name AnimalsGetObservations
     * @summary The observations registered against one animal, newest first.
     * @request GET:/animals/{id}/observations
     * @secure
     * @response `200` `HealthSystemAPIControllersAnimalsResponsesGetAnimalObservationsResponse` OK
     * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
     * @response `401` `void` Unauthorized
     */
    animalsGetObservations: (
      { id, ...query }: AnimalsGetObservationsParams,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemAPIControllersAnimalsResponsesGetAnimalObservationsResponse,
        HSAPIHostingApiResponseApiErrorResult | void
      >({
        path: `/animals/${id}/observations`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Animals
     * @name AnimalsGetProjectedSlaughterDate
     * @request GET:/animals/{id}/projected-slaughter-date
     * @secure
     * @response `200` `HealthSystemDomainDigitalTwinModelsProjectedSlaughterDateResult` OK
     * @response `401` `void` Unauthorized
     * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
     * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
     */
    animalsGetProjectedSlaughterDate: (
      { id }: AnimalsGetProjectedSlaughterDateParams,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainDigitalTwinModelsProjectedSlaughterDateResult,
        void | HSAPIHostingApiResponseApiErrorResult
      >({
        path: `/animals/${id}/projected-slaughter-date`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Animals
     * @name AnimalsGetSearchAnimalsParentNumbers
     * @summary The values behind the sow or boar column's filter menu on the search table: the distinct parent numbers of the whole filtered search, not only of the page on screen.
     * @request POST:/animals/search/parent-numbers
     * @secure
     * @response `200` `HealthSystemAPIControllersAnimalsResponsesAnimalParentNumbersResponse` OK
     * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
     * @response `401` `void` Unauthorized
     * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
     */
    animalsGetSearchAnimalsParentNumbers: (
      data: HealthSystemAPIControllersAnimalsRequestsAnimalParentNumbersRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemAPIControllersAnimalsResponsesAnimalParentNumbersResponse,
        HSAPIHostingApiResponseApiErrorResult | void
      >({
        path: `/animals/search/parent-numbers`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Animals
     * @name AnimalsGetSearchAnimalsTrendData
     * @request POST:/animals/search/trend-data
     * @secure
     * @response `200` `HealthSystemDomainAnimalsResultAnimalTrendDataViewModel` OK
     * @response `401` `void` Unauthorized
     */
    animalsGetSearchAnimalsTrendData: (
      data: HealthSystemDomainAnimalsCommandsSearchAnimalsTrendDataQuery,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainAnimalsResultAnimalTrendDataViewModel,
        void
      >({
        path: `/animals/search/trend-data`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Animals
     * @name AnimalsMoveSowWithPiglets
     * @summary Assigns a sow to a location and moves the piglets of her most recent birth cycle with her. Piglets that are in a quarantine location stay behind and are reported as skipped.
     * @request PUT:/animals/sow/move-with-piglets
     * @secure
     * @response `200` `HealthSystemAPIControllersAnimalsResponsesMoveSowWithPigletsResponse` OK
     * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
     * @response `401` `void` Unauthorized
     * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
     * @response `409` `HSAPIHostingApiResponseApiErrorResult` Conflict
     * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
     */
    animalsMoveSowWithPiglets: (
      data: HealthSystemAPIControllersAnimalsRequestsMoveSowWithPigletsRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemAPIControllersAnimalsResponsesMoveSowWithPigletsResponse,
        HSAPIHostingApiResponseApiErrorResult | void
      >({
        path: `/animals/sow/move-with-piglets`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Animals
     * @name AnimalsRecalculateAnimalWeights
     * @request PUT:/animals/weights/recalculate-weights
     * @secure
     * @response `200` `HealthSystemDomainAnimalsResultAnimalViewModel` OK
     * @response `401` `void` Unauthorized
     */
    animalsRecalculateAnimalWeights: (
      data: HealthSystemDomainAnimalsCommandsRecalculateAnimalWeightCommand,
      params: RequestParams = {},
    ) =>
      this.request<HealthSystemDomainAnimalsResultAnimalViewModel, void>({
        path: `/animals/weights/recalculate-weights`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Animals
     * @name AnimalsSearchAnimals
     * @request POST:/animals/search
     * @secure
     * @response `200` `HealthSystemDomainAnimalsResultAnimalsSearchQueryResult` OK
     * @response `401` `void` Unauthorized
     */
    animalsSearchAnimals: (
      data: HealthSystemDomainAnimalsCommandsAnimalsSearchQuery,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainAnimalsResultAnimalsSearchQueryResult,
        void
      >({
        path: `/animals/search`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Animals
     * @name AnimalsSetAnimalWeights
     * @request PUT:/animals/weights
     * @deprecated
     * @secure
     * @response `200` `HealthSystemDomainAnimalsResultAnimalViewModel` OK
     * @response `401` `void` Unauthorized
     */
    animalsSetAnimalWeights: (
      data: HealthSystemDomainAnimalsCommandsSetAnimalWeightsCommand,
      params: RequestParams = {},
    ) =>
      this.request<HealthSystemDomainAnimalsResultAnimalViewModel, void>({
        path: `/animals/weights`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Animals
     * @name AnimalsUpdateAnimal
     * @request POST:/animals/update
     * @secure
     * @response `200` `HealthSystemDomainCommonResultEntityBatchResult` OK
     * @response `401` `void` Unauthorized
     */
    animalsUpdateAnimal: (
      data: HealthSystemDomainAnimalsCommandsUpdateAnimalCommand,
      params: RequestParams = {},
    ) =>
      this.request<HealthSystemDomainCommonResultEntityBatchResult, void>({
        path: `/animals/update`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Animals
     * @name AnimalsUpdateAnimalSetInseminated
     * @request POST:/animals/inseminate
     * @secure
     * @response `200` `string` OK
     * @response `401` `void` Unauthorized
     */
    animalsUpdateAnimalSetInseminated: (
      query: AnimalsUpdateAnimalSetInseminatedParams = {},
      params: RequestParams = {},
    ) =>
      this.request<string, void>({
        path: `/animals/inseminate`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  auth = {
    /**
     * No description
     *
     * @tags Auth
     * @name AuthAcceptInvitation
     * @request POST:/auth/accept-invitation
     * @response `204` `void` No Content
     * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
     */
    authAcceptInvitation: (
      data: HealthSystemAPIControllersAuthRequestsAcceptInvitationRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, HSAPIHostingApiResponseApiErrorResult>({
        path: `/auth/accept-invitation`,
        method: "POST",
        body: data,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthAuthFarm
     * @request POST:/auth/farm
     * @response `200` `HealthSystemDomainFarmsResultFarmAuthResult` OK
     * @response `400` `HealthSystemCommonExceptionsValidationResult` Bad Request
     */
    authAuthFarm: (
      data: HealthSystemDomainFarmsCommandsAuthFarmCommand,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainFarmsResultFarmAuthResult,
        HealthSystemCommonExceptionsValidationResult
      >({
        path: `/auth/farm`,
        method: "POST",
        body: data,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthAuthUser
     * @request POST:/auth/user
     * @response `200` `HealthSystemDomainUsersResultUserAuthResult` OK
     * @response `400` `HealthSystemCommonExceptionsValidationResult` Bad Request
     */
    authAuthUser: (
      data: HealthSystemDomainUsersCommandsAuthUserCommand,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainUsersResultUserAuthResult,
        HealthSystemCommonExceptionsValidationResult
      >({
        path: `/auth/user`,
        method: "POST",
        body: data,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthAuthVeterinary
     * @request POST:/auth/vet
     * @response `200` `HealthSystemDomainUsersResultAuthVeterinaryResult` OK
     * @response `400` `HealthSystemCommonExceptionsValidationResult` Bad Request
     */
    authAuthVeterinary: (
      data: HealthSystemDomainUsersCommandsAuthVeterinaryCommand,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainUsersResultAuthVeterinaryResult,
        HealthSystemCommonExceptionsValidationResult
      >({
        path: `/auth/vet`,
        method: "POST",
        body: data,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthAuthWebUser
     * @request POST:/auth/webuser
     * @response `200` `HealthSystemDomainUsersResultAuthWebUserResult` OK
     * @response `400` `HealthSystemCommonExceptionsValidationResult` Bad Request
     */
    authAuthWebUser: (
      data: HealthSystemDomainUsersCommandsAuthWebUserCommand,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainUsersResultAuthWebUserResult,
        HealthSystemCommonExceptionsValidationResult
      >({
        path: `/auth/webuser`,
        method: "POST",
        body: data,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthForgotPassword
     * @request POST:/auth/forgot-password
     * @response `204` `void` No Content
     */
    authForgotPassword: (
      data: HealthSystemAPIControllersAuthRequestsForgotPasswordRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/auth/forgot-password`,
        method: "POST",
        body: data,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthGetInvitationDetails
     * @request GET:/auth/invitations/{token}
     * @response `200` `HealthSystemAPIControllersAuthResponsesInvitationDetailsResponse` OK
     * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
     */
    authGetInvitationDetails: (
      { token }: AuthGetInvitationDetailsParams,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemAPIControllersAuthResponsesInvitationDetailsResponse,
        HSAPIHostingApiResponseApiErrorResult
      >({
        path: `/auth/invitations/${token}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthLogin
     * @request POST:/auth/login
     * @response `200` `HealthSystemDomainUsersResultAuthenticationResponse` OK
     * @response `400` `HealthSystemCommonExceptionsValidationResult` Bad Request
     */
    authLogin: (
      data: HealthSystemDomainUsersCommandsUserLoginCommand,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainUsersResultAuthenticationResponse,
        HealthSystemCommonExceptionsValidationResult
      >({
        path: `/auth/login`,
        method: "POST",
        body: data,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthLoginBusinessUnit
     * @request POST:/auth/login/business-unit
     * @response `200` `HealthSystemDomainUsersResultAuthenticationResponse` OK
     * @response `400` `HealthSystemCommonExceptionsValidationResult` Bad Request
     */
    authLoginBusinessUnit: (
      data: HealthSystemDomainUsersCommandsUserBusinessUnitLoginCommand,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainUsersResultAuthenticationResponse,
        HealthSystemCommonExceptionsValidationResult
      >({
        path: `/auth/login/business-unit`,
        method: "POST",
        body: data,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthLoginChangeBusinessUnit
     * @request POST:/auth/login/business-unit/change
     * @secure
     * @response `200` `HealthSystemDomainUsersResultAuthenticationResponse` OK
     * @response `400` `HealthSystemCommonExceptionsValidationResult` Bad Request
     * @response `401` `void` Unauthorized
     */
    authLoginChangeBusinessUnit: (
      data: HealthSystemDomainUsersCommandsUserLoginChangeBusinessUnitCommand,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainUsersResultAuthenticationResponse,
        HealthSystemCommonExceptionsValidationResult | void
      >({
        path: `/auth/login/business-unit/change`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthRefreshAuthToken
     * @request POST:/auth/refresh
     * @response `200` `HealthSystemDomainUsersResultAuthResultBase` OK
     */
    authRefreshAuthToken: (
      data: HealthSystemDomainUsersCommandsRefreshAuthCommand,
      params: RequestParams = {},
    ) =>
      this.request<HealthSystemDomainUsersResultAuthResultBase, any>({
        path: `/auth/refresh`,
        method: "POST",
        body: data,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthResetPassword
     * @request POST:/auth/reset-password
     * @response `204` `void` No Content
     * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
     */
    authResetPassword: (
      data: HealthSystemAPIControllersAuthRequestsResetPasswordRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, HSAPIHostingApiResponseApiErrorResult>({
        path: `/auth/reset-password`,
        method: "POST",
        body: data,
        type: "application/json",
        ...params,
      }),
  };
  carbonFootprint = {
    /**
     * No description
     *
     * @tags CarbonFootprint
     * @name CarbonFootprintGetCarbonFootprintByYear
     * @request GET:/carbon-footprint
     * @secure
     * @response `200` `HealthSystemDomainCarbonFootPrintResultCarbonFootprintPerYearViewModel` OK
     * @response `401` `void` Unauthorized
     */
    carbonFootprintGetCarbonFootprintByYear: (
      query: CarbonFootprintGetCarbonFootprintByYearParams = {},
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainCarbonFootPrintResultCarbonFootprintPerYearViewModel,
        void
      >({
        path: `/carbon-footprint`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  chipNumbers = {
    /**
     * No description
     *
     * @tags ChipNumbers
     * @name ChipNumbersCreateChipNumber
     * @request POST:/chip-mumbers/v1
     * @secure
     * @response `200` `string` OK
     * @response `401` `void` Unauthorized
     */
    chipNumbersCreateChipNumber: (
      data: HealthSystemDomainChipNumbersCommandUpsertChipNumberCommand,
      params: RequestParams = {},
    ) =>
      this.request<string, void>({
        path: `/chip-mumbers/v1`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ChipNumbers
     * @name ChipNumbersDeleteChipNumber
     * @request DELETE:/chip-mumbers/v1
     * @secure
     * @response `200` `string` OK
     * @response `401` `void` Unauthorized
     */
    chipNumbersDeleteChipNumber: (
      data: HealthSystemDomainChipNumbersCommandRemoveChipNumberCommand,
      params: RequestParams = {},
    ) =>
      this.request<string, void>({
        path: `/chip-mumbers/v1`,
        method: "DELETE",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ChipNumbers
     * @name ChipNumbersGetChipNumber
     * @request GET:/chip-mumbers/v1
     * @secure
     * @response `200` `HealthSystemDomainChipNumbersResultChipNumberListResult` OK
     * @response `401` `void` Unauthorized
     */
    chipNumbersGetChipNumber: (
      query: ChipNumbersGetChipNumberParams = {},
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainChipNumbersResultChipNumberListResult,
        void
      >({
        path: `/chip-mumbers/v1`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ChipNumbers
     * @name ChipNumbersGetChipNumberInfo
     * @request GET:/chip-mumbers/v1/info
     * @secure
     * @response `200` `(HealthSystemDomainChipNumbersResultChipNumberInfoViewModel)[]` OK
     * @response `401` `void` Unauthorized
     */
    chipNumbersGetChipNumberInfo: (
      query: ChipNumbersGetChipNumberInfoParams,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainChipNumbersResultChipNumberInfoViewModel[],
        void
      >({
        path: `/chip-mumbers/v1/info`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  dashboards = {
    /**
     * No description
     *
     * @tags Dashboards
     * @name DashboardsGetDashboard
     * @summary Reports on the caller's own farm, or on the farm named by farmId. Naming another farm requires the admin role.
     * @request GET:/dashboard
     * @secure
     * @response `200` `HealthSystemDomainDashboardsResultDashboardViewModel` OK
     * @response `401` `void` Unauthorized
     * @response `403` `HSAPIHostingApiResponseApiErrorResult` Forbidden
     * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
     */
    dashboardsGetDashboard: (
      query: DashboardsGetDashboardParams = {},
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainDashboardsResultDashboardViewModel,
        void | HSAPIHostingApiResponseApiErrorResult
      >({
        path: `/dashboard`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dashboards
     * @name DashboardsGetPigletRegistrationDashboard
     * @summary Reports on the caller's own farm, or on the farm named by farmId. Naming another farm requires the admin role, and reports on it even when that farm turned the widget off on its own dashboard.
     * @request GET:/dashboard/piglets
     * @secure
     * @response `200` `HealthSystemAPIControllersDashboardsResponsesPigletRegistrationDashboardResponse` OK
     * @response `401` `void` Unauthorized
     * @response `403` `HSAPIHostingApiResponseApiErrorResult` Forbidden
     * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
     */
    dashboardsGetPigletRegistrationDashboard: (
      query: DashboardsGetPigletRegistrationDashboardParams = {},
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemAPIControllersDashboardsResponsesPigletRegistrationDashboardResponse,
        void | HSAPIHostingApiResponseApiErrorResult
      >({
        path: `/dashboard/piglets`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Separate from `/dashboard/piglets` on purpose - that widget answers how many piglets were registered, this one how heavy they were - but both bucket by the animal's date of birth, so the two charts on the same screen describe the same weeks.
     *
     * @tags Dashboards
     * @name DashboardsGetWeightMilestoneDashboard
     * @summary Weight milestone chart for the caller's own farm, or for the farm named by farmId. Naming another farm requires the admin role.
     * @request GET:/dashboard/weights
     * @secure
     * @response `200` `HealthSystemAPIControllersDashboardsResponsesWeightMilestoneDashboardResponse` OK
     * @response `401` `void` Unauthorized
     * @response `403` `HSAPIHostingApiResponseApiErrorResult` Forbidden
     * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
     */
    dashboardsGetWeightMilestoneDashboard: (
      query: DashboardsGetWeightMilestoneDashboardParams = {},
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemAPIControllersDashboardsResponsesWeightMilestoneDashboardResponse,
        void | HSAPIHostingApiResponseApiErrorResult
      >({
        path: `/dashboard/weights`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  dataImport = {
    /**
     * No description
     *
     * @tags DataImport
     * @name DataImportGetSlaughterImportHistory
     * @request GET:/data-import/slaughter-history
     * @secure
     * @response `200` `HealthSystemAPIControllersDataImportResponsesSlaughterImportHistoryResponse` OK
     * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
     * @response `401` `void` Unauthorized
     * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
     */
    dataImportGetSlaughterImportHistory: (
      query: DataImportGetSlaughterImportHistoryParams = {},
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemAPIControllersDataImportResponsesSlaughterImportHistoryResponse,
        HSAPIHostingApiResponseApiErrorResult | void
      >({
        path: `/data-import/slaughter-history`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  device = {
    /**
     * @description This endpoint allows mobile users to connect a HealthInjector device to a farm. If the device is already connected to a different farm, the farm association will be updated.
     *
     * @tags Device
     * @name DeviceConnectHealthInjector
     * @summary Connect a HealthInjector device to a farm (mobile endpoint)
     * @request POST:/device/injector/connect
     * @secure
     * @response `200` `HealthSystemAPIControllersDeviceResponsesHealthInjectorConnectionResponse` OK
     * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
     * @response `401` `void` Unauthorized
     * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
     * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
     */
    deviceConnectHealthInjector: (
      data: HealthSystemAPIControllersDeviceRequestsConnectHealthInjectorRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemAPIControllersDeviceResponsesHealthInjectorConnectionResponse,
        HSAPIHostingApiResponseApiErrorResult | void
      >({
        path: `/device/injector/connect`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Device
     * @name DeviceDownloadDeviceFirmware
     * @summary Download device firmware
     * @request GET:/device/firmware/file
     * @secure
     * @response `200` `File` OK
     * @response `401` `void` Unauthorized
     */
    deviceDownloadDeviceFirmware: (
      query: DeviceDownloadDeviceFirmwareParams = {},
      params: RequestParams = {},
    ) =>
      this.request<File, void>({
        path: `/device/firmware/file`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Exports reader actions matching the given filters to a CSV file. Use the Columns list to select which fields to include; if empty, all columns are exported. Valid column names: Number, HookId, DateTime, FarmId, Farm, Weight, TradingClass, BaconCutlet, Fat, LeanMeat, Belly, Ham, Spine, Shoulder, Money, EventMessage, Slaughterhouse
     *
     * @tags Device
     * @name DeviceExportReaderActions
     * @summary Export reader actions to CSV
     * @request POST:/device/reader/action/export
     * @secure
     * @response `200` `File` OK
     * @response `401` `void` Unauthorized
     */
    deviceExportReaderActions: (
      data: HealthSystemAPIControllersDeviceRequestsExportReaderActionsRequest,
      params: RequestParams = {},
    ) =>
      this.request<File, void>({
        path: `/device/reader/action/export`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Device
     * @name DeviceGetDeviceFirmwareVersions
     * @summary Get device firmware versions
     * @request GET:/device/firmware
     * @secure
     * @response `200` `HealthSystemDomainDeviceResultDeviceFirmwareQueryResult` OK
     * @response `401` `void` Unauthorized
     */
    deviceGetDeviceFirmwareVersions: (
      query: DeviceGetDeviceFirmwareVersionsParams = {},
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainDeviceResultDeviceFirmwareQueryResult,
        void
      >({
        path: `/device/firmware`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description The read side of the sync reports the mobile app files below. Each device is represented by its latest report, so this is the farm's current backlog rather than a log: `totalPendingCount` is what has not reached the backend yet, and `pendingSince` says how long a device has been sitting on it - a queue that never drops is what separates a stuck device from a busy one. `farmId` defaults to the caller's own farm; naming another one requires admin. `pendingOnly` narrows the device list to the ones that are behind, and never changes the counts.
     *
     * @tags Device
     * @name DeviceGetDeviceSyncStatus
     * @summary List the mobile devices that still have unsent animals queued
     * @request GET:/device/sync-status
     * @secure
     * @response `200` `HealthSystemAPIControllersDeviceResponsesDeviceSyncStatusOverviewResponse` OK
     * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
     * @response `401` `void` Unauthorized
     * @response `403` `HSAPIHostingApiResponseApiErrorResult` Forbidden
     * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
     */
    deviceGetDeviceSyncStatus: (
      query: DeviceGetDeviceSyncStatusParams = {},
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemAPIControllersDeviceResponsesDeviceSyncStatusOverviewResponse,
        HSAPIHostingApiResponseApiErrorResult | void
      >({
        path: `/device/sync-status`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns a paginated list of activity events for a specific HealthInjector device. Supports filtering by activity type and date range.
     *
     * @tags Device
     * @name DeviceGetHealthInjectorActivities
     * @summary Get paginated HealthInjector activities
     * @request GET:/device/injector/{id}/activities
     * @secure
     * @response `200` `HealthSystemAPIControllersDeviceResponsesHealthInjectorActivitiesResponse` OK
     * @response `401` `void` Unauthorized
     * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
     * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
     */
    deviceGetHealthInjectorActivities: (
      { id, ...query }: DeviceGetHealthInjectorActivitiesParams,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemAPIControllersDeviceResponsesHealthInjectorActivitiesResponse,
        void | HSAPIHostingApiResponseApiErrorResult
      >({
        path: `/device/injector/${id}/activities`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns detailed information about a specific HealthInjector device including farm association, firmware versions, and operational status.
     *
     * @tags Device
     * @name DeviceGetHealthInjectorDetails
     * @summary Get HealthInjector details by ID
     * @request GET:/device/injector/{id}
     * @secure
     * @response `200` `HealthSystemAPIControllersDeviceResponsesHealthInjectorDetailsResponse` OK
     * @response `401` `void` Unauthorized
     * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
     * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
     */
    deviceGetHealthInjectorDetails: (
      { id }: DeviceGetHealthInjectorDetailsParams,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemAPIControllersDeviceResponsesHealthInjectorDetailsResponse,
        void | HSAPIHostingApiResponseApiErrorResult
      >({
        path: `/device/injector/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns a paginated list of application events linked to a specific HealthInjector device. Events are automatically linked by MAC address when created. Supports filtering by date range and error status.
     *
     * @tags Device
     * @name DeviceGetHealthInjectorEvents
     * @summary Get paginated AppEventLog entries for a HealthInjector
     * @request GET:/device/injector/{id}/events
     * @secure
     * @response `200` `HealthSystemAPIControllersDeviceResponsesHealthInjectorEventsResponse` OK
     * @response `401` `void` Unauthorized
     * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
     * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
     */
    deviceGetHealthInjectorEvents: (
      { id, ...query }: DeviceGetHealthInjectorEventsParams,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemAPIControllersDeviceResponsesHealthInjectorEventsResponse,
        void | HSAPIHostingApiResponseApiErrorResult
      >({
        path: `/device/injector/${id}/events`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Device
     * @name DeviceGetHealthInjectors
     * @request GET:/device/injector
     * @secure
     * @response `200` `HealthSystemDomainDeviceResultHealthInjectorsQueryResult` OK
     * @response `401` `void` Unauthorized
     */
    deviceGetHealthInjectors: (
      query: DeviceGetHealthInjectorsParams = {},
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainDeviceResultHealthInjectorsQueryResult,
        void
      >({
        path: `/device/injector`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Device
     * @name DeviceGetLatestDeviceFirmwareVersion
     * @summary Get latest device firmware version
     * @request GET:/device/firmware/latest
     * @secure
     * @response `200` `HealthSystemDomainDeviceResultDeviceFirmwareViewModel` OK
     * @response `401` `void` Unauthorized
     */
    deviceGetLatestDeviceFirmwareVersion: (
      query: DeviceGetLatestDeviceFirmwareVersionParams = {},
      params: RequestParams = {},
    ) =>
      this.request<HealthSystemDomainDeviceResultDeviceFirmwareViewModel, void>(
        {
          path: `/device/firmware/latest`,
          method: "GET",
          query: query,
          secure: true,
          format: "json",
          ...params,
        },
      ),

    /**
     * No description
     *
     * @tags Device
     * @name DeviceGetReaderActions
     * @request POST:/device/reader/action/search
     * @secure
     * @response `200` `HealthSystemDomainDeviceResultReaderActionsQueryResult` OK
     * @response `401` `void` Unauthorized
     */
    deviceGetReaderActions: (
      data: HealthSystemDomainDeviceCommandsReaderActionsQuery,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainDeviceResultReaderActionsQueryResult,
        void
      >({
        path: `/device/reader/action/search`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Device
     * @name DeviceGetReaders
     * @request GET:/device/reader
     * @secure
     * @response `200` `HealthSystemDomainDeviceResultReadersQueryResult` OK
     * @response `401` `void` Unauthorized
     */
    deviceGetReaders: (
      query: DeviceGetReadersParams = {},
      params: RequestParams = {},
    ) =>
      this.request<HealthSystemDomainDeviceResultReadersQueryResult, void>({
        path: `/device/reader`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Called periodically by the mobile app while it drains its offline queue, so a device sitting on unsent animals is visible on the backend. Each call appends a new record rather than replacing the previous one. The MAC address identifies the health injector the phone is paired with. If it matches no registered device the report is still stored, with a null HealthInjectorId and `injectorMatched: false` in the response.
     *
     * @tags Device
     * @name DevicePostDeviceSyncStatus
     * @summary Report the state of a mobile device's offline sync queue
     * @request POST:/device/sync-status
     * @secure
     * @response `200` `HealthSystemAPIControllersDeviceResponsesDeviceSyncStatusResponse` OK
     * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
     * @response `401` `void` Unauthorized
     * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
     * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
     */
    devicePostDeviceSyncStatus: (
      data: HealthSystemAPIControllersDeviceRequestsPostDeviceSyncStatusRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemAPIControllersDeviceResponsesDeviceSyncStatusResponse,
        HSAPIHostingApiResponseApiErrorResult | void
      >({
        path: `/device/sync-status`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Device
     * @name DevicePostReaderActions
     * @request POST:/device/reader/action
     * @secure
     * @response `200` `HealthSystemDomainDeviceResultCreateReaderActionViewModel` OK
     * @response `401` `void` Unauthorized
     */
    devicePostReaderActions: (
      data: HealthSystemDomainDeviceCommandsCreateReaderActionCommand,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainDeviceResultCreateReaderActionViewModel,
        void
      >({
        path: `/device/reader/action`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Device
     * @name DevicePostReaderHeartbeat
     * @request POST:/device/reader/heartbeat
     * @secure
     * @response `200` `HealthSystemDomainDeviceCommandsRecordReaderHeartbeatResult` OK
     * @response `401` `HSAPIHostingApiResponseApiErrorResult` Unauthorized
     * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
     */
    devicePostReaderHeartbeat: (
      data: HealthSystemAPIControllersDeviceRequestsPostReaderHeartbeatRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainDeviceCommandsRecordReaderHeartbeatResult,
        HSAPIHostingApiResponseApiErrorResult
      >({
        path: `/device/reader/heartbeat`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Device
     * @name DeviceRegisterHealthInjector
     * @request POST:/device/injector
     * @secure
     * @response `200` `string` OK
     * @response `401` `void` Unauthorized
     */
    deviceRegisterHealthInjector: (
      data: HealthSystemDomainDeviceCommandsCreateHealthInjectorCommand,
      params: RequestParams = {},
    ) =>
      this.request<string, void>({
        path: `/device/injector`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Device
     * @name DeviceRemoveDeviceFirmware
     * @summary Remove device firmware
     * @request DELETE:/device/firmware
     * @secure
     * @response `200` `string` OK
     * @response `401` `void` Unauthorized
     */
    deviceRemoveDeviceFirmware: (
      query: DeviceRemoveDeviceFirmwareParams,
      params: RequestParams = {},
    ) =>
      this.request<string, void>({
        path: `/device/firmware`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Both values are replaced: send the current short description to keep it, and an empty release log to clear it.
     *
     * @tags Device
     * @name DeviceUpdateDeviceFirmwareDescription
     * @summary Update the description and the markdown release log of an uploaded device firmware
     * @request PATCH:/device/firmware/{id}
     * @secure
     * @response `200` `HealthSystemAPIControllersDeviceResponsesDeviceFirmwareDescriptionResponse` OK
     * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
     * @response `401` `void` Unauthorized
     * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
     */
    deviceUpdateDeviceFirmwareDescription: (
      { id }: DeviceUpdateDeviceFirmwareDescriptionParams,
      data: HealthSystemAPIControllersDeviceRequestsUpdateDeviceFirmwareDescriptionRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemAPIControllersDeviceResponsesDeviceFirmwareDescriptionResponse,
        HSAPIHostingApiResponseApiErrorResult | void
      >({
        path: `/device/firmware/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Device
     * @name DeviceUpdateHealthInjector
     * @request PUT:/device/injector
     * @secure
     * @response `200` `string` OK
     * @response `401` `void` Unauthorized
     */
    deviceUpdateHealthInjector: (
      data: HealthSystemDomainDeviceCommandsUpdateHealthInjectorCommand,
      params: RequestParams = {},
    ) =>
      this.request<string, void>({
        path: `/device/injector`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Device
     * @name DeviceUpdateHealthInjectorVersion
     * @request POST:/device/injector/version
     * @secure
     * @response `200` `string` OK
     * @response `401` `void` Unauthorized
     */
    deviceUpdateHealthInjectorVersion: (
      data: HealthSystemDomainDeviceCommandsUpdateHealthInjectorVersionCommand,
      params: RequestParams = {},
    ) =>
      this.request<string, void>({
        path: `/device/injector/version`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Device
     * @name DeviceUploadDeviceFirmware
     * @summary Upload device firmware
     * @request POST:/device/firmware
     * @secure
     * @response `200` `string` OK
     * @response `401` `void` Unauthorized
     */
    deviceUploadDeviceFirmware: (
      data: DeviceUploadDeviceFirmwarePayload,
      params: RequestParams = {},
    ) =>
      this.request<string, void>({
        path: `/device/firmware`,
        method: "POST",
        body: data,
        secure: true,
        type: "multipart/form-data",
        format: "json",
        ...params,
      }),
  };
  deviceDailyReports = {
    /**
     * @description The body is the report document the device produced, taken as is - there is deliberately no request model mirroring its fields yet.
     *
     * @tags DeviceDailyReports
     * @name DeviceDailyReportsCreate
     * @request POST:/farms/{farmId}/device-daily-reports
     * @secure
     * @response `200` `HealthSystemAPIControllersDeviceDailyReportsResponsesCreateDeviceDailyReportResponse` OK
     * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
     * @response `401` `void` Unauthorized
     * @response `403` `HSAPIHostingApiResponseApiErrorResult` Forbidden
     * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
     * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
     */
    deviceDailyReportsCreate: (
      { farmId }: DeviceDailyReportsCreateParams,
      data: DeviceDailyReportsCreatePayload,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemAPIControllersDeviceDailyReportsResponsesCreateDeviceDailyReportResponse,
        HSAPIHostingApiResponseApiErrorResult | void
      >({
        path: `/farms/${farmId}/device-daily-reports`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DeviceDailyReports
     * @name DeviceDailyReportsGetByFarm
     * @request GET:/farms/{farmId}/device-daily-reports
     * @secure
     * @response `200` `(HealthSystemAPIControllersDeviceDailyReportsResponsesDeviceDailyReportResponse)[]` OK
     * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
     * @response `401` `void` Unauthorized
     * @response `403` `HSAPIHostingApiResponseApiErrorResult` Forbidden
     * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
     */
    deviceDailyReportsGetByFarm: (
      { farmId }: DeviceDailyReportsGetByFarmParams,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemAPIControllersDeviceDailyReportsResponsesDeviceDailyReportResponse[],
        HSAPIHostingApiResponseApiErrorResult | void
      >({
        path: `/farms/${farmId}/device-daily-reports`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  diseases = {
    /**
     * No description
     *
     * @tags Diseases
     * @name DiseasesCreateDisease
     * @request POST:/diseases
     * @secure
     * @response `200` `string` OK
     * @response `401` `void` Unauthorized
     */
    diseasesCreateDisease: (
      data: HealthSystemDomainDiseasesCommandsCreateDiseaseCommand,
      params: RequestParams = {},
    ) =>
      this.request<string, void>({
        path: `/diseases`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Diseases
     * @name DiseasesDiseasesSearch
     * @request GET:/diseases
     * @secure
     * @response `200` `HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainDiseasesDiseaseViewModel` OK
     * @response `401` `void` Unauthorized
     */
    diseasesDiseasesSearch: (
      query: DiseasesDiseasesSearchParams = {},
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainDiseasesDiseaseViewModel,
        void
      >({
        path: `/diseases`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Diseases
     * @name DiseasesGetAllDiseases
     * @request GET:/diseases/all
     * @secure
     * @response `200` `(HealthSystemDomainDiseasesDiseaseViewModel)[]` OK
     * @response `401` `void` Unauthorized
     */
    diseasesGetAllDiseases: (
      query: DiseasesGetAllDiseasesParams = {},
      params: RequestParams = {},
    ) =>
      this.request<HealthSystemDomainDiseasesDiseaseViewModel[], void>({
        path: `/diseases/all`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Diseases
     * @name DiseasesRemoveDisease
     * @request DELETE:/diseases
     * @secure
     * @response `200` `string` OK
     * @response `401` `void` Unauthorized
     */
    diseasesRemoveDisease: (
      data: HealthSystemDomainDiseasesCommandsRemoveDiseaseCommand,
      params: RequestParams = {},
    ) =>
      this.request<string, void>({
        path: `/diseases`,
        method: "DELETE",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),
  };
  documents = {
    /**
     * No description
     *
     * @tags Documents
     * @name DocumentsCreateAnimalChipNumbersExport
     * @request POST:/export/animals/chip-numbers
     * @secure
     * @response `200` `boolean` OK
     * @response `401` `void` Unauthorized
     */
    documentsCreateAnimalChipNumbersExport: (
      data: HealthSystemAPIControllersDocumentsRequestsExportAnimalsByChipNumbersRequest,
      params: RequestParams = {},
    ) =>
      this.request<boolean, void>({
        path: `/export/animals/chip-numbers`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name DocumentsCreateAnimalSearchExport
     * @request POST:/export/animals
     * @secure
     * @response `200` `boolean` OK
     * @response `401` `void` Unauthorized
     */
    documentsCreateAnimalSearchExport: (
      data: HealthSystemDomainAnimalsCommandsExportAnimalSearchCommand,
      params: RequestParams = {},
    ) =>
      this.request<boolean, void>({
        path: `/export/animals`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name DocumentsCreateLivestockBalanceCardExport
     * @request POST:/export/livestock-balance-card
     * @secure
     * @response `200` `boolean` OK
     * @response `401` `void` Unauthorized
     */
    documentsCreateLivestockBalanceCardExport: (
      data: HealthSystemAPIControllersDocumentsRequestsExportLivestockBalanceCardRequest,
      params: RequestParams = {},
    ) =>
      this.request<boolean, void>({
        path: `/export/livestock-balance-card`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name DocumentsDeleteFarmDocument
     * @request DELETE:/documents
     * @secure
     * @response `200` `string` OK
     * @response `401` `void` Unauthorized
     */
    documentsDeleteFarmDocument: (
      data: HealthSystemDomainDocumentsCommandsDeleteFarmDocumentCommand,
      params: RequestParams = {},
    ) =>
      this.request<string, void>({
        path: `/documents`,
        method: "DELETE",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name DocumentsDownloadExportDocument
     * @request GET:/export/animals
     * @secure
     * @response `200` `File` OK
     * @response `401` `void` Unauthorized
     */
    documentsDownloadExportDocument: (
      query: DocumentsDownloadExportDocumentParams = {},
      params: RequestParams = {},
    ) =>
      this.request<File, void>({
        path: `/export/animals`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Documents
     * @name DocumentsSearchDocuments
     * @request GET:/documents
     * @secure
     * @response `200` `HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainDocumentsResultFarmDocumentViewModel` OK
     * @response `401` `void` Unauthorized
     */
    documentsSearchDocuments: (
      query: DocumentsSearchDocumentsParams = {},
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainDocumentsResultFarmDocumentViewModel,
        void
      >({
        path: `/documents`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  emissionSourceSettings = {
    /**
     * No description
     *
     * @tags EmissionSourceSettings
     * @name EmissionSourceSettingsAddEmissionSourceUsage
     * @request POST:/emission-sources/usage-entries
     * @secure
     * @response `201` `string` Created
     * @response `401` `void` Unauthorized
     */
    emissionSourceSettingsAddEmissionSourceUsage: (
      data: HealthSystemDomainEmissionSourceUsageEntriesCommandHandlersAddEmissionSourceUsageEntryCommand,
      params: RequestParams = {},
    ) =>
      this.request<string, void>({
        path: `/emission-sources/usage-entries`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags EmissionSourceSettings
     * @name EmissionSourceSettingsCreateEmissionSource
     * @summary Create a new emission source.
     * @request POST:/emission-sources/settings
     * @secure
     * @response `200` `string` OK
     * @response `401` `void` Unauthorized
     */
    emissionSourceSettingsCreateEmissionSource: (
      data: HealthSystemDomainEmissionSourcesCommandHandlersCreateEmissionSourceCommand,
      params: RequestParams = {},
    ) =>
      this.request<string, void>({
        path: `/emission-sources/settings`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags EmissionSourceSettings
     * @name EmissionSourceSettingsDelete
     * @summary Delete an emission source by ID.
     * @request DELETE:/emission-sources/settings
     * @secure
     * @response `204` `void` No Content
     * @response `401` `void` Unauthorized
     */
    emissionSourceSettingsDelete: (
      data: HealthSystemDomainEmissionSourcesCommandHandlersDeleteEmissionSourceCommand,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/emission-sources/settings`,
        method: "DELETE",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags EmissionSourceSettings
     * @name EmissionSourceSettingsDeleteEmissionSourceUsageEntry
     * @request DELETE:/emission-sources/usage-entries
     * @secure
     * @response `204` `string` No Content
     * @response `401` `void` Unauthorized
     */
    emissionSourceSettingsDeleteEmissionSourceUsageEntry: (
      data: HealthSystemDomainEmissionSourceUsageEntriesCommandHandlersDeleteEmissionSourceUsageEntryCommand,
      params: RequestParams = {},
    ) =>
      this.request<string, void>({
        path: `/emission-sources/usage-entries`,
        method: "DELETE",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags EmissionSourceSettings
     * @name EmissionSourceSettingsGet
     * @request GET:/emission-sources/usage-entries
     * @secure
     * @response `200` `HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainEmissionSourceUsageEntriesViewModelsEmissionSourceUsageEntryViewModel` OK
     * @response `401` `void` Unauthorized
     */
    emissionSourceSettingsGet: (
      query: EmissionSourceSettingsGetParams = {},
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainEmissionSourceUsageEntriesViewModelsEmissionSourceUsageEntryViewModel,
        void
      >({
        path: `/emission-sources/usage-entries`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags EmissionSourceSettings
     * @name EmissionSourceSettingsGetAll
     * @summary Get all emission sources with pagination.
     * @request GET:/emission-sources/settings
     * @secure
     * @response `200` `HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainEmissionSourcesViewModelsEmissionSourceViewModel` OK
     * @response `401` `void` Unauthorized
     */
    emissionSourceSettingsGetAll: (
      query: EmissionSourceSettingsGetAllParams = {},
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainEmissionSourcesViewModelsEmissionSourceViewModel,
        void
      >({
        path: `/emission-sources/settings`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags EmissionSourceSettings
     * @name EmissionSourceSettingsUpdateEmissionSource
     * @summary Update an existing emission source.
     * @request PUT:/emission-sources/settings
     * @secure
     * @response `204` `void` No Content
     * @response `401` `void` Unauthorized
     */
    emissionSourceSettingsUpdateEmissionSource: (
      data: HealthSystemDomainEmissionSourcesCommandHandlersUpdateEmissionSourceCommand,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/emission-sources/settings`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags EmissionSourceSettings
     * @name EmissionSourceSettingsUpdateEmissionSourceUsage
     * @request PUT:/emission-sources/usage-entries
     * @secure
     * @response `204` `string` No Content
     * @response `401` `void` Unauthorized
     */
    emissionSourceSettingsUpdateEmissionSourceUsage: (
      data: HealthSystemDomainEmissionSourceUsageEntriesCommandHandlersUpdateEmissionSourceUsageEntryCommand,
      params: RequestParams = {},
    ) =>
      this.request<string, void>({
        path: `/emission-sources/usage-entries`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),
  };
  farmConfigurationProviders = {
    /**
     * No description
     *
     * @tags FarmConfigurationProviders
     * @name FarmConfigurationProvidersDisable
     * @request POST:/farms/{farmId}/configuration-providers/{type}/disable
     * @secure
     * @response `204` `void` No Content
     * @response `401` `void` Unauthorized
     * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
     * @response `409` `HSAPIHostingApiResponseApiErrorResult` Conflict
     * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
     */
    farmConfigurationProvidersDisable: (
      { farmId, type }: FarmConfigurationProvidersDisableParams,
      params: RequestParams = {},
    ) =>
      this.request<void, void | HSAPIHostingApiResponseApiErrorResult>({
        path: `/farms/${farmId}/configuration-providers/${type}/disable`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags FarmConfigurationProviders
     * @name FarmConfigurationProvidersEnable
     * @request POST:/farms/{farmId}/configuration-providers/{type}/enable
     * @secure
     * @response `204` `void` No Content
     * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
     * @response `401` `void` Unauthorized
     * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
     * @response `409` `HSAPIHostingApiResponseApiErrorResult` Conflict
     * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
     */
    farmConfigurationProvidersEnable: (
      { farmId, type }: FarmConfigurationProvidersEnableParams,
      params: RequestParams = {},
    ) =>
      this.request<void, HSAPIHostingApiResponseApiErrorResult | void>({
        path: `/farms/${farmId}/configuration-providers/${type}/enable`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags FarmConfigurationProviders
     * @name FarmConfigurationProvidersGetAll
     * @request GET:/farms/{farmId}/configuration-providers
     * @secure
     * @response `200` `(HealthSystemAPIControllersFarmConfigurationProvidersResponsesFarmConfigurationProviderResponse)[]` OK
     * @response `401` `void` Unauthorized
     * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
     */
    farmConfigurationProvidersGetAll: (
      { farmId }: FarmConfigurationProvidersGetAllParams,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemAPIControllersFarmConfigurationProvidersResponsesFarmConfigurationProviderResponse[],
        void | HSAPIHostingApiResponseApiErrorResult
      >({
        path: `/farms/${farmId}/configuration-providers`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FarmConfigurationProviders
     * @name FarmConfigurationProvidersUpsert
     * @request PUT:/farms/{farmId}/configuration-providers/{type}
     * @secure
     * @response `204` `void` No Content
     * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
     * @response `401` `void` Unauthorized
     * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
     */
    farmConfigurationProvidersUpsert: (
      { farmId, type }: FarmConfigurationProvidersUpsertParams,
      data: HealthSystemAPIControllersFarmConfigurationProvidersRequestsUpsertFarmConfigurationProviderRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, HSAPIHostingApiResponseApiErrorResult | void>({
        path: `/farms/${farmId}/configuration-providers/${type}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),
  };
  farms = {
    /**
     * No description
     *
     * @tags Farms
     * @name FarmsCreateFarm
     * @request POST:/farms
     * @secure
     * @response `200` `string` OK
     * @response `401` `void` Unauthorized
     */
    farmsCreateFarm: (
      data: HealthSystemDomainFarmsCommandsCreateFarmCommand,
      params: RequestParams = {},
    ) =>
      this.request<string, void>({
        path: `/farms`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Farms
     * @name FarmsGetCurrentUserFarm
     * @request GET:/farms/current-user
     * @secure
     * @response `200` `HealthSystemDomainFarmsResultFarmViewModel` OK
     * @response `401` `void` Unauthorized
     */
    farmsGetCurrentUserFarm: (params: RequestParams = {}) =>
      this.request<HealthSystemDomainFarmsResultFarmViewModel, void>({
        path: `/farms/current-user`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Farms
     * @name FarmsGetFarms
     * @request GET:/farms
     * @secure
     * @response `200` `HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainFarmsResultFarmViewModel` OK
     * @response `401` `void` Unauthorized
     */
    farmsGetFarms: (
      query: FarmsGetFarmsParams = {},
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainFarmsResultFarmViewModel,
        void
      >({
        path: `/farms`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Farms
     * @name FarmsUpdateFarm
     * @request PUT:/farms
     * @secure
     * @response `200` `string` OK
     * @response `401` `void` Unauthorized
     */
    farmsUpdateFarm: (
      data: HealthSystemDomainFarmsCommandsUpdateFarmCommand,
      params: RequestParams = {},
    ) =>
      this.request<string, void>({
        path: `/farms`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),
  };
  feedConversion = {
    /**
     * No description
     *
     * @tags FeedConversion
     * @name FeedConversionGetFeedConversion
     * @request GET:/feed-conversions
     * @secure
     * @response `200` `HealthSystemAPIControllersFeedResponsesGetFeedConversionResponse` OK
     * @response `401` `void` Unauthorized
     * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
     */
    feedConversionGetFeedConversion: (
      query: FeedConversionGetFeedConversionParams = {},
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemAPIControllersFeedResponsesGetFeedConversionResponse,
        void | HSAPIHostingApiResponseApiErrorResult
      >({
        path: `/feed-conversions`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  feedRegistrations = {
    /**
     * No description
     *
     * @tags FeedRegistrations
     * @name FeedRegistrationsCreate
     * @request POST:/farms/{farmId}/feed-registrations
     * @secure
     * @response `200` `(HealthSystemAPIControllersFeedSupplyResponsesFeedRegistrationResponse)[]` OK
     * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
     * @response `401` `void` Unauthorized
     * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
     */
    feedRegistrationsCreate: (
      { farmId }: FeedRegistrationsCreateParams,
      data: HealthSystemAPIControllersFeedSupplyRequestsCreateFeedRegistrationRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemAPIControllersFeedSupplyResponsesFeedRegistrationResponse[],
        HSAPIHostingApiResponseApiErrorResult | void
      >({
        path: `/farms/${farmId}/feed-registrations`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FeedRegistrations
     * @name FeedRegistrationsDelete
     * @request DELETE:/farms/{farmId}/feed-registrations/{registrationId}
     * @secure
     * @response `204` `void` No Content
     * @response `401` `void` Unauthorized
     * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
     */
    feedRegistrationsDelete: (
      { farmId, registrationId }: FeedRegistrationsDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<void, void | HSAPIHostingApiResponseApiErrorResult>({
        path: `/farms/${farmId}/feed-registrations/${registrationId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags FeedRegistrations
     * @name FeedRegistrationsGet
     * @request GET:/farms/{farmId}/feed-registrations
     * @secure
     * @response `200` `HealthSystemAPIControllersFeedSupplyResponsesFeedRegistrationsPageResponse` OK
     * @response `401` `void` Unauthorized
     */
    feedRegistrationsGet: (
      { farmId, ...query }: FeedRegistrationsGetParams,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemAPIControllersFeedSupplyResponsesFeedRegistrationsPageResponse,
        void
      >({
        path: `/farms/${farmId}/feed-registrations`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FeedRegistrations
     * @name FeedRegistrationsUpdate
     * @request PUT:/farms/{farmId}/feed-registrations/{registrationId}
     * @secure
     * @response `200` `HealthSystemAPIControllersFeedSupplyResponsesFeedRegistrationResponse` OK
     * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
     * @response `401` `void` Unauthorized
     * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
     */
    feedRegistrationsUpdate: (
      { farmId, registrationId }: FeedRegistrationsUpdateParams,
      data: HealthSystemAPIControllersFeedSupplyRequestsUpdateFeedRegistrationRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemAPIControllersFeedSupplyResponsesFeedRegistrationResponse,
        HSAPIHostingApiResponseApiErrorResult | void
      >({
        path: `/farms/${farmId}/feed-registrations/${registrationId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),
  };
  feedSilos = {
    /**
     * No description
     *
     * @tags FeedSilos
     * @name FeedSilosCreate
     * @request POST:/farms/{farmId}/feed-silos
     * @secure
     * @response `200` `HealthSystemDomainFeedSupplyCommandsCreateFeedSiloResult` OK
     * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
     * @response `401` `void` Unauthorized
     * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
     * @response `409` `HSAPIHostingApiResponseApiErrorResult` Conflict
     */
    feedSilosCreate: (
      { farmId }: FeedSilosCreateParams,
      data: HealthSystemAPIControllersFeedSupplyRequestsCreateFeedSiloRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainFeedSupplyCommandsCreateFeedSiloResult,
        HSAPIHostingApiResponseApiErrorResult | void
      >({
        path: `/farms/${farmId}/feed-silos`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FeedSilos
     * @name FeedSilosCreateBatch
     * @request POST:/farms/{farmId}/feed-silos/{siloId}/batches
     * @secure
     * @response `200` `HealthSystemDomainFeedSupplyCommandsCreateFeedBatchResult` OK
     * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
     * @response `401` `void` Unauthorized
     * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
     */
    feedSilosCreateBatch: (
      { farmId, siloId }: FeedSilosCreateBatchParams,
      data: HealthSystemAPIControllersFeedSupplyRequestsCreateFeedBatchRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainFeedSupplyCommandsCreateFeedBatchResult,
        HSAPIHostingApiResponseApiErrorResult | void
      >({
        path: `/farms/${farmId}/feed-silos/${siloId}/batches`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FeedSilos
     * @name FeedSilosDelete
     * @request DELETE:/farms/{farmId}/feed-silos/{siloId}
     * @secure
     * @response `204` `void` No Content
     * @response `401` `void` Unauthorized
     * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
     */
    feedSilosDelete: (
      { farmId, siloId }: FeedSilosDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<void, void | HSAPIHostingApiResponseApiErrorResult>({
        path: `/farms/${farmId}/feed-silos/${siloId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags FeedSilos
     * @name FeedSilosDeleteBatch
     * @request DELETE:/farms/{farmId}/feed-silos/{siloId}/batches/{batchId}
     * @secure
     * @response `204` `void` No Content
     * @response `401` `void` Unauthorized
     * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
     */
    feedSilosDeleteBatch: (
      { farmId, siloId, batchId }: FeedSilosDeleteBatchParams,
      params: RequestParams = {},
    ) =>
      this.request<void, void | HSAPIHostingApiResponseApiErrorResult>({
        path: `/farms/${farmId}/feed-silos/${siloId}/batches/${batchId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags FeedSilos
     * @name FeedSilosGetBatches
     * @request GET:/farms/{farmId}/feed-silos/{siloId}/batches
     * @secure
     * @response `200` `HealthSystemDomainFeedSupplyQueriesGetFeedBatchesResult` OK
     * @response `401` `void` Unauthorized
     * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
     */
    feedSilosGetBatches: (
      { farmId, siloId, ...query }: FeedSilosGetBatchesParams,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainFeedSupplyQueriesGetFeedBatchesResult,
        void | HSAPIHostingApiResponseApiErrorResult
      >({
        path: `/farms/${farmId}/feed-silos/${siloId}/batches`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FeedSilos
     * @name FeedSilosGetByFarm
     * @request GET:/farms/{farmId}/feed-silos
     * @secure
     * @response `200` `(HealthSystemAPIControllersFeedSupplyResponsesFeedSiloResponse)[]` OK
     * @response `401` `void` Unauthorized
     */
    feedSilosGetByFarm: (
      { farmId }: FeedSilosGetByFarmParams,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemAPIControllersFeedSupplyResponsesFeedSiloResponse[],
        void
      >({
        path: `/farms/${farmId}/feed-silos`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FeedSilos
     * @name FeedSilosUpdate
     * @request PUT:/farms/{farmId}/feed-silos/{siloId}
     * @secure
     * @response `200` `HealthSystemDomainFeedSupplyCommandsUpdateFeedSiloResult` OK
     * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
     * @response `401` `void` Unauthorized
     * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
     * @response `409` `HSAPIHostingApiResponseApiErrorResult` Conflict
     */
    feedSilosUpdate: (
      { farmId, siloId }: FeedSilosUpdateParams,
      data: HealthSystemAPIControllersFeedSupplyRequestsUpdateFeedSiloRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainFeedSupplyCommandsUpdateFeedSiloResult,
        HSAPIHostingApiResponseApiErrorResult | void
      >({
        path: `/farms/${farmId}/feed-silos/${siloId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FeedSilos
     * @name FeedSilosUpdateBatch
     * @request PUT:/farms/{farmId}/feed-silos/{siloId}/batches/{batchId}
     * @secure
     * @response `200` `HealthSystemDomainFeedSupplyCommandsUpdateFeedBatchResult` OK
     * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
     * @response `401` `void` Unauthorized
     * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
     */
    feedSilosUpdateBatch: (
      { farmId, siloId, batchId }: FeedSilosUpdateBatchParams,
      data: HealthSystemAPIControllersFeedSupplyRequestsUpdateFeedBatchRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainFeedSupplyCommandsUpdateFeedBatchResult,
        HSAPIHostingApiResponseApiErrorResult | void
      >({
        path: `/farms/${farmId}/feed-silos/${siloId}/batches/${batchId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),
  };
  feedSupplier = {
    /**
     * No description
     *
     * @tags FeedSupplier
     * @name FeedSupplierGetFeedSuppliers
     * @request GET:/feed-supplier
     * @secure
     * @response `200` `HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainFeedFeedSuppliersFeedSupplierViewModel` OK
     * @response `401` `void` Unauthorized
     */
    feedSupplierGetFeedSuppliers: (
      query: FeedSupplierGetFeedSuppliersParams = {},
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainFeedFeedSuppliersFeedSupplierViewModel,
        void
      >({
        path: `/feed-supplier`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  feedSuppliers = {
    /**
     * No description
     *
     * @tags FeedSuppliers
     * @name FeedSuppliersCreate
     * @request POST:/feed-suppliers
     * @secure
     * @response `200` `HealthSystemDomainFeedSupplyCommandsCreateFeedSupplierResult` OK
     * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
     * @response `401` `void` Unauthorized
     */
    feedSuppliersCreate: (
      data: HealthSystemAPIControllersFeedSupplyRequestsCreateFeedSupplierRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainFeedSupplyCommandsCreateFeedSupplierResult,
        HSAPIHostingApiResponseApiErrorResult | void
      >({
        path: `/feed-suppliers`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FeedSuppliers
     * @name FeedSuppliersDelete
     * @request DELETE:/feed-suppliers/{id}
     * @secure
     * @response `204` `void` No Content
     * @response `401` `void` Unauthorized
     * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
     */
    feedSuppliersDelete: (
      { id }: FeedSuppliersDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<void, void | HSAPIHostingApiResponseApiErrorResult>({
        path: `/feed-suppliers/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags FeedSuppliers
     * @name FeedSuppliersGetAll
     * @request GET:/feed-suppliers
     * @secure
     * @response `200` `HealthSystemDomainFeedSupplyQueriesGetFeedSuppliersResult` OK
     * @response `401` `void` Unauthorized
     */
    feedSuppliersGetAll: (
      query: FeedSuppliersGetAllParams = {},
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainFeedSupplyQueriesGetFeedSuppliersResult,
        void
      >({
        path: `/feed-suppliers`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FeedSuppliers
     * @name FeedSuppliersUpdate
     * @request PUT:/feed-suppliers/{id}
     * @secure
     * @response `200` `HealthSystemDomainFeedSupplyCommandsUpdateFeedSupplierResult` OK
     * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
     * @response `401` `void` Unauthorized
     * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
     */
    feedSuppliersUpdate: (
      { id }: FeedSuppliersUpdateParams,
      data: HealthSystemAPIControllersFeedSupplyRequestsUpdateFeedSupplierRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainFeedSupplyCommandsUpdateFeedSupplierResult,
        HSAPIHostingApiResponseApiErrorResult | void
      >({
        path: `/feed-suppliers/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),
  };
  import = {
    /**
     * No description
     *
     * @tags Import
     * @name ImportDownloadCsvExample
     * @summary Downloads a sample CSV file template for animal import
     * @request GET:/import/csv-example
     * @secure
     * @response `200` `void` OK
     * @response `401` `void` Unauthorized
     */
    importDownloadCsvExample: (
      query: ImportDownloadCsvExampleParams = {},
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/import/csv-example`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Import
     * @name ImportGetCsvExampleFormats
     * @summary Gets available CSV example formats
     * @request GET:/import/csv-examples
     * @secure
     * @response `200` `HealthSystemDomainImportResultCsvExampleFormatsResponse` OK
     * @response `401` `void` Unauthorized
     */
    importGetCsvExampleFormats: (params: RequestParams = {}) =>
      this.request<
        HealthSystemDomainImportResultCsvExampleFormatsResponse,
        void
      >({
        path: `/import/csv-examples`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Import
     * @name ImportGetImportDocumentation
     * @summary Gets the animal import documentation for display in the UI
     * @request GET:/import/documentation
     * @secure
     * @response `200` `HealthSystemDomainImportResultImportDocumentationResponse` OK
     * @response `401` `void` Unauthorized
     */
    importGetImportDocumentation: (params: RequestParams = {}) =>
      this.request<
        HealthSystemDomainImportResultImportDocumentationResponse,
        void
      >({
        path: `/import/documentation`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Import
     * @name ImportImportAnimals
     * @request POST:/import
     * @secure
     * @response `200` `HealthSystemDomainImportResultImportDataFromCsvFileResult` OK
     * @response `401` `void` Unauthorized
     */
    importImportAnimals: (
      data: ImportImportAnimalsPayload,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainImportResultImportDataFromCsvFileResult,
        void
      >({
        path: `/import`,
        method: "POST",
        body: data,
        secure: true,
        type: "multipart/form-data",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Import
     * @name ImportValidateAnimals
     * @request POST:/import/validate
     * @secure
     * @response `200` `HealthSystemDomainImportResultImportDataFromCsvFileResult` OK
     * @response `401` `void` Unauthorized
     */
    importValidateAnimals: (
      data: ImportValidateAnimalsPayload,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainImportResultImportDataFromCsvFileResult,
        void
      >({
        path: `/import/validate`,
        method: "POST",
        body: data,
        secure: true,
        type: "multipart/form-data",
        format: "json",
        ...params,
      }),
  };
  injections = {
    /**
     * No description
     *
     * @tags Injections
     * @name InjectionsCreateInjectionRecord
     * @request POST:/injections/register
     * @secure
     * @response `200` `HealthSystemDomainCommonResultEntityBatchResult` OK
     * @response `401` `void` Unauthorized
     */
    injectionsCreateInjectionRecord: (
      data: HealthSystemDomainInjectionsCommandsCreateInjectionCommand,
      params: RequestParams = {},
    ) =>
      this.request<HealthSystemDomainCommonResultEntityBatchResult, void>({
        path: `/injections/register`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Injections
     * @name InjectionsCreateInjectionRecordBatch
     * @request POST:/injections/register-batch
     * @secure
     * @response `200` `HealthSystemDomainCommonResultEntityBatchResult` OK
     * @response `401` `void` Unauthorized
     */
    injectionsCreateInjectionRecordBatch: (
      data: HealthSystemDomainInjectionsCommandsCreateInjectionsBatchCommand,
      params: RequestParams = {},
    ) =>
      this.request<HealthSystemDomainCommonResultEntityBatchResult, void>({
        path: `/injections/register-batch`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Injections
     * @name InjectionsCreateOralFeedInjectionRecord
     * @request POST:/injections/oralfeed
     * @secure
     * @response `200` `(string)[]` OK
     * @response `401` `void` Unauthorized
     */
    injectionsCreateOralFeedInjectionRecord: (
      data: HealthSystemDomainInjectionsCommandsCreateOralFeedInjectionCommand,
      params: RequestParams = {},
    ) =>
      this.request<string[], void>({
        path: `/injections/oralfeed`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Injections
     * @name InjectionsCreateOralFeedInjectionRecordByLocation
     * @request POST:/injections/oralfeed/location/{locationId}
     * @secure
     * @response `200` `HealthSystemAPIControllersInjectionsResponsesCreateLocationOralFeedInjectionResponse` OK
     * @response `401` `void` Unauthorized
     */
    injectionsCreateOralFeedInjectionRecordByLocation: (
      { locationId }: InjectionsCreateOralFeedInjectionRecordByLocationParams,
      data: HealthSystemAPIControllersInjectionsRequestsCreateLocationOralFeedInjectionRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemAPIControllersInjectionsResponsesCreateLocationOralFeedInjectionResponse,
        void
      >({
        path: `/injections/oralfeed/location/${locationId}`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Injections
     * @name InjectionsCreateVaccinationInjectionRecordByLocation
     * @request POST:/injections/vaccination/location/{locationId}
     * @secure
     * @response `200` `HealthSystemAPIControllersInjectionsResponsesCreateLocationVaccinationInjectionResponse` OK
     * @response `401` `void` Unauthorized
     */
    injectionsCreateVaccinationInjectionRecordByLocation: (
      {
        locationId,
      }: InjectionsCreateVaccinationInjectionRecordByLocationParams,
      data: HealthSystemAPIControllersInjectionsRequestsCreateLocationVaccinationInjectionRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemAPIControllersInjectionsResponsesCreateLocationVaccinationInjectionResponse,
        void
      >({
        path: `/injections/vaccination/location/${locationId}`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Injections
     * @name InjectionsGetInjectionAgeTrendData
     * @request GET:/injections/age-trend-data
     * @secure
     * @response `200` `HealthSystemAPIControllersInjectionsResponsesInjectionHistoryAgeTrendDataResponse` OK
     * @response `401` `void` Unauthorized
     */
    injectionsGetInjectionAgeTrendData: (
      query: InjectionsGetInjectionAgeTrendDataParams = {},
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemAPIControllersInjectionsResponsesInjectionHistoryAgeTrendDataResponse,
        void
      >({
        path: `/injections/age-trend-data`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Injections
     * @name InjectionsGetInjectionStrategy
     * @request GET:/injections/strategy
     * @secure
     * @response `200` `HealthSystemDomainInjectionsResultInjectionHistoryStrategyViewModel` OK
     * @response `401` `void` Unauthorized
     */
    injectionsGetInjectionStrategy: (
      query: InjectionsGetInjectionStrategyParams = {},
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainInjectionsResultInjectionHistoryStrategyViewModel,
        void
      >({
        path: `/injections/strategy`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Injections
     * @name InjectionsGetInjectionTrendData
     * @request GET:/injections/trend-data
     * @secure
     * @response `200` `HealthSystemDomainInjectionsResultInjectionHistoryTrendDataViewModel` OK
     * @response `401` `void` Unauthorized
     */
    injectionsGetInjectionTrendData: (
      query: InjectionsGetInjectionTrendDataParams = {},
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainInjectionsResultInjectionHistoryTrendDataViewModel,
        void
      >({
        path: `/injections/trend-data`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Injections
     * @name InjectionsGetLocationInjectionStrategy
     * @request GET:/injections/location/{locationId}/strategy
     * @secure
     * @response `200` `HealthSystemAPIControllersInjectionsResponsesInjectionHistoryLocationStrategyResponse` OK
     * @response `401` `void` Unauthorized
     */
    injectionsGetLocationInjectionStrategy: (
      { locationId, ...query }: InjectionsGetLocationInjectionStrategyParams,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemAPIControllersInjectionsResponsesInjectionHistoryLocationStrategyResponse,
        void
      >({
        path: `/injections/location/${locationId}/strategy`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Injections
     * @name InjectionsQueryInjectionHistories
     * @request GET:/injections
     * @secure
     * @response `200` `HealthSystemDomainInjectionsResultInjectionHistoryQueryResult` OK
     * @response `401` `void` Unauthorized
     */
    injectionsQueryInjectionHistories: (
      query: InjectionsQueryInjectionHistoriesParams,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainInjectionsResultInjectionHistoryQueryResult,
        void
      >({
        path: `/injections`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  labelPrint = {
    /**
     * No description
     *
     * @tags LabelPrint
     * @name LabelPrintGetLabelPrintTasks
     * @request GET:/labelprint/tasks
     * @secure
     * @response `200` `HealthSystemDomainCommonQueryResultPageableResultHealthSystemDALModelMedicalSuppliesLabelPrintTask` OK
     * @response `401` `void` Unauthorized
     */
    labelPrintGetLabelPrintTasks: (
      query: LabelPrintGetLabelPrintTasksParams = {},
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainCommonQueryResultPageableResultHealthSystemDALModelMedicalSuppliesLabelPrintTask,
        void
      >({
        path: `/labelprint/tasks`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags LabelPrint
     * @name LabelPrintUpdateLabelPrintTaskStatus
     * @request PUT:/labelprint/tasks
     * @secure
     * @response `200` `string` OK
     * @response `401` `void` Unauthorized
     */
    labelPrintUpdateLabelPrintTaskStatus: (
      data: HealthSystemDomainMedicalSuppliesQueryUpdateLabelPrintTaskStatusCommand,
      params: RequestParams = {},
    ) =>
      this.request<string, void>({
        path: `/labelprint/tasks`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),
  };
  locationCycles = {
    /**
     * No description
     *
     * @tags LocationCycles
     * @name LocationCyclesCreateLocationCycles
     * @request POST:/location-cycles
     * @deprecated
     * @secure
     * @response `200` `HealthSystemDomainCommonResultEntityBatchResult` OK
     * @response `401` `void` Unauthorized
     */
    locationCyclesCreateLocationCycles: (
      data: HealthSystemDomainLocationCyclesCreateLocationCyclesCommand,
      params: RequestParams = {},
    ) =>
      this.request<HealthSystemDomainCommonResultEntityBatchResult, void>({
        path: `/location-cycles`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags LocationCycles
     * @name LocationCyclesGetLocationCycleAnimals
     * @request GET:/location-cycles/animals
     * @deprecated
     * @secure
     * @response `200` `(HealthSystemDomainLocationCyclesResultLocationCycleAnimalViewModel)[]` OK
     * @response `401` `void` Unauthorized
     */
    locationCyclesGetLocationCycleAnimals: (
      query: LocationCyclesGetLocationCycleAnimalsParams = {},
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainLocationCyclesResultLocationCycleAnimalViewModel[],
        void
      >({
        path: `/location-cycles/animals`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags LocationCycles
     * @name LocationCyclesGetLocationCycles
     * @request GET:/location-cycles
     * @deprecated
     * @secure
     * @response `200` `HealthSystemDomainLocationCyclesResultLocationCyclesSearchPageableQueryResult` OK
     * @response `401` `void` Unauthorized
     */
    locationCyclesGetLocationCycles: (
      query: LocationCyclesGetLocationCyclesParams = {},
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainLocationCyclesResultLocationCyclesSearchPageableQueryResult,
        void
      >({
        path: `/location-cycles`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  locations = {
    /**
     * No description
     *
     * @tags Locations
     * @name LocationsAnimalDiedByLocation
     * @request PUT:/locations/died
     * @secure
     * @response `200` `string` OK
     * @response `401` `void` Unauthorized
     */
    locationsAnimalDiedByLocation: (
      data: HealthSystemDomainLocationsCommandsDiedLocationAnimalCommand,
      params: RequestParams = {},
    ) =>
      this.request<string, void>({
        path: `/locations/died`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Locations
     * @name LocationsCreateLocation
     * @request POST:/locations
     * @secure
     * @response `200` `HealthSystemDomainCommonResultEntityBatchResult` OK
     * @response `401` `void` Unauthorized
     */
    locationsCreateLocation: (
      data: HealthSystemDomainLocationsCommandsCreateLocationCommand,
      params: RequestParams = {},
    ) =>
      this.request<HealthSystemDomainCommonResultEntityBatchResult, void>({
        path: `/locations`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Locations
     * @name LocationsGetLocationAnimals
     * @request GET:/locations/animals
     * @secure
     * @response `200` `HealthSystemDomainLocationsResultLocationAnimalsResult` OK
     * @response `401` `void` Unauthorized
     */
    locationsGetLocationAnimals: (
      query: LocationsGetLocationAnimalsParams = {},
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainLocationsResultLocationAnimalsResult,
        void
      >({
        path: `/locations/animals`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Locations
     * @name LocationsGetLocationHistory
     * @request GET:/locations/{id}/history
     * @secure
     * @response `200` `HealthSystemAPIControllersLocationsResponsesLocationHistoryResponse` OK
     * @response `401` `void` Unauthorized
     * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
     * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
     */
    locationsGetLocationHistory: (
      { id, ...query }: LocationsGetLocationHistoryParams,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemAPIControllersLocationsResponsesLocationHistoryResponse,
        void | HSAPIHostingApiResponseApiErrorResult
      >({
        path: `/locations/${id}/history`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Locations
     * @name LocationsGetLocationsHierarchy
     * @request GET:/locations/hierarchy
     * @secure
     * @response `200` `HealthSystemDomainLocationsResultLocationHierarchyResult` OK
     * @response `401` `void` Unauthorized
     */
    locationsGetLocationsHierarchy: (
      query: LocationsGetLocationsHierarchyParams = {},
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainLocationsResultLocationHierarchyResult,
        void
      >({
        path: `/locations/hierarchy`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Locations
     * @name LocationsSearchLocations
     * @request GET:/locations/search
     * @secure
     * @response `200` `HealthSystemDomainLocationsResultLocationSearchPageableQueryResult` OK
     * @response `401` `void` Unauthorized
     */
    locationsSearchLocations: (
      query: LocationsSearchLocationsParams = {},
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainLocationsResultLocationSearchPageableQueryResult,
        void
      >({
        path: `/locations/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Locations
     * @name LocationsSickAnimal
     * @request PUT:/locations/sick
     * @secure
     * @response `200` `HealthSystemDomainCommonResultEntityBatchResult` OK
     * @response `401` `void` Unauthorized
     */
    locationsSickAnimal: (
      data: HealthSystemDomainLocationsCommandsSickAnimalCommand,
      params: RequestParams = {},
    ) =>
      this.request<HealthSystemDomainCommonResultEntityBatchResult, void>({
        path: `/locations/sick`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Locations
     * @name LocationsUpdateLocation
     * @request PUT:/locations
     * @secure
     * @response `200` `string` OK
     * @response `401` `void` Unauthorized
     */
    locationsUpdateLocation: (
      data: HealthSystemDomainLocationsCommandsUpdateLocationCommand,
      params: RequestParams = {},
    ) =>
      this.request<string, void>({
        path: `/locations`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Locations
     * @name LocationsUpdateLocationCycle
     * @request PUT:/locations/cycle
     * @deprecated
     * @secure
     * @response `200` `(string)[]` OK
     * @response `401` `void` Unauthorized
     */
    locationsUpdateLocationCycle: (
      data: HealthSystemDomainLocationsCommandsUpdateLocationCycleCommand,
      params: RequestParams = {},
    ) =>
      this.request<string[], void>({
        path: `/locations/cycle`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Locations
     * @name LocationsViewClimateLocation
     * @request GET:/locations/climate
     * @secure
     * @response `200` `HealthSystemDomainLocationsModelsLocationClimateViewModel` OK
     * @response `401` `void` Unauthorized
     */
    locationsViewClimateLocation: (
      query: LocationsViewClimateLocationParams = {},
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainLocationsModelsLocationClimateViewModel,
        void
      >({
        path: `/locations/climate`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Locations
     * @name LocationsViewLocation
     * @request GET:/locations
     * @secure
     * @response `200` `HealthSystemDomainLocationsResultLocationViewModel` OK
     * @response `401` `void` Unauthorized
     */
    locationsViewLocation: (
      query: LocationsViewLocationParams = {},
      params: RequestParams = {},
    ) =>
      this.request<HealthSystemDomainLocationsResultLocationViewModel, void>({
        path: `/locations`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  lungWeather = {
    /**
     * @description Scoped to the caller's own farm rather than taking a farm id, like the rest of the farm-facing API. Returns a payload with an empty `stables` list when no peak has been detected yet - that is the normal state for a farm in its first season, not an error.
     *
     * @tags LungWeather
     * @name LungWeatherGetReview
     * @summary The review for one lung disease on the current user's farm: this week's verdict, every stored wind pattern scored against it, and the track record.
     * @request GET:/lung-weather/diseases/{diseaseId}
     * @secure
     * @response `200` `HealthSystemDomainWeatherResultLungWeatherReviewViewModel` OK
     * @response `401` `void` Unauthorized
     * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
     * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
     */
    lungWeatherGetReview: (
      { diseaseId, ...query }: LungWeatherGetReviewParams,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainWeatherResultLungWeatherReviewViewModel,
        void | HSAPIHostingApiResponseApiErrorResult
      >({
        path: `/lung-weather/diseases/${diseaseId}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  medicalSupplies = {
    /**
     * No description
     *
     * @tags MedicalSupplies
     * @name MedicalSuppliesCompleteMedicalSupplyOrder
     * @request POST:/medical-supplies/orders/complete
     * @secure
     * @response `200` `string` OK
     * @response `401` `void` Unauthorized
     */
    medicalSuppliesCompleteMedicalSupplyOrder: (
      data: HealthSystemDomainMedicalSuppliesCommandsCompleteMedicalSupplyOrderCommand,
      params: RequestParams = {},
    ) =>
      this.request<string, void>({
        path: `/medical-supplies/orders/complete`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MedicalSupplies
     * @name MedicalSuppliesConfirmMedicalSupplyOrder
     * @request POST:/medical-supplies/orders/confirm
     * @secure
     * @response `200` `string` OK
     * @response `401` `void` Unauthorized
     */
    medicalSuppliesConfirmMedicalSupplyOrder: (
      data: HealthSystemDomainMedicalSuppliesCommandsMedicalSupplyOrderConfirmCommand,
      params: RequestParams = {},
    ) =>
      this.request<string, void>({
        path: `/medical-supplies/orders/confirm`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MedicalSupplies
     * @name MedicalSuppliesCreateFarmMedicalSupply
     * @request POST:/farm/medical-supplies
     * @secure
     * @response `200` `string` OK
     * @response `401` `void` Unauthorized
     */
    medicalSuppliesCreateFarmMedicalSupply: (
      data: HealthSystemDomainMedicalSuppliesCommandsCreateFarmMedicalSupplyCommand,
      params: RequestParams = {},
    ) =>
      this.request<string, void>({
        path: `/farm/medical-supplies`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MedicalSupplies
     * @name MedicalSuppliesCreateMedicalSupply
     * @request POST:/medical-supplies
     * @secure
     * @response `200` `string` OK
     * @response `401` `void` Unauthorized
     */
    medicalSuppliesCreateMedicalSupply: (
      data: HealthSystemDomainMedicalSuppliesCommandsCreateMedicalSupplyCommand,
      params: RequestParams = {},
    ) =>
      this.request<string, void>({
        path: `/medical-supplies`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MedicalSupplies
     * @name MedicalSuppliesCreateMedicalSupplyBottle
     * @request POST:/medical-supplies/bottles
     * @secure
     * @response `200` `string` OK
     * @response `400` `HealthSystemCommonExceptionsValidationResult` Bad Request
     * @response `401` `void` Unauthorized
     */
    medicalSuppliesCreateMedicalSupplyBottle: (
      data: HealthSystemDomainMedicalSuppliesCommandsCreateMedicalSupplyBottleCommand,
      params: RequestParams = {},
    ) =>
      this.request<string, HealthSystemCommonExceptionsValidationResult | void>(
        {
          path: `/medical-supplies/bottles`,
          method: "POST",
          body: data,
          secure: true,
          type: "application/json",
          format: "json",
          ...params,
        },
      ),

    /**
     * No description
     *
     * @tags MedicalSupplies
     * @name MedicalSuppliesCreateMedicalSupplyOrder
     * @request POST:/medical-supplies/orders
     * @secure
     * @response `200` `string` OK
     * @response `401` `void` Unauthorized
     */
    medicalSuppliesCreateMedicalSupplyOrder: (
      data: HealthSystemDomainMedicalSuppliesCommandsCreateMedicalSupplyOrderCommand,
      params: RequestParams = {},
    ) =>
      this.request<string, void>({
        path: `/medical-supplies/orders`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MedicalSupplies
     * @name MedicalSuppliesDeleteMedicalSupply
     * @request DELETE:/medical-supplies
     * @secure
     * @response `200` `void` OK
     * @response `401` `void` Unauthorized
     */
    medicalSuppliesDeleteMedicalSupply: (
      query: MedicalSuppliesDeleteMedicalSupplyParams = {},
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/medical-supplies`,
        method: "DELETE",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags MedicalSupplies
     * @name MedicalSuppliesGetAllMedicalSupplies
     * @request GET:/medical-supplies/all
     * @secure
     * @response `200` `(HealthSystemDomainMedicalSuppliesResultMedicalSupplyViewModel)[]` OK
     * @response `401` `void` Unauthorized
     */
    medicalSuppliesGetAllMedicalSupplies: (
      query: MedicalSuppliesGetAllMedicalSuppliesParams = {},
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainMedicalSuppliesResultMedicalSupplyViewModel[],
        void
      >({
        path: `/medical-supplies/all`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MedicalSupplies
     * @name MedicalSuppliesGetFarmMedicalSupplies
     * @request GET:/farm/medical-supplies
     * @secure
     * @response `200` `(HealthSystemDomainMedicalSuppliesResultFarmMedicalSupplyViewModel)[]` OK
     * @response `401` `void` Unauthorized
     */
    medicalSuppliesGetFarmMedicalSupplies: (
      query: MedicalSuppliesGetFarmMedicalSuppliesParams = {},
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainMedicalSuppliesResultFarmMedicalSupplyViewModel[],
        void
      >({
        path: `/farm/medical-supplies`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MedicalSupplies
     * @name MedicalSuppliesGetMedicalSupplies
     * @request GET:/medical-supplies
     * @secure
     * @response `200` `HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainMedicalSuppliesResultMedicalSupplyViewModel` OK
     * @response `401` `void` Unauthorized
     */
    medicalSuppliesGetMedicalSupplies: (
      query: MedicalSuppliesGetMedicalSuppliesParams = {},
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainMedicalSuppliesResultMedicalSupplyViewModel,
        void
      >({
        path: `/medical-supplies`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MedicalSupplies
     * @name MedicalSuppliesGetMedicalSupplyBottles
     * @request GET:/medical-supplies/bottles
     * @secure
     * @response `200` `HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainMedicalSuppliesResultMedicalSupplyBottleViewModel` OK
     * @response `401` `void` Unauthorized
     */
    medicalSuppliesGetMedicalSupplyBottles: (
      query: MedicalSuppliesGetMedicalSupplyBottlesParams = {},
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainMedicalSuppliesResultMedicalSupplyBottleViewModel,
        void
      >({
        path: `/medical-supplies/bottles`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MedicalSupplies
     * @name MedicalSuppliesGetMedicalSupplyOrderById
     * @request GET:/medical-supplies/orders/{id}
     * @secure
     * @response `200` `HealthSystemDomainMedicalSuppliesResultMedicalSupplyOrderViewModel` OK
     * @response `401` `void` Unauthorized
     */
    medicalSuppliesGetMedicalSupplyOrderById: (
      { id }: MedicalSuppliesGetMedicalSupplyOrderByIdParams,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainMedicalSuppliesResultMedicalSupplyOrderViewModel,
        void
      >({
        path: `/medical-supplies/orders/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MedicalSupplies
     * @name MedicalSuppliesGetMedicalSupplyOrders
     * @request GET:/medical-supplies/orders
     * @secure
     * @response `200` `HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainMedicalSuppliesResultMedicalSupplyOrderViewModel` OK
     * @response `401` `void` Unauthorized
     */
    medicalSuppliesGetMedicalSupplyOrders: (
      query: MedicalSuppliesGetMedicalSupplyOrdersParams = {},
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainMedicalSuppliesResultMedicalSupplyOrderViewModel,
        void
      >({
        path: `/medical-supplies/orders`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MedicalSupplies
     * @name MedicalSuppliesGetMedicationMatrix
     * @summary Medication matrix for the mobile auto-dose flow: every medical supply with its withdrawal period and CC per kilogram per animal type. A single unfiltered call is enough for the offline sync.
     * @request GET:/medical-supplies/medication-matrix
     * @secure
     * @response `200` `HealthSystemAPIControllersMedicalSuppliesResponsesMedicationMatrixResponse` OK
     * @response `401` `void` Unauthorized
     */
    medicalSuppliesGetMedicationMatrix: (
      query: MedicalSuppliesGetMedicationMatrixParams = {},
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemAPIControllersMedicalSuppliesResponsesMedicationMatrixResponse,
        void
      >({
        path: `/medical-supplies/medication-matrix`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MedicalSupplies
     * @name MedicalSuppliesRemoveMedicalSupplyBottle
     * @request DELETE:/medical-supplies/bottles/{id}
     * @secure
     * @response `204` `void` No Content
     * @response `401` `void` Unauthorized
     * @response `403` `HSAPIHostingApiResponseApiErrorResult` Forbidden
     * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
     */
    medicalSuppliesRemoveMedicalSupplyBottle: (
      { id }: MedicalSuppliesRemoveMedicalSupplyBottleParams,
      params: RequestParams = {},
    ) =>
      this.request<void, void | HSAPIHostingApiResponseApiErrorResult>({
        path: `/medical-supplies/bottles/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags MedicalSupplies
     * @name MedicalSuppliesUpdateBottleVisibility
     * @request PUT:/farm/medical-supplies/bottles/visibility
     * @secure
     * @response `200` `string` OK
     * @response `401` `void` Unauthorized
     */
    medicalSuppliesUpdateBottleVisibility: (
      data: HealthSystemDomainMedicalSuppliesCommandsMedicalSupplyBottleVisibilityCommand,
      params: RequestParams = {},
    ) =>
      this.request<string, void>({
        path: `/farm/medical-supplies/bottles/visibility`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MedicalSupplies
     * @name MedicalSuppliesUpdateFarmMedicalSupplyStock
     * @request PUT:/farm/medical-supplies
     * @secure
     * @response `200` `string` OK
     * @response `401` `void` Unauthorized
     */
    medicalSuppliesUpdateFarmMedicalSupplyStock: (
      data: HealthSystemDomainMedicalSuppliesCommandsUpdateFarmMedicalSupplyCommand,
      params: RequestParams = {},
    ) =>
      this.request<string, void>({
        path: `/farm/medical-supplies`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MedicalSupplies
     * @name MedicalSuppliesUpdateMedicalSupply
     * @request PUT:/medical-supplies/{id}
     * @secure
     * @response `204` `void` No Content
     * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
     * @response `401` `void` Unauthorized
     * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
     */
    medicalSuppliesUpdateMedicalSupply: (
      { id }: MedicalSuppliesUpdateMedicalSupplyParams,
      data: HealthSystemAPIControllersMedicalSuppliesRequestsUpdateMedicalSupplyRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, HSAPIHostingApiResponseApiErrorResult | void>({
        path: `/medical-supplies/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MedicalSupplies
     * @name MedicalSuppliesUpdateMedicalSupplyBottle
     * @request PUT:/medical-supplies/bottles/{id}
     * @secure
     * @response `204` `void` No Content
     * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
     * @response `401` `void` Unauthorized
     * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
     */
    medicalSuppliesUpdateMedicalSupplyBottle: (
      { id }: MedicalSuppliesUpdateMedicalSupplyBottleParams,
      data: HealthSystemAPIControllersMedicalSuppliesRequestsUpdateMedicalSupplyBottleRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, HSAPIHostingApiResponseApiErrorResult | void>({
        path: `/medical-supplies/bottles/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),
  };
  medications = {
    /**
     * No description
     *
     * @tags Medications
     * @name MedicationsGetAll
     * @summary Lists medications with their packs and withdrawal periods.
     * @request GET:/medications
     * @secure
     * @response `200` `HealthSystemDomainMedicationsQueriesGetMedicationsResult` OK
     * @response `401` `void` Unauthorized
     */
    medicationsGetAll: (
      query: MedicationsGetAllParams = {},
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainMedicationsQueriesGetMedicationsResult,
        void
      >({
        path: `/medications`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Idempotent — packs match on their register code and medications on their short name, so the same batch can be sent twice. A medication whose packs disagree on a withdrawal period is reported in `Rejected` and not written; the rest of the batch still loads. Admin only, deliberately: a veterinarian reads the catalogue but does not load it, and this writes the numbers their labels will print.
     *
     * @tags Medications
     * @name MedicationsImport
     * @summary Loads a batch of catalogue packs.
     * @request POST:/medications/import
     * @secure
     * @response `200` `HealthSystemDomainMedicationsCommandsImportMedicationsResult` OK
     * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
     * @response `401` `void` Unauthorized
     */
    medicationsImport: (
      data: HealthSystemAPIControllersMedicationsRequestsImportMedicationsRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainMedicationsCommandsImportMedicationsResult,
        HSAPIHostingApiResponseApiErrorResult | void
      >({
        path: `/medications/import`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),
  };
  mortalityReasons = {
    /**
     * No description
     *
     * @tags MortalityReasons
     * @name MortalityReasonsCreateMortalityReason
     * @request POST:/mortality-reasons
     * @secure
     * @response `200` `string` OK
     * @response `401` `void` Unauthorized
     */
    mortalityReasonsCreateMortalityReason: (
      data: HealthSystemDomainMortalityReasonsCommandsCreateMortalityReasonCommand,
      params: RequestParams = {},
    ) =>
      this.request<string, void>({
        path: `/mortality-reasons`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MortalityReasons
     * @name MortalityReasonsGetAllDiseases
     * @request GET:/mortality-reasons/all
     * @secure
     * @response `200` `(HealthSystemDomainMortalityReasonsMortalityReasonViewModel)[]` OK
     * @response `401` `void` Unauthorized
     */
    mortalityReasonsGetAllDiseases: (
      query: MortalityReasonsGetAllDiseasesParams = {},
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainMortalityReasonsMortalityReasonViewModel[],
        void
      >({
        path: `/mortality-reasons/all`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MortalityReasons
     * @name MortalityReasonsMortalityReasonsSearch
     * @request GET:/mortality-reasons
     * @secure
     * @response `200` `HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainMortalityReasonsMortalityReasonViewModel` OK
     * @response `401` `void` Unauthorized
     */
    mortalityReasonsMortalityReasonsSearch: (
      query: MortalityReasonsMortalityReasonsSearchParams = {},
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainMortalityReasonsMortalityReasonViewModel,
        void
      >({
        path: `/mortality-reasons`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MortalityReasons
     * @name MortalityReasonsRemoveMortalityReason
     * @request DELETE:/mortality-reasons
     * @secure
     * @response `200` `string` OK
     * @response `401` `void` Unauthorized
     */
    mortalityReasonsRemoveMortalityReason: (
      data: HealthSystemDomainMortalityReasonsCommandsRemoveMortalityReasonCommand,
      params: RequestParams = {},
    ) =>
      this.request<string, void>({
        path: `/mortality-reasons`,
        method: "DELETE",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),
  };
  notificationRules = {
    /**
     * No description
     *
     * @tags NotificationRules
     * @name NotificationRulesCreateNotificationRule
     * @request POST:/notification-rules
     * @secure
     * @response `200` `string` OK
     * @response `401` `void` Unauthorized
     */
    notificationRulesCreateNotificationRule: (
      data: HealthSystemDomainNotificationRulesCommandCreateNotificationRuleCommand,
      params: RequestParams = {},
    ) =>
      this.request<string, void>({
        path: `/notification-rules`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags NotificationRules
     * @name NotificationRulesCreateNotificationRules
     * @request POST:/notification-rules/multiple
     * @secure
     * @response `200` `(string)[]` OK
     * @response `401` `void` Unauthorized
     */
    notificationRulesCreateNotificationRules: (
      data: HealthSystemDomainNotificationRulesCommandCreateNotificationRulesCommand,
      params: RequestParams = {},
    ) =>
      this.request<string[], void>({
        path: `/notification-rules/multiple`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags NotificationRules
     * @name NotificationRulesDeleteNotificationRule
     * @request DELETE:/notification-rules
     * @secure
     * @response `200` `string` OK
     * @response `401` `void` Unauthorized
     */
    notificationRulesDeleteNotificationRule: (
      query: NotificationRulesDeleteNotificationRuleParams,
      params: RequestParams = {},
    ) =>
      this.request<string, void>({
        path: `/notification-rules`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags NotificationRules
     * @name NotificationRulesUpdateNotificationRule
     * @request PUT:/notification-rules
     * @secure
     * @response `200` `string` OK
     * @response `401` `void` Unauthorized
     */
    notificationRulesUpdateNotificationRule: (
      data: HealthSystemDomainNotificationRulesCommandUpdateNotificationRuleCommand,
      params: RequestParams = {},
    ) =>
      this.request<string, void>({
        path: `/notification-rules`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags NotificationRules
     * @name NotificationRulesUpdateNotificationRules
     * @request PUT:/notification-rules/multiple
     * @secure
     * @response `200` `(string)[]` OK
     * @response `401` `void` Unauthorized
     */
    notificationRulesUpdateNotificationRules: (
      data: HealthSystemDomainNotificationRulesCommandUpdateNotificationRulesCommand,
      params: RequestParams = {},
    ) =>
      this.request<string[], void>({
        path: `/notification-rules/multiple`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags NotificationRules
     * @name NotificationRulesViewNotificationRules
     * @request GET:/notification-rules
     * @secure
     * @response `200` `HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainNotificationRulesResultNotificationRuleViewModel` OK
     * @response `401` `void` Unauthorized
     */
    notificationRulesViewNotificationRules: (
      query: NotificationRulesViewNotificationRulesParams = {},
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainNotificationRulesResultNotificationRuleViewModel,
        void
      >({
        path: `/notification-rules`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  notifications = {
    /**
     * No description
     *
     * @tags Notifications
     * @name NotificationsGetNotifications
     * @request GET:/notifications
     * @secure
     * @response `200` `HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainNotificationsResultNotificationViewModel` OK
     * @response `401` `void` Unauthorized
     */
    notificationsGetNotifications: (
      query: NotificationsGetNotificationsParams = {},
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainNotificationsResultNotificationViewModel,
        void
      >({
        path: `/notifications`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notifications
     * @name NotificationsViewNotifications
     * @request POST:/notifications/view
     * @secure
     * @response `200` `(string)[]` OK
     * @response `401` `void` Unauthorized
     */
    notificationsViewNotifications: (
      data: HealthSystemDomainNotificationsViewNotificationsCommand,
      params: RequestParams = {},
    ) =>
      this.request<string[], void>({
        path: `/notifications/view`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),
  };
  savedComparisons = {
    /**
     * No description
     *
     * @tags SavedComparisons
     * @name SavedComparisonsCreate
     * @request POST:/saved-comparisons
     * @secure
     * @response `204` `void` No Content
     * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
     * @response `401` `void` Unauthorized
     * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
     */
    savedComparisonsCreate: (
      data: HealthSystemAPIControllersSavedComparisonsRequestsCreateSavedComparisonRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, HSAPIHostingApiResponseApiErrorResult | void>({
        path: `/saved-comparisons`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SavedComparisons
     * @name SavedComparisonsDelete
     * @request DELETE:/saved-comparisons/{id}
     * @secure
     * @response `204` `void` No Content
     * @response `401` `void` Unauthorized
     * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
     * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
     */
    savedComparisonsDelete: (
      { id }: SavedComparisonsDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<void, void | HSAPIHostingApiResponseApiErrorResult>({
        path: `/saved-comparisons/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags SavedComparisons
     * @name SavedComparisonsGetAll
     * @request GET:/saved-comparisons
     * @secure
     * @response `200` `(HealthSystemDomainSavedComparisonQueriesSavedComparisonResult)[]` OK
     * @response `401` `void` Unauthorized
     * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
     */
    savedComparisonsGetAll: (params: RequestParams = {}) =>
      this.request<
        HealthSystemDomainSavedComparisonQueriesSavedComparisonResult[],
        void | HSAPIHostingApiResponseApiErrorResult
      >({
        path: `/saved-comparisons`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  scheduledReports = {
    /**
     * No description
     *
     * @tags ScheduledReports
     * @name ScheduledReportsCreate
     * @request POST:/scheduled-reports
     * @secure
     * @response `200` `HealthSystemAPIControllersScheduledReportsResponsesScheduledReportResponse` OK
     * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
     * @response `401` `void` Unauthorized
     * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
     */
    scheduledReportsCreate: (
      data: HealthSystemAPIControllersScheduledReportsRequestsCreateScheduledReportRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemAPIControllersScheduledReportsResponsesScheduledReportResponse,
        HSAPIHostingApiResponseApiErrorResult | void
      >({
        path: `/scheduled-reports`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ScheduledReports
     * @name ScheduledReportsDelete
     * @request DELETE:/scheduled-reports/{id}
     * @secure
     * @response `204` `void` No Content
     * @response `401` `void` Unauthorized
     * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
     * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
     */
    scheduledReportsDelete: (
      { id }: ScheduledReportsDeleteParams,
      params: RequestParams = {},
    ) =>
      this.request<void, void | HSAPIHostingApiResponseApiErrorResult>({
        path: `/scheduled-reports/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ScheduledReports
     * @name ScheduledReportsGetAll
     * @request GET:/scheduled-reports
     * @secure
     * @response `200` `(HealthSystemAPIControllersScheduledReportsResponsesScheduledReportResponse)[]` OK
     * @response `401` `void` Unauthorized
     * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
     */
    scheduledReportsGetAll: (params: RequestParams = {}) =>
      this.request<
        HealthSystemAPIControllersScheduledReportsResponsesScheduledReportResponse[],
        void | HSAPIHostingApiResponseApiErrorResult
      >({
        path: `/scheduled-reports`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ScheduledReports
     * @name ScheduledReportsSendNow
     * @request POST:/scheduled-reports/{id}/send-now
     * @secure
     * @response `200` `HealthSystemAPIControllersScheduledReportsResponsesSendScheduledReportNowResponse` OK
     * @response `401` `void` Unauthorized
     * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
     * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
     */
    scheduledReportsSendNow: (
      { id }: ScheduledReportsSendNowParams,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemAPIControllersScheduledReportsResponsesSendScheduledReportNowResponse,
        void | HSAPIHostingApiResponseApiErrorResult
      >({
        path: `/scheduled-reports/${id}/send-now`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ScheduledReports
     * @name ScheduledReportsSetActive
     * @request PUT:/scheduled-reports/{id}/active
     * @secure
     * @response `204` `void` No Content
     * @response `401` `void` Unauthorized
     * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
     * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
     */
    scheduledReportsSetActive: (
      { id }: ScheduledReportsSetActiveParams,
      data: HealthSystemAPIControllersScheduledReportsRequestsSetScheduledReportActiveRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, void | HSAPIHostingApiResponseApiErrorResult>({
        path: `/scheduled-reports/${id}/active`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ScheduledReports
     * @name ScheduledReportsUpdate
     * @request PUT:/scheduled-reports/{id}
     * @secure
     * @response `200` `HealthSystemAPIControllersScheduledReportsResponsesScheduledReportResponse` OK
     * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
     * @response `401` `void` Unauthorized
     * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
     * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
     */
    scheduledReportsUpdate: (
      { id }: ScheduledReportsUpdateParams,
      data: HealthSystemAPIControllersScheduledReportsRequestsUpdateScheduledReportRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemAPIControllersScheduledReportsResponsesScheduledReportResponse,
        HSAPIHostingApiResponseApiErrorResult | void
      >({
        path: `/scheduled-reports/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),
  };
  sensorDevices = {
    /**
     * No description
     *
     * @tags SensorDevices
     * @name SensorDevicesAssignLocation
     * @request PUT:/farms/{farmId}/sensor-devices/{sensorDeviceId}/location
     * @secure
     * @response `204` `void` No Content
     * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
     * @response `401` `void` Unauthorized
     * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
     * @response `409` `HSAPIHostingApiResponseApiErrorResult` Conflict
     * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
     */
    sensorDevicesAssignLocation: (
      { farmId, sensorDeviceId }: SensorDevicesAssignLocationParams,
      data: HealthSystemAPIControllersSensorDevicesRequestsAssignSensorDeviceLocationRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, HSAPIHostingApiResponseApiErrorResult | void>({
        path: `/farms/${farmId}/sensor-devices/${sensorDeviceId}/location`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * @description Registers and binds devices only; readings still arrive with the sync worker.
     *
     * @tags SensorDevices
     * @name SensorDevicesDiscover
     * @summary Asks the farm's sensor provider what devices it has now, rather than waiting for the daily sync.
     * @request POST:/farms/{farmId}/sensor-devices/discover
     * @secure
     * @response `200` `HealthSystemAPIControllersSensorDevicesResponsesDiscoverSensorDevicesResponse` OK
     * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
     * @response `401` `void` Unauthorized
     * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
     */
    sensorDevicesDiscover: (
      { farmId }: SensorDevicesDiscoverParams,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemAPIControllersSensorDevicesResponsesDiscoverSensorDevicesResponse,
        HSAPIHostingApiResponseApiErrorResult | void
      >({
        path: `/farms/${farmId}/sensor-devices/discover`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Devices the provider has stopped reporting are left out: they hold no pen and will send nothing further, so there is nothing here to do about them. Their rows and readings are kept.
     *
     * @tags SensorDevices
     * @name SensorDevicesGetAll
     * @summary The farm's devices and the pen each is bound to.
     * @request GET:/farms/{farmId}/sensor-devices
     * @secure
     * @response `200` `(HealthSystemAPIControllersSensorDevicesResponsesSensorDeviceResponse)[]` OK
     * @response `401` `void` Unauthorized
     * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
     */
    sensorDevicesGetAll: (
      { farmId }: SensorDevicesGetAllParams,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemAPIControllersSensorDevicesResponsesSensorDeviceResponse[],
        void | HSAPIHostingApiResponseApiErrorResult
      >({
        path: `/farms/${farmId}/sensor-devices`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SensorDevices
     * @name SensorDevicesUnassignLocation
     * @request DELETE:/farms/{farmId}/sensor-devices/{sensorDeviceId}/location
     * @secure
     * @response `204` `void` No Content
     * @response `401` `void` Unauthorized
     * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
     * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
     */
    sensorDevicesUnassignLocation: (
      { farmId, sensorDeviceId }: SensorDevicesUnassignLocationParams,
      params: RequestParams = {},
    ) =>
      this.request<void, void | HSAPIHostingApiResponseApiErrorResult>({
        path: `/farms/${farmId}/sensor-devices/${sensorDeviceId}/location`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  settings = {
    /**
     * No description
     *
     * @tags Settings
     * @name SettingsCreateEventLog
     * @request POST:/eventlog
     * @secure
     * @response `200` `string` OK
     * @response `401` `void` Unauthorized
     */
    settingsCreateEventLog: (
      data: HealthSystemDomainSettingsCreateEventLogCommand,
      params: RequestParams = {},
    ) =>
      this.request<string, void>({
        path: `/eventlog`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Settings
     * @name SettingsCreateTranslation
     * @request POST:/locales
     * @secure
     * @response `200` `string` OK
     * @response `401` `void` Unauthorized
     */
    settingsCreateTranslation: (
      data: HealthSystemDomainSettingsCreateTranslationCommand,
      params: RequestParams = {},
    ) =>
      this.request<string, void>({
        path: `/locales`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Settings
     * @name SettingsGetAnimalCapacity
     * @request GET:/settings/animalcapacity
     * @secure
     * @response `200` `HealthSystemDomainSettingsResultAnimalCapacityViewModel` OK
     * @response `401` `void` Unauthorized
     */
    settingsGetAnimalCapacity: (
      query: SettingsGetAnimalCapacityParams = {},
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainSettingsResultAnimalCapacityViewModel,
        void
      >({
        path: `/settings/animalcapacity`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Settings
     * @name SettingsGetConfig
     * @request GET:/config
     * @response `200` `HealthSystemDomainSettingsResultConfigViewModel` OK
     */
    settingsGetConfig: (params: RequestParams = {}) =>
      this.request<HealthSystemDomainSettingsResultConfigViewModel, any>({
        path: `/config`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Settings
     * @name SettingsGetFarmSettings
     * @request GET:/settings/farm
     * @secure
     * @response `200` `HealthSystemDomainSettingsResultFarmSettingsViewModel` OK
     * @response `401` `void` Unauthorized
     */
    settingsGetFarmSettings: (
      query: SettingsGetFarmSettingsParams = {},
      params: RequestParams = {},
    ) =>
      this.request<HealthSystemDomainSettingsResultFarmSettingsViewModel, void>(
        {
          path: `/settings/farm`,
          method: "GET",
          query: query,
          secure: true,
          format: "json",
          ...params,
        },
      ),

    /**
     * No description
     *
     * @tags Settings
     * @name SettingsGetHoldingRoomLocations
     * @request GET:/settings/farm/holding-room-locations
     * @secure
     * @response `200` `(HealthSystemDomainSettingsResultHoldingRoomLocationViewModel)[]` OK
     * @response `401` `void` Unauthorized
     */
    settingsGetHoldingRoomLocations: (params: RequestParams = {}) =>
      this.request<
        HealthSystemDomainSettingsResultHoldingRoomLocationViewModel[],
        void
      >({
        path: `/settings/farm/holding-room-locations`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Settings
     * @name SettingsGetTranslationByIsoCode
     * @summary This method is used with i18next backend plugin api call
     * @request GET:/locales/{isoCode}
     * @response `200` `void` OK
     */
    settingsGetTranslationByIsoCode: (
      { isoCode }: SettingsGetTranslationByIsoCodeParams,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/locales/${isoCode}`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Settings
     * @name SettingsGetTranslations
     * @request GET:/locales
     * @secure
     * @response `200` `(HealthSystemDomainSettingsResultTranslationViewModel)[]` OK
     * @response `401` `void` Unauthorized
     */
    settingsGetTranslations: (params: RequestParams = {}) =>
      this.request<
        HealthSystemDomainSettingsResultTranslationViewModel[],
        void
      >({
        path: `/locales`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Settings
     * @name SettingsSearchEventLogs
     * @request GET:/eventlog
     * @secure
     * @response `200` `HealthSystemDomainCommonQueryResultPageableResultHealthSystemDALModelLogAppEventLog` OK
     * @response `401` `void` Unauthorized
     */
    settingsSearchEventLogs: (
      query: SettingsSearchEventLogsParams = {},
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainCommonQueryResultPageableResultHealthSystemDALModelLogAppEventLog,
        void
      >({
        path: `/eventlog`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Settings
     * @name SettingsUpdateFarmSettings
     * @request POST:/settings/farm
     * @secure
     * @response `200` `string` OK
     * @response `401` `void` Unauthorized
     */
    settingsUpdateFarmSettings: (
      data: HealthSystemDomainSettingsUpdateFarmSettingsCommand,
      params: RequestParams = {},
    ) =>
      this.request<string, void>({
        path: `/settings/farm`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Settings
     * @name SettingsUpdateTranslation
     * @request PUT:/locales
     * @secure
     * @response `200` `string` OK
     * @response `401` `void` Unauthorized
     */
    settingsUpdateTranslation: (
      data: HealthSystemDomainSettingsUpdateTranslationCommand,
      params: RequestParams = {},
    ) =>
      this.request<string, void>({
        path: `/locales`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),
  };
  slaughterhouses = {
    /**
     * No description
     *
     * @tags Slaughterhouses
     * @name SlaughterhousesCreate
     * @request POST:/slaughterhouses
     * @secure
     * @response `200` `HealthSystemDomainSlaughterhouseCommandsCreateSlaughterhouseResult` OK
     * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
     * @response `401` `void` Unauthorized
     */
    slaughterhousesCreate: (
      data: HealthSystemAPIControllersSlaughterhousesRequestsCreateSlaughterhouseRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainSlaughterhouseCommandsCreateSlaughterhouseResult,
        HSAPIHostingApiResponseApiErrorResult | void
      >({
        path: `/slaughterhouses`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Slaughterhouses
     * @name SlaughterhousesDeleteApiKey
     * @request DELETE:/slaughterhouses/{id}/api-keys/{apiKeyId}
     * @secure
     * @response `204` `void` No Content
     * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
     * @response `401` `void` Unauthorized
     * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
     */
    slaughterhousesDeleteApiKey: (
      { id, apiKeyId }: SlaughterhousesDeleteApiKeyParams,
      params: RequestParams = {},
    ) =>
      this.request<void, HSAPIHostingApiResponseApiErrorResult | void>({
        path: `/slaughterhouses/${id}/api-keys/${apiKeyId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Slaughterhouses
     * @name SlaughterhousesGenerateApiKey
     * @request POST:/slaughterhouses/{id}/api-keys
     * @secure
     * @response `200` `HealthSystemAPIControllersSlaughterhousesResponsesGenerateSlaughterhouseApiKeyResponse` OK
     * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
     * @response `401` `void` Unauthorized
     * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
     */
    slaughterhousesGenerateApiKey: (
      { id }: SlaughterhousesGenerateApiKeyParams,
      data: HealthSystemAPIControllersSlaughterhousesRequestsGenerateApiKeyRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemAPIControllersSlaughterhousesResponsesGenerateSlaughterhouseApiKeyResponse,
        HSAPIHostingApiResponseApiErrorResult | void
      >({
        path: `/slaughterhouses/${id}/api-keys`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Slaughterhouses
     * @name SlaughterhousesGetAll
     * @request GET:/slaughterhouses
     * @secure
     * @response `200` `HealthSystemDomainSlaughterhouseModelsSlaughterhouseListResult` OK
     * @response `401` `void` Unauthorized
     */
    slaughterhousesGetAll: (
      query: SlaughterhousesGetAllParams = {},
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainSlaughterhouseModelsSlaughterhouseListResult,
        void
      >({
        path: `/slaughterhouses`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Slaughterhouses
     * @name SlaughterhousesGetById
     * @request GET:/slaughterhouses/{id}
     * @secure
     * @response `200` `HealthSystemDomainSlaughterhouseModelsSlaughterhouseViewModel` OK
     * @response `401` `void` Unauthorized
     * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
     */
    slaughterhousesGetById: (
      { id }: SlaughterhousesGetByIdParams,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainSlaughterhouseModelsSlaughterhouseViewModel,
        void | HSAPIHostingApiResponseApiErrorResult
      >({
        path: `/slaughterhouses/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Slaughterhouses
     * @name SlaughterhousesUpdate
     * @request PUT:/slaughterhouses/{id}
     * @secure
     * @response `204` `void` No Content
     * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
     * @response `401` `void` Unauthorized
     * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
     */
    slaughterhousesUpdate: (
      { id }: SlaughterhousesUpdateParams,
      data: HealthSystemAPIControllersSlaughterhousesRequestsUpdateSlaughterhouseRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, HSAPIHostingApiResponseApiErrorResult | void>({
        path: `/slaughterhouses/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Slaughterhouses
     * @name SlaughterhousesUpdateApiKey
     * @request PUT:/slaughterhouses/{id}/api-keys/{apiKeyId}
     * @secure
     * @response `204` `void` No Content
     * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
     * @response `401` `void` Unauthorized
     * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
     */
    slaughterhousesUpdateApiKey: (
      { id, apiKeyId }: SlaughterhousesUpdateApiKeyParams,
      data: HealthSystemAPIControllersSlaughterhousesRequestsUpdateApiKeyRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, HSAPIHostingApiResponseApiErrorResult | void>({
        path: `/slaughterhouses/${id}/api-keys/${apiKeyId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),
  };
  slaughterPreparation = {
    /**
     * No description
     *
     * @tags SlaughterPreparation
     * @name SlaughterPreparationGetPreOrderDetails
     * @request GET:/slaughter-preparation/pre-order-details
     * @secure
     * @response `200` `HealthSystemDomainSlaughterPreparationsResultPreOrderDetailsViewModel` OK
     * @response `401` `void` Unauthorized
     */
    slaughterPreparationGetPreOrderDetails: (
      query: SlaughterPreparationGetPreOrderDetailsParams = {},
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainSlaughterPreparationsResultPreOrderDetailsViewModel,
        void
      >({
        path: `/slaughter-preparation/pre-order-details`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SlaughterPreparation
     * @name SlaughterPreparationGetPreOrdersSummaries
     * @request GET:/slaughter-preparation/pre-orders-summaries
     * @secure
     * @response `200` `HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainSlaughterPreparationsResultPreOrdersSummariesViewModel` OK
     * @response `401` `void` Unauthorized
     */
    slaughterPreparationGetPreOrdersSummaries: (
      query: SlaughterPreparationGetPreOrdersSummariesParams = {},
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainSlaughterPreparationsResultPreOrdersSummariesViewModel,
        void
      >({
        path: `/slaughter-preparation/pre-orders-summaries`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SlaughterPreparation
     * @name SlaughterPreparationGetSummaryInfo
     * @request GET:/slaughter-preparation
     * @secure
     * @response `200` `HealthSystemDomainSlaughterPreparationsResultSlaughterPreparationViewModel` OK
     * @response `401` `void` Unauthorized
     */
    slaughterPreparationGetSummaryInfo: (params: RequestParams = {}) =>
      this.request<
        HealthSystemDomainSlaughterPreparationsResultSlaughterPreparationViewModel,
        void
      >({
        path: `/slaughter-preparation`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SlaughterPreparation
     * @name SlaughterPreparationSavePreDelivery
     * @request POST:/slaughter-preparation
     * @secure
     * @response `200` `string` OK
     * @response `401` `void` Unauthorized
     */
    slaughterPreparationSavePreDelivery: (
      data: HealthSystemDomainSlaughterPreparationsSlaughterPreDeliveryCommand,
      params: RequestParams = {},
    ) =>
      this.request<string, void>({
        path: `/slaughter-preparation`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),
  };
  taskList = {
    /**
     * No description
     *
     * @tags TaskList
     * @name TaskListCreateProductionSchedule
     * @request POST:/tasks/v1/production-schedule
     * @secure
     * @response `200` `HealthSystemAPIControllersTaskV1ResponsesProductionScheduleResponse` OK
     * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
     * @response `401` `void` Unauthorized
     * @response `409` `HSAPIHostingApiResponseApiErrorResult` Conflict
     * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
     */
    taskListCreateProductionSchedule: (
      data: HealthSystemAPIControllersTaskV1RequestsCreateProductionScheduleRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemAPIControllersTaskV1ResponsesProductionScheduleResponse,
        HSAPIHostingApiResponseApiErrorResult | void
      >({
        path: `/tasks/v1/production-schedule`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TaskList
     * @name TaskListGetAllProductionSchedules
     * @request GET:/tasks/v1/production-schedules
     * @secure
     * @response `200` `(HealthSystemAPIControllersTaskV1ResponsesProductionScheduleResponse)[]` OK
     * @response `401` `void` Unauthorized
     */
    taskListGetAllProductionSchedules: (params: RequestParams = {}) =>
      this.request<
        HealthSystemAPIControllersTaskV1ResponsesProductionScheduleResponse[],
        void
      >({
        path: `/tasks/v1/production-schedules`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TaskList
     * @name TaskListGetAttachmentDownloadUrl
     * @request GET:/tasks/v1/library/attachment-download-url
     * @secure
     * @response `200` `HealthSystemAPIControllersTaskV1ResponsesGetAttachmentDownloadUrlResponse` OK
     * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
     * @response `401` `void` Unauthorized
     * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
     */
    taskListGetAttachmentDownloadUrl: (
      query: TaskListGetAttachmentDownloadUrlParams = {},
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemAPIControllersTaskV1ResponsesGetAttachmentDownloadUrlResponse,
        HSAPIHostingApiResponseApiErrorResult | void
      >({
        path: `/tasks/v1/library/attachment-download-url`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TaskList
     * @name TaskListGetAttachmentUploadUrl
     * @request GET:/tasks/v1/library/attachment-upload-url
     * @secure
     * @response `200` `HealthSystemAPIControllersTaskV1ResponsesGetAttachmentUploadUrlResponse` OK
     * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
     * @response `401` `void` Unauthorized
     * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
     */
    taskListGetAttachmentUploadUrl: (
      query: TaskListGetAttachmentUploadUrlParams = {},
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemAPIControllersTaskV1ResponsesGetAttachmentUploadUrlResponse,
        HSAPIHostingApiResponseApiErrorResult | void
      >({
        path: `/tasks/v1/library/attachment-upload-url`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TaskList
     * @name TaskListGetDailyTaskPlan
     * @request GET:/tasks/v1/plans/daily
     * @secure
     * @response `200` `(HealthSystemDomainTaskLibraryResultTaskOccurrenceViewModel)[]` OK
     * @response `401` `void` Unauthorized
     */
    taskListGetDailyTaskPlan: (
      query: TaskListGetDailyTaskPlanParams = {},
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainTaskLibraryResultTaskOccurrenceViewModel[],
        void
      >({
        path: `/tasks/v1/plans/daily`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TaskList
     * @name TaskListGetDailyUserOccurrences
     * @request GET:/tasks/v1/plans/daily/users
     * @secure
     * @response `200` `(HealthSystemDomainTaskLibraryResultUserTaskOccurrencesViewModel)[]` OK
     * @response `401` `void` Unauthorized
     */
    taskListGetDailyUserOccurrences: (
      query: TaskListGetDailyUserOccurrencesParams = {},
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainTaskLibraryResultUserTaskOccurrencesViewModel[],
        void
      >({
        path: `/tasks/v1/plans/daily/users`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TaskList
     * @name TaskListGetProductionSchedule
     * @request GET:/tasks/v1/production-schedule
     * @secure
     * @response `200` `HealthSystemAPIControllersTaskV1ResponsesProductionScheduleResponse` OK
     * @response `401` `void` Unauthorized
     * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
     */
    taskListGetProductionSchedule: (
      query: TaskListGetProductionScheduleParams = {},
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemAPIControllersTaskV1ResponsesProductionScheduleResponse,
        void | HSAPIHostingApiResponseApiErrorResult
      >({
        path: `/tasks/v1/production-schedule`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TaskList
     * @name TaskListGetTaskLibrary
     * @request GET:/tasks/v1/library
     * @secure
     * @response `200` `(HealthSystemDomainTaskLibraryResultTaskTemplateViewModel)[]` OK
     * @response `401` `void` Unauthorized
     */
    taskListGetTaskLibrary: (
      query: TaskListGetTaskLibraryParams = {},
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainTaskLibraryResultTaskTemplateViewModel[],
        void
      >({
        path: `/tasks/v1/library`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TaskList
     * @name TaskListGetTaskLibraryList
     * @request GET:/tasks/v1/lists
     * @secure
     * @response `200` `Record<string,HealthSystemDomainTaskLibraryResultTaskScheduleViewModel>` OK
     * @response `401` `void` Unauthorized
     */
    taskListGetTaskLibraryList: (
      query: TaskListGetTaskLibraryListParams,
      params: RequestParams = {},
    ) =>
      this.request<
        Record<
          string,
          HealthSystemDomainTaskLibraryResultTaskScheduleViewModel
        >,
        void
      >({
        path: `/tasks/v1/lists`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TaskList
     * @name TaskListGetTaskPlans
     * @request GET:/tasks/v1/plans
     * @secure
     * @response `200` `HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainTaskLibraryResultTaskOccurrenceViewModel` OK
     * @response `401` `void` Unauthorized
     */
    taskListGetTaskPlans: (
      query: TaskListGetTaskPlansParams = {},
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainTaskLibraryResultTaskOccurrenceViewModel,
        void
      >({
        path: `/tasks/v1/plans`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TaskList
     * @name TaskListUpdateTaskOccurrence
     * @request PUT:/tasks/v1/plans/update
     * @secure
     * @response `200` `HealthSystemAPIControllersTaskV1ResponsesUpdateTaskOccurrenceResponse` OK
     * @response `401` `HSAPIHostingApiResponseApiErrorResult` Unauthorized
     * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
     * @response `409` `HSAPIHostingApiResponseApiErrorResult` Conflict
     */
    taskListUpdateTaskOccurrence: (
      data: HealthSystemAPIControllersTaskV1RequestsUpdateTaskOccurrenceRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemAPIControllersTaskV1ResponsesUpdateTaskOccurrenceResponse,
        HSAPIHostingApiResponseApiErrorResult
      >({
        path: `/tasks/v1/plans/update`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TaskList
     * @name TaskListUpsertTaskLibrary
     * @request POST:/tasks/v1/library
     * @secure
     * @response `200` `string` OK
     * @response `401` `void` Unauthorized
     */
    taskListUpsertTaskLibrary: (
      data: HealthSystemDomainTaskLibraryCommandUpsertTaskTemplateCommand,
      params: RequestParams = {},
    ) =>
      this.request<string, void>({
        path: `/tasks/v1/library`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TaskList
     * @name TaskListUpsertTaskLibraryList
     * @request POST:/tasks/v1/lists
     * @secure
     * @response `200` `void` OK
     * @response `401` `void` Unauthorized
     * @response `409` `HSAPIHostingApiResponseApiErrorResult` Conflict
     */
    taskListUpsertTaskLibraryList: (
      data: HealthSystemDomainTaskLibraryCommandUpsertTaskScheduleCommand,
      params: RequestParams = {},
    ) =>
      this.request<void, void | HSAPIHostingApiResponseApiErrorResult>({
        path: `/tasks/v1/lists`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),
  };
  tasks = {
    /**
     * No description
     *
     * @tags Tasks
     * @name TasksCreateTaskList
     * @request POST:/tasks
     * @secure
     * @response `200` `string` OK
     * @response `401` `void` Unauthorized
     */
    tasksCreateTaskList: (
      data: HealthSystemDomainTaskListsCommandCreateTaskListCommand,
      params: RequestParams = {},
    ) =>
      this.request<string, void>({
        path: `/tasks`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tasks
     * @name TasksCreateTaskListRule
     * @request POST:/tasks/rules
     * @secure
     * @response `200` `string` OK
     * @response `401` `void` Unauthorized
     */
    tasksCreateTaskListRule: (
      data: HealthSystemDomainTaskListsCommandCreateTaskListRuleCommand,
      params: RequestParams = {},
    ) =>
      this.request<string, void>({
        path: `/tasks/rules`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tasks
     * @name TasksDeleteTaskListRule
     * @request DELETE:/tasks/rules
     * @secure
     * @response `200` `string` OK
     * @response `401` `void` Unauthorized
     */
    tasksDeleteTaskListRule: (
      data: HealthSystemDomainTaskListsCommandRemoveTaskListRuleCommand,
      params: RequestParams = {},
    ) =>
      this.request<string, void>({
        path: `/tasks/rules`,
        method: "DELETE",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tasks
     * @name TasksFinishTaskList
     * @request PUT:/tasks/finish
     * @secure
     * @response `200` `string` OK
     * @response `401` `void` Unauthorized
     */
    tasksFinishTaskList: (
      data: HealthSystemDomainTaskListsCommandFinishTaskListCommand,
      params: RequestParams = {},
    ) =>
      this.request<string, void>({
        path: `/tasks/finish`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tasks
     * @name TasksGetTaskLists
     * @request GET:/tasks
     * @secure
     * @response `200` `HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainTaskListsResultTaskListViewModel` OK
     * @response `401` `void` Unauthorized
     */
    tasksGetTaskLists: (
      query: TasksGetTaskListsParams = {},
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainTaskListsResultTaskListViewModel,
        void
      >({
        path: `/tasks`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tasks
     * @name TasksGetTaskListsRules
     * @request GET:/tasks/rules
     * @secure
     * @response `200` `HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainTaskListsResultTaskListRuleViewModel` OK
     * @response `401` `void` Unauthorized
     */
    tasksGetTaskListsRules: (
      query: TasksGetTaskListsRulesParams = {},
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainTaskListsResultTaskListRuleViewModel,
        void
      >({
        path: `/tasks/rules`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tasks
     * @name TasksStartTaskList
     * @request PUT:/tasks/start
     * @secure
     * @response `200` `string` OK
     * @response `401` `void` Unauthorized
     */
    tasksStartTaskList: (
      data: HealthSystemDomainTaskListsCommandStartTaskListCommand,
      params: RequestParams = {},
    ) =>
      this.request<string, void>({
        path: `/tasks/start`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tasks
     * @name TasksUpdateTaskList
     * @request PUT:/tasks
     * @secure
     * @response `200` `string` OK
     * @response `401` `void` Unauthorized
     */
    tasksUpdateTaskList: (
      data: HealthSystemDomainTaskListsCommandUpdateTaskListCommand,
      params: RequestParams = {},
    ) =>
      this.request<string, void>({
        path: `/tasks`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),
  };
  userAccounts = {
    /**
     * No description
     *
     * @tags UserAccounts
     * @name UserAccountsChangePassword
     * @request PUT:/users/me/change-password
     * @secure
     * @response `204` `void` No Content
     * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
     * @response `401` `void` Unauthorized
     * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
     */
    userAccountsChangePassword: (
      data: HealthSystemAPIControllersUserAccountsRequestsChangePasswordRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, HSAPIHostingApiResponseApiErrorResult | void>({
        path: `/users/me/change-password`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * @description A link that was mailed earlier keeps working: this adds one rather than replacing it. Only the hash of a token is stored, so a link is shown exactly once - here - and a caller who loses it has to generate another.
     *
     * @tags UserAccounts
     * @name UserAccountsCreateInvitationLink
     * @summary Generates an invitation link for a user who has not activated their account yet, so it can be shared by hand when the invitation email never arrived.
     * @request POST:/users/{id}/invitation-link
     * @secure
     * @response `200` `HealthSystemAPIControllersUserAccountsResponsesInvitationLinkResponse` OK
     * @response `401` `void` Unauthorized
     * @response `403` `HSAPIHostingApiResponseApiErrorResult` Forbidden
     * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
     * @response `409` `HSAPIHostingApiResponseApiErrorResult` Conflict
     */
    userAccountsCreateInvitationLink: (
      { id }: UserAccountsCreateInvitationLinkParams,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemAPIControllersUserAccountsResponsesInvitationLinkResponse,
        void | HSAPIHostingApiResponseApiErrorResult
      >({
        path: `/users/${id}/invitation-link`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserAccounts
     * @name UserAccountsResendInvitation
     * @request POST:/users/{id}/resend-invitation
     * @secure
     * @response `204` `void` No Content
     * @response `401` `void` Unauthorized
     * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
     */
    userAccountsResendInvitation: (
      { id }: UserAccountsResendInvitationParams,
      params: RequestParams = {},
    ) =>
      this.request<void, void | HSAPIHostingApiResponseApiErrorResult>({
        path: `/users/${id}/resend-invitation`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserAccounts
     * @name UserAccountsSendInvitation
     * @request POST:/users/invite
     * @secure
     * @response `200` `string` OK
     * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
     * @response `401` `void` Unauthorized
     * @response `409` `HSAPIHostingApiResponseApiErrorResult` Conflict
     */
    userAccountsSendInvitation: (
      data: HealthSystemAPIControllersUserAccountsRequestsSendInvitationRequest,
      params: RequestParams = {},
    ) =>
      this.request<string, HSAPIHostingApiResponseApiErrorResult | void>({
        path: `/users/invite`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),
  };
  users = {
    /**
     * No description
     *
     * @tags Users
     * @name UsersActivateUser
     * @summary Restores access for a user deactivated earlier. Their password and role are unchanged.
     * @request POST:/users/{userId}/activate
     * @secure
     * @response `204` `void` No Content
     * @response `401` `void` Unauthorized
     * @response `403` `MicrosoftAspNetCoreMvcProblemDetails` Forbidden
     * @response `404` `MicrosoftAspNetCoreMvcProblemDetails` Not Found
     */
    usersActivateUser: (
      { userId }: UsersActivateUserParams,
      params: RequestParams = {},
    ) =>
      this.request<void, void | MicrosoftAspNetCoreMvcProblemDetails>({
        path: `/users/${userId}/activate`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UsersCreateUser
     * @request POST:/users
     * @secure
     * @response `200` `string` OK
     * @response `401` `void` Unauthorized
     */
    usersCreateUser: (
      data: HealthSystemDomainUsersCommandsCreateUserCommand,
      params: RequestParams = {},
    ) =>
      this.request<string, void>({
        path: `/users`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UsersDeactivateUser
     * @summary Revokes a user's access to this farm. Their history is kept and the account can be restored with M:HealthSystem.API.Controllers.UsersController.ActivateUser(System.Guid,System.Threading.CancellationToken).
     * @request POST:/users/{userId}/deactivate
     * @secure
     * @response `204` `void` No Content
     * @response `400` `MicrosoftAspNetCoreMvcProblemDetails` Bad Request
     * @response `401` `void` Unauthorized
     * @response `403` `MicrosoftAspNetCoreMvcProblemDetails` Forbidden
     * @response `404` `MicrosoftAspNetCoreMvcProblemDetails` Not Found
     */
    usersDeactivateUser: (
      { userId }: UsersDeactivateUserParams,
      params: RequestParams = {},
    ) =>
      this.request<void, MicrosoftAspNetCoreMvcProblemDetails | void>({
        path: `/users/${userId}/deactivate`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UsersGetUserActionLog
     * @request POST:/users/actions/search
     * @secure
     * @response `200` `HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainUsersResultUserActionLogViewModel` OK
     * @response `401` `void` Unauthorized
     * @response `403` `MicrosoftAspNetCoreMvcProblemDetails` Forbidden
     */
    usersGetUserActionLog: (
      data: HealthSystemDomainUsersQueryUserActionLogQuery,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainUsersResultUserActionLogViewModel,
        void | MicrosoftAspNetCoreMvcProblemDetails
      >({
        path: `/users/actions/search`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UsersGetUsers
     * @request GET:/users/search
     * @secure
     * @response `200` `HealthSystemDomainUsersResultUsersSearchQueryResult` OK
     * @response `401` `void` Unauthorized
     * @response `403` `MicrosoftAspNetCoreMvcProblemDetails` Forbidden
     */
    usersGetUsers: (
      query: UsersGetUsersParams = {},
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainUsersResultUsersSearchQueryResult,
        void | MicrosoftAspNetCoreMvcProblemDetails
      >({
        path: `/users/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UsersGetUsersAll
     * @request GET:/users/all
     * @secure
     * @response `200` `(HealthSystemDomainUsersResultUserViewModel)[]` OK
     * @response `401` `void` Unauthorized
     * @response `403` `MicrosoftAspNetCoreMvcProblemDetails` Forbidden
     */
    usersGetUsersAll: (
      query: UsersGetUsersAllParams = {},
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainUsersResultUserViewModel[],
        void | MicrosoftAspNetCoreMvcProblemDetails
      >({
        path: `/users/all`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UsersGetUserView
     * @request GET:/users
     * @secure
     * @response `200` `HealthSystemDomainUsersResultUserViewModel` OK
     * @response `401` `void` Unauthorized
     * @response `403` `MicrosoftAspNetCoreMvcProblemDetails` Forbidden
     */
    usersGetUserView: (
      query: UsersGetUserViewParams = {},
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainUsersResultUserViewModel,
        void | MicrosoftAspNetCoreMvcProblemDetails
      >({
        path: `/users`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UsersLoginBusinessUnit
     * @request GET:/users/business-units
     * @secure
     * @response `200` `(HealthSystemDomainUsersResultBusinessUnitResponse)[]` OK
     * @response `401` `void` Unauthorized
     * @response `403` `MicrosoftAspNetCoreMvcProblemDetails` Forbidden
     */
    usersLoginBusinessUnit: (
      data: HealthSystemDomainUsersCommandsGetUserBusinessUnitCommand,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainUsersResultBusinessUnitResponse[],
        void | MicrosoftAspNetCoreMvcProblemDetails
      >({
        path: `/users/business-units`,
        method: "GET",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UsersPutUserActionLogs
     * @request PUT:/users/actions
     * @secure
     * @response `200` `HealthSystemDomainCommonResultEntityBatchResult` OK
     * @response `401` `void` Unauthorized
     * @response `403` `MicrosoftAspNetCoreMvcProblemDetails` Forbidden
     */
    usersPutUserActionLogs: (
      data: HealthSystemDomainUsersCommandsAddUserActionLogCommand,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainCommonResultEntityBatchResult,
        void | MicrosoftAspNetCoreMvcProblemDetails
      >({
        path: `/users/actions`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UsersUpdateUser
     * @request PUT:/users
     * @secure
     * @response `200` `string` OK
     * @response `401` `void` Unauthorized
     * @response `403` `MicrosoftAspNetCoreMvcProblemDetails` Forbidden
     */
    usersUpdateUser: (
      data: HealthSystemDomainUsersCommandsUpdateUserCommand,
      params: RequestParams = {},
    ) =>
      this.request<string, void | MicrosoftAspNetCoreMvcProblemDetails>({
        path: `/users`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UsersUpdateUserLanguage
     * @request PUT:/users/language
     * @secure
     * @response `200` `string` OK
     * @response `401` `void` Unauthorized
     * @response `403` `MicrosoftAspNetCoreMvcProblemDetails` Forbidden
     */
    usersUpdateUserLanguage: (
      data: HealthSystemDomainUsersCommandsUpdateUserLanguageCommand,
      params: RequestParams = {},
    ) =>
      this.request<string, void | MicrosoftAspNetCoreMvcProblemDetails>({
        path: `/users/language`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),
  };
  vaccinationRules = {
    /**
     * No description
     *
     * @tags VaccinationRules
     * @name VaccinationRulesCreateVaccinationRule
     * @request POST:/farm/vaccination-rules/v1
     * @secure
     * @response `200` `string` OK
     * @response `401` `void` Unauthorized
     */
    vaccinationRulesCreateVaccinationRule: (
      data: HealthSystemDomainVaccinationRulesCreateVaccinationRuleCommand,
      params: RequestParams = {},
    ) =>
      this.request<string, void>({
        path: `/farm/vaccination-rules/v1`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags VaccinationRules
     * @name VaccinationRulesGetAllVaccinationRules
     * @request GET:/farm/vaccination-rules/v1/all
     * @secure
     * @response `200` `(HealthSystemDomainVaccinationRulesResultVaccinationRuleViewModel)[]` OK
     * @response `401` `void` Unauthorized
     */
    vaccinationRulesGetAllVaccinationRules: (
      query: VaccinationRulesGetAllVaccinationRulesParams = {},
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainVaccinationRulesResultVaccinationRuleViewModel[],
        void
      >({
        path: `/farm/vaccination-rules/v1/all`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags VaccinationRules
     * @name VaccinationRulesRemoveVaccinationRule
     * @request DELETE:/farm/vaccination-rules/v1
     * @secure
     * @response `200` `string` OK
     * @response `401` `void` Unauthorized
     */
    vaccinationRulesRemoveVaccinationRule: (
      data: HealthSystemDomainVaccinationRulesRemoveVaccinationRuleCommand,
      params: RequestParams = {},
    ) =>
      this.request<string, void>({
        path: `/farm/vaccination-rules/v1`,
        method: "DELETE",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags VaccinationRules
     * @name VaccinationRulesVaccinationRulesSearch
     * @request GET:/farm/vaccination-rules/v1
     * @secure
     * @response `200` `HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainVaccinationRulesResultVaccinationRuleViewModel` OK
     * @response `401` `void` Unauthorized
     */
    vaccinationRulesVaccinationRulesSearch: (
      query: VaccinationRulesVaccinationRulesSearchParams = {},
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainVaccinationRulesResultVaccinationRuleViewModel,
        void
      >({
        path: `/farm/vaccination-rules/v1`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  veterinary = {
    /**
     * No description
     *
     * @tags Veterinary
     * @name VeterinaryAddVeterinaryContact
     * @request POST:/vets/contact
     * @secure
     * @response `200` `string` OK
     * @response `401` `void` Unauthorized
     */
    veterinaryAddVeterinaryContact: (
      data: HealthSystemDomainVetsCommandsAddVetContactCommand,
      params: RequestParams = {},
    ) =>
      this.request<string, void>({
        path: `/vets/contact`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Veterinary
     * @name VeterinaryAssignFarmToVeterinary
     * @request PUT:/vets/farm
     * @secure
     * @response `200` `string` OK
     * @response `401` `void` Unauthorized
     */
    veterinaryAssignFarmToVeterinary: (
      data: HealthSystemDomainVetsCommandsAddFarmToVetCommand,
      params: RequestParams = {},
    ) =>
      this.request<string, void>({
        path: `/vets/farm`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Veterinary
     * @name VeterinaryCreateOralFeedInjectionRecord
     * @request POST:/vets/injections/oralfeed
     * @secure
     * @response `200` `(string)[]` OK
     * @response `401` `void` Unauthorized
     */
    veterinaryCreateOralFeedInjectionRecord: (
      data: HealthSystemDomainVetsQueryVeterinaryCreateOralFeedInjectionCommand,
      params: RequestParams = {},
    ) =>
      this.request<string[], void>({
        path: `/vets/injections/oralfeed`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Veterinary
     * @name VeterinaryCreateVaccinationInjectionRecord
     * @request POST:/vets/injections/vaccination
     * @secure
     * @response `200` `(string)[]` OK
     * @response `401` `void` Unauthorized
     */
    veterinaryCreateVaccinationInjectionRecord: (
      data: HealthSystemDomainVetsQueryVeterinaryCreateVaccinationInjectionCommand,
      params: RequestParams = {},
    ) =>
      this.request<string[], void>({
        path: `/vets/injections/vaccination`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Veterinary
     * @name VeterinaryCreateVeterinary
     * @request POST:/vets
     * @secure
     * @response `200` `string` OK
     * @response `401` `void` Unauthorized
     */
    veterinaryCreateVeterinary: (
      data: HealthSystemDomainVetsCommandsCreateVeterinaryCommand,
      params: RequestParams = {},
    ) =>
      this.request<string, void>({
        path: `/vets`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Veterinary
     * @name VeterinaryDeleteVeterinaryContact
     * @request DELETE:/vets/contact
     * @secure
     * @response `200` `string` OK
     * @response `401` `void` Unauthorized
     */
    veterinaryDeleteVeterinaryContact: (
      data: HealthSystemDomainVetsCommandsDeleteVetContactCommand,
      params: RequestParams = {},
    ) =>
      this.request<string, void>({
        path: `/vets/contact`,
        method: "DELETE",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Veterinary
     * @name VeterinaryGetFarmMedicalSupplies
     * @request GET:/vets/medical-supplies
     * @secure
     * @response `200` `(HealthSystemDomainMedicalSuppliesResultFarmMedicalSupplyViewModel)[]` OK
     * @response `401` `void` Unauthorized
     */
    veterinaryGetFarmMedicalSupplies: (
      query: VeterinaryGetFarmMedicalSuppliesParams = {},
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainMedicalSuppliesResultFarmMedicalSupplyViewModel[],
        void
      >({
        path: `/vets/medical-supplies`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Veterinary
     * @name VeterinaryGetVetById
     * @request GET:/vets/{id}
     * @secure
     * @response `200` `HealthSystemDomainVetsResultVeterinaryViewModel` OK
     * @response `401` `void` Unauthorized
     */
    veterinaryGetVetById: (
      { id }: VeterinaryGetVetByIdParams,
      params: RequestParams = {},
    ) =>
      this.request<HealthSystemDomainVetsResultVeterinaryViewModel, void>({
        path: `/vets/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Veterinary
     * @name VeterinaryGetVeterinaryDashboard
     * @request GET:/vets/dashboard
     * @secure
     * @response `200` `HealthSystemDomainDashboardsResultVeterinaryDashboardViewModel` OK
     * @response `401` `void` Unauthorized
     */
    veterinaryGetVeterinaryDashboard: (
      query: VeterinaryGetVeterinaryDashboardParams = {},
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainDashboardsResultVeterinaryDashboardViewModel,
        void
      >({
        path: `/vets/dashboard`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Veterinary
     * @name VeterinaryGetVeterinaryOrders
     * @request GET:/vets/orders
     * @secure
     * @response `200` `HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainMedicalSuppliesResultVeterinaryOrderViewModel` OK
     * @response `401` `void` Unauthorized
     */
    veterinaryGetVeterinaryOrders: (
      query: VeterinaryGetVeterinaryOrdersParams = {},
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainMedicalSuppliesResultVeterinaryOrderViewModel,
        void
      >({
        path: `/vets/orders`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Veterinary
     * @name VeterinaryGetVets
     * @request GET:/vets
     * @secure
     * @response `200` `HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainVetsResultVeterinaryViewModel` OK
     * @response `401` `void` Unauthorized
     */
    veterinaryGetVets: (
      query: VeterinaryGetVetsParams = {},
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainVetsResultVeterinaryViewModel,
        void
      >({
        path: `/vets`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Veterinary
     * @name VeterinarySearchLocations
     * @request GET:/vets/locations/search
     * @secure
     * @response `200` `HealthSystemDomainVetsResultVeterinaryLocationSearchPageableQueryResult` OK
     * @response `401` `void` Unauthorized
     */
    veterinarySearchLocations: (
      query: VeterinarySearchLocationsParams = {},
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainVetsResultVeterinaryLocationSearchPageableQueryResult,
        void
      >({
        path: `/vets/locations/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Veterinary
     * @name VeterinaryUnlinkFarmFromVeterinary
     * @request DELETE:/vets/farm
     * @secure
     * @response `200` `string` OK
     * @response `401` `void` Unauthorized
     */
    veterinaryUnlinkFarmFromVeterinary: (
      data: HealthSystemDomainVetsCommandsRemoveFarmFromVetCommand,
      params: RequestParams = {},
    ) =>
      this.request<string, void>({
        path: `/vets/farm`,
        method: "DELETE",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Veterinary
     * @name VeterinaryUpdateVeterinary
     * @request PUT:/vets
     * @secure
     * @response `200` `string` OK
     * @response `401` `void` Unauthorized
     */
    veterinaryUpdateVeterinary: (
      data: HealthSystemDomainVetsCommandsUpdateVeterinaryCommand,
      params: RequestParams = {},
    ) =>
      this.request<string, void>({
        path: `/vets`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Veterinary
     * @name VeterinaryUpdateVeterinaryContact
     * @request PUT:/vets/contact
     * @secure
     * @response `200` `string` OK
     * @response `401` `void` Unauthorized
     */
    veterinaryUpdateVeterinaryContact: (
      data: HealthSystemDomainVetsCommandsUpdateVetContactCommand,
      params: RequestParams = {},
    ) =>
      this.request<string, void>({
        path: `/vets/contact`,
        method: "PUT",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),
  };
  vitalityTracker = {
    /**
     * No description
     *
     * @tags VitalityTracker
     * @name VitalityTrackerGetAnimalActivities
     * @request GET:/vitality/actions
     * @secure
     * @response `200` `HealthSystemDomainCommonQueryResultPageableResultHealthSystemDALModelAnimalActivity` OK
     * @response `401` `void` Unauthorized
     */
    vitalityTrackerGetAnimalActivities: (
      query: VitalityTrackerGetAnimalActivitiesParams = {},
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainCommonQueryResultPageableResultHealthSystemDALModelAnimalActivity,
        void
      >({
        path: `/vitality/actions`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags VitalityTracker
     * @name VitalityTrackerGetDetailedGroupAnalytics
     * @request POST:/vitality/analytics/detailed
     * @secure
     * @response `200` `HealthSystemDomainVitalityTrackerRequestsAnimalGroupAnalyticsDetailedResult` OK
     * @response `401` `void` Unauthorized
     */
    vitalityTrackerGetDetailedGroupAnalytics: (
      data: HealthSystemDomainVitalityTrackerRequestsAnimalGroupAnalyticsDetailedQuery,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainVitalityTrackerRequestsAnimalGroupAnalyticsDetailedResult,
        void
      >({
        path: `/vitality/analytics/detailed`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags VitalityTracker
     * @name VitalityTrackerGetGroupAnalytics
     * @request POST:/vitality/analytics
     * @secure
     * @response `200` `HealthSystemDomainVitalityTrackerRequestsAnimalGroupAnalyticsResult` OK
     * @response `401` `void` Unauthorized
     */
    vitalityTrackerGetGroupAnalytics: (
      data: HealthSystemDomainVitalityTrackerRequestsAnimalGroupAnalyticsQuery,
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainVitalityTrackerRequestsAnimalGroupAnalyticsResult,
        void
      >({
        path: `/vitality/analytics`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags VitalityTracker
     * @name VitalityTrackerPushAnimalActivities
     * @request POST:/vitality/actions
     * @secure
     * @response `200` `(string)[]` OK
     * @response `401` `void` Unauthorized
     */
    vitalityTrackerPushAnimalActivities: (
      data: HealthSystemDomainVitalityTrackerRequestsPushAnimalActivitiesCommand,
      params: RequestParams = {},
    ) =>
      this.request<string[], void>({
        path: `/vitality/actions`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        format: "json",
        ...params,
      }),
  };
  weightCurves = {
    /**
     * @description The whole set comes back in a single unfiltered call, which is what the offline sync makes: the app looks up the animal's age itself and multiplies the weight by the CC per kilogram it holds from the medication matrix. Nothing here is farm-specific.
     *
     * @tags WeightCurves
     * @name WeightCurvesGetWeightCurves
     * @summary The growth curves behind the mobile auto-dose flow: the expected weight of a pig on every day of its life, one curve per birth weight, plus the age past which no dose may be estimated.
     * @request GET:/weight-curves
     * @secure
     * @response `200` `HealthSystemAPIControllersWeightCurvesResponsesWeightCurvesResponse` OK
     * @response `401` `void` Unauthorized
     */
    weightCurvesGetWeightCurves: (params: RequestParams = {}) =>
      this.request<
        HealthSystemAPIControllersWeightCurvesResponsesWeightCurvesResponse,
        void
      >({
        path: `/weight-curves`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  weightDiagnostic = {
    /**
     * No description
     *
     * @tags WeightDiagnostic
     * @name WeightDiagnosticCreateRecord
     * @request POST:/weight-diagnostic
     * @secure
     * @response `204` `void` No Content
     * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
     * @response `401` `void` Unauthorized
     * @response `404` `HSAPIHostingApiResponseApiErrorResult` Not Found
     * @response `500` `HSAPIHostingApiResponseApiErrorResult` Internal Server Error
     */
    weightDiagnosticCreateRecord: (
      data: HealthSystemAPIControllersWeightDiagnosticRequestsCreateWeightDiagnosticRecordRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, HSAPIHostingApiResponseApiErrorResult | void>({
        path: `/weight-diagnostic`,
        method: "POST",
        body: data,
        secure: true,
        type: "application/json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags WeightDiagnostic
     * @name WeightDiagnosticGetRecords
     * @request GET:/weight-diagnostic
     * @secure
     * @response `200` `HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainWeightDiagnosticQueriesWeightDiagnosticRecordViewModel` OK
     * @response `400` `HSAPIHostingApiResponseApiErrorResult` Bad Request
     * @response `401` `void` Unauthorized
     */
    weightDiagnosticGetRecords: (
      query: WeightDiagnosticGetRecordsParams = {},
      params: RequestParams = {},
    ) =>
      this.request<
        HealthSystemDomainCommonQueryResultPageableResultHealthSystemDomainWeightDiagnosticQueriesWeightDiagnosticRecordViewModel,
        HSAPIHostingApiResponseApiErrorResult | void
      >({
        path: `/weight-diagnostic`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
}
